msgid ""
msgstr ""
"POT-Creation-Date: \n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en_US\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid " — a new Reserved Instance or Savings Plan costs money but removes on-demand usage; the net effect (usually a saving) is shown here."
msgstr " — a new Reserved Instance or Savings Plan costs money but removes on-demand usage; the net effect (usually a saving) is shown here."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid " — Aurora I/O cost changes and incremental RDS storage cost after right-sizing."
msgstr " — Aurora I/O cost changes and incremental RDS storage cost after right-sizing."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid " — Aurora Serverless (ACU-based) and DynamoDB On-Demand costs not covered by the categories above."
msgstr " — Aurora Serverless (ACU-based) and DynamoDB On-Demand costs not covered by the categories above."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid " — resizing compute to cheaper instances (EC2, ECS, EKS)."
msgstr " — resizing compute to cheaper instances (EC2, ECS, EKS)."

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "; until then it is shown but not counted in the plan total."
msgstr "; until then it is shown but not counted in the plan total."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "\"Covers\" is the on-demand-equivalent usage the commitment absorbs each month. Over-committed means it covers less than it costs — you are paying for more reservation than your usage needs."
msgstr "\"Covers\" is the on-demand-equivalent usage the commitment absorbs each month. Over-committed means it covers less than it costs — you are paying for more reservation than your usage needs."

#: app/frontend/components/optimization_dashboard/RunSwitcher.jsx
msgid "({shown} of {total} runs)"
msgstr "({shown} of {total} runs)"

#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "(empty)"
msgstr "(empty)"

#. placeholder {0}: data.account_count
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "{0, plural, one {# account} other {# accounts}}"
msgstr "{0, plural, one {# account} other {# accounts}}"

#. placeholder {0}: row.account_count
#: app/frontend/pages/admin/guardian_global_dashboard/FleetRow.jsx
msgid "{0, plural, one {# acct} other {# accts}}"
msgstr "{0, plural, one {# acct} other {# accts}}"

#. placeholder {0}: action.count
#. placeholder {0}: actions.length
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "{0, plural, one {# action} other {# actions}}"
msgstr "{0, plural, one {# action} other {# actions}}"

#. placeholder {0}: rpo.total
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0, plural, one {# backup job evaluated} other {# backup jobs evaluated}}"
msgstr "{0, plural, one {# backup job evaluated} other {# backup jobs evaluated}}"

#. placeholder {0}: backupPlans.total
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0, plural, one {# backup plan} other {# backup plans}}"
msgstr "{0, plural, one {# backup plan} other {# backup plans}}"

#. placeholder {0}: clusters.length
#. placeholder {0}: eksClusters.length
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "{0, plural, one {# cluster} other {# clusters}}"
msgstr "{0, plural, one {# cluster} other {# clusters}}"

#. placeholder {0}: drRpo.total
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "{0, plural, one {# copy job evaluated} other {# copy jobs evaluated}}"
msgstr "{0, plural, one {# copy job evaluated} other {# copy jobs evaluated}}"

#. placeholder {0}: day.count
#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "{0, plural, one {# copy} other {# copies}}"
msgstr "{0, plural, one {# copy} other {# copies}}"

#. placeholder {0}: row.days_until_phase_end
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{0, plural, one {# day} other {# days}}"
msgstr "{0, plural, one {# day} other {# days}}"

#. placeholder {0}: domains.length
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "{0, plural, one {# domain} other {# domains}}"
msgstr "{0, plural, one {# domain} other {# domains}}"

#. placeholder {0}: instances.length
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "{0, plural, one {# instance} other {# instances}}"
msgstr "{0, plural, one {# instance} other {# instances}}"

#. placeholder {0}: day.operations.length
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "{0, plural, one {# operation} other {# operations}}"
msgstr "{0, plural, one {# operation} other {# operations}}"

#. placeholder {0}: backupPlans.without_jobs
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0, plural, one {# plan with no jobs} other {# plans with no jobs}}"
msgstr "{0, plural, one {# plan with no jobs} other {# plans with no jobs}}"

#. placeholder {0}: signal.breaching
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{0, plural, one {# priority breaching} other {# priorities breaching}}"
msgstr "{0, plural, one {# priority breaching} other {# priorities breaching}}"

#. placeholder {0}: rto.total
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0, plural, one {# restore job evaluated} other {# restore jobs evaluated}}"
msgstr "{0, plural, one {# restore job evaluated} other {# restore jobs evaluated}}"

#. placeholder {0}: day.count
#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "{0, plural, one {# run} other {# runs}}"
msgstr "{0, plural, one {# run} other {# runs}}"

#. placeholder {0}: snapshots.servers_with_snapshots
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "{0, plural, one {# server with snapshots} other {# servers with snapshots}}"
msgstr "{0, plural, one {# server with snapshots} other {# servers with snapshots}}"

#. placeholder {0}: rest.length
#: app/frontend/components/RankedBarLegend.jsx
msgid "{0, plural, one {Other (# type)} other {Other (# types)}}"
msgstr "{0, plural, one {Other (# type)} other {Other (# types)}}"

#. placeholder {0}: items.length
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendBand.jsx
msgid "{0, plural, one {Unusual spend: {saving}/mo across # service} other {Unusual spend: {saving}/mo across # services}}"
msgstr "{0, plural, one {Unusual spend: {saving}/mo across # service} other {Unusual spend: {saving}/mo across # services}}"

#. placeholder {0}: slices.length
#: app/frontend/components/RankedBarLegend.jsx
msgid "{0, plural, one {View all # type} other {View all # types}}"
msgstr "{0, plural, one {View all # type} other {View all # types}}"

#. placeholder {0}: tf.backup_codes_left
#: app/frontend/pages/users/two_factor/show.jsx
msgid "{0, plural, one {You have # code left.} other {You have # codes left.}}"
msgstr "{0, plural, one {You have # code left.} other {You have # codes left.}}"

#. placeholder {0}: plan.code
#: app/frontend/pages/admin/plans/organizations.jsx
msgid "{0} — {visibility}, {marketplace}. The plan itself: which organizations hold it, and the feature templates a new subscription is copied from. Editing a template changes what future subscriptions start with, never an existing one."
msgstr "{0} — {visibility}, {marketplace}. The plan itself: which organizations hold it, and the feature templates a new subscription is copied from. Editing a template changes what future subscriptions start with, never an existing one."

#. placeholder {0}: monthLabel(snapshot.data?.period)
#. placeholder {0}: monthLabel(storage.data?.period)
#. placeholder {1}: pctOfTotal(snapshot.data?.value, total.data?.value)
#. placeholder {1}: pctOfTotal(storage.data?.value, total.data?.value)
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "{0} · {1}% of total spend"
msgstr "{0} · {1}% of total spend"

#. placeholder {0}: fmtCount(row.protected)
#. placeholder {0}: fmtCount(standard.passed)
#. placeholder {1}: fmtCount(row.eligible)
#. placeholder {1}: fmtCount(standard.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{0} / {1}"
msgstr "{0} / {1}"

#. placeholder {0}: num(coverage.protected)
#. placeholder {1}: num(coverage.total_ec2)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "{0} / {1} EC2 instances protected"
msgstr "{0} / {1} EC2 instances protected"

#. placeholder {0}: coverage.patched.toLocaleString()
#. placeholder {1}: coverage.total.toLocaleString()
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
msgid "{0} / {1} eligible instances"
msgstr "{0} / {1} eligible instances"

#. placeholder {0}: compliance.compliant.toLocaleString()
#. placeholder {1}: compliance.total.toLocaleString()
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/ComplianceCard.jsx
msgid "{0} / {1} instances"
msgstr "{0} / {1} instances"

#. placeholder {0}: fmtCount(resolved)
#. placeholder {1}: fmtCount(opened)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "{0} / {1} resolved"
msgstr "{0} / {1} resolved"

#. placeholder {0}: fmtCount(monitoring.finished)
#. placeholder {1}: fmtCount(monitoring.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "{0} / {1} resolved or closed"
msgstr "{0} / {1} resolved or closed"

#. placeholder {0}: entry.ago
#: app/frontend/pages/notifications/show.jsx
msgid "{0} ago"
msgstr "{0} ago"

#. placeholder {0}: parts[0]
#. placeholder {1}: parts[1]
#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "{0} and {1}"
msgstr "{0} and {1}"

#. placeholder {0}: inventory.backup_eligible_resources.toLocaleString()
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "{0} backup-eligible resources"
msgstr "{0} backup-eligible resources"

#. placeholder {0}: drRpo.breached
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "{0} breaching DR RPO"
msgstr "{0} breaching DR RPO"

#. placeholder {0}: rpo.breached
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0} breaching RPO"
msgstr "{0} breaching RPO"

#. placeholder {0}: rto.breached
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "{0} breaching RTO"
msgstr "{0} breaching RTO"

#. placeholder {0}: Math.round(seconds / 86400)
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{0} d"
msgstr "{0} d"

#. placeholder {0}: grace.days
#. placeholder {0}: row.age_days
#. placeholder {0}: sla.grace_period_days
#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{0} days"
msgstr "{0} days"

#. placeholder {0}: fmtCount(patchStatus.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{0} eligible instances"
msgstr "{0} eligible instances"

#. placeholder {0}: summary.evaluated
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{0} evaluated"
msgstr "{0} evaluated"

#. placeholder {0}: totals.services_failed
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{0} failed"
msgstr "{0} failed"

#. placeholder {0}: freeGrouped.reduce((n, f) => n + f.n, 0)
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "{0} free editions"
msgstr "{0} free editions"

#. placeholder {0}: r.size
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "{0} GiB"
msgstr "{0} GiB"

#. placeholder {0}: Math.round(seconds / 3600)
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{0} h"
msgstr "{0} h"

#. placeholder {0}: fmtCount(tickets.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{0} in this period"
msgstr "{0} in this period"

#. placeholder {0}: summary.breached
#: app/frontend/components/guardian/EC2AvailabilityTrendChart.jsx
msgid "{0} instances breached"
msgstr "{0} instances breached"

#. placeholder {0}: Math.round(seconds / 60)
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{0} min"
msgstr "{0} min"

#. placeholder {0}: Math.floor(days / 30)
#: app/frontend/utils/format.js
msgid "{0} months ago"
msgstr "{0} months ago"

#. placeholder {0}: num(failedChecks.failed)
#. placeholder {1}: num(failedChecks.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "{0} of {1} checks failed"
msgstr "{0} of {1} checks failed"

#. placeholder {0}: row.services_succeeded
#. placeholder {1}: row.services_total
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "{0} of {1} completed"
msgstr "{0} of {1} completed"

#. placeholder {0}: num(controls.controls_passed)
#. placeholder {1}: num(controls.controls_total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "{0} of {1} controls passed"
msgstr "{0} of {1} controls passed"

#. placeholder {0}: fmtCount(controls.passed)
#. placeholder {0}: num(standard.passed)
#. placeholder {1}: fmtCount(controls.total)
#. placeholder {1}: num(standard.total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "{0} of {1} passed"
msgstr "{0} of {1} passed"

#. placeholder {0}: fmtCount(coverage.protected)
#. placeholder {1}: fmtCount(coverage.eligible)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{0} of {1} resources protected"
msgstr "{0} of {1} resources protected"

#. placeholder {0}: run?.services_succeeded ?? 0
#. placeholder {1}: services.length
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
msgid "{0} of {1} services completed."
msgstr "{0} of {1} services completed."

#. placeholder {0}: fmtUsd(remaining - after_plan)
#. placeholder {1}: fmtUsd(remaining)
#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "{0} of {1} used by this plan"
msgstr "{0} of {1} used by this plan"

#. placeholder {0}: billing.fee_percent
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "{0} of bill"
msgstr "{0} of bill"

#. placeholder {0}: inventory.patch_instances.toLocaleString()
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "{0} patch-eligible instances"
msgstr "{0} patch-eligible instances"

#. placeholder {0}: endingSoon?.data?.count ?? 0
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "{0} reservations, next 60 days"
msgstr "{0} reservations, next 60 days"

#. placeholder {0}: resources.length
#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "{0} resources"
msgstr "{0} resources"

#. placeholder {0}: available.size
#. placeholder {0}: draft.length
#. placeholder {0}: resources.length
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerModal.jsx
msgid "{0} selected"
msgstr "{0} selected"

#. placeholder {0}: totals.services_stale
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{0} stale"
msgstr "{0} stale"

#. placeholder {0}: keys.length
#. placeholder {0}: tags.length
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "{0} tags"
msgstr "{0} tags"

#. placeholder {0}: fmtCount(monitoring.total)
#. placeholder {0}: fmtCount(summary.total)
#. placeholder {0}: fmtCount(total)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/TicketStatusCard.jsx
msgid "{0} tickets"
msgstr "{0} tickets"

#. placeholder {0}: fmtCount(totals.recommendation_count)
#. placeholder {0}: recommendation_count.toLocaleString('en-US')
#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{0} total"
msgstr "{0} total"

#. placeholder {0}: row.vcpus_available
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{0} vCPUs active today"
msgstr "{0} vCPUs active today"

#. placeholder {0}: fmtUsd(Math.abs(totals.savings_yearly))
#. placeholder {0}: money(savings_yearly)
#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{0}/yr projected"
msgstr "{0}/yr projected"

#. placeholder {0}: Math.round(grace.credit_cap * 100)
#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
msgid "{0}%"
msgstr "{0}%"

#. placeholder {0}: item.share_pct
#. placeholder {1}: item.typical_pct
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "{0}% · typical {1}%"
msgstr "{0}% · typical {1}%"

#. placeholder {0}: Math.round((current / capacity) * 100)
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{0}% of the new size"
msgstr "{0}% of the new size"

#. placeholder {0}: Math.round(((onDemand.data?.value ?? 0) / total.data.value) * 100)
#. placeholder {0}: Math.round(((onDemandTrend?.data?.value ?? 0) / totalTrend.data.value) * 100)
#. placeholder {0}: Math.round(((reserved.data?.value ?? 0) / total.data.value) * 100)
#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "{0}% of total spend"
msgstr "{0}% of total spend"

#. placeholder {0}: ha.production
#. placeholder {0}: standard.production
#. placeholder {1}: ha.non_production
#. placeholder {1}: standard.non_production
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{0}% production / {1}% non-production"
msgstr "{0}% production / {1}% non-production"

#. placeholder {0}: totals.services_analyzed
#. placeholder {1}: totals.services_total
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{0}<0> of {1}</0>"
msgstr "{0}<0> of {1}</0>"

#. placeholder {0}: Math.floor(minutes / 60)
#. placeholder {1}: minutes % 60
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "{0}h {1}m"
msgstr "{0}h {1}m"

#. placeholder {0}: row.term
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{0}y"
msgstr "{0}y"

#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "{awsAccounts, plural, one {# AWS account} other {# AWS accounts}}"
msgstr "{awsAccounts, plural, one {# AWS account} other {# AWS accounts}}"

#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "{azureSubscriptions, plural, one {# Azure subscription} other {# Azure subscriptions}}"
msgstr "{azureSubscriptions, plural, one {# Azure subscription} other {# Azure subscriptions}}"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
msgid "{count, plural, one {# AWS account} other {# AWS accounts}}"
msgstr "{count, plural, one {# AWS account} other {# AWS accounts}}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/BreachCard.jsx
msgid "{count, plural, one {# instance breaching its SLA} other {# instances breaching their SLA}}"
msgstr "{count, plural, one {# instance breaching its SLA} other {# instances breaching their SLA}}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "{count, plural, one {# operation} other {# operations}}"
msgstr "{count, plural, one {# operation} other {# operations}}"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
msgid "{count, plural, one {# Resource Group} other {# Resource Groups}}"
msgstr "{count, plural, one {# Resource Group} other {# Resource Groups}}"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} databases · {amount} per month, counted"
msgstr "{count} databases · {amount} per month, counted"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} databases · {amount} per month, not counted"
msgstr "{count} databases · {amount} per month, not counted"

#. placeholder {0}: items.length
#: app/frontend/components/optimization_dashboard/schedule/RecommendationGroup.jsx
msgid "{count} of {0} selected"
msgstr "{count} of {0} selected"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} VMs · {amount} per month, counted"
msgstr "{count} VMs · {amount} per month, counted"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} VMs · {amount} per month, not counted"
msgstr "{count} VMs · {amount} per month, not counted"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} VMs · {cores} licence cores · {amount} per month, counted"
msgstr "{count} VMs · {cores} licence cores · {amount} per month, counted"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{count} VMs · {cores} licence cores · {amount} per month, not counted"
msgstr "{count} VMs · {cores} licence cores · {amount} per month, not counted"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "{cutoff}h"
msgstr "{cutoff}h"

#: app/frontend/pages/users/admin_tokens/new.jsx
#: app/frontend/utils/format_duration.js
msgid "{days, plural, one {# day} other {# days}}"
msgstr "{days, plural, one {# day} other {# days}}"

#: app/frontend/utils/format.js
msgid "{days} days ago"
msgstr "{days} days ago"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "{duration}h"
msgstr "{duration}h"

#: app/frontend/utils/format_duration.js
msgid "{hours}h"
msgstr "{hours}h"

#: app/frontend/utils/format_duration.js
msgid "{hours}h {minutes}m"
msgstr "{hours}h {minutes}m"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "{inSets} of {total} VMs are in an Availability Set"
msgstr "{inSets} of {total} VMs are in an Availability Set"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
msgid "{instanceCount, plural, one {# instance without a successful patch in the period} other {# instances without a successful patch in the period}}"
msgstr "{instanceCount, plural, one {# instance without a successful patch in the period} other {# instances without a successful patch in the period}}"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "{label} is required"
msgstr "{label} is required"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{maintenanceHours} h / month"
msgstr "{maintenanceHours} h / month"

#: app/frontend/pages/users/settings/password.jsx
msgid "{minLength, plural, one {# character minimum} other {# characters minimum}}"
msgstr "{minLength, plural, one {# character minimum} other {# characters minimum}}"

#: app/frontend/utils/format_duration.js
msgid "{minutes} min"
msgstr "{minutes} min"

#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "{minutes}m"
msgstr "{minutes}m"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "{months} months left"
msgstr "{months} months left"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{n} breaching RPO"
msgstr "{n} breaching RPO"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "{n} breaching RTO"
msgstr "{n} breaching RTO"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "{nonProduction, plural, one {# non-production account} other {# non-production accounts}}"
msgstr "{nonProduction, plural, one {# non-production account} other {# non-production accounts}}"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "{passwordMinLength, plural, one {# character minimum} other {# characters minimum}}"
msgstr "{passwordMinLength, plural, one {# character minimum} other {# characters minimum}}"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "{production, plural, one {# production account} other {# production accounts}}"
msgstr "{production, plural, one {# production account} other {# production accounts}}"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "{production} production, {nonProduction} non-production"
msgstr "{production} production, {nonProduction} non-production"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ComplianceCard.jsx
msgid "{protectedCount}/{eligible} eligible resources"
msgstr "{protectedCount}/{eligible} eligible resources"

#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "{replacedCount} resources with a replaced value"
msgstr "{replacedCount} resources with a replaced value"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "{restore} / TB"
msgstr "{restore} / TB"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "{reversible_pct}% reversible within a year"
msgstr "{reversible_pct}% reversible within a year"

#: app/frontend/utils/format_duration.js
msgid "{s} sec"
msgstr "{s} sec"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "{selectedCount} selected"
msgstr "{selectedCount} selected"

#: app/frontend/components/optimization_dashboard/RunSwitcher.jsx
msgid "{shown, plural, one {# run} other {# runs}}"
msgstr "{shown, plural, one {# run} other {# runs}}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "{sign}{delta} pp"
msgstr "{sign}{delta} pp"

#: app/frontend/components/optimization_dashboard/PercentileMetricChart.jsx
msgid "{title} percentile"
msgstr "{title} percentile"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/RequestTypeCard.jsx
msgid "{total} tickets"
msgstr "{total} tickets"

#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "{unanalyzed} never analyzed"
msgstr "{unanalyzed} never analyzed"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "{unattachedCount} volumes"
msgstr "{unattachedCount} volumes"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# failed check (crit/high)} other {# failed checks (crit/high)}}"
msgstr "{v, plural, one {# failed check (crit/high)} other {# failed checks (crit/high)}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# instance without a patch group} other {# instances without a patch group}}"
msgstr "{v, plural, one {# instance without a patch group} other {# instances without a patch group}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# resource without backup} other {# resources without backup}}"
msgstr "{v, plural, one {# resource without backup} other {# resources without backup}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# RPO breach} other {# RPO breaches}}"
msgstr "{v, plural, one {# RPO breach} other {# RPO breaches}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# RTO breach} other {# RTO breaches}}"
msgstr "{v, plural, one {# RTO breach} other {# RTO breaches}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {# ticket missed resolution SLA} other {# tickets missed resolution SLA}}"
msgstr "{v, plural, one {# ticket missed resolution SLA} other {# tickets missed resolution SLA}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {Avg resolution over SLA (# priority)} other {Avg resolution over SLA (# priorities)}}"
msgstr "{v, plural, one {Avg resolution over SLA (# priority)} other {Avg resolution over SLA (# priorities)}}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "{v, plural, one {Avg response over SLA (# priority)} other {Avg response over SLA (# priorities)}}"
msgstr "{v, plural, one {Avg response over SLA (# priority)} other {Avg response over SLA (# priorities)}}"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "* To ensure uniformity across the charts, the data imported is consistently set to a three-day delay (D-3)."
msgstr "* To ensure uniformity across the charts, the data imported is consistently set to a three-day delay (D-3)."

#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "/mo"
msgstr "/mo"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "/mo committed"
msgstr "/mo committed"

#: app/frontend/layout/footer.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "© {year} skie.io."
msgstr "© {year} skie.io."

#. placeholder {0}: values.length - limit
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "+{0} more"
msgstr "+{0} more"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "<0>Before <1>Step 3</1></0>, you will also need some additional information from your Skie.io consultant: your company's <2>Organization ID</2> and <3>Organization API Token</3>."
msgstr "<0>Before <1>Step 3</1></0>, you will also need some additional information from your Skie.io consultant: your company's <2>Organization ID</2> and <3>Organization API Token</3>."

#. placeholder {0}: fmtPct(ri_savings_rate)
#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "<0>Compute SCORE</0> data sources: savings_plans_utilization_monthly (ComputeSavingsPlans & EC2InstanceSavingsPlans), ec2_reservation_utilizations_monthly (all EC2 RIs), cost_and_usage_by_service_monthly (On Demand Instances — EC2, ECS, EKS, Lambda). · <1>Database SCORE</1>: fixed {0} RI savings rate · cost_and_usage_by_service_monthly (Standard Reserved Instances & On Demand Instances — RDS, ElastiCache, OpenSearch, Redshift, DocumentDB)."
msgstr "<0>Compute SCORE</0> data sources: savings_plans_utilization_monthly (ComputeSavingsPlans & EC2InstanceSavingsPlans), ec2_reservation_utilizations_monthly (all EC2 RIs), cost_and_usage_by_service_monthly (On Demand Instances — EC2, ECS, EKS, Lambda). · <1>Database SCORE</1>: fixed {0} RI savings rate · cost_and_usage_by_service_monthly (Standard Reserved Instances & On Demand Instances — RDS, ElastiCache, OpenSearch, Redshift, DocumentDB)."

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/created.jsx
msgid "<0>Important:</0> copy your token now and save it securely. If you lose your token, you will not be able to recover it and will need to create a new one."
msgstr "<0>Important:</0> copy your token now and save it securely. If you lose your token, you will not be able to recover it and will need to create a new one."

#. placeholder {0}: (min_coverage * 100).toFixed(1)
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "<0>Services covered:</0> EC2, RDS, S3, ECS, EKS. ElastiCache, Lambda and CloudFront are excluded — no resource-level tag data available. · <1>System keys excluded:</1> aws:, skie-io:, user:ops:, eks:, kubernetes.io/, k8s.io/ and other infrastructure-managed prefixes. · <2>Compliant</2> means the tag key exists with a non-empty value. · <3>Min coverage</3> filters out keys that appear on fewer than {0}% of total resources."
msgstr "<0>Services covered:</0> EC2, RDS, S3, ECS, EKS. ElastiCache, Lambda and CloudFront are excluded — no resource-level tag data available. · <1>System keys excluded:</1> aws:, skie-io:, user:ops:, eks:, kubernetes.io/, k8s.io/ and other infrastructure-managed prefixes. · <2>Compliant</2> means the tag key exists with a non-empty value. · <3>Min coverage</3> filters out keys that appear on fewer than {0}% of total resources."

#. placeholder {0}: formatDuration(targetSeconds)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "≤ {0}"
msgstr "≤ {0}"

#. placeholder {0}: row[targetKey]
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "≤ {0}"
msgstr "≤ {0}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
msgid "≤ {label}"
msgstr "≤ {label}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
msgid "≤ {label}/TB"
msgstr "≤ {label}/TB"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "≥80% green · ≥50% yellow · <50% red"
msgstr "≥80% green · ≥50% yellow · <50% red"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hello! How can I assist you today?"
msgstr "👋 Hello! How can I assist you today?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hello! Let me know how I can help you today!"
msgstr "👋 Hello! Let me know how I can help you today!"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hello! What can I do for you today?"
msgstr "👋 Hello! What can I do for you today?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hey there! What can I do for you?"
msgstr "👋 Hey there! What can I do for you?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hey! Great to see you here, how can I help?"
msgstr "👋 Hey! Great to see you here, how can I help?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hey! I’m here to help, let’s chat!"
msgstr "👋 Hey! I’m here to help, let’s chat!"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hi there! Let’s get started—what’s on your mind?"
msgstr "👋 Hi there! Let’s get started—what’s on your mind?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hi! Hope you’re having a great day, need help?"
msgstr "👋 Hi! Hope you’re having a great day, need help?"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hi! Ready to dive in? Let me assist you!"
msgstr "👋 Hi! Ready to dive in? Let me assist you!"

#: app/frontend/components/chat/greetings.js
msgid "👋 Hi! What do you need assistance with?"
msgstr "👋 Hi! What do you need assistance with?"

#. placeholder {0}: feature.terms.cloudflex_fee
#. placeholder {1}: feature.terms.cloudflex_quantity
#: app/frontend/pages/dashboard/subscriptions/sections/CloudFlexSection.jsx
msgid "${0} for {1} units"
msgstr "${0} for {1} units"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "$/GiB RAM-hr · trailing 18 months"
msgstr "$/GiB RAM-hr · trailing 18 months"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "0 (any)"
msgstr "0 (any)"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "0 green · any value red"
msgstr "0 green · any value red"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "0 green · any value yellow"
msgstr "0 green · any value yellow"

#: app/frontend/utils/format_duration.js
msgid "0 sec"
msgstr "0 sec"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "1 Month"
msgstr "1 Month"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "1 Week"
msgstr "1 Week"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "1440 (1 day)"
msgstr "1440 (1 day)"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "1d Utilization"
msgstr "1d Utilization"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "240 (4h)"
msgstr "240 (4h)"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "3 Months"
msgstr "3 Months"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "30-day average · Virtual Machines reservations"
msgstr "30-day average · Virtual Machines reservations"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "30-Day Detection Trend"
msgstr "30-Day Detection Trend"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "30d utilization"
msgstr "30d utilization"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "30d Utilization"
msgstr "30d Utilization"

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "6-digit code"
msgstr "6-digit code"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "6-month trend"
msgstr "6-month trend"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "60 (1h)"
msgstr "60 (1h)"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "7d Utilization"
msgstr "7d Utilization"

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "99.5% production / 95.0% non-production monthly uptime target."
msgstr "99.5% production / 95.0% non-production monthly uptime target."

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "99.9% production / 95.0% non-production monthly uptime target."
msgstr "99.9% production / 95.0% non-production monthly uptime target."

#: app/frontend/components/guardian/help/patch_management.js
msgid "A change request is one maintenance window. It patches every server in its scope at the same time, and each server runs its own execution — one may fail while the others succeed."
msgstr "A change request is one maintenance window. It patches every server in its scope at the same time, and each server runs its own execution — one may fail while the others succeed."

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
msgid "A Change Request scheduler for organizations with a Guardian subscription that has the \"Automatic Opening of Change Requests\" option enabled."
msgstr "A Change Request scheduler for organizations with a Guardian subscription that has the \"Automatic Opening of Change Requests\" option enabled."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "A disbursement attempt failed; this negates that transaction."
msgstr "A disbursement attempt failed; this negates that transaction."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "A dot marks clusters that override this global default."
msgstr "A dot marks clusters that override this global default."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "A dot marks instances that override this global default."
msgstr "A dot marks instances that override this global default."

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "A paid SQL Server edition is installed but AWS bills no SQL license for the host."
msgstr "A paid SQL Server edition is installed but AWS bills no SQL license for the host."

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "A paid SQL Server edition is installed that AWS does not license: BYOL, or the installed edition differs from the licensed one. Free editions (Developer, Express, Internal) never count."
msgstr "A paid SQL Server edition is installed that AWS does not license: BYOL, or the installed edition differs from the licensed one. Free editions (Developer, Express, Internal) never count."

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "A run is already in progress. Wait for it to finish before starting another."
msgstr "A run is already in progress. Wait for it to finish before starting another."

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "A snapshot of the settings in effect when this optimization was triggered."
msgstr "A snapshot of the settings in effect when this optimization was triggered."

#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "A unique identifier used internally to reference this plan."
msgstr "A unique identifier used internally to reference this plan."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Abort after (days)"
msgstr "Abort after (days)"

#: app/frontend/components/guardian/GuardianHelpDrawer.jsx
msgid "About"
msgstr "About"

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Above typical"
msgstr "Above typical"

#: app/frontend/pages/dashboard/invitation_acceptances/show.jsx
msgid "Accept invitation"
msgstr "Accept invitation"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Acceptable"
msgstr "Acceptable"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Access Keys Auth"
msgstr "Access Keys Auth"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Access tier"
msgstr "Access tier"

#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Access Tier"
msgstr "Access Tier"

#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "Access Tier Status"
msgstr "Access Tier Status"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/baselines/index.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Account"
msgstr "Account"

#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
msgid "Account Alias"
msgstr "Account Alias"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Account associations"
msgstr "Account associations"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Account email"
msgstr "Account email"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "Account ID"
msgstr "Account ID"

#: app/frontend/layout/top_bar.jsx
msgid "Account menu"
msgstr "Account menu"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Account name"
msgstr "Account name"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Account Name"
msgstr "Account Name"

#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Account Status"
msgstr "Account Status"

#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Account Subtype"
msgstr "Account Subtype"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "Account type"
msgstr "Account type"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Account Type"
msgstr "Account Type"

#: app/frontend/components/guardian/GuardianAccountsDrawer.jsx
msgid "Accounts"
msgstr "Accounts"

#: app/frontend/pages/admin/billing_organizations/index.jsx
msgid "Accounts with Billing enabled"
msgstr "Accounts with Billing enabled"

#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
msgid "Accounts with Billing V2 enabled"
msgstr "Accounts with Billing V2 enabled"

#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
msgid "Accounts with Guardian Billing enabled"
msgstr "Accounts with Guardian Billing enabled"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Acknowledge"
msgstr "Acknowledge"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "across all connected subscriptions"
msgstr "across all connected subscriptions"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Across EC2 and RDS. Paid SQL Server that AWS does not license (BYOL or edition mismatch)."
msgstr "Across EC2 and RDS. Paid SQL Server that AWS does not license (BYOL or edition mismatch)."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Across the cohort, compute the distribution of client_share values:"
msgstr "Across the cohort, compute the distribution of client_share values:"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Action"
msgstr "Action"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Action date"
msgstr "Action date"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "Action Details"
msgstr "Action Details"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Actionable"
msgstr "Actionable"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Actionable findings of minor risk."
msgstr "Actionable findings of minor risk."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Actionable findings of moderate risk."
msgstr "Actionable findings of moderate risk."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Actionable findings requiring prompt attention."
msgstr "Actionable findings requiring prompt attention."

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "Actionable recommendations"
msgstr "Actionable recommendations"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
msgid "Actionable recommendations propose a real change (e.g. a different instance type) and can be scheduled. The total also counts instances already optimally sized."
msgstr "Actionable recommendations propose a real change (e.g. a different instance type) and can be scheduled. The total also counts instances already optimally sized."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Actions & transaction types"
msgstr "Actions & transaction types"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
msgid "Actions are changes created from recommendations (e.g. a resize or a Saving Plan purchase). The breakdown shows how many are already applied, still pending, or cancelled."
msgstr "Actions are changes created from recommendations (e.g. a resize or a Saving Plan purchase). The breakdown shows how many are already applied, still pending, or cancelled."

#: app/frontend/components/table/RowActions.jsx
msgid "Actions for {label}"
msgstr "Actions for {label}"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "Active"
msgstr "Active"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Active AWS Security Hub findings in the selected period, counted by actionable severity (Critical/High/Medium/Low). Informational findings carry no severity and are listed separately."
msgstr "Active AWS Security Hub findings in the selected period, counted by actionable severity (Critical/High/Medium/Low). Informational findings carry no severity and are listed separately."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Active AWS Security Hub Standard findings in the selected period. Excludes Informational (controls that passed), which are shown separately."
msgstr "Active AWS Security Hub Standard findings in the selected period. Excludes Informational (controls that passed), which are shown separately."

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/MetricsSection.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/MetricsSection.jsx
msgid "Active Connections"
msgstr "Active Connections"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Active findings"
msgstr "Active findings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Active findings by severity"
msgstr "Active findings by severity"

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Active Services"
msgstr "Active Services"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Active SLA breaches"
msgstr "Active SLA breaches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Active threats"
msgstr "Active threats"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Active threats by severity"
msgstr "Active threats by severity"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/utils/azure.js
msgid "Actual Cost"
msgstr "Actual Cost"

#: app/frontend/components/aws/RDSMetricsSection.jsx
msgid "ACU Utilization"
msgstr "ACU Utilization"

#: app/frontend/components/optimizer/ResourcePickerDrawer.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Add"
msgstr "Add"

#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
msgid "Add account"
msgstr "Add account"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Add an exception for a specific cluster to skip it, set its autoscaling mode, or override its buffer, percentile, and node minimums."
msgstr "Add an exception for a specific cluster to skip it, set its autoscaling mode, or override its buffer, percentile, and node minimums."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Add an exception for a specific instance to skip it, set a SAP HANA workload kind, or override its buffer and percentile."
msgstr "Add an exception for a specific instance to skip it, set a SAP HANA workload kind, or override its buffer and percentile."

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "Add AWS Account"
msgstr "Add AWS Account"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "Add Azure Credential"
msgstr "Add Azure Credential"

#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
msgid "Add Azure Subscription"
msgstr "Add Azure Subscription"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Add Cluster"
msgstr "Add Cluster"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "Add Database Setting"
msgstr "Add Database Setting"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
msgid "Add Database Settings"
msgstr "Add Database Settings"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Add Domain"
msgstr "Add Domain"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Add EC2 Instance"
msgstr "Add EC2 Instance"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Add EC2 Instance Setting"
msgstr "Add EC2 Instance Setting"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "Add EC2 Instance Settings"
msgstr "Add EC2 Instance Settings"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Add EKS Cluster"
msgstr "Add EKS Cluster"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Add EKS Cluster Setting"
msgstr "Add EKS Cluster Setting"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Add EKS Cluster Settings"
msgstr "Add EKS Cluster Settings"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Add ElastiCache Cluster"
msgstr "Add ElastiCache Cluster"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "Add ElastiCache Cluster Setting"
msgstr "Add ElastiCache Cluster Setting"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
msgid "Add ElastiCache Cluster Settings"
msgstr "Add ElastiCache Cluster Settings"

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
msgid "Add filter"
msgstr "Add filter"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Add HPA"
msgstr "Add HPA"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Add Instance"
msgstr "Add Instance"

#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "Add Instance Credential"
msgstr "Add Instance Credential"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Add Opensearch Cluster Setting"
msgstr "Add Opensearch Cluster Setting"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Add Opensearch Cluster Settings"
msgstr "Add Opensearch Cluster Settings"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Add OpenSearch Domain"
msgstr "Add OpenSearch Domain"

#: app/frontend/pages/dashboard/organizations/index.jsx
msgid "Add organization"
msgstr "Add organization"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Add RDS Instance"
msgstr "Add RDS Instance"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Add RDS Instance Setting"
msgstr "Add RDS Instance Setting"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
msgid "Add RDS Instance Settings"
msgstr "Add RDS Instance Settings"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Add the following bucket policy to allow the <0>bcm-data-exports.amazonaws.com</0> service to write report files and to allow Skie.io to read them. Replace <1>YOUR_ACCOUNT_ID</1> with your AWS account ID:"
msgstr "Add the following bucket policy to allow the <0>bcm-data-exports.amazonaws.com</0> service to write report files and to allow Skie.io to read them. Replace <1>YOUR_ACCOUNT_ID</1> with your AWS account ID:"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Add the instances to a patch resource group, or apply the skie-io:patch:disable tag if exclusion is intentional."
msgstr "Add the instances to a patch resource group, or apply the skie-io:patch:disable tag if exclusion is intentional."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Add to the relevant backup plan, or skip-tag if exclusion is intentional."
msgstr "Add to the relevant backup plan, or skip-tag if exclusion is intentional."

#: app/frontend/pages/admin/service_users/show.jsx
msgid "Add trusted key"
msgstr "Add trusted key"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Add Virtual Machine Setting"
msgstr "Add Virtual Machine Setting"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Add Virtual Machine Settings"
msgstr "Add Virtual Machine Settings"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Added"
msgstr "Added"

#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "Adds every resource that matches the current filters, from all pages."
msgstr "Adds every resource that matches the current filters, from all pages."

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
msgid "Adjusted Savings"
msgstr "Adjusted Savings"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/admin/reseller_organizations/index.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Admin"
msgstr "Admin"

#: app/frontend/pages/admin/users/show.jsx
msgctxt "user attribute"
msgid "Admin"
msgstr "Admin"

#: app/frontend/pages/users/admin_tokens/created.jsx
msgid "Admin token created"
msgstr "Admin token created"

#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Admin tokens"
msgstr "Admin tokens"

#: app/frontend/pages/users/admin_tokens/created.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Admin tokens are for personal use only. Don't use them in automations or other systems. Use a service user instead."
msgstr "Admin tokens are for personal use only. Don't use them in automations or other systems. Use a service user instead."

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Admin User"
msgstr "Admin User"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Admin Username"
msgstr "Admin Username"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Administrative Actions"
msgstr "Administrative Actions"

#: app/frontend/pages/admin/admins/index.jsx
#: app/frontend/pages/admin/users/UsersSectionNav.jsx
msgid "Admins"
msgstr "Admins"

#: app/frontend/pages/admin/admins/index.jsx
msgid "Admins are users who have access to all organizations on Zee. They don't need to be invited and are restricted to users with an @skie.io email address."
msgstr "Admins are users who have access to all organizations on Zee. They don't need to be invited and are restricted to users with an @skie.io email address."

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Advanced — Includes Flex + skie.io manages infrastructure, provisioning, and access. Requires a non-prod environment per production environment."
msgstr "Advanced — Includes Flex + skie.io manages infrastructure, provisioning, and access. Requires a non-prod environment per production environment."

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Advanced (Non-Production)"
msgstr "Advanced (Non-Production)"

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Advanced Backup Settings"
msgstr "Advanced Backup Settings"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "Advanced Configurations"
msgstr "Advanced Configurations"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "affected"
msgstr "affected"

#. placeholder {0}: offending.map((type) => type.type).join(', ')
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Affected: {0}"
msgstr "Affected: {0}"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "After approval, the Change will be scheduled to be executed in the Change Scheduler."
msgstr "After approval, the Change will be scheduled to be executed in the Change Scheduler."

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "after recommended cancellations"
msgstr "after recommended cancellations"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "After the export is created, AWS will begin delivering CUR 2.0 reports to your S3 bucket. The first report may take up to 24 hours to appear."
msgstr "After the export is created, AWS will begin delivering CUR 2.0 reports to your S3 bucket. The first report may take up to 24 hours to appear."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "After these settings are configured, Skie.io will be able to perform the enabled write actions in your AWS account."
msgstr "After these settings are configured, Skie.io will be able to perform the enabled write actions in your AWS account."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "After these settings are configured, Skie.io will begin collecting the necessary data from the AWS account. Once the data is collected, a cost analysis will be performed."
msgstr "After these settings are configured, Skie.io will begin collecting the necessary data from the AWS account. Once the data is collected, a cost analysis will be performed."

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "After this operation, the Change will be canceled and no operation will be performed in the Change Scheduler."
msgstr "After this operation, the Change will be canceled and no operation will be performed in the Change Scheduler."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Age"
msgstr "Age"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Agent Version"
msgstr "Agent Version"

#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
msgid "Agreement"
msgstr "Agreement"

#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Agreement Type"
msgstr "Agreement Type"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "AHB Opportunity by Subscription"
msgstr "AHB Opportunity by Subscription"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Align the installed edition with the billed one."
msgstr "Align the installed edition with the billed one."

#: app/frontend/components/FinopsFilterBar.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "All"
msgstr "All"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "All accounts"
msgstr "All accounts"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "All availability zones"
msgstr "All availability zones"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "All available organizations are already subscribed to this plan."
msgstr "All available organizations are already subscribed to this plan."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "All cache node types"
msgstr "All cache node types"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "All DB instance classes"
msgstr "All DB instance classes"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
msgid "All eligible instances are patched or not yet due"
msgstr "All eligible instances are patched or not yet due"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "All engine versions"
msgstr "All engine versions"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "All engines"
msgstr "All engines"

#: app/frontend/components/DonutLegend.jsx
msgid "All entries"
msgstr "All entries"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "All Events"
msgstr "All Events"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "All Guardian services are inactive — turn on the master toggle in the plan configuration."
msgstr "All Guardian services are inactive — turn on the master toggle in the plan configuration."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "All instance types"
msgstr "All instance types"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/BreachCard.jsx
msgid "All instances are meeting their SLA"
msgstr "All instances are meeting their SLA"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "All locations"
msgstr "All locations"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "All Nodegroups"
msgstr "All Nodegroups"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "All Nodes"
msgstr "All Nodes"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "All plans have jobs"
msgstr "All plans have jobs"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "All provisioning states"
msgstr "All provisioning states"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "All regions"
msgstr "All regions"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "All required steps are documented below. If you have any questions, feel free to reach out to"
msgstr "All required steps are documented below. If you have any questions, feel free to reach out to"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "All states"
msgstr "All states"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "All statuses"
msgstr "All statuses"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "All subscriptions"
msgstr "All subscriptions"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "All tenancies"
msgstr "All tenancies"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "All time, all connected accounts"
msgstr "All time, all connected accounts"

#: app/frontend/components/RankedBarLegend.jsx
msgid "All types"
msgstr "All types"

#: app/frontend/utils/aws.js
msgid "All Upfront"
msgstr "All Upfront"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "All usage operations"
msgstr "All usage operations"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "All versions"
msgstr "All versions"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "All VM sizes"
msgstr "All VM sizes"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "All within DR RPO"
msgstr "All within DR RPO"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "All within RPO"
msgstr "All within RPO"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "All within RTO"
msgstr "All within RTO"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Allocated Storage"
msgstr "Allocated Storage"

#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
msgid "Allocation"
msgstr "Allocation"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Allocation ID"
msgstr "Allocation ID"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Allocation Time"
msgstr "Allocation Time"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Allow Blob Public Access"
msgstr "Allow Blob Public Access"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Allowed Roles"
msgstr "Allowed Roles"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Allows Multiple Instance Types"
msgstr "Allows Multiple Instance Types"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Already checked for you: this is a data disk, LRS, with on-demand bursting off, on a zonal VM."
msgstr "Already checked for you: this is a data disk, LRS, with on-demand bursting off, on a zonal VM."

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Already have an account?"
msgstr "Already have an account?"

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Also show unusual spend to"
msgstr "Also show unusual spend to"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Amazon Elastic Compute Cloud (EC2) - Compute EC2 - Other"
msgstr "Amazon Elastic Compute Cloud (EC2) - Compute EC2 - Other"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Amazon Elastic Container Service"
msgstr "Amazon Elastic Container Service"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Amazon Relational Database Service (RDS)"
msgstr "Amazon Relational Database Service (RDS)"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Amazon Simple Storage Service (S3)"
msgstr "Amazon Simple Storage Service (S3)"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/utils/aws.js
msgid "Amortized"
msgstr "Amortized"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/utils/azure.js
msgid "Amortized Cost"
msgstr "Amortized Cost"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Amount"
msgstr "Amount"

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "An active Red Hat subscription with Cloud Access; attach the VM with subscription-manager after the change."
msgstr "An active Red Hat subscription with Cloud Access; attach the VM with subscription-manager after the change."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "An active SUSE subscription for this VM; register it with SUSEConnect after the change."
msgstr "An active SUSE subscription for this VM; register it with SUSEConnect after the change."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "An adjustment AWS made to resolve an invoicing issue."
msgstr "An adjustment AWS made to resolve an invoicing issue."

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "An instance with no data (not enough collected minutes to compute a percentage yet) is treated as a breach, not as compliant."
msgstr "An instance with no data (not enough collected minutes to compute a percentage yet) is treated as a breach, not as compliant."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "An online CrowdStrike Falcon agent is reporting for the EC2 instance."
msgstr "An online CrowdStrike Falcon agent is reporting for the EC2 instance."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "An optional group name to categorize this setting."
msgstr "An optional group name to categorize this setting."

#: app/frontend/components/aws_portfolio/dashboard.jsx
msgid "An owner can run the optimizer to generate one."
msgstr "An owner can run the optimizer to generate one."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Analytics"
msgstr "Analytics"

#: app/frontend/pages/dashboard/resource_groups/TagClauses.jsx
msgid "and"
msgstr "and"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "and pressing <0>Enter</0>."
msgstr "and pressing <0>Enter</0>."

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Anomaly ID"
msgstr "Anomaly ID"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Any"
msgstr "Any"

#: app/frontend/pages/dashboard/organization_tokens/DeleteTokenModal.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Anything still calling the API with this token stops working immediately. The token cannot be restored."
msgstr "Anything still calling the API with this token stops working immediately. The token cannot be restored."

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
msgid "API Tokens"
msgstr "API Tokens"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "App Service Plan"
msgstr "App Service Plan"

#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
msgid "App Service Plan ID"
msgstr "App Service Plan ID"

#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
msgid "App Service Plans"
msgstr "App Service Plans"

#: app/frontend/layout/top_bar.jsx
msgid "Appearance"
msgstr "Appearance"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Application"
msgstr "Application"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Application Administrator"
msgstr "Application Administrator"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Application Developer"
msgstr "Application Developer"

#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
msgid "Application Gateway ID"
msgstr "Application Gateway ID"

#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
msgid "Application Gateways"
msgstr "Application Gateways"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
msgid "applied"
msgstr "applied"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Applied as the default across every resource type unless overridden below."
msgstr "Applied as the default across every resource type unless overridden below."

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Applied Scope Properties"
msgstr "Applied Scope Properties"

#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Applied Scope Type"
msgstr "Applied Scope Type"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Applies on the next OS patch"
msgstr "Applies on the next OS patch"

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerModal.jsx
msgid "Apply"
msgstr "Apply"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "Apply as standalone actions with a Change Request"
msgstr "Apply as standalone actions with a Change Request"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Apply CPU Recommendation"
msgstr "Apply CPU Recommendation"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "Apply during the next OS patch"
msgstr "Apply during the next OS patch"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Apply during the next OS patch maintenance window"
msgstr "Apply during the next OS patch maintenance window"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Apply Memory Recommendation"
msgstr "Apply Memory Recommendation"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Apply the tag to the EC2 instance."
msgstr "Apply the tag to the EC2 instance."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Applying a recommendation"
msgstr "Applying a recommendation"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Approaching"
msgstr "Approaching"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Approval Rules"
msgstr "Approval Rules"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Approve"
msgstr "Approve"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Approved"
msgstr "Approved"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Approved by"
msgstr "Approved by"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Approved Patches"
msgstr "Approved Patches"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Architecture"
msgstr "Architecture"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Architectures"
msgstr "Architectures"

#: app/frontend/pages/notifications/index.jsx
#: app/frontend/pages/notifications/show.jsx
msgid "Archive"
msgstr "Archive"

#: app/frontend/pages/notifications/show.jsx
msgid "Archived"
msgstr "Archived"

#: app/frontend/pages/notifications/show.jsx
msgid "Archived by"
msgstr "Archived by"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Are you sure you want to approve the Change Request?"
msgstr "Are you sure you want to approve the Change Request?"

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to block this user?"
msgstr "Are you sure you want to block this user?"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Are you sure you want to cancel the Change Request?"
msgstr "Are you sure you want to cancel the Change Request?"

#. placeholder {0}: maintenance_window.name
#. placeholder {0}: row.name
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Are you sure you want to delete \"{0}\"? Its resources will become unassigned."
msgstr "Are you sure you want to delete \"{0}\"? Its resources will become unassigned."

#. placeholder {0}: resource_group.name
#. placeholder {0}: row.name
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Are you sure you want to delete \"{0}\"? This cannot be undone."
msgstr "Are you sure you want to delete \"{0}\"? This cannot be undone."

#. placeholder {0}: row.display_id
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Are you sure you want to delete run {0}? This cannot be undone."
msgstr "Are you sure you want to delete run {0}? This cannot be undone."

#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
msgid "Are you sure you want to delete this feature? This cannot be undone."
msgstr "Are you sure you want to delete this feature? This cannot be undone."

#: app/frontend/components/optimizations/OptimizationsListing.jsx
msgid "Are you sure you want to delete this optimization? This cannot be undone."
msgstr "Are you sure you want to delete this optimization? This cannot be undone."

#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "Are you sure you want to delete this plan feature? This cannot be undone."
msgstr "Are you sure you want to delete this plan feature? This cannot be undone."

#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
msgid "Are you sure you want to delete this service user? This cannot be undone."
msgstr "Are you sure you want to delete this service user? This cannot be undone."

#: app/frontend/pages/admin/tag_templates/show.jsx
msgid "Are you sure you want to delete this tag template? This cannot be undone."
msgstr "Are you sure you want to delete this tag template? This cannot be undone."

#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
msgid "Are you sure you want to delete this trusted key? This cannot be undone."
msgstr "Are you sure you want to delete this trusted key? This cannot be undone."

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to delete this user? This cannot be undone."
msgstr "Are you sure you want to delete this user? This cannot be undone."

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to grant admin permissions to this user?"
msgstr "Are you sure you want to grant admin permissions to this user?"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Are you sure you want to import Azure Reservations?"
msgstr "Are you sure you want to import Azure Reservations?"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Are you sure you want to reject the Change Request?"
msgstr "Are you sure you want to reject the Change Request?"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following Database?"
msgstr "Are you sure you want to remove the settings for the following Database?"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following EC2 instance?"
msgstr "Are you sure you want to remove the settings for the following EC2 instance?"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following EKS cluster?"
msgstr "Are you sure you want to remove the settings for the following EKS cluster?"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following ElastiCache cluster?"
msgstr "Are you sure you want to remove the settings for the following ElastiCache cluster?"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following Opensearch cluster?"
msgstr "Are you sure you want to remove the settings for the following Opensearch cluster?"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following RDS instance?"
msgstr "Are you sure you want to remove the settings for the following RDS instance?"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Are you sure you want to remove the settings for the following Virtual Machine?"
msgstr "Are you sure you want to remove the settings for the following Virtual Machine?"

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to revoke admin permissions from this user?"
msgstr "Are you sure you want to revoke admin permissions from this user?"

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to turn off two-factor authentication for this user?"
msgstr "Are you sure you want to turn off two-factor authentication for this user?"

#: app/frontend/pages/admin/users/show.jsx
msgid "Are you sure you want to unblock this user?"
msgstr "Are you sure you want to unblock this user?"

#: app/frontend/pages/dashboard/aws/data_imports/DeleteDataImportModal.jsx
#: app/frontend/pages/dashboard/memberships/ConfirmRemoveModal.jsx
#: app/frontend/pages/users/settings/connections.jsx
#: app/frontend/pages/users/settings/privacy.jsx
msgid "Are you sure?"
msgstr "Are you sure?"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "ARM"
msgstr "ARM"

#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
msgid "ARN"
msgstr "ARN"

#: app/frontend/components/PageHeader.jsx
msgid "As of"
msgstr "As of"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "Ask an owner of your organization to subscribe."
msgstr "Ask an owner of your organization to subscribe."

#: app/frontend/components/chat/Composer.jsx
msgid "Ask Skie Assist…"
msgstr "Ask Skie Assist…"

#. placeholder {0}: source.label
#. placeholder {1}: source.focus
#: app/frontend/components/chat/MessageList.jsx
msgid "Asking about {0} · {1} from this optimization run."
msgstr "Asking about {0} · {1} from this optimization run."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Assets with the most findings"
msgstr "Assets with the most findings"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Assign access to cost data"
msgstr "Assign access to cost data"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Assign Azure roles using the Azure portal"
msgstr "Assign Azure roles using the Azure portal"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Assignee"
msgstr "Assignee"

#: app/frontend/components/chat/SourceMenu.jsx
msgid "Assistant unavailable"
msgstr "Assistant unavailable"

#: app/frontend/pages/users/aws_marketplace/associate.jsx
msgid "Associate account"
msgstr "Associate account"

#: app/frontend/pages/users/aws_marketplace/associate.jsx
msgid "Associate my account"
msgstr "Associate my account"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Association ID"
msgstr "Association ID"

#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Association Status"
msgstr "Association Status"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "assumed, no Azure data yet"
msgstr "assumed, no Azure data yet"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Assumptions"
msgstr "Assumptions"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "At least one check for the control failed."
msgstr "At least one check for the control failed."

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "At Rest Encryption"
msgstr "At Rest Encryption"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "At the top right corner of the page, click <0>Create Stack</0>, then select <1>With new resources (standard)</1>."
msgstr "At the top right corner of the page, click <0>Create Stack</0>, then select <1>With new resources (standard)</1>."

#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "Attached Instances"
msgstr "Attached Instances"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Attachments"
msgstr "Attachments"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Attachments Status"
msgstr "Attachments Status"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Attention"
msgstr "Attention"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Attention lists"
msgstr "Attention lists"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Attribute Definitions"
msgstr "Attribute Definitions"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Aurora I/O-Optimized"
msgstr "Aurora I/O-Optimized"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "Auth Method"
msgstr "Auth Method"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Auth Method is required"
msgstr "Auth Method is required"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "Auth Type"
msgstr "Auth Type"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Auth Type is required"
msgstr "Auth Type is required"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Authentication Options"
msgstr "Authentication Options"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Authenticator app"
msgstr "Authenticator app"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Auto associate"
msgstr "Auto associate"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Auto Minor Version Upgrade"
msgstr "Auto Minor Version Upgrade"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Auto Placement"
msgstr "Auto Placement"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Auto Provision Zones"
msgstr "Auto Provision Zones"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Auto Scaling IPs"
msgstr "Auto Scaling IPs"

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "Auto-Group Tag Keys"
msgstr "Auto-Group Tag Keys"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Auto-scaling mode for the cluster"
msgstr "Auto-scaling mode for the cluster"

#: app/frontend/pages/dashboard/aws/accounts/SetupGuideTabs.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Automatic onboarding (CloudFormation)"
msgstr "Automatic onboarding (CloudFormation)"

#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
msgid "Automatic Opening of Change Requests"
msgstr "Automatic Opening of Change Requests"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Automatic purchase"
msgstr "Automatic purchase"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Automatic Registration (Recommended)"
msgstr "Automatic Registration (Recommended)"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Automatically approve the Change Requests created from this maintenance window."
msgstr "Automatically approve the Change Requests created from this maintenance window."

#: app/frontend/components/ResourceStagesTable.jsx
msgid "Automation"
msgstr "Automation"

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Automation updates"
msgstr "Automation updates"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
msgid "Autoscale IOPS"
msgstr "Autoscale IOPS"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Autoscaled Mode"
msgstr "Autoscaled Mode"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Availability"
msgstr "Availability"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/index.jsx
msgid "Availability Compliance Trend (12 months)"
msgstr "Availability Compliance Trend (12 months)"

#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Availability Mode"
msgstr "Availability Mode"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Availability Set"
msgstr "Availability Set"

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "Availability SLA"
msgstr "Availability SLA"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
msgid "Availability zone"
msgstr "Availability zone"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Availability Zone"
msgstr "Availability Zone"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Availability zone count"
msgstr "Availability zone count"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "Availability Zone Count"
msgstr "Availability Zone Count"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Availability Zone ID"
msgstr "Availability Zone ID"

#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "Availability Zones"
msgstr "Availability Zones"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Available %"
msgstr "Available %"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Available memory for a VM under a VM Scale Set."
msgstr "Available memory for a VM under a VM Scale Set."

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Available vCPUs"
msgstr "Available vCPUs"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Available volumes"
msgstr "Available volumes"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Available Volumes"
msgstr "Available Volumes"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Average"
msgstr "Average"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "average compliance across all services & keys"
msgstr "average compliance across all services & keys"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Average time from issue creation to first response, per priority, over the last 12 months. Calculated using SLA clock metrics. Lower is better."
msgstr "Average time from issue creation to first response, per priority, over the last 12 months. Calculated using SLA clock metrics. Lower is better."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Average time from issue creation to resolution, per priority, over the last 12 months. Calculated using SLA clock metrics. Lower is better."
msgstr "Average time from issue creation to resolution, per priority, over the last 12 months. Calculated using SLA clock metrics. Lower is better."

#: app/frontend/components/echarts/options.js
msgid "avg"
msgstr "avg"

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Avg"
msgstr "Avg"

#. placeholder {0}: formatDuration(jobs.avg_drill_duration_seconds)
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Avg RTO: {0}"
msgstr "Avg RTO: {0}"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "AWS"
msgstr "AWS"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "AWS account"
msgstr "AWS account"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "AWS Account"
msgstr "AWS Account"

#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "AWS Account ID"
msgstr "AWS Account ID"

#: app/frontend/pages/dashboard/aws/accounts/GuideShell.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "AWS account setup guide"
msgstr "AWS account setup guide"

#: app/frontend/layout/menu.jsx
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "AWS accounts"
msgstr "AWS accounts"

#: app/frontend/components/FinopsFilterBar.jsx
#: app/frontend/pages/dashboard/aws/accounts/GuideShell.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "AWS Accounts"
msgstr "AWS Accounts"

#: app/frontend/pages/dashboard/subscriptions/sections/AwsAccountsSection.jsx
msgid "AWS accounts in scope"
msgstr "AWS accounts in scope"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "AWS Backup"
msgstr "AWS Backup"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "AWS Baseline ID"
msgstr "AWS Baseline ID"

#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "AWS Billing Groups"
msgstr "AWS Billing Groups"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "AWS bills one edition, but a different paid edition is installed."
msgstr "AWS bills one edition, but a different paid edition is installed."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "AWS collected the invoiced amount from the buyer."
msgstr "AWS collected the invoiced amount from the buyer."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "AWS Cost Explorer"
msgstr "AWS Cost Explorer"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "AWS Created At"
msgstr "AWS Created At"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "AWS Dashboard"
msgstr "AWS Dashboard"

#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "AWS Data Imports"
msgstr "AWS Data Imports"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "AWS EC2 Optimizer Settings"
msgstr "AWS EC2 Optimizer Settings"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "AWS EKS Optimizer Settings"
msgstr "AWS EKS Optimizer Settings"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "AWS ElastiCache ID"
msgstr "AWS ElastiCache ID"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "AWS ElastiCache Optimizer Settings"
msgstr "AWS ElastiCache Optimizer Settings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "AWS GuardDuty threat detections created in the selected period."
msgstr "AWS GuardDuty threat detections created in the selected period."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "AWS Inspector vulnerability findings created in the selected period."
msgstr "AWS Inspector vulnerability findings created in the selected period."

#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "AWS Instance Credentials"
msgstr "AWS Instance Credentials"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
msgid "AWS instance ID"
msgstr "AWS instance ID"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "AWS Instance ID"
msgstr "AWS Instance ID"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "AWS Instance Types"
msgstr "AWS Instance Types"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "AWS Marketplace Logo"
msgstr "AWS Marketplace Logo"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "AWS Master Account"
msgstr "AWS Master Account"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "AWS Opensearch domain ID"
msgstr "AWS Opensearch domain ID"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "AWS Opensearch Domain ID"
msgstr "AWS Opensearch Domain ID"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "AWS Opensearch Optimizer Settings"
msgstr "AWS Opensearch Optimizer Settings"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "AWS Optimizer Skipped Accounts"
msgstr "AWS Optimizer Skipped Accounts"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "AWS Primary Account"
msgstr "AWS Primary Account"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
msgid "AWS RDS ID"
msgstr "AWS RDS ID"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "AWS RDS Optimizer Settings"
msgstr "AWS RDS Optimizer Settings"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "AWS returned the following error message:"
msgstr "AWS returned the following error message:"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "AWS returned the following identity details:"
msgstr "AWS returned the following identity details:"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "AWS services with the most active findings in the selected period — actionable only (Informational/passed excluded), so the counts reconcile with the active total."
msgstr "AWS services with the most active findings in the selected period — actionable only (Informational/passed excluded), so the counts reconcile with the active total."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "AWS settled this amount — paying it out, or netting it against the payout."
msgstr "AWS settled this amount — paying it out, or netting it against the payout."

#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "AWS Snapshot ID"
msgstr "AWS Snapshot ID"

#: app/frontend/pages/dashboard/aws/settings/write_permissions.jsx
msgid "AWS Write Permissions"
msgstr "AWS Write Permissions"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "AWS wrote this amount off; the buyer wasn't charged."
msgstr "AWS wrote this amount off; the buyer wasn't charged."

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
msgid "AZ"
msgstr "AZ"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
msgid "AZ Count"
msgstr "AZ Count"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Azure"
msgstr "Azure"

#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Azure billing account"
msgstr "Azure billing account"

#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
msgid "Azure Billing Accounts"
msgstr "Azure Billing Accounts"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "Azure bills the SQL Server licence on its own meter on top of the vCore compute price. Setting the licence type to BasePrice stops that meter; the database itself does not change."
msgstr "Azure bills the SQL Server licence on its own meter on top of the vCore compute price. Setting the licence type to BasePrice stops that meter; the database itself does not change."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Azure bills the Windows licence on its own meter on top of the compute price. Setting the licence type to Windows_Server stops that meter; the VM itself does not change."
msgstr "Azure bills the Windows licence on its own meter on top of the compute price. Setting the licence type to Windows_Server stops that meter; the VM itself does not change."

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Azure cannot convert a disk to Premium SSD v2 in place — recreate it from a snapshot."
msgstr "Azure cannot convert a disk to Premium SSD v2 in place — recreate it from a snapshot."

#: app/frontend/pages/dashboard/azure/credentials/show.jsx
msgid "Azure credential"
msgstr "Azure credential"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
msgid "Azure Credentials"
msgstr "Azure Credentials"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Azure Dashboard"
msgstr "Azure Dashboard"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "Azure Databases Optimizer Settings"
msgstr "Azure Databases Optimizer Settings"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Azure DB"
msgstr "Azure DB"

#: app/frontend/pages/dashboard/azure/disks/optimizations/index.jsx
msgid "Azure Disk Optimizations"
msgstr "Azure Disk Optimizations"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Azure documentation"
msgstr "Azure documentation"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Azure Hybrid Benefit reuses licences you already own. Azure cannot tell us whether you have them, so these answers decide whether licence savings count as real."
msgstr "Azure Hybrid Benefit reuses licences you already own. Azure cannot tell us whether you have them, so these answers decide whether licence savings count as real."

#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Azure ID"
msgstr "Azure ID"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Azure Licensing"
msgstr "Azure Licensing"

#: app/frontend/pages/dashboard/azure/network/optimizations/index.jsx
msgid "Azure Network Optimizations"
msgstr "Azure Network Optimizations"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Azure Optimizer Skipped Subscriptions"
msgstr "Azure Optimizer Skipped Subscriptions"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Azure refunds cancelled reservations up to USD 50,000 of commitment per rolling 12 months per billing scope, with no termination fee today. New commitment inside what remains of that allowance, after the cancellations this plan recommends, can be unwound; only the rest is locked in."
msgstr "Azure refunds cancelled reservations up to USD 50,000 of commitment per rolling 12 months per billing scope, with no termination fee today. New commitment inside what remains of that allowance, after the cancellations this plan recommends, can be unwound; only the rest is locked in."

#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Azure Resource ID"
msgstr "Azure Resource ID"

#: app/frontend/pages/dashboard/azure/sql/optimizations/index.jsx
msgid "Azure SQL Optimizations"
msgstr "Azure SQL Optimizations"

#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Azure subscription"
msgstr "Azure subscription"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
msgid "Azure Subscription ID"
msgstr "Azure Subscription ID"

#: app/frontend/pages/dashboard/azure/subscriptions/setup.jsx
msgid "Azure subscription setup guide"
msgstr "Azure subscription setup guide"

#: app/frontend/layout/menu.jsx
msgid "Azure subscriptions"
msgstr "Azure subscriptions"

#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/setup.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Azure Subscriptions"
msgstr "Azure Subscriptions"

#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
msgid "Azure Type"
msgstr "Azure Type"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Azure Virtual Machines Optimizer Settings"
msgstr "Azure Virtual Machines Optimizer Settings"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Azure VM ID"
msgstr "Azure VM ID"

#: app/frontend/pages/dashboard/azure/vms/optimizations/index.jsx
msgid "Azure VM Optimizations"
msgstr "Azure VM Optimizations"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Back"
msgstr "Back"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Back to Workload"
msgstr "Back to Workload"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
msgid "Backup"
msgstr "Backup"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Backup & DR"
msgstr "Backup & DR"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Backup codes"
msgstr "Backup codes"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Backup codes (Step 3 of 3)"
msgstr "Backup codes (Step 3 of 3)"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Backup coverage"
msgstr "Backup coverage"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Backup Coverage"
msgstr "Backup Coverage"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Backup coverage {v}%"
msgstr "Backup coverage {v}%"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Coverage Resources - {periodLabel}"
msgstr "Backup Coverage Resources - {periodLabel}"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Backup coverage states"
msgstr "Backup coverage states"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "Backup history"
msgstr "Backup history"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Jobs - {periodLabel}"
msgstr "Backup Jobs - {periodLabel}"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Level"
msgstr "Backup Level"

#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Backup Management Type"
msgstr "Backup Management Type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Plan"
msgstr "Backup Plan"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "Backup plans"
msgstr "Backup plans"

#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Backup Plans"
msgstr "Backup Plans"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup plans - {groupLabel}"
msgstr "Backup plans - {groupLabel}"

#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Backup Policies"
msgstr "Backup Policies"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Backup restore"
msgstr "Backup restore"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Backup Retention (days)"
msgstr "Backup Retention (days)"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Backup Retention Period"
msgstr "Backup Retention Period"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Status"
msgstr "Backup Status"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backup Tag"
msgstr "Backup Tag"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Backups"
msgstr "Backups"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Backups missing their RPO target. AWS Backup resource-level + Commvault job-level."
msgstr "Backups missing their RPO target. AWS Backup resource-level + Commvault job-level."

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Bare Metal"
msgstr "Bare Metal"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Base RPUs"
msgstr "Base RPUs"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Based on ProsperOps ESR methodology. SCORE excludes spot savings, EDP discounts, and private pricing. Realistic maximum for a well-optimized org: ~40% (90% coverage × 45% effective discount)."
msgstr "Based on ProsperOps ESR methodology. SCORE excludes spot savings, EDP discounts, and private pricing. Realistic maximum for a well-optimized org: ~40% (90% coverage × 45% effective discount)."

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Baseline Bandwidth"
msgstr "Baseline Bandwidth"

#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
msgid "Baseline Cost"
msgstr "Baseline Cost"

#: app/frontend/pages/dashboard/aws/baselines/index.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Baseline ID"
msgstr "Baseline ID"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Baseline IOPS"
msgstr "Baseline IOPS"

#: app/frontend/pages/dashboard/aws/baselines/index.jsx
msgid "Baseline Name"
msgstr "Baseline Name"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Baseline Throughput"
msgstr "Baseline Throughput"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Baseline Unit Cost"
msgstr "Baseline Unit Cost"

#: app/frontend/pages/dashboard/aws/patch_manager/PatchManagerTabs.jsx
msgid "Baselines"
msgstr "Baselines"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Basic"
msgstr "Basic"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
msgid "Batch"
msgstr "Batch"

#: app/frontend/components/optimization_overview/OverviewHeader.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Batch runs"
msgstr "Batch runs"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "Before preparing and applying the CloudFormation file (below) you need to setup some elements in the AWS management (payer) account."
msgstr "Before preparing and applying the CloudFormation file (below) you need to setup some elements in the AWS management (payer) account."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Before resizing: move the Windows pagefile off the temporary drive (D:), or the Linux swap and /mnt mounts, then resize from the CLI or with the VM deallocated."
msgstr "Before resizing: move the Windows pagefile off the temporary drive (D:), or the Linux swap and /mnt mounts, then resize from the CLI or with the VM deallocated."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Below Average"
msgstr "Below Average"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Benchmark"
msgstr "Benchmark"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Benchmark Compress"
msgstr "Benchmark Compress"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Benchmark Decompress"
msgstr "Benchmark Decompress"

#: app/frontend/components/RankedBarLegend.jsx
msgid "Beyond top {TOP_N} — folded into \"Other\" on the card"
msgstr "Beyond top {TOP_N} — folded into \"Other\" on the card"

#: app/frontend/components/DonutLegend.jsx
msgid "Beyond top {TOP_N} — folded into \"Other\" on the chart"
msgstr "Beyond top {TOP_N} — folded into \"Other\" on the chart"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Billed"
msgstr "Billed"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "Billed at"
msgstr "Billed at"

#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Billed vCores"
msgstr "Billed vCores"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Billing Account Owner"
msgstr "Billing Account Owner"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Billing Accounts"
msgstr "Billing Accounts"

#: app/frontend/pages/admin/billing_entries/index.jsx
msgid "Billing Entries"
msgstr "Billing Entries"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Billing event ID"
msgstr "Billing event ID"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Billing group"
msgstr "Billing group"

#: app/frontend/pages/admin/billing_entries/index.jsx
msgid "Billing Group"
msgstr "Billing Group"

#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
msgid "Billing groups help you organize and track costs from multiple accounts in an AWS organization. They are automatically imported if your accounts belong to an AWS organization."
msgstr "Billing groups help you organize and track costs from multiple accounts in an AWS organization. They are automatically imported if your accounts belong to an AWS organization."

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Billing Line Items"
msgstr "Billing Line Items"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Billing Mode Summary"
msgstr "Billing Mode Summary"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Billing model"
msgstr "Billing model"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Billing Plan"
msgstr "Billing Plan"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Billing Report"
msgstr "Billing Report"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Billing Scope ID"
msgstr "Billing Scope ID"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "Billing settings in the AWS management (payer) account"
msgstr "Billing settings in the AWS management (payer) account"

#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
msgid "Billing V2"
msgstr "Billing V2"

#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
msgid "Billings"
msgstr "Billings"

#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
msgid "Binpacking Policy"
msgstr "Binpacking Policy"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Binpacking Restriction"
msgstr "Binpacking Restriction"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Binpacking restriction option for Azure DB optimization. Default: Free."
msgstr "Binpacking restriction option for Azure DB optimization. Default: Free."

#. placeholder {0}: binpackingLabel(optimization.binpacking_option)
#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
msgid "Binpacking: {0}"
msgstr "Binpacking: {0}"

#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
msgid "Block Size"
msgstr "Block Size"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Block size is calculated by dividing the bytes transferred by the number of I/O operations in the same period. Larger average block sizes indicate workloads transferring more data per operation (e.g. sequential reads), while smaller sizes indicate random I/O patterns."
msgstr "Block size is calculated by dividing the bytes transferred by the number of I/O operations in the same period. Larger average block sizes indicate workloads transferring more data per operation (e.g. sequential reads), while smaller sizes indicate random I/O patterns."

#: app/frontend/pages/admin/users/show.jsx
msgid "Block user"
msgstr "Block user"

#: app/frontend/pages/admin/users/show.jsx
msgid "Blocked"
msgstr "Blocked"

#: app/frontend/pages/admin/users/show.jsx
msgid "Blocked at"
msgstr "Blocked at"

#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "Bootable"
msgstr "Bootable"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Bottom 5 (organization, tier) by combined backup coverage — AWS Backup + DRS + Commvault. Rows where Backup is disabled are excluded."
msgstr "Bottom 5 (organization, tier) by combined backup coverage — AWS Backup + DRS + Commvault. Rows where Backup is disabled are excluded."

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Bottom 5 (organization, tier) by patched EC2 instances divided by total eligible. Rows where Patch is disabled are excluded."
msgstr "Bottom 5 (organization, tier) by patched EC2 instances divided by total eligible. Rows where Patch is disabled are excluded."

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Bottom 5 (organization, tier) by Security Hub controls pass rate. Rows where Security is disabled are excluded."
msgstr "Bottom 5 (organization, tier) by Security Hub controls pass rate. Rows where Security is disabled are excluded."

#: app/frontend/components/echarts/options.js
msgid "Boxplot"
msgstr "Boxplot"

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "Breach status"
msgstr "Breach status"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Breached"
msgstr "Breached"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Breaks down this period's customer tickets by their Jira request type."
msgstr "Breaks down this period's customer tickets by their Jira request type."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "Bucket"
msgstr "Bucket"

#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
msgid "Buckets"
msgstr "Buckets"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Burstable Performance Supported"
msgstr "Burstable Performance Supported"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Business support per account"
msgstr "Business support per account"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Buyer transaction ref"
msgstr "Buyer transaction ref"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing cost trends across different services over 18 months, stakeholders can identify areas of high expenditure, potential cost optimizations, and opportunities for resource allocation adjustments."
msgstr "By analyzing cost trends across different services over 18 months, stakeholders can identify areas of high expenditure, potential cost optimizations, and opportunities for resource allocation adjustments."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing cost trends over the preceding 30 days, stakeholders can swiftly identify recent spending patterns, detect any sudden fluctuations in costs, and prioritize areas for immediate attention or optimization."
msgstr "By analyzing cost trends over the preceding 30 days, stakeholders can swiftly identify recent spending patterns, detect any sudden fluctuations in costs, and prioritize areas for immediate attention or optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing the memory variability depicted in the chart, stakeholders can gain insights into optimizing resource allocation and performance tuning for their database environments."
msgstr "By analyzing the memory variability depicted in the chart, stakeholders can gain insights into optimizing resource allocation and performance tuning for their database environments."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their commitments, optimizing cost efficiency and resource allocation."
msgstr "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their commitments, optimizing cost efficiency and resource allocation."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their EC2 reservations, optimizing cost efficiency and resource allocation."
msgstr "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their EC2 reservations, optimizing cost efficiency and resource allocation."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their Savings Plans, optimizing cost efficiency and resource allocation."
msgstr "By analyzing the trends displayed in the graph, users can make informed decisions regarding the renewal or modification of their Savings Plans, optimizing cost efficiency and resource allocation."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing this chart, users can detect trends, spot unusual spending, and better understand which service families are the main cost drivers in their Azure environment. This supports more effective budgeting, forecasting, and resource allocation."
msgstr "By analyzing this chart, users can detect trends, spot unusual spending, and better understand which service families are the main cost drivers in their Azure environment. This supports more effective budgeting, forecasting, and resource allocation."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing this chart, users can discern the variability in resource utilization and performance characteristics among different DB Engines available on Amazon RDS. Understanding these variations can aid in formulating effective AWS service management strategies. For instance, selecting a DB Engine with lower FTE variability may contribute to more predictable performance outcomes for applications. Additionally, adjusting RDS instance configurations based on the observed FTE variability can optimize resource allocation and enhance overall system efficiency. Regular monitoring of FTE metrics depicted in this chart enables users to proactively manage AWS resources, ensuring consistent and reliable database performance for their applications."
msgstr "By analyzing this chart, users can discern the variability in resource utilization and performance characteristics among different DB Engines available on Amazon RDS. Understanding these variations can aid in formulating effective AWS service management strategies. For instance, selecting a DB Engine with lower FTE variability may contribute to more predictable performance outcomes for applications. Additionally, adjusting RDS instance configurations based on the observed FTE variability can optimize resource allocation and enhance overall system efficiency. Regular monitoring of FTE metrics depicted in this chart enables users to proactively manage AWS resources, ensuring consistent and reliable database performance for their applications."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By analyzing this chart, users can pinpoint high-cost categories, uncover spending patterns, and make informed decisions to better allocate resources and control AWS costs."
msgstr "By analyzing this chart, users can pinpoint high-cost categories, uncover spending patterns, and make informed decisions to better allocate resources and control AWS costs."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "By having these, and passing them to the PowerShell script, one extra layer of security is added to the process, as you are no longer required to take notes of the new application's credentials nor to send to Skie.io the list of subscriptions you are granting read permissions."
msgstr "By having these, and passing them to the PowerShell script, one extra layer of security is added to the process, as you are no longer required to take notes of the new application's credentials nor to send to Skie.io the list of subscriptions you are granting read permissions."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "By month"
msgstr "By month"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "By Priority"
msgstr "By Priority"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "By private offer only"
msgstr "By private offer only"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "By resource type"
msgstr "By resource type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "By severity"
msgstr "By severity"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "By standard"
msgstr "By standard"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "By visualizing cost breakdowns by usage type over a defined timeframe, stakeholders can identify patterns, trends, and areas of significant expenditure, enabling them to optimize resource allocation and enhance cost-effectiveness."
msgstr "By visualizing cost breakdowns by usage type over a defined timeframe, stakeholders can identify patterns, trends, and areas of significant expenditure, enabling them to optimize resource allocation and enhance cost-effectiveness."

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "BYOL"
msgstr "BYOL"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "BYOL not covered"
msgstr "BYOL not covered"

#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
msgid "BYOL SQL Server may exist on these hosts but cannot be detected."
msgstr "BYOL SQL Server may exist on these hosts but cannot be detected."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Bytes"
msgstr "Bytes"

#: app/frontend/pages/dashboard/azure/managed_disks/MetricsSection.jsx
msgid "Bytes per Second"
msgstr "Bytes per Second"

#: app/frontend/pages/dashboard/azure/application_gateways/MetricsSection.jsx
msgid "Bytes Received/Sent"
msgstr "Bytes Received/Sent"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Bytes/Second"
msgstr "Bytes/Second"

#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
msgid "Cache for Redis"
msgstr "Cache for Redis"

#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
msgid "Cache ID"
msgstr "Cache ID"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
msgid "Cache Node Count"
msgstr "Cache Node Count"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
msgid "Cache node type"
msgstr "Cache node type"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "Cache Node Type"
msgstr "Cache Node Type"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Cache Parameter Group"
msgstr "Cache Parameter Group"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Cache Subnet Group"
msgstr "Cache Subnet Group"

#: app/frontend/pages/admin/billing_reports/index.jsx
msgid "Calculate Billing"
msgstr "Calculate Billing"

#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "Calculate Billing V2"
msgstr "Calculate Billing V2"

#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
msgid "Calculate Guardian Billing"
msgstr "Calculate Guardian Billing"

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "Can't scan the QR code? Enter this setup key in the authenticator app:"
msgstr "Can't scan the QR code? Enter this setup key in the authenticator app:"

#: app/frontend/components/chat/TopicSidebar.jsx
#: app/frontend/components/optimization_dashboard/CancelActionButton.jsx
#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
#: app/frontend/components/optimization_dashboard/schedule/ScheduleFooter.jsx
#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
#: app/frontend/components/table/RowActions.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
#: app/frontend/pages/admin/plan_features/edit.jsx
#: app/frontend/pages/admin/plans/organizations.jsx
#: app/frontend/pages/admin/plans/PlanForm.jsx
#: app/frontend/pages/admin/service_users/ServiceUserForm.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/admin/trusted_keys/new.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerModal.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/memberships/ConfirmRemoveModal.jsx
#: app/frontend/pages/dashboard/resource_group_settings/edit.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
#: app/frontend/pages/users/admin_tokens/new.jsx
#: app/frontend/pages/users/settings/connections.jsx
#: app/frontend/pages/users/settings/privacy.jsx
msgid "Cancel"
msgstr "Cancel"

#: app/frontend/components/optimization_dashboard/CancelActionButton.jsx
msgid "Cancel action"
msgstr "Cancel action"

#: app/frontend/components/optimization_dashboard/CancelActionButton.jsx
msgid "Cancel optimization action?"
msgstr "Cancel optimization action?"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Cancel subscription"
msgstr "Cancel subscription"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Cancel Subscription"
msgstr "Cancel Subscription"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Cancel subscription?"
msgstr "Cancel subscription?"

#: app/frontend/components/guardian/TicketStatusTree.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Canceled"
msgstr "Canceled"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
msgid "cancelled"
msgstr "cancelled"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
msgid "Cancelled"
msgstr "Cancelled"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
msgid "Cancelling"
msgstr "Cancelling"

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "cannot start with \"aws:\" or \"azure:\"."
msgstr "cannot start with \"aws:\" or \"azure:\"."

#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Canonical Hosted Zone ID"
msgstr "Canonical Hosted Zone ID"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Capabilities"
msgstr "Capabilities"

#: app/frontend/pages/admin/users/show.jsx
msgid "Capabilities granted by this role"
msgstr "Capabilities granted by this role"

#: app/frontend/pages/dashboard/azure/databases/index.jsx
msgid "Capacity"
msgstr "Capacity"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Capacity Providers"
msgstr "Capacity Providers"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Capacity Type"
msgstr "Capacity Type"

#: app/frontend/pages/dashboard/azure/application_gateways/MetricsSection.jsx
msgid "Capacity Units"
msgstr "Capacity Units"

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Capture rate per signal"
msgstr "Capture rate per signal"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "capture_rate is set per signal in Settings (0.6 by default) — the fraction of the peer gap counted as realistically recoverable."
msgstr "capture_rate is set per signal in Settings (0.6 by default) — the fraction of the peer gap counted as realistically recoverable."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "CAS (Cluster Autoscaler)"
msgstr "CAS (Cluster Autoscaler)"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Catching up — first sync, working through a backlog, rescanning, or taking a snapshot."
msgstr "Catching up — first sync, working through a backlog, rescanning, or taking a snapshot."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Category"
msgstr "Category"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Certificate"
msgstr "Certificate"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Change"
msgstr "Change"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "Change CPU options"
msgstr "Change CPU options"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Change DB instance class"
msgstr "Change DB instance class"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "Change instance class"
msgstr "Change instance class"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "Change instance type"
msgstr "Change instance type"

#: app/frontend/pages/dashboard/change_requests/show.jsx
msgid "Change request"
msgstr "Change request"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Change Request"
msgstr "Change Request"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Change Request Approval"
msgstr "Change Request Approval"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
msgid "Change Requests"
msgstr "Change Requests"

#. placeholder {0}: maintenance_window.name
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Change requests will be opened now for the resources of \"{0}\", instead of waiting for the monthly scheduler."
msgstr "Change requests will be opened now for the resources of \"{0}\", instead of waiting for the monthly scheduler."

#: app/frontend/pages/dashboard/memberships/ChangeRoleModal.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Change role"
msgstr "Change role"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Change volume kind"
msgstr "Change volume kind"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
msgid "Change volume type"
msgstr "Change volume type"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Change/mo"
msgstr "Change/mo"

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Changes show on the dashboards and on this page after the next daily run."
msgstr "Changes show on the dashboards and on this page after the next daily run."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Channel"
msgstr "Channel"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "Charge type"
msgstr "Charge type"

#: app/frontend/components/ChartCardHeader.jsx
msgid "Chart info"
msgstr "Chart info"

#: app/frontend/components/ChartCardHeader.jsx
#: app/frontend/components/echarts/chart/chart.jsx
#: app/frontend/components/echarts/modal/info_button.jsx
msgid "Chart Info"
msgstr "Chart Info"

#: app/frontend/components/chat/TopicSidebar.jsx
msgid "Chats in {organizationName}"
msgstr "Chats in {organizationName}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Check support coverage and on-call rotation for breaching priorities; consider tightening escalation paths."
msgstr "Check support coverage and on-call rotation for breaching priorities; consider tightening escalation paths."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Check the failing backup jobs in AWS Backup / Commvault. Investigate job schedules, storage limits, and last-success timestamps."
msgstr "Check the failing backup jobs in AWS Backup / Commvault. Investigate job schedules, storage limits, and last-success timestamps."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "Check the option <0>Require external ID (Best practice when a third party will assume this role)</0> and enter the following <1>External ID</1>:"
msgstr "Check the option <0>Require external ID (Best practice when a third party will assume this role)</0> and enter the following <1>External ID</1>:"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Check what changes"
msgstr "Check what changes"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Choose which AWS account will own this Savings Plan purchase. If not set, it can be configured later."
msgstr "Choose which AWS account will own this Savings Plan purchase. If not set, it can be configured later."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Class"
msgstr "Class"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Class / Family"
msgstr "Class / Family"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Cleanup"
msgstr "Cleanup"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Click <0>Create export</0> and select <1>Standard data export</1>."
msgstr "Click <0>Create export</0> and select <1>Standard data export</1>."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Click <0>Create Stack</0>, then <1>With new resources (standard)</1>, choose <2>Choose an existing template</2> and <3>Upload a template file</3>, and upload the template you just downloaded."
msgstr "Click <0>Create Stack</0>, then <1>With new resources (standard)</1>, choose <2>Choose an existing template</2> and <3>Upload a template file</3>, and upload the template you just downloaded."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Click <0>Next</0>."
msgstr "Click <0>Next</0>."

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Click <0>Save</0>"
msgstr "Click <0>Save</0>"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Click <0>Services</0> and search for <1>CloudFormation</1>."
msgstr "Click <0>Services</0> and search for <1>CloudFormation</1>."

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Click on the container name to visualize, edit and approve recommendations"
msgstr "Click on the container name to visualize, edit and approve recommendations"

#: app/frontend/pages/dashboard/invitation_acceptances/show.jsx
msgid "Click the button below to accept."
msgstr "Click the button below to accept."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Click the button below to download the CloudFormation template:"
msgstr "Click the button below to download the CloudFormation template:"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Click the button below to download the FOCUS CUR CloudFormation template:"
msgstr "Click the button below to download the FOCUS CUR CloudFormation template:"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Click the button below to test if the ETL can assume the configured IAM role in the AWS account"
msgstr "Click the button below to test if the ETL can assume the configured IAM role in the AWS account"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Client"
msgstr "Client"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Client CIDR Block"
msgstr "Client CIDR Block"

#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Client ID"
msgstr "Client ID"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Client Protocol"
msgstr "Client Protocol"

#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
msgid "Client Secret"
msgstr "Client Secret"

#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Client Secret Path"
msgstr "Client Secret Path"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
msgid "Client VPN"
msgstr "Client VPN"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "client_total_bill covers the last three complete months, so dividing by 3 gives a monthly figure."
msgstr "client_total_bill covers the last three complete months, so dividing by 3 gives a monthly figure."

#: app/frontend/components/chat/ChatPanel.jsx
#: app/frontend/components/optimizer/DeleteSettingModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/DeleteAccountModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DeleteDataImportModal.jsx
#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/credentials/DeleteCredentialModal.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/DeleteSubscriptionModal.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/memberships/ChangeRoleModal.jsx
#: app/frontend/pages/dashboard/memberships/InviteModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/organization_tokens/DeleteTokenModal.jsx
#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "Close"
msgstr "Close"

#: app/frontend/components/guardian/GuardianContextBar.jsx
#: app/frontend/components/guardian/TicketStatusTree.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ServiceHoursCard.jsx
msgid "Closed"
msgstr "Closed"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Cloud providers"
msgstr "Cloud providers"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/CloudFlexSection.jsx
msgid "CloudFlex"
msgstr "CloudFlex"

#: app/frontend/pages/dashboard/subscriptions/sections/CloudFlexSection.jsx
msgid "CloudFlex pricing for this organization"
msgstr "CloudFlex pricing for this organization"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "CloudFormation setup"
msgstr "CloudFormation setup"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
msgid "Cloudwatch Information"
msgstr "Cloudwatch Information"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Cluster"
msgstr "Cluster"

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Cluster ARN"
msgstr "Cluster ARN"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Cluster Create Time"
msgstr "Cluster Create Time"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Cluster Details"
msgstr "Cluster Details"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "Cluster Engine"
msgstr "Cluster Engine"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
msgid "Cluster ID"
msgstr "Cluster ID"

#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
msgid "Cluster Identifier"
msgstr "Cluster Identifier"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
msgid "Cluster name"
msgstr "Cluster name"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Cluster Name"
msgstr "Cluster Name"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "Cluster Status"
msgstr "Cluster Status"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Clustering Policy"
msgstr "Clustering Policy"

#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
msgid "Clusters"
msgstr "Clusters"

#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "Code"
msgstr "Code"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Coefficient of Variation"
msgstr "Coefficient of Variation"

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Cohort (benchmark)"
msgstr "Cohort (benchmark)"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Cohort definition"
msgstr "Cohort definition"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Collecting metrics"
msgstr "Collecting metrics"

#: app/frontend/components/ListingTable.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Columns"
msgstr "Columns"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Combined"
msgstr "Combined"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Combined on-demand + reserved/savings-plan spend for the latest of the trailing 6 months, across all connected AWS accounts."
msgstr "Combined on-demand + reserved/savings-plan spend for the latest of the trailing 6 months, across all connected AWS accounts."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Combined on-demand, reserved, and savings plan spend for the previous month, across all connected AWS accounts."
msgstr "Combined on-demand, reserved, and savings plan spend for the previous month, across all connected AWS accounts."

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "Combined S3 spend for the previous month, across all connected AWS accounts."
msgstr "Combined S3 spend for the previous month, across all connected AWS accounts."

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Combined SLA credits are capped at {creditCap} of the monthly service fee, regardless of how many violations occur."
msgstr "Combined SLA credits are capped at {creditCap} of the monthly service fee, regardless of how many violations occur."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Combined spend across all connected AWS accounts, previous month."
msgstr "Combined spend across all connected AWS accounts, previous month."

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Combined spend across all connected Azure subscriptions, for the latest of the trailing 6 months."
msgstr "Combined spend across all connected Azure subscriptions, for the latest of the trailing 6 months."

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Combined spend across all pricing models for the latest of the trailing 6 months, across all connected Azure subscriptions."
msgstr "Combined spend across all pricing models for the latest of the trailing 6 months, across all connected Azure subscriptions."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Combined volume storage + snapshot spend for the previous month, across all connected AWS accounts."
msgstr "Combined volume storage + snapshot spend for the previous month, across all connected AWS accounts."

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
msgid "Comma-separated values"
msgstr "Comma-separated values"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "command. The file you just uploaded should show among the other files in the current folder."
msgstr "command. The file you just uploaded should show among the other files in the current folder."

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Commit affected"
msgstr "Commit affected"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Commit after right-sizing"
msgstr "Commit after right-sizing"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Commit now"
msgstr "Commit now"

#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Commitment"
msgstr "Commitment"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Commitment coverage"
msgstr "Commitment coverage"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Commitment Coverage"
msgstr "Commitment Coverage"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Commitment exposure"
msgstr "Commitment exposure"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Commitment Type"
msgstr "Commitment Type"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Commitment Utilization by Product Name"
msgstr "Commitment Utilization by Product Name"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Commitment Waste"
msgstr "Commitment Waste"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Commitments"
msgstr "Commitments"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Commitments cutoff date"
msgstr "Commitments cutoff date"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "Commitments Cutoff Date"
msgstr "Commitments Cutoff Date"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Commvault"
msgstr "Commvault"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Compare with current to understand proposed changes."
msgstr "Compare with current to understand proposed changes."

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Compared with other Skie customers over the last 3 complete months. Lists services where your share of the bill is far above the typical customer's. Savings are estimates."
msgstr "Compared with other Skie customers over the last 3 complete months. Lists services where your share of the bill is far above the typical customer's. Savings are estimates."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Compares daily RDS costs before and after optimization to validate savings impact."
msgstr "Compares daily RDS costs before and after optimization to validate savings impact."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Compares EC2 daily costs before and after optimization to validate savings."
msgstr "Compares EC2 daily costs before and after optimization to validate savings."

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/lastJob.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Completed"
msgstr "Completed"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Completed — analyzed within the last {STALE_AFTER_DAYS} days. Stale — the last completed analysis is older than that, so prices and inventory may have moved; run the optimizer again. Failed — every attempt so far has failed. Never run — this service has not been analyzed yet."
msgstr "Completed — analyzed within the last {STALE_AFTER_DAYS} days. Stale — the last completed analysis is older than that, so prices and inventory may have moved; run the optimizer again. Failed — every attempt so far has failed. Never run — this service has not been analyzed yet."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Completed At"
msgstr "Completed At"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Compliance"
msgstr "Compliance"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Compliance Level"
msgstr "Compliance Level"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/PatchManagerTabs.jsx
msgid "Compliance Report"
msgstr "Compliance Report"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Compliance Status"
msgstr "Compliance Status"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Compliance status distribution for managed instances."
msgstr "Compliance status distribution for managed instances."

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Compliance Summary"
msgstr "Compliance Summary"

#. placeholder {0}: pct.toFixed(1)
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Compliance: {0}%"
msgstr "Compliance: {0}%"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Compliant"
msgstr "Compliant"

#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "Components"
msgstr "Components"

#: app/frontend/pages/dashboard/azure/managed_disks/MetricsSection.jsx
msgid "Composite Disk Bytes/sec"
msgstr "Composite Disk Bytes/sec"

#: app/frontend/pages/dashboard/azure/managed_disks/MetricsSection.jsx
msgid "Composite Disk Operations/sec"
msgstr "Composite Disk Operations/sec"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Compression:"
msgstr "Compression:"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Compute"
msgstr "Compute"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Compute Breakdown"
msgstr "Compute Breakdown"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Compute per day"
msgstr "Compute per day"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Compute SCORE"
msgstr "Compute SCORE"

#: app/frontend/pages/dashboard/azure/databases/show.jsx
msgid "Compute Tier"
msgstr "Compute Tier"

#: app/frontend/pages/dashboard/azure/application_gateways/MetricsSection.jsx
msgid "Compute Units"
msgstr "Compute Units"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Compute vs License Spend"
msgstr "Compute vs License Spend"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Computing savings"
msgstr "Computing savings"

#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Concurrency Group"
msgstr "Concurrency Group"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Confidence"
msgstr "Confidence"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Configuration"
msgstr "Configuration"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "Configure Access"
msgstr "Configure Access"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "Configure Permissions"
msgstr "Configure Permissions"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Configure the export with the following settings:"
msgstr "Configure the export with the following settings:"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Configure the settings this run will use and choose which clusters to include. The optimization starts immediately after you click Run Optimizer Now."
msgstr "Configure the settings this run will use and choose which clusters to include. The optimization starts immediately after you click Run Optimizer Now."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Configure the settings this run will use and choose which domains to include. The optimization starts immediately after you click Run Optimizer Now."
msgstr "Configure the settings this run will use and choose which domains to include. The optimization starts immediately after you click Run Optimizer Now."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Configure the settings this run will use and choose which instances to include. The optimization starts immediately after you click Run Optimizer Now."
msgstr "Configure the settings this run will use and choose which instances to include. The optimization starts immediately after you click Run Optimizer Now."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Configure tier"
msgstr "Configure tier"

#: app/frontend/components/optimizer/DeleteSettingModal.jsx
#: app/frontend/pages/admin/users/show.jsx
msgid "Confirm"
msgstr "Confirm"

#: app/frontend/components/optimization_dashboard/schedule/ScheduleFooter.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Confirm and Schedule"
msgstr "Confirm and Schedule"

#: app/frontend/components/chat/TopicSidebar.jsx
msgid "Confirm delete"
msgstr "Confirm delete"

#: app/frontend/components/optimization_dashboard/schedule/ScheduleFooter.jsx
msgid "Confirm optimization"
msgstr "Confirm optimization"

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "Confirm the settings this run will use. The optimization starts immediately after you click Run Optimizer Now."
msgstr "Confirm the settings this run will use. The optimization starts immediately after you click Run Optimizer Now."

#: app/frontend/pages/users/registrations/edit.jsx
msgid "Confirm your new email"
msgstr "Confirm your new email"

#: app/frontend/pages/admin/users/show.jsx
msgid "Confirmation sent at"
msgstr "Confirmation sent at"

#: app/frontend/pages/admin/users/show.jsx
msgid "Confirmed at"
msgstr "Confirmed at"

#: app/frontend/pages/users/settings/connections.jsx
msgid "Connect"
msgstr "Connect"

#: app/frontend/pages/users/settings/connections.jsx
msgid "Connected"
msgstr "Connected"

#: app/frontend/pages/users/settings/connections.jsx
msgid "Connected and managed by skie.io"
msgstr "Connected and managed by skie.io"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Connection Log Options"
msgstr "Connection Log Options"

#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/pages/users/settings/connections.jsx
msgid "Connections"
msgstr "Connections"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Connectivity"
msgstr "Connectivity"

#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Connectivity Type"
msgstr "Connectivity Type"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Consider the I/O-Optimized storage configuration when recommending Aurora clusters with high I/O spend."
msgstr "Consider the I/O-Optimized storage configuration when recommending Aurora clusters with high I/O spend."

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Consistency Policy"
msgstr "Consistency Policy"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Consistent"
msgstr "Consistent"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Container"
msgstr "Container"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Container CPU Usage"
msgstr "Container CPU Usage"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Container Information"
msgstr "Container Information"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Container Memory Usage"
msgstr "Container Memory Usage"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Container Name"
msgstr "Container Name"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Container Status"
msgstr "Container Status"

#. placeholder {0}: container.container
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Container: {0}"
msgstr "Container: {0}"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Containers"
msgstr "Containers"

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "contains invalid characters. Only A-Z, 0-9, +, -, =, ., _, :, @ are allowed."
msgstr "contains invalid characters. Only A-Z, 0-9, +, -, =, ., _, :, @ are allowed."

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Content:"
msgstr "Content:"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Continue"
msgstr "Continue"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Contract commitments"
msgstr "Contract commitments"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Contract commitments are measured against the SLA your organization bought. Skie recommendations are our own service best practice, not contract clauses — each one prints the rule it was flagged by."
msgstr "Contract commitments are measured against the SLA your organization bought. Skie recommendations are our own service best practice, not contract clauses — each one prints the rule it was flagged by."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Contracted targets"
msgstr "Contracted targets"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Control ID"
msgstr "Control ID"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Control status"
msgstr "Control status"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Controls passed divided by controls enabled across the standards Security Hub has activated."
msgstr "Controls passed divided by controls enabled across the standards Security Hub has activated."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Controls passing"
msgstr "Controls passing"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Controls with the most failed checks — the breakdown of the “Failed Checks” total above."
msgstr "Controls with the most failed checks — the breakdown of the “Failed Checks” total above."

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Convert"
msgstr "Convert"

#: app/frontend/components/CopyableCode.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Copied"
msgstr "Copied"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Copies"
msgstr "Copies"

#: app/frontend/components/CopyableCode.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Copy"
msgstr "Copy"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Core"
msgstr "Core"

#: app/frontend/pages/dashboard/subscriptions/sections/CoreServicesCard.jsx
msgid "Core services"
msgstr "Core services"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Cores"
msgstr "Cores"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Correlate spikes with workload changes to troubleshoot performance issues."
msgstr "Correlate spikes with workload changes to troubleshoot performance issues."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Correlate with VM workload to assess storage throughput requirements."
msgstr "Correlate with VM workload to assess storage throughput requirements."

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Cosmos DB Account ID"
msgstr "Cosmos DB Account ID"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
msgid "Cosmos DB Accounts"
msgstr "Cosmos DB Accounts"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "Cost"
msgstr "Cost"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Cost Analysis"
msgstr "Cost Analysis"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Cost Anomalies"
msgstr "Cost Anomalies"

#: app/frontend/pages/admin/plan_features/BillingV2ComponentsGrid.jsx
msgid "Cost Baseline"
msgstr "Cost Baseline"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Cost Category Name"
msgstr "Cost Category Name"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Cost Category Spend"
msgstr "Cost Category Spend"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Cost change by optimization category"
msgstr "Cost change by optimization category"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Cost component"
msgstr "Cost component"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Cost data is unavailable for some Azure subscriptions"
msgstr "Cost data is unavailable for some Azure subscriptions"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Cost Data Source"
msgstr "Cost Data Source"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Cost Kind"
msgstr "Cost Kind"

#: app/frontend/components/optimization_overview/OverviewHeader.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Cost Optimization"
msgstr "Cost Optimization"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Cost visibility and optimization across the connected clouds"
msgstr "Cost visibility and optimization across the connected clouds"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Costs by Resource Location"
msgstr "Costs by Resource Location"

#: app/frontend/components/chat/TopicSidebar.jsx
msgid "Could not delete the conversation. Please try again."
msgstr "Could not delete the conversation. Please try again."

#: app/frontend/layout/menu.jsx
msgid "Could not load organizations."
msgstr "Could not load organizations."

#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Count"
msgstr "Count"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Count, Day"
msgstr "Count, Day"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Counts backups and restores that missed their contracted RPO or RTO target this period."
msgstr "Counts backups and restores that missed their contracted RPO or RTO target this period."

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Cover it with a valid SA/BYOL agreement, or move to a license-included AMI."
msgstr "Cover it with a valid SA/BYOL agreement, or move to a license-included AMI."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Coverage"
msgstr "Coverage"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Coverage and score rates are coloured by the Skie recommendation rule — green from 80%, amber from 50%. The contractual rows are left uncoloured here: they are judged against your SLA, in the attention lists below."
msgstr "Coverage and score rates are coloured by the Skie recommendation rule — green from 80%, amber from 50%. The contractual rows are left uncoloured here: they are judged against your SLA, in the attention lists below."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Coverage is pulled from several sources: AWS Backup (resources whose backup tag puts them on an active plan), cross-region DR copies, third-party Managed DB backups, and Elastic Disaster Recovery (DRS)."
msgstr "Coverage is pulled from several sources: AWS Backup (resources whose backup tag puts them on an active plan), cross-region DR copies, third-party Managed DB backups, and Elastic Disaster Recovery (DRS)."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Coverage Rate"
msgstr "Coverage Rate"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Coverage-driven"
msgstr "Coverage-driven"

#. placeholder {0}: fmtUsd(covered)
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "covers {0}/mo of usage"
msgstr "covers {0}/mo of usage"

#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
msgid "CPU"
msgstr "CPU"

#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "CPU Consumption"
msgstr "CPU Consumption"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
msgid "CPU Core Count"
msgstr "CPU Core Count"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
msgid "CPU Core Threads"
msgstr "CPU Core Threads"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "CPU Cores × Threads"
msgstr "CPU Cores × Threads"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "CPU Impact"
msgstr "CPU Impact"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "CPU Limit"
msgstr "CPU Limit"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "CPU Provisioned vs Used"
msgstr "CPU Provisioned vs Used"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "CPU request"
msgstr "CPU request"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "CPU Request"
msgstr "CPU Request"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "CPU Requests"
msgstr "CPU Requests"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "CPU Savings"
msgstr "CPU Savings"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "CPU Status"
msgstr "CPU Status"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "CPU Usage"
msgstr "CPU Usage"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "CPU usage for a VM under a VM Scale Set."
msgstr "CPU usage for a VM under a VM Scale Set."

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "CPU Utilization"
msgstr "CPU Utilization"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "CPU utilization for the RDS instance used to evaluate rightsizing recommendations."
msgstr "CPU utilization for the RDS instance used to evaluate rightsizing recommendations."

#: app/frontend/pages/admin/trusted_keys/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Create"
msgstr "Create"

#: app/frontend/layout/menu.jsx
msgid "Create a new organization"
msgstr "Create a new organization"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Create a new S3 bucket to store the CUR 2.0 report files. Note the bucket name for later steps."
msgstr "Create a new S3 bucket to store the CUR 2.0 report files. Note the bucket name for later steps."

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Create account"
msgstr "Create account"

#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "Create Plan"
msgstr "Create Plan"

#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "Create token"
msgstr "Create token"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Create your free account to access Skie.io's Always Optimized Cloud™"
msgstr "Create your free account to access Skie.io's Always Optimized Cloud™"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Create your user for AWS Account #{awsAccountId}"
msgstr "Create your user for AWS Account #{awsAccountId}"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
msgid "Created"
msgstr "Created"

#: app/frontend/pages/admin/admins/index.jsx
#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/reseller_organizations/index.jsx
#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/admin/users/index.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/dashboard/organizations/index.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Created at"
msgstr "Created at"

#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Created At"
msgstr "Created At"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Created at AWS"
msgstr "Created at AWS"

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
msgid "Created by"
msgstr "Created by"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Created Date"
msgstr "Created Date"

#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Created Time"
msgstr "Created Time"

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
msgid "Creation Date"
msgstr "Creation Date"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Creation Date Time"
msgstr "Creation Date Time"

#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Creation time"
msgstr "Creation time"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Creation Time"
msgstr "Creation Time"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
msgid "Credential"
msgstr "Credential"

#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Credential Error"
msgstr "Credential Error"

#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Credential ID"
msgstr "Credential ID"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Credentials"
msgstr "Credentials"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Credit cap"
msgstr "Credit cap"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Credits"
msgstr "Credits"

#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
msgid "Credits & grace period"
msgstr "Credits & grace period"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Crit / High"
msgstr "Crit / High"

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Critical"
msgstr "Critical"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Critical Gaps"
msgstr "Critical Gaps"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Critical Non-Compliant Count"
msgstr "Critical Non-Compliant Count"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Criticality"
msgstr "Criticality"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Cross-customer FinOps signals — benchmark every client against the book to surface architectural outliers and savings opportunities."
msgstr "Cross-customer FinOps signals — benchmark every client against the book to surface architectural outliers and savings opportunities."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "CrowdStrike Detections - {periodLabel}"
msgstr "CrowdStrike Detections - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "CrowdStrike Falcon agent coverage across EC2 instances in the selected accounts. Protected = online agent; Offline = agent installed but not reporting; Unmanaged = EC2 instances with no agent detected."
msgstr "CrowdStrike Falcon agent coverage across EC2 instances in the selected accounts. Protected = online agent; Offline = agent installed but not reporting; Unmanaged = EC2 instances with no agent detected."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "CrowdStrike Falcon detections currently open (status: new), grouped by severity."
msgstr "CrowdStrike Falcon detections currently open (status: new), grouped by severity."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "CrowdStrike Hosts - {periodLabel}"
msgstr "CrowdStrike Hosts - {periodLabel}"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "CSV File"
msgstr "CSV File"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Currency"
msgstr "Currency"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Currency Code"
msgstr "Currency Code"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimization_overview/CostChart.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Current"
msgstr "Current"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Current /mo"
msgstr "Current /mo"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "Current class"
msgstr "Current class"

#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
msgid "Current Class"
msgstr "Current Class"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
msgid "Current cores"
msgstr "Current cores"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Current CPU Requests"
msgstr "Current CPU Requests"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Current daily"
msgstr "Current daily"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Current Daily Cost"
msgstr "Current Daily Cost"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current DB and Pool SKUs in use."
msgstr "Current DB and Pool SKUs in use."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current distribution of Azure disk types."
msgstr "Current distribution of Azure disk types."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current distribution of EBS volume types."
msgstr "Current distribution of EBS volume types."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current EBS storage allocation by volume kind (gp3, io1, sc1, etc.), shown as a proportional bar strip with a table below listing the volume count and total space for each kind."
msgstr "Current EBS storage allocation by volume kind (gp3, io1, sc1, etc.), shown as a proportional bar strip with a table below listing the volume count and total space for each kind."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current EBS volumes grouped by state (e.g. in-use, available, error), shown as a donut chart with a legend listing each state's count and share of the total."
msgstr "Current EBS volumes grouped by state (e.g. in-use, available, error), shown as a donut chart with a legend listing each state's count and share of the total."

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Current Generation"
msgstr "Current Generation"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Current hourly commitment"
msgstr "Current hourly commitment"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Current inventory"
msgstr "Current inventory"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Current IOPS"
msgstr "Current IOPS"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
msgid "Current kind"
msgstr "Current kind"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Current Kind"
msgstr "Current Kind"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Current Memory Requests"
msgstr "Current Memory Requests"

#: app/frontend/pages/users/registrations/edit.jsx
#: app/frontend/pages/users/settings/password.jsx
#: app/frontend/pages/users/two_factor/PasswordDialog.jsx
msgid "Current password"
msgstr "Current password"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Current RIs"
msgstr "Current RIs"

#: app/frontend/pages/admin/users/show.jsx
msgid "Current sign in at"
msgstr "Current sign in at"

#: app/frontend/pages/admin/users/show.jsx
msgid "Current sign in IP"
msgstr "Current sign in IP"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Current size"
msgstr "Current size"

#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Current SKU"
msgstr "Current SKU"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
msgid "Current threads / core"
msgstr "Current threads / core"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Current Throughput"
msgstr "Current Throughput"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Current type"
msgstr "Current type"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
msgid "Current Type"
msgstr "Current Type"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current types of the instances we recommend changing."
msgstr "Current types of the instances we recommend changing."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Current VM SKUs in use across your Azure environment."
msgstr "Current VM SKUs in use across your Azure environment."

#: app/frontend/components/optimization_overview/CostChart.jsx
msgid "Current vs optimized monthly cost"
msgstr "Current vs optimized monthly cost"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Current/mo"
msgstr "Current/mo"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "Custom agreement"
msgstr "Custom agreement"

#: app/frontend/pages/dashboard/subscriptions/sections/IntegrationsCard.jsx
msgid "Customer access"
msgstr "Customer access"

#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Customer Owned IPv4 Pool"
msgstr "Customer Owned IPv4 Pool"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Customer Tickets"
msgstr "Customer Tickets"

#: app/frontend/components/guardian/help/service_desk.js
msgid "Customer Tickets are opened by your users and carry the headline SLA, resolution and trend metrics. Internal Monitoring covers tickets opened by automation such as the Monitoring Bot and AutoSRE Bot, shown as a separate summary so they don't skew the customer figures."
msgstr "Customer Tickets are opened by your users and carry the headline SLA, resolution and trend metrics. Internal Monitoring covers tickets opened by automation such as the Monitoring Bot and AutoSRE Bot, shown as a separate summary so they don't skew the customer figures."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Customer tickets resolved or closed divided by tickets opened this period."
msgstr "Customer tickets resolved or closed divided by tickets opened this period."

#: app/frontend/components/guardian/help/service_desk.js
msgid "Customer Tickets vs Internal Monitoring"
msgstr "Customer Tickets vs Internal Monitoring"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Cutoff"
msgstr "Cutoff"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "Cutoff (in hours)"
msgstr "Cutoff (in hours)"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Cutoff time (in hours)"
msgstr "Cutoff time (in hours)"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Daily"
msgstr "Daily"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Daily cost"
msgstr "Daily cost"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Daily cost comparison for Azure databases before and after optimization."
msgstr "Daily cost comparison for Azure databases before and after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Daily cost comparison for Azure disks before and after optimization."
msgstr "Daily cost comparison for Azure disks before and after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Daily cost comparison for Azure VMs before and after optimization."
msgstr "Daily cost comparison for Azure VMs before and after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Daily cost comparison for EBS storage before and after optimization."
msgstr "Daily cost comparison for EBS storage before and after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Daily cost comparison for ElastiCache workloads before and after optimization."
msgstr "Daily cost comparison for ElastiCache workloads before and after optimization."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Daily CrowdStrike Falcon detections over the last 30 days, broken down by severity."
msgstr "Daily CrowdStrike Falcon detections over the last 30 days, broken down by severity."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Daily savings"
msgstr "Daily savings"

#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Daily Savings"
msgstr "Daily Savings"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Daily Spend"
msgstr "Daily Spend"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Daily Spend by Usage Type"
msgstr "Daily Spend by Usage Type"

#: app/frontend/layout/top_bar.jsx
msgid "Dark"
msgstr "Dark"

#: app/frontend/pages/dashboard/aws/patch_manager/PatchManagerTabs.jsx
msgid "Dashboard"
msgstr "Dashboard"

#: app/frontend/components/guardian/help/common.js
msgid "Data freshness"
msgstr "Data freshness"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Data is shown with a three-day delay (D-3) to ensure consistency across all charts."
msgstr "Data is shown with a three-day delay (D-3) to ensure consistency across all charts."

#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Data Node CPU Utilization"
msgstr "Data Node CPU Utilization"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Data node type"
msgstr "Data node type"

#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Data Node Type"
msgstr "Data Node Type"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Data node types"
msgstr "Data node types"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Data nodes"
msgstr "Data nodes"

#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Data Nodes"
msgstr "Data Nodes"

#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
msgid "Data Space Used Percent"
msgstr "Data Space Used Percent"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Data space used percent. Not applicable to hyperscale."
msgstr "Data space used percent. Not applicable to hyperscale."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Database"
msgstr "Database"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Database / Pool"
msgstr "Database / Pool"

#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
msgid "Database ID"
msgstr "Database ID"

#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Database Name"
msgstr "Database Name"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
msgid "Database Port"
msgstr "Database Port"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
msgid "Database Reservations"
msgstr "Database Reservations"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Database SCORE"
msgstr "Database SCORE"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Databases"
msgstr "Databases"

#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
msgid "Databases Dashboard"
msgstr "Databases Dashboard"

#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Datasource ID"
msgstr "Datasource ID"

#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Datasource Type"
msgstr "Datasource Type"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Date"
msgstr "Date"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Date / Time"
msgstr "Date / Time"

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Date Range"
msgstr "Date Range"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Days since last connection"
msgstr "Days since last connection"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "DB Cluster Identifier"
msgstr "DB Cluster Identifier"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "DB Cluster Instance Class"
msgstr "DB Cluster Instance Class"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "DB Cluster Members"
msgstr "DB Cluster Members"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "DB Engine"
msgstr "DB Engine"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "DB Instance Automated Backups Replications"
msgstr "DB Instance Automated Backups Replications"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
msgid "DB instance class"
msgstr "DB instance class"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "DB Instance Class"
msgstr "DB Instance Class"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
msgid "DB Instance Identifier"
msgstr "DB Instance Identifier"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "DB Instance Status"
msgstr "DB Instance Status"

#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "DB Name"
msgstr "DB Name"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Decision"
msgstr "Decision"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Dedicated"
msgstr "Dedicated"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Dedicated EBS Throughput"
msgstr "Dedicated EBS Throughput"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Dedicated Host ID"
msgstr "Dedicated Host ID"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
msgid "Dedicated Hosts"
msgstr "Dedicated Hosts"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Dedicated Hosts Supported"
msgstr "Dedicated Hosts Supported"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Dedicated master count"
msgstr "Dedicated master count"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "Dedicated Master Count"
msgstr "Dedicated Master Count"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Dedicated master enabled"
msgstr "Dedicated master enabled"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Dedicated master node count override for this domain."
msgstr "Dedicated master node count override for this domain."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Dedicated master type"
msgstr "Dedicated master type"

#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Default"
msgstr "Default"

#: app/frontend/pages/dashboard/organizations/edit.jsx
msgid "Default AWS STS External ID"
msgstr "Default AWS STS External ID"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Default Capacity Provider Strategy"
msgstr "Default Capacity Provider Strategy"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Default Cores"
msgstr "Default Cores"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Default IAM Role ARN"
msgstr "Default IAM Role ARN"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Default maximum number of master and data nodes"
msgstr "Default maximum number of master and data nodes"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Default Maximum Number of Master and Data Nodes"
msgstr "Default Maximum Number of Master and Data Nodes"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Default maximum number of master and data nodes. The default value is 3."
msgstr "Default maximum number of master and data nodes. The default value is 3."

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Default Threads Per Core"
msgstr "Default Threads Per Core"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Default Vcpus"
msgstr "Default Vcpus"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Defaults"
msgstr "Defaults"

#: app/frontend/components/chat/TopicSidebar.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/plan_features/edit.jsx
#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DeleteDataImportModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/memberships/ConfirmRemoveModal.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Delete"
msgstr "Delete"

#: app/frontend/pages/dashboard/aws/accounts/DeleteAccountModal.jsx
msgid "Delete account"
msgstr "Delete account"

#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Delete admin token?"
msgstr "Delete admin token?"

#: app/frontend/pages/dashboard/azure/credentials/DeleteCredentialModal.jsx
msgid "Delete credential"
msgstr "Delete credential"

#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
msgid "Delete feature"
msgstr "Delete feature"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Delete maintenance window"
msgstr "Delete maintenance window"

#: app/frontend/pages/users/settings/privacy.jsx
msgid "Delete my account"
msgstr "Delete my account"

#: app/frontend/components/optimizations/OptimizationsListing.jsx
msgid "Delete optimization"
msgstr "Delete optimization"

#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Delete optimization run"
msgstr "Delete optimization run"

#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
#: app/frontend/pages/dashboard/organizations/edit.jsx
msgid "Delete organization"
msgstr "Delete organization"

#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "Delete plan feature"
msgstr "Delete plan feature"

#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Delete resource group"
msgstr "Delete resource group"

#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
msgid "Delete service user?"
msgstr "Delete service user?"

#: app/frontend/pages/dashboard/azure/subscriptions/DeleteSubscriptionModal.jsx
msgid "Delete subscription"
msgstr "Delete subscription"

#: app/frontend/pages/admin/tag_templates/show.jsx
msgid "Delete tag template"
msgstr "Delete tag template"

#: app/frontend/pages/dashboard/organization_tokens/DeleteTokenModal.jsx
msgid "Delete the API token?"
msgstr "Delete the API token?"

#: app/frontend/pages/dashboard/aws/accounts/DeleteAccountModal.jsx
msgid "Delete the AWS account?"
msgstr "Delete the AWS account?"

#: app/frontend/pages/dashboard/azure/credentials/DeleteCredentialModal.jsx
msgid "Delete the Azure credential?"
msgstr "Delete the Azure credential?"

#: app/frontend/pages/dashboard/azure/subscriptions/DeleteSubscriptionModal.jsx
msgid "Delete the Azure subscription?"
msgstr "Delete the Azure subscription?"

#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "Delete the organization?"
msgstr "Delete the organization?"

#: app/frontend/pages/dashboard/organization_tokens/DeleteTokenModal.jsx
msgid "Delete token"
msgstr "Delete token"

#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
msgid "Delete trusted key?"
msgstr "Delete trusted key?"

#: app/frontend/pages/admin/users/show.jsx
msgid "Delete user"
msgstr "Delete user"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Deleted"
msgstr "Deleted"

#: app/frontend/pages/dashboard/azure/credentials/DeleteCredentialModal.jsx
msgid "Deleting this credential also removes its client secret. A credential that still serves an Azure subscription cannot be deleted."
msgstr "Deleting this credential also removes its client secret. A credential that still serves an Azure subscription cannot be deleted."

#: app/frontend/pages/users/settings/privacy.jsx
msgid "Deleting your account will remove all of your information from our database. This cannot be undone."
msgstr "Deleting your account will remove all of your information from our database. This cannot be undone."

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Deletion Date"
msgstr "Deletion Date"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Deletion Protection Enabled"
msgstr "Deletion Protection Enabled"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Delivery"
msgstr "Delivery"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Deployment"
msgstr "Deployment"

#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
msgid "Deployment Model"
msgstr "Deployment Model"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Deployment Type"
msgstr "Deployment Type"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/baselines/index.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "Description"
msgstr "Description"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "Deselect all"
msgstr "Deselect all"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Desired"
msgstr "Desired"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Destination Region"
msgstr "Destination Region"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Detail"
msgstr "Detail"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/admin/billing_line_items/index.jsx
#: app/frontend/pages/admin/plans/PlanSettingsLayout.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Details"
msgstr "Details"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Detected At"
msgstr "Detected At"

#: app/frontend/pages/dashboard/subscriptions/sections/AwsAccountsSection.jsx
msgid "development"
msgstr "development"

#: app/frontend/components/guardian/GuardianAccountsDrawer.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Development"
msgstr "Development"

#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "Device"
msgstr "Device"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Dimension"
msgstr "Dimension"

#: app/frontend/utils/azure.js
msgid "Disable binpacking — do not migrate databases."
msgstr "Disable binpacking — do not migrate databases."

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Disabled"
msgstr "Disabled"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
msgid "Disaster Recovery"
msgstr "Disaster Recovery"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Disaster recovery — RPO / RTO"
msgstr "Disaster recovery — RPO / RTO"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Disbursement event"
msgstr "Disbursement event"

#: app/frontend/pages/users/settings/connections.jsx
msgid "Disconnect"
msgstr "Disconnect"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
#: app/frontend/pages/users/settings/connections.jsx
msgid "Disconnected"
msgstr "Disconnected"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Disk"
msgstr "Disk"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Disk Bytes / Second"
msgstr "Disk Bytes / Second"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Disk Bytes/sec"
msgstr "Disk Bytes/sec"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Disk Count"
msgstr "Disk Count"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Disk Count, Percentage"
msgstr "Disk Count, Percentage"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Disk ID"
msgstr "Disk ID"

#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
msgid "Disk inventory and spend by disk type across all connected Azure subscriptions"
msgstr "Disk inventory and spend by disk type across all connected Azure subscriptions"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Disk IOPS for a VM under a VM Scale Set."
msgstr "Disk IOPS for a VM under a VM Scale Set."

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Disk Operations"
msgstr "Disk Operations"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Disk Operations / Second"
msgstr "Disk Operations / Second"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Disk Ops/Sec"
msgstr "Disk Ops/Sec"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
msgid "Disk Size"
msgstr "Disk Size"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Disk SKUs"
msgstr "Disk SKUs"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
msgid "Disk Snapshots"
msgstr "Disk Snapshots"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "Disk State"
msgstr "Disk State"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Disk Throughput"
msgstr "Disk Throughput"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Disk throughput for a VM under a VM Scale Set."
msgstr "Disk throughput for a VM under a VM Scale Set."

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
msgid "Disk Type"
msgstr "Disk Type"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Disks"
msgstr "Disks"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Dismiss"
msgstr "Dismiss"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Dismiss CPU Recommendation"
msgstr "Dismiss CPU Recommendation"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Dismiss Memory Recommendation"
msgstr "Dismiss Memory Recommendation"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Dismissed"
msgstr "Dismissed"

#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Display Name"
msgstr "Display Name"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a bar chart, it elucidates monthly costs in USD on the Y-axis over the months on the X-axis. Each bar is segmented to represent the cost proportion attributable to a specific account, facilitating a granular understanding of spending patterns. Users can hover over individual segments to view account-specific expenditure details."
msgstr "Displayed as a bar chart, it elucidates monthly costs in USD on the Y-axis over the months on the X-axis. Each bar is segmented to represent the cost proportion attributable to a specific account, facilitating a granular understanding of spending patterns. Users can hover over individual segments to view account-specific expenditure details."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a bar graph, the Y-axis quantifies costs in USD, while the X-axis delineates the months within the specified timeframe. Each bar segment represents the proportion of costs attributed to a specific operating system. Users can access detailed information for each segment by hovering over it, revealing the exact value associated with that particular operating system."
msgstr "Displayed as a bar graph, the Y-axis quantifies costs in USD, while the X-axis delineates the months within the specified timeframe. Each bar segment represents the proportion of costs attributed to a specific operating system. Users can access detailed information for each segment by hovering over it, revealing the exact value associated with that particular operating system."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a donut chart, each segment corresponds to a specific VM size (such as Standard_D2s_v3, Standard_E4s_v4, etc.). Hovering over segments reveals the number of VMs and their relative proportion."
msgstr "Displayed as a donut chart, each segment corresponds to a specific VM size (such as Standard_D2s_v3, Standard_E4s_v4, etc.). Hovering over segments reveals the number of VMs and their relative proportion."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a multi-series line chart, each line represents a distinct meter subcategory, enabling users to observe cost trends and fluctuations over time. Hovering over individual data points reveals precise monthly expenditure values for each subcategory."
msgstr "Displayed as a multi-series line chart, each line represents a distinct meter subcategory, enabling users to observe cost trends and fluctuations over time. Hovering over individual data points reveals precise monthly expenditure values for each subcategory."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a multi-series line chart, each line represents an individual Azure subscription, enabling users to track cost trends and variations over time. Hovering over data points reveals exact monthly spend values for each subscription."
msgstr "Displayed as a multi-series line chart, each line represents an individual Azure subscription, enabling users to track cost trends and variations over time. Hovering over data points reveals exact monthly spend values for each subscription."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a pie chart, each segment represents the expenses attributed to a specific type group, offering a straightforward overview of cost allocation. Users can access detailed insights by hovering over each segment, revealing the value and percentage associated with that particular group."
msgstr "Displayed as a pie chart, each segment represents the expenses attributed to a specific type group, offering a straightforward overview of cost allocation. Users can access detailed insights by hovering over each segment, revealing the value and percentage associated with that particular group."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a pie chart, it highlights the total expenditure at the center, with each segment representing spending on a specific service. Users can gain insights by hovering over segments, accessing detailed expenditure values and percentages for each service."
msgstr "Displayed as a pie chart, it highlights the total expenditure at the center, with each segment representing spending on a specific service. Users can gain insights by hovering over segments, accessing detailed expenditure values and percentages for each service."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a pie chart, it visually depicts the distribution of instances across various usage operations. The total aggregated count of instances for each usage operation is prominently featured at the chart's center. Each segment of the chart represents the proportion of instances attributed to a specific usage operation, allowing users to access detailed information by hovering over segments, including the total count of instances."
msgstr "Displayed as a pie chart, it visually depicts the distribution of instances across various usage operations. The total aggregated count of instances for each usage operation is prominently featured at the chart's center. Each segment of the chart represents the proportion of instances attributed to a specific usage operation, allowing users to access detailed information by hovering over segments, including the total count of instances."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a scale chart, it effectively contrasts the CPU utilization of the two instance versions based on the metrics from the current instance. The Y-axis represents the CPU utilization percentage, while the X-axis showcases the interval between data points. Each bar segment corresponds to the CPU utilization for a specific type, allowing users to hover over segments for more detailed insights."
msgstr "Displayed as a scale chart, it effectively contrasts the CPU utilization of the two instance versions based on the metrics from the current instance. The Y-axis represents the CPU utilization percentage, while the X-axis showcases the interval between data points. Each bar segment corresponds to the CPU utilization for a specific type, allowing users to hover over segments for more detailed insights."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a stacked area chart, it effectively contrasts the network utilization of the two instance versions based on the metrics from the current instance. The Y-axis represents the total network utilization, while the X-axis showcases the intervals between data points. Each bar segment is composed of two components: 'Network In' and 'Network Out', allowing users to hover over segments for more detailed insights."
msgstr "Displayed as a stacked area chart, it effectively contrasts the network utilization of the two instance versions based on the metrics from the current instance. The Y-axis represents the total network utilization, while the X-axis showcases the intervals between data points. Each bar segment is composed of two components: 'Network In' and 'Network Out', allowing users to hover over segments for more detailed insights."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a stacked bar chart, each bar breaks down monthly spend by charge type, with the top 10 charge types shown individually and the rest grouped into \"Other\", along with the total."
msgstr "Displayed as a stacked bar chart, each bar breaks down monthly spend by charge type, with the top 10 charge types shown individually and the rest grouped into \"Other\", along with the total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a stacked bar chart, each bar breaks down monthly spend into Compute and License segments, with the total shown alongside."
msgstr "Displayed as a stacked bar chart, each bar breaks down monthly spend into Compute and License segments, with the total shown alongside."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as a stacked column chart, each bar represents a month, with segments showing the cost per disk type (e.g., Premium SSD, Standard SSD, Standard HDD). Hovering over segments reveals exact monthly costs for each disk type."
msgstr "Displayed as a stacked column chart, each bar represents a month, with segments showing the cost per disk type (e.g., Premium SSD, Standard SSD, Standard HDD). Hovering over segments reveals exact monthly costs for each disk type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Displayed as horizontal bars, each row corresponds to a VM size, ordered from highest to lowest spend."
msgstr "Displayed as horizontal bars, each row corresponds to a VM size, ordered from highest to lowest spend."

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Distinct EC2 instances running a paid SQL Server edition (Standard, Enterprise or Web). Counts both license-included and BYOL/self-installed instances detected via SSM. Free editions are excluded."
msgstr "Distinct EC2 instances running a paid SQL Server edition (Standard, Enterprise or Web). Counts both license-included and BYOL/self-installed instances detected via SSM. Free editions are excluded."

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Distinct organizations with at least one active Guardian tier in the selected period."
msgstr "Distinct organizations with at least one active Guardian tier in the selected period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Distribution of current ElastiCache node types in your fleet."
msgstr "Distribution of current ElastiCache node types in your fleet."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Distribution of current OpenSearch data node instance types."
msgstr "Distribution of current OpenSearch data node instance types."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Distribution of current OpenSearch master node instance types."
msgstr "Distribution of current OpenSearch master node instance types."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Distribution of current RDS DB instance classes in your fleet."
msgstr "Distribution of current RDS DB instance classes in your fleet."

#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "DNS Name"
msgstr "DNS Name"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "DNS Servers"
msgstr "DNS Servers"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Document Endpoint"
msgstr "Document Endpoint"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Domain"
msgstr "Domain"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Domain ID"
msgstr "Domain ID"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Domain name"
msgstr "Domain name"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "Domain Name"
msgstr "Domain Name"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Don't Add HPA"
msgstr "Don't Add HPA"

#: app/frontend/components/guardian/TicketStatusTree.jsx
#: app/frontend/pages/users/admin_tokens/created.jsx
#: app/frontend/pages/users/two_factor/BackupCodesDialog.jsx
msgid "Done"
msgstr "Done"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Down (min)"
msgstr "Down (min)"

#: app/frontend/pages/users/two_factor/BackupCodesDialog.jsx
msgid "Download as a text file"
msgstr "Download as a text file"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Download create-skie-application.ps1"
msgstr "Download create-skie-application.ps1"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Download the CloudFormation template"
msgstr "Download the CloudFormation template"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Download the FOCUS CUR template"
msgstr "Download the FOCUS CUR template"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "DR copy job history"
msgstr "DR copy job history"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DR Copy Jobs - {periodLabel}"
msgstr "DR Copy Jobs - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "DR Coverage"
msgstr "DR Coverage"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "DR Drills"
msgstr "DR Drills"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DR Region"
msgstr "DR Region"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DR Resources - {periodLabel}"
msgstr "DR Resources - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DR RPO"
msgstr "DR RPO"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DR Status"
msgstr "DR Status"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "DR-Protected"
msgstr "DR-Protected"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "DR-Skipped"
msgstr "DR-Skipped"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "DR-Unprotected"
msgstr "DR-Unprotected"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "drills"
msgstr "drills"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "DRS (AWS Elastic Disaster Recovery) continuously copies whole servers so they can be started up elsewhere after a disaster. Drills are test recoveries and their average recovery time; a snapshot is Consistent when it is a usable point to recover from."
msgstr "DRS (AWS Elastic Disaster Recovery) continuously copies whole servers so they can be started up elsewhere after a disaster. Drills are test recoveries and their average recovery time; a snapshot is Consistent when it is a usable point to recover from."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "DRS Protected Resources - {periodLabel}"
msgstr "DRS Protected Resources - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "DRS Snapshots"
msgstr "DRS Snapshots"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "DRS Source Servers"
msgstr "DRS Source Servers"

#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "DTU Consumption"
msgstr "DTU Consumption"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "DTU Percent"
msgstr "DTU Percent"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "DTU utilization for the database over time to evaluate sizing and performance."
msgstr "DTU utilization for the database over time to evaluate sizing and performance."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Duration"
msgstr "Duration"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Duration (in hours)"
msgstr "Duration (in hours)"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "DynamoDB"
msgstr "DynamoDB"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "DynamoDB table"
msgstr "DynamoDB table"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "DynamoDB Tables"
msgstr "DynamoDB Tables"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "e.g. 2.5"
msgstr "e.g. 2.5"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "e.g. analytics"
msgstr "e.g. analytics"

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
msgid "e.g. Env"
msgstr "e.g. Env"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "e.g. Prod-Critical"
msgstr "e.g. Prod-Critical"

#: app/frontend/components/guardian/help/common.js
msgid "Each area shows its own \"As of\" date — the last time that source synced successfully. Everything refreshes once a day, so figures reflect yesterday, not this moment."
msgstr "Each area shows its own \"As of\" date — the last time that source synced successfully. Everything refreshes once a day, so figures reflect yesterday, not this moment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Each bar is a percentage: the on-demand equivalent is estimated by matching each meter to its current retail price and multiplying by the hours actually consumed, then savings % = (on-demand equivalent − amortized cost) ÷ on-demand equivalent."
msgstr "Each bar is a percentage: the on-demand equivalent is estimated by matching each meter to its current retail price and multiplying by the hours actually consumed, then savings % = (on-demand equivalent − amortized cost) ÷ on-demand equivalent."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Each bar on the chart represents a month within the specified period, with the Y-axis indicating costs in USD and the X-axis denoting the months. The segments within each bar represent the proportion of costs attributed to a specific purchase type. Users can gain detailed insights into each segment by hovering over them, revealing the exact values associated with the respective purchase type."
msgstr "Each bar on the chart represents a month within the specified period, with the Y-axis indicating costs in USD and the X-axis denoting the months. The segments within each bar represent the proportion of costs attributed to a specific purchase type. Users can gain detailed insights into each segment by hovering over them, revealing the exact values associated with the respective purchase type."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Each cell = standard deviations above the cohort median for that service."
msgstr "Each cell = standard deviations above the cohort median for that service."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Each eligible instance falls in exactly one status for the period: patched, failed, running, missed, awaiting its maintenance window, outside any patch group, skipped, or past vendor end of support."
msgstr "Each eligible instance falls in exactly one status for the period: patched, failed, running, missed, awaiting its maintenance window, outside any patch group, skipped, or past vendor end of support."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Each lever's net effect on monthly spend (green = saving, red = added cost)."
msgstr "Each lever's net effect on monthly spend (green = saving, red = added cost)."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Each pillar's current rate is compared to the previous period, alongside a rolling six-month trend."
msgstr "Each pillar's current rate is compared to the previous period, alongside a rolling six-month trend."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Each priority's average time to first response is compared to its SLA target, with a 25% grace buffer before it turns red."
msgstr "Each priority's average time to first response is compared to its SLA target, with a 25% grace buffer before it turns red."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Each priority's average time to resolve is compared to its SLA target, with a 25% grace buffer before it turns red. Not applicable for tiers without a formal resolution SLA."
msgstr "Each priority's average time to resolve is compared to its SLA target, with a 25% grace buffer before it turns red. Not applicable for tiers without a formal resolution SLA."

#: app/frontend/components/guardian/help/patch_management.js
msgid "Each server goes through three phases, each made of several steps: pre-hook (preparation, such as stopping services or taking a snapshot), patch automation (installing the patches and rebooting), and post-hook (putting the server back in service and checking it)."
msgstr "Each server goes through three phases, each made of several steps: pre-hook (preparation, such as stopping services or taking a snapshot), patch automation (installing the patches and rebooting), and post-hook (putting the server back in service and checking it)."

#: app/frontend/components/optimization_overview/OverviewHeader.jsx
msgid "Each service's most recent completed analysis. The \"as of\" date differs per service; anything older than 30 days is flagged."
msgstr "Each service's most recent completed analysis. The \"as of\" date differs per service; anything older than 30 days is flagged."

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "Each SQL Server Enterprise core covers four General Purpose vCores or one Business Critical vCore; each Standard core covers one General Purpose vCore."
msgstr "Each SQL Server Enterprise core covers four General Purpose vCores or one Business Critical vCore; each Standard core covers one General Purpose vCore."

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
msgid "EBS"
msgstr "EBS"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "EBS commitments"
msgstr "EBS commitments"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "EBS Dashboard"
msgstr "EBS Dashboard"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
msgid "EBS optimization action"
msgstr "EBS optimization action"

#: app/frontend/pages/dashboard/aws/ebs/optimizations/index.jsx
msgid "EBS Optimizations"
msgstr "EBS Optimizations"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "EBS Optimized"
msgstr "EBS Optimized"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "EBS unattached volumes"
msgstr "EBS unattached volumes"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "EBS Volume Modification"
msgstr "EBS Volume Modification"

#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "EBS Volumes"
msgstr "EBS Volumes"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "EC2"
msgstr "EC2"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "EC2 · ECS · EKS · Lambda — all figures exact"
msgstr "EC2 · ECS · EKS · Lambda — all figures exact"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "EC2 Attachment Status"
msgstr "EC2 Attachment Status"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "EC2 Availability"
msgstr "EC2 Availability"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "EC2 Availability - {periodLabel}"
msgstr "EC2 Availability - {periodLabel}"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "EC2 availability — H/A"
msgstr "EC2 availability — H/A"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "EC2 availability — Standard"
msgstr "EC2 availability — Standard"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "EC2 CPU Optimized"
msgstr "EC2 CPU Optimized"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "EC2 Dashboard"
msgstr "EC2 Dashboard"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "EC2 instance"
msgstr "EC2 instance"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "EC2 Instance"
msgstr "EC2 Instance"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "EC2 instance exceptions"
msgstr "EC2 instance exceptions"

#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "EC2 Instance Family"
msgstr "EC2 Instance Family"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "EC2 Instance Settings"
msgstr "EC2 Instance Settings"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "EC2 Instances"
msgstr "EC2 Instances"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "EC2 instances meeting their availability target"
msgstr "EC2 instances meeting their availability target"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "EC2 instances not matched by any patch resource group."
msgstr "EC2 instances not matched by any patch resource group."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "EC2 instances with the most active Inspector findings in the selected period, with the support status of the operating system they run. Findings on an OS past its vendor support will not go away with patching — the instance has to be upgraded."
msgstr "EC2 instances with the most active Inspector findings in the selected period, with the support status of the operating system they run. Findings on an OS past its vendor support will not go away with patching — the instance has to be upgraded."

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "EC2 optimization action"
msgstr "EC2 optimization action"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/index.jsx
msgid "EC2 Optimizations"
msgstr "EC2 Optimizations"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "EC2 Reserved Instances"
msgstr "EC2 Reserved Instances"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "EC2 right sizing"
msgstr "EC2 right sizing"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "EC2 Right Sizing"
msgstr "EC2 Right Sizing"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "EC2 Right Sizing / Right Typing"
msgstr "EC2 Right Sizing / Right Typing"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "EC2 rightsizing"
msgstr "EC2 rightsizing"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "EC2 underutilized RIs"
msgstr "EC2 underutilized RIs"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "ECS"
msgstr "ECS"

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
msgid "ECS Clusters"
msgstr "ECS Clusters"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "ECS right sizing"
msgstr "ECS right sizing"

#: app/frontend/components/optimizer/OptimizerSettingsListing.jsx
#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Edit"
msgstr "Edit"

#: app/frontend/pages/dashboard/change_requests/edit.jsx
msgid "Edit Change Request"
msgstr "Edit Change Request"

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
msgid "Edit data import"
msgstr "Edit data import"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
msgid "Edit Database Settings"
msgstr "Edit Database Settings"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
msgid "Edit EBS Volume Recommendation"
msgstr "Edit EBS Volume Recommendation"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
msgid "Edit EC2 CPU Optimized Recommendation"
msgstr "Edit EC2 CPU Optimized Recommendation"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "Edit EC2 Instance Settings"
msgstr "Edit EC2 Instance Settings"

#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Edit EC2 Right Size Recommendation"
msgstr "Edit EC2 Right Size Recommendation"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Edit EKS Cluster Settings"
msgstr "Edit EKS Cluster Settings"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
msgid "Edit ElastiCache Cluster Settings"
msgstr "Edit ElastiCache Cluster Settings"

#: app/frontend/pages/dashboard/aws/maintenance_windows/edit.jsx
msgid "Edit Maintenance Window"
msgstr "Edit Maintenance Window"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Edit Opensearch Cluster Settings"
msgstr "Edit Opensearch Cluster Settings"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
msgid "Edit RDS Instance Settings"
msgstr "Edit RDS Instance Settings"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Edit recommendation"
msgstr "Edit recommendation"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Edit Recommendation"
msgstr "Edit Recommendation"

#: app/frontend/pages/dashboard/resource_groups/edit.jsx
msgid "Edit Resource Group"
msgstr "Edit Resource Group"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Edit selection"
msgstr "Edit selection"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Edit settings"
msgstr "Edit settings"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Edit Virtual Machine Settings"
msgstr "Edit Virtual Machine Settings"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
msgid "Edition"
msgstr "Edition"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Edition / Version"
msgstr "Edition / Version"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Edition mismatch"
msgstr "Edition mismatch"

#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Effective Date"
msgstr "Effective Date"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Effective Discount"
msgstr "Effective Discount"

#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
msgid "Effective Engine"
msgstr "Effective Engine"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Effective Savings"
msgstr "Effective Savings"

#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
msgid "EFS File Systems"
msgstr "EFS File Systems"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "EKS"
msgstr "EKS"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "EKS Auto Mode"
msgstr "EKS Auto Mode"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "EKS cluster exceptions"
msgstr "EKS cluster exceptions"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "EKS Cluster Settings"
msgstr "EKS Cluster Settings"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
msgid "EKS Clusters"
msgstr "EKS Clusters"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "EKS Dashboard"
msgstr "EKS Dashboard"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "EKS enabled"
msgstr "EKS enabled"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "EKS fleet right-sizing"
msgstr "EKS fleet right-sizing"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "EKS robustness"
msgstr "EKS robustness"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "EKS Robustness"
msgstr "EKS Robustness"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "EKS Split Cost"
msgstr "EKS Split Cost"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "EKS Split Cost — CUR 2.0 Data Export Setup"
msgstr "EKS Split Cost — CUR 2.0 Data Export Setup"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
msgid "Elastic Disaster Recovery"
msgstr "Elastic Disaster Recovery"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Elastic Disaster Recovery (DRS)"
msgstr "Elastic Disaster Recovery (DRS)"

#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
msgid "Elastic IPs"
msgstr "Elastic IPs"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "ElastiCache"
msgstr "ElastiCache"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "ElastiCache cluster"
msgstr "ElastiCache cluster"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "ElastiCache cluster exceptions"
msgstr "ElastiCache cluster exceptions"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "ElastiCache Cluster Settings"
msgstr "ElastiCache Cluster Settings"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "ElastiCache Clusters"
msgstr "ElastiCache Clusters"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "ElastiCache Engine"
msgstr "ElastiCache Engine"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/index.jsx
msgid "ElastiCache Optimizations"
msgstr "ElastiCache Optimizations"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
msgid "ElastiCache reserved instance"
msgstr "ElastiCache reserved instance"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
msgid "ElastiCache Reserved Instances"
msgstr "ElastiCache Reserved Instances"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "ElastiCache right sizing"
msgstr "ElastiCache right sizing"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "ElastiCache Settings"
msgstr "ElastiCache Settings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
msgid "Eligible EC2 instances that completed a successful patch run in the selected period."
msgstr "Eligible EC2 instances that completed a successful patch run in the selected period."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Eligible resources without active backup coverage."
msgstr "Eligible resources without active backup coverage."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Eliminated"
msgstr "Eliminated"

#: app/frontend/pages/admin/admins/index.jsx
#: app/frontend/pages/admin/users/index.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
#: app/frontend/pages/dashboard/memberships/InviteModal.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
#: app/frontend/pages/users/registrations/edit.jsx
msgid "Email"
msgstr "Email"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Enable <0>\"Account Owner can view charges\"</0>"
msgstr "Enable <0>\"Account Owner can view charges\"</0>"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable Aurora IO Optimized"
msgstr "Enable Aurora IO Optimized"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable Aurora IO Optimized if you want to receive recommendations for Aurora IO Optimized instances."
msgstr "Enable Aurora IO Optimized if you want to receive recommendations for Aurora IO Optimized instances."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Enable EBS volume modifications, snapshot creation/deletion, and volume management"
msgstr "Enable EBS volume modifications, snapshot creation/deletion, and volume management"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable EKS Optimization"
msgstr "Enable EKS Optimization"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable EKS optimization recommendations."
msgstr "Enable EKS optimization recommendations."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Enable OS patch automation and instance right sizing actions"
msgstr "Enable OS patch automation and instance right sizing actions"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Enable purchasing of Savings Plans for cost optimization"
msgstr "Enable purchasing of Savings Plans for cost optimization"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Enable RDS instance class modifications for database optimization"
msgstr "Enable RDS instance class modifications for database optimization"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable the AWS accounts to skip from the optimizer recommendations."
msgstr "Enable the AWS accounts to skip from the optimizer recommendations."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Enable the Azure subscriptions to skip from the optimizer recommendations."
msgstr "Enable the Azure subscriptions to skip from the optimizer recommendations."

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Enable the SSM agent on the host."
msgstr "Enable the SSM agent on the host."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Enable write permissions to allow Skie.io to perform cost optimization actions in your AWS account. When enabled, additional IAM policies will be generated and must be applied to your existing role."
msgstr "Enable write permissions to allow Skie.io to perform cost optimization actions in your AWS account. When enabled, additional IAM policies will be generated and must be applied to your existing role."

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "Enable write permissions to apply cost optimization actions"
msgstr "Enable write permissions to apply cost optimization actions"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
#: app/frontend/pages/users/two_factor/show.jsx
msgid "Enabled"
msgstr "Enabled"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "Enabled capabilities"
msgstr "Enabled capabilities"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Encrypted"
msgstr "Encrypted"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "End Date"
msgstr "End Date"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "End of support"
msgstr "End of support"

#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "End of Support"
msgstr "End of Support"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "End Time"
msgstr "End Time"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "End-of-Support instances"
msgstr "End-of-Support instances"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "End-of-Support instances — yellow when present, signals upgrade need."
msgstr "End-of-Support instances — yellow when present, signals upgrade need."

#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Endpoint"
msgstr "Endpoint"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Endpoint coverage"
msgstr "Endpoint coverage"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Endpoint Coverage"
msgstr "Endpoint Coverage"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Endpoint ID"
msgstr "Endpoint ID"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
msgid "Endpoint Security"
msgstr "Endpoint Security"

#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Enforce Security Group Inbound Rules"
msgstr "Enforce Security Group Inbound Rules"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Engine"
msgstr "Engine"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
msgid "Engine version"
msgstr "Engine version"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Engine Version"
msgstr "Engine Version"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Enhanced VPC Routing"
msgstr "Enhanced VPC Routing"

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "Enter a tag key and press Enter or click Add."
msgstr "Enter a tag key and press Enter or click Add."

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "Enter the 6-digit code generated by your app."
msgstr "Enter the 6-digit code generated by your app."

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Enter your password to generate new backup codes. The codes you have now will stop working."
msgstr "Enter your password to generate new backup codes. The codes you have now will stop working."

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Enter your password to start setting up two-factor authentication."
msgstr "Enter your password to start setting up two-factor authentication."

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Enter your password to turn off two-factor authentication. You will no longer be asked for a code when you sign in."
msgstr "Enter your password to turn off two-factor authentication. You will no longer be asked for a code when you sign in."

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Enterprise"
msgstr "Enterprise"

#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
msgid "Entitlements"
msgstr "Entitlements"

#: app/frontend/pages/admin/billing_reports/index.jsx
msgid "Entries"
msgstr "Entries"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Environment"
msgstr "Environment"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "EoS"
msgstr "EoS"

#: app/frontend/layout/hooks.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "Error"
msgstr "Error"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Error details"
msgstr "Error details"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Errors on this tab"
msgstr "Errors on this tab"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Est. monthly impact"
msgstr "Est. monthly impact"

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Est. saving"
msgstr "Est. saving"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Estimated · 35%"
msgstr "Estimated · 35%"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Estimated impact"
msgstr "Estimated impact"

#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "every configured service analyzed"
msgstr "every configured service analyzed"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Every resource in scope falls in exactly one state: protected by a backup plan, unprotected, or excluded from coverage. Excluded resources are counted in the bar but left out of the protected-of-eligible headline."
msgstr "Every resource in scope falls in exactly one state: protected by a backup plan, unprotected, or excluded from coverage. Excluded resources are counted in the bar but left out of the protected-of-eligible headline."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Every signal across the book in one worklist."
msgstr "Every signal across the book in one worklist."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Every ticket opened in the period, grouped by Jira's own three categories — To Do, In Progress and Done — with the statuses that make up each group. A status Jira files outside the three lands under \"Other statuses\", so the rows always add up to the period total."
msgstr "Every ticket opened in the period, grouped by Jira's own three categories — To Do, In Progress and Done — with the statuses that make up each group. A status Jira files outside the three lands under \"Other statuses\", so the rows always add up to the period total."

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Eviction Policy"
msgstr "Eviction Policy"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Evolution"
msgstr "Evolution"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Exact"
msgstr "Exact"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Excellent"
msgstr "Excellent"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
msgid "Excluded Savings"
msgstr "Excluded Savings"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Execution context"
msgstr "Execution context"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Execution Context"
msgstr "Execution Context"

#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
msgid "Execution details"
msgstr "Execution details"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Execution Details"
msgstr "Execution Details"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Execution mode"
msgstr "Execution mode"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Execution Mode"
msgstr "Execution Mode"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Execution Workflow"
msgstr "Execution Workflow"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Executive Summary"
msgstr "Executive Summary"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Executive Summary gives a one-glance view of the whole Guardian dashboard: what was delivered this period, how each pillar is trending, what needs attention, and supporting detail for tickets and recovery targets."
msgstr "Executive Summary gives a one-glance view of the whole Guardian dashboard: what was delivered this period, how each pillar is trending, what needs attention, and supporting detail for tickets and recovery targets."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Existing RI"
msgstr "Existing RI"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Existing RIs"
msgstr "Existing RIs"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Expected CPU"
msgstr "Expected CPU"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Expiration Date"
msgstr "Expiration Date"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Expired"
msgstr "Expired"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Expires"
msgstr "Expires"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Expires at"
msgstr "Expires at"

#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "Expires in"
msgstr "Expires in"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Expires in {days} days"
msgstr "Expires in {days} days"

#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Expiry Date"
msgstr "Expiry Date"

#: app/frontend/components/echarts/modal/export_button.jsx
msgid "Export"
msgstr "Export"

#: app/frontend/components/ChartCardHeader.jsx
#: app/frontend/components/guardian/GuardianDrillDown.jsx
#: app/frontend/components/ListingTable.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Export CSV"
msgstr "Export CSV"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Export CSV Report"
msgstr "Export CSV Report"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Export PDF"
msgstr "Export PDF"

#: app/frontend/pages/dashboard/subscriptions/sections/ThirdPartyIntegrationsSection.jsx
msgid "External systems linked to this organization"
msgstr "External systems linked to this organization"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Extracted At"
msgstr "Extracted At"

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
msgid "Extraction type"
msgstr "Extraction type"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Fabric"
msgstr "Fabric"

#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
msgid "Fabric Capacities"
msgstr "Fabric Capacities"

#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
msgid "Fabric Capacity ID"
msgstr "Fabric Capacity ID"

#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/lastJob.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Failed"
msgstr "Failed"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Failed / Total"
msgstr "Failed / Total"

#: app/frontend/pages/admin/users/show.jsx
msgid "Failed attempts"
msgstr "Failed attempts"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Failed checks"
msgstr "Failed checks"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Failed Checks - {periodLabel}"
msgstr "Failed Checks - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Failed checks by severity"
msgstr "Failed checks by severity"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Failed Controls"
msgstr "Failed Controls"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Failed Critical / High checks"
msgstr "Failed Critical / High checks"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Failed Security Hub checks at CRITICAL or HIGH severity."
msgstr "Failed Security Hub checks at CRITICAL or HIGH severity."

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Failover Priority"
msgstr "Failover Priority"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
msgid "Failure"
msgstr "Failure"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Failure Code"
msgstr "Failure Code"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Failure Details"
msgstr "Failure Details"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Failure Message"
msgstr "Failure Message"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Families the optimizer is allowed to buy Instance Savings Plans in."
msgstr "Families the optimizer is allowed to buy Instance Savings Plans in."

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Families the optimizer is allowed to buy Reserved Instances in."
msgstr "Families the optimizer is allowed to buy Reserved Instances in."

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
msgid "Family"
msgstr "Family"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Family Category"
msgstr "Family Category"

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Far above typical"
msgstr "Far above typical"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Fastest-Growing Service"
msgstr "Fastest-Growing Service"

#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Fault Domain"
msgstr "Fault Domain"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
msgid "Feature not enabled for this tier."
msgstr "Feature not enabled for this tier."

#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "Feature Template Configuration"
msgstr "Feature Template Configuration"

#: app/frontend/pages/admin/plans/PlanSettingsLayout.jsx
msgid "Feature Templates"
msgstr "Feature Templates"

#: app/frontend/pages/dashboard/subscriptions/features/OrganizationFeaturesLayout.jsx
msgid "Features"
msgstr "Features"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Fee"
msgstr "Fee"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Fee %"
msgstr "Fee %"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Fee MS"
msgstr "Fee MS"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Feedback"
msgstr "Feedback"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Fees paid for unused Reserved Instance or Savings Plan capacity"
msgstr "Fees paid for unused Reserved Instance or Savings Plan capacity"

#: app/frontend/components/guardian/GuardianHelpDrawer.jsx
msgid "Figures refresh once a day."
msgstr "Figures refresh once a day."

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "File capacity (storage account)"
msgstr "File capacity (storage account)"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "File share"
msgstr "File share"

#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "File Share ID"
msgstr "File Share ID"

#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
msgid "File Shares"
msgstr "File Shares"

#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "File System ID"
msgstr "File System ID"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "File System Type"
msgstr "File System Type"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "File System Type Version"
msgstr "File System Type Version"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "File transactions (storage account)"
msgstr "File transactions (storage account)"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Fill in the S3 Bucket Name and S3 Prefix fields above, then click the button below to download the CloudFormation template:"
msgstr "Fill in the S3 Bucket Name and S3 Prefix fields above, then click the button below to download the CloudFormation template:"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "Filter by ARN, account or region"
msgstr "Filter by ARN, account or region"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "Filter by ID, account or region"
msgstr "Filter by ID, account or region"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "Filter by Node"
msgstr "Filter by Node"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "Filter by Nodegroup"
msgstr "Filter by Nodegroup"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Filter by region"
msgstr "Filter by region"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Filter by tenancy"
msgstr "Filter by tenancy"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Finding"
msgstr "Finding"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Finding everything tied to one sale"
msgstr "Finding everything tied to one sale"

#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Finding ID"
msgstr "Finding ID"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Findings"
msgstr "Findings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Findings by instance"
msgstr "Findings by instance"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Findings for controls that passed — Security Hub records these with Informational severity. Not issues to action, and not included in the active total above."
msgstr "Findings for controls that passed — Security Hub records these with Informational severity. Not issues to action, and not included in the active total above."

#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/trusted_keys/new.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
msgid "Fingerprint"
msgstr "Fingerprint"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Finished"
msgstr "Finished"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "First Observed at"
msgstr "First Observed at"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
msgid "First Response"
msgstr "First Response"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "First response time per severity vs the SLA target. Based on Jira tickets linked to GuardDuty findings. A finding is compliant when the first response was sent within the allowed window."
msgstr "First response time per severity vs the SLA target. Based on Jira tickets linked to GuardDuty findings. A finding is compliant when the first response was sent within the allowed window."

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Fixed Price"
msgstr "Fixed Price"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Flat over the shown months"
msgstr "Flat over the shown months"

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Flex — Monitoring & incident management. You provision and manage your own resources."
msgstr "Flex — Monitoring & incident management. You provision and manage your own resources."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Flexibility group"
msgstr "Flexibility group"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "FOCUS cost and usage export"
msgstr "FOCUS cost and usage export"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "Follow our setup guide for detailed instructions on creating and configuring your credentials."
msgstr "Follow our setup guide for detailed instructions on creating and configuring your credentials."

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Follow the steps to download a CloudFormation template, or choose the manual onboarding option. Notice that information about your account and other services will be available in a 24 hour period."
msgstr "Follow the steps to download a CloudFormation template, or choose the manual onboarding option. Notice that information about your account and other services will be available in a 24 hour period."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For assigning the <0>Billing Account Reader</0> and <1>Billing Profile Reader</1> roles to Skie.io's application. The latter is assigned on each billing profile, for Microsoft Customer Agreement accounts only."
msgstr "For assigning the <0>Billing Account Reader</0> and <1>Billing Profile Reader</1> roles to Skie.io's application. The latter is assigned on each billing profile, for Microsoft Customer Agreement accounts only."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For assigning the <0>Reader</0> and <1>Billing Reader</1> roles to Skie.io's application."
msgstr "For assigning the <0>Reader</0> and <1>Billing Reader</1> roles to Skie.io's application."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For assigning the <0>Reservations Reader</0> role to Skie.io's application."
msgstr "For assigning the <0>Reservations Reader</0> role to Skie.io's application."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For assigning the <0>Savings Plan Reader</0> role to Skie.io's application."
msgstr "For assigning the <0>Savings Plan Reader</0> role to Skie.io's application."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "For CPU, we keep limits as they are currently set, except if the new request is greater than the current limit"
msgstr "For CPU, we keep limits as they are currently set, except if the new request is greater than the current limit"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For creating a custom role and assigning the <0>Management Group Subscriptions Reader</0> role to Skie.io's application."
msgstr "For creating a custom role and assigning the <0>Management Group Subscriptions Reader</0> role to Skie.io's application."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "For creating the Skie.io's application."
msgstr "For creating the Skie.io's application."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "For each client, compute their spend on that service as a share of their total bill:"
msgstr "For each client, compute their spend on that service as a share of their total bill:"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "For each signal, the client's own metric (% of bill) is shown alongside the cohort median of the same metric, excluding this client."
msgstr "For each signal, the client's own metric (% of bill) is shown alongside the cohort median of the same metric, excluding this client."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "For existing RIs, use the split and merge trick to create a new CRI with the same expiration date"
msgstr "For existing RIs, use the split and merge trick to create a new CRI with the same expiration date"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "For memory, we try to keep the request/limit ratio constant. However, for safety, we always keep the new limit above the historically observed maximum usage."
msgstr "For memory, we try to keep the request/limit ratio constant. However, for safety, we always keep the new limit above the historically observed maximum usage."

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "For more information, check the"
msgstr "For more information, check the"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "For the full picture on any pillar, open its dedicated page from the sidebar — this page only summarizes it."
msgstr "For the full picture on any pillar, open its dedicated page from the sidebar — this page only summarizes it."

#: app/frontend/utils/azure.js
msgid "Forbidden"
msgstr "Forbidden"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Force migrate to Valkey"
msgstr "Force migrate to Valkey"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Force Migration of Redis Workloads to Valkey"
msgstr "Force Migration of Redis Workloads to Valkey"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Force migration of Redis workloads to Valkey."
msgstr "Force migration of Redis workloads to Valkey."

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "Format"
msgstr "Format"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Format:"
msgstr "Format:"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "FQDN"
msgstr "FQDN"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "free"
msgstr "free"

#: app/frontend/utils/azure.js
msgid "Free"
msgstr "Free"

#: app/frontend/components/aws/RDSMetricsSection.jsx
msgid "Free Storage Space"
msgstr "Free Storage Space"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "Free trial"
msgstr "Free trial"

#: app/frontend/components/aws/RDSMetricsSection.jsx
msgid "Freeable Memory"
msgstr "Freeable Memory"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Freeform tag for organizing related clusters."
msgstr "Freeform tag for organizing related clusters."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Freeform tag for organizing related domains."
msgstr "Freeform tag for organizing related domains."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Freeform tag for organizing related instances."
msgstr "Freeform tag for organizing related instances."

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "from"
msgstr "from"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "From"
msgstr "From"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "From a resource group"
msgstr "From a resource group"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "From templates"
msgstr "From templates"

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "from the billed licence meter"
msgstr "from the billed licence meter"

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "from the retail price list"
msgstr "from the retail price list"

#. placeholder {0}: n.from
#: app/frontend/pages/notifications/show.jsx
msgid "From: {0}"
msgstr "From: {0}"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
msgid "FSx File Systems"
msgstr "FSx File Systems"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "FTE Variability by DB Engine"
msgstr "FTE Variability by DB Engine"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
msgid "Full"
msgstr "Full"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Full Amount / Quantity"
msgstr "Full Amount / Quantity"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
msgid "Full Version"
msgstr "Full Version"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Fully Compliant"
msgstr "Fully Compliant"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Fully reversible"
msgstr "Fully reversible"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "GB, Min, Average, Max"
msgstr "GB, Min, Average, Max"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "General"
msgstr "General"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Generate new backup codes"
msgstr "Generate new backup codes"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Generate new codes"
msgstr "Generate new codes"

#: app/frontend/pages/admin/trusted_keys/new.jsx
msgid "Generate the corresponding public key:"
msgstr "Generate the corresponding public key:"

#: app/frontend/pages/admin/trusted_keys/new.jsx
msgid "Generate the fingerprint:"
msgstr "Generate the fingerprint:"

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
msgid "Generate token"
msgstr "Generate token"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Generating recommendations"
msgstr "Generating recommendations"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Generator ID"
msgstr "Generator ID"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Generator Type"
msgstr "Generator Type"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Geo-Redundant Backup"
msgstr "Geo-Redundant Backup"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "Get Started with Setup Guide"
msgstr "Get Started with Setup Guide"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "gets {gets}"
msgstr "gets {gets}"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "GiB"
msgstr "GiB"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Give the stack a name (e.g. <0>skie-io-focus-cur-stack</0>), leave the parameters at their default values, and click through <1>Next</1> to <2>Submit</2>. This template does not create IAM roles, so no capability acknowledgment is required."
msgstr "Give the stack a name (e.g. <0>skie-io-focus-cur-stack</0>), leave the parameters at their default values, and click through <1>Next</1> to <2>Submit</2>. This template does not create IAM roles, so no capability acknowledgment is required."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Global Administrator"
msgstr "Global Administrator"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Global Filters"
msgstr "Global Filters"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Global Optimizer Settings"
msgstr "Global Optimizer Settings"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Global Secondary Indexes"
msgstr "Global Secondary Indexes"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Global Settings"
msgstr "Global Settings"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Go to <0>Policies</0> (under Settings)"
msgstr "Go to <0>Policies</0> (under Settings)"

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Go to <0>Policies</0> and then click <1>Create policy</1>."
msgstr "Go to <0>Policies</0> and then click <1>Create policy</1>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "Go to <0>Roles</0> and click <1>Create role</1>."
msgstr "Go to <0>Roles</0> and click <1>Create role</1>."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Go to <0>Roles</0>, search for your existing Skie.io role, and attach the newly created policy to the role."
msgstr "Go to <0>Roles</0>, search for your existing Skie.io role, and attach the newly created policy to the role."

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Go to portal.azure.com and sign in as an Enterprise Administrator"
msgstr "Go to portal.azure.com and sign in as an Enterprise Administrator"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Good"
msgstr "Good"

#: app/frontend/pages/users/settings/connections.jsx
msgid "Google"
msgstr "Google"

#: app/frontend/pages/admin/users/show.jsx
msgid "Google user ID"
msgstr "Google user ID"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "GovCloud"
msgstr "GovCloud"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "GPUs"
msgstr "GPUs"

#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Grace period"
msgstr "Grace period"

#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Grand Total"
msgstr "Grand Total"

#: app/frontend/pages/admin/users/show.jsx
msgid "Grant admin permissions"
msgstr "Grant admin permissions"

#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Group"
msgstr "Group"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Group A"
msgstr "Group A"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Group A — EC2 Instances"
msgstr "Group A — EC2 Instances"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group A — MS fee (non-production, per instance)"
msgstr "Group A — MS fee (non-production, per instance)"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group A — MS fee (production, per instance)"
msgstr "Group A — MS fee (production, per instance)"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Group B"
msgstr "Group B"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Group B — Cloud Services"
msgstr "Group B — Cloud Services"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group B — non-production"
msgstr "Group B — non-production"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group B — production"
msgstr "Group B — production"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group B non-production accounts"
msgstr "Group B non-production accounts"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Group B production accounts"
msgstr "Group B production accounts"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "Group for the instance"
msgstr "Group for the instance"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
msgid "GuardDuty"
msgstr "GuardDuty"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "GuardDuty findings answered in time"
msgstr "GuardDuty findings answered in time"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "GuardDuty response & resolution SLA"
msgstr "GuardDuty response & resolution SLA"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "GuardDuty Threats"
msgstr "GuardDuty Threats"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "GuardDuty Threats - {periodLabel}"
msgstr "GuardDuty Threats - {periodLabel}"

#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
msgid "Guardian"
msgstr "Guardian"

#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Guardian Billing"
msgstr "Guardian Billing"

#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
msgid "Guardian Billing Reports"
msgstr "Guardian Billing Reports"

#: app/frontend/components/guardian/help/common.js
msgid "Guardian Compliance"
msgstr "Guardian Compliance"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Guardian Global View"
msgstr "Guardian Global View"

#: app/frontend/components/guardian/help/common.js
msgid "Guardian measures how well your environment meets its compliance targets. It is not a live monitor — the data is a once-a-day snapshot showing the previous day's state."
msgstr "Guardian measures how well your environment meets its compliance targets. It is not a live monitor — the data is a once-a-day snapshot showing the previous day's state."

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Guardian plan"
msgstr "Guardian plan"

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "H/A"
msgstr "H/A"

#: app/frontend/pages/dashboard/azure/databases/show.jsx
msgid "Hardware"
msgstr "Hardware"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Head to the <0>official documentation</0> for details on how to elevate access."
msgstr "Head to the <0>official documentation</0> for details on how to elevate access."

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Heads up"
msgstr "Heads up"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Health snapshot across every organization and tier — spot SLA breaches, coverage drops, and outliers in one screen."
msgstr "Health snapshot across every organization and tier — spot SLA breaches, coverage drops, and outliers in one screen."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Health Status"
msgstr "Health Status"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Healthy"
msgstr "Healthy"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Healthy — the server is being continuously replicated to the recovery region."
msgstr "Healthy — the server is being continuously replicated to the recovery region."

#: app/frontend/components/guardian/GuardianContextBar.jsx
#: app/frontend/components/guardian/GuardianHelpDrawer.jsx
msgid "Help"
msgstr "Help"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Helps assess storage subsystem performance and workload intensity."
msgstr "Helps assess storage subsystem performance and workload intensity."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Helps identify over/under-provisioned data nodes for optimization."
msgstr "Helps identify over/under-provisioned data nodes for optimization."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Here's an example of the JSON object the script will generate (only needed if not using automatic registration):"
msgstr "Here's an example of the JSON object the script will generate (only needed if not using automatic registration):"

#: app/frontend/pages/users/admin_tokens/created.jsx
msgid "Here's your new admin token:"
msgstr "Here's your new admin token:"

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
msgid "Here's your new API token:"
msgstr "Here's your new API token:"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "hidden from organizations"
msgstr "hidden from organizations"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Hide"
msgstr "Hide"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Hide breakdown"
msgstr "Hide breakdown"

#: app/frontend/components/chat/ChatLauncher.jsx
msgid "Hide Skie Assist"
msgstr "Hide Skie Assist"

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "High"
msgstr "High"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgctxt "network profile"
msgid "High"
msgstr "High"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "High Availability"
msgstr "High Availability"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "High priority"
msgstr "High priority"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "High throughput may indicate intensive I/O workloads."
msgstr "High throughput may indicate intensive I/O workloads."

#. placeholder {0}: row.percentile
#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Higher than {0}% of peers"
msgstr "Higher than {0}% of peers"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Highest-risk findings — actionable and counted in every tab's active total."
msgstr "Highest-risk findings — actionable and counted in every tab's active total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Historical compliance trend over time."
msgstr "Historical compliance trend over time."

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Historical compliance trends"
msgstr "Historical compliance trends"

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Historical noncompliance counts"
msgstr "Historical noncompliance counts"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Historical noncompliance patch counts over time."
msgstr "Historical noncompliance patch counts over time."

#: app/frontend/components/BreadcrumbBar.jsx
msgid "Home"
msgstr "Home"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Horizontal Pod Autoscaler"
msgstr "Horizontal Pod Autoscaler"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Host"
msgstr "Host"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Host ID"
msgstr "Host ID"

#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Host Name"
msgstr "Host Name"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Host Recovery"
msgstr "Host Recovery"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Host Reservation ID"
msgstr "Host Reservation ID"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Hostname"
msgstr "Hostname"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "Hourly commitment"
msgstr "Hourly commitment"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Hours"
msgstr "Hours"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Hours before the window ends when new tasks stop being scheduled."
msgstr "Hours before the window ends when new tasks stop being scheduled."

#: app/frontend/components/guardian/help/patch_management.js
msgid "How a patch operation runs"
msgstr "How a patch operation runs"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "How Azure Hybrid Benefit works"
msgstr "How Azure Hybrid Benefit works"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "How it is calculated"
msgstr "How it is calculated"

#: app/frontend/components/guardian/help/common.js
msgid "How long from a ticket being opened until it is fully resolved."
msgstr "How long from a ticket being opened until it is fully resolved."

#: app/frontend/components/guardian/help/common.js
msgid "How long from a ticket being opened until someone first responds to it."
msgstr "How long from a ticket being opened until someone first responds to it."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "How long until resolved, counting only time inside the support window for this ticket's work type and priority. Time waiting for a customer reply is not counted. See the Service Hours card for the windows in force."
msgstr "How long until resolved, counting only time inside the support window for this ticket's work type and priority. Time waiting for a customer reply is not counted. See the Service Hours card for the windows in force."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "How long until the first response, counting only time inside the support window for this ticket's work type and priority. See the Service Hours card for the windows in force."
msgstr "How long until the first response, counting only time inside the support window for this ticket's work type and priority. See the Service Hours card for the windows in force."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "How long you can afford to be down — i.e. the maximum acceptable time to get service back after an incident."
msgstr "How long you can afford to be down — i.e. the maximum acceptable time to get service back after an incident."

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "How managed resources and operations fees are calculated for this plan"
msgstr "How managed resources and operations fees are calculated for this plan"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "How much recent data you can afford to lose — i.e. the maximum acceptable age of the latest backup when an incident hits. A 1-day RPO means losing at most a day of data."
msgstr "How much recent data you can afford to lose — i.e. the maximum acceptable age of the latest backup when an incident hits. A 1-day RPO means losing at most a day of data."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "How new Savings Plans and Reserved Instances are paid for. Default: Partial Upfront."
msgstr "How new Savings Plans and Reserved Instances are paid for. Default: Partial Upfront."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "How new Savings Plans and Reserved Instances recommended by this run are paid for."
msgstr "How new Savings Plans and Reserved Instances recommended by this run are paid for."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "How to Apply"
msgstr "How to Apply"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "How to enable it"
msgstr "How to enable it"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "How to resolve"
msgstr "How to resolve"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "HPA Recommendation"
msgstr "HPA Recommendation"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "HPA Status"
msgstr "HPA Status"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "HTTPS Traffic Only"
msgstr "HTTPS Traffic Only"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Hypervisor"
msgstr "Hypervisor"

#: app/frontend/pages/admin/users/show.jsx
msgid "I acknowledge that this action is permanent and cannot be undone"
msgstr "I acknowledge that this action is permanent and cannot be undone"

#: app/frontend/pages/dashboard/aws/accounts/DeleteAccountModal.jsx
msgid "I acknowledge that this will delete all data associated with the AWS account"
msgstr "I acknowledge that this will delete all data associated with the AWS account"

#: app/frontend/pages/dashboard/azure/subscriptions/DeleteSubscriptionModal.jsx
msgid "I acknowledge that this will delete all data associated with the Azure subscription"
msgstr "I acknowledge that this will delete all data associated with the Azure subscription"

#. placeholder {0}: organization.name
#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "I acknowledge that this will delete all data associated with the organization <0>{0}</0>"
msgstr "I acknowledge that this will delete all data associated with the organization <0>{0}</0>"

#. placeholder {0}: organization.name
#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "I acknowledge that this will delete all data associated with the organization <0>{0}</0>, including {included}"
msgstr "I acknowledge that this will delete all data associated with the organization <0>{0}</0>, including {included}"

#: app/frontend/pages/users/two_factor/BackupCodesDialog.jsx
msgid "I have copied or downloaded these codes and saved them in a secure place"
msgstr "I have copied or downloaded these codes and saved them in a secure place"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "IAM Roles"
msgstr "IAM Roles"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
msgid "id"
msgstr "id"

#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
#: app/frontend/pages/admin/reseller_organizations/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/organizations/edit.jsx
msgid "ID"
msgstr "ID"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "ID:"
msgstr "ID:"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Identify sustained high CPU to consider scaling or optimization."
msgstr "Identify sustained high CPU to consider scaling or optimization."

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Identity"
msgstr "Identity"

#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
msgid "Idle Time"
msgstr "Idle Time"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "If it's your first time, select <0>PowerShell</0> as your shell, choose a subscription, and click <1>Apply</1>."
msgstr "If it's your first time, select <0>PowerShell</0> as your shell, choose a subscription, and click <1>Apply</1>."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "If you ran the script with your <0>Organization ID</0> and <1>Organization API Token</1>, your setup is complete and you can <2>skip this step</2>."
msgstr "If you ran the script with your <0>Organization ID</0> and <1>Organization API Token</1>, your setup is complete and you can <2>skip this step</2>."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "image by"
msgstr "image by"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Image ID"
msgstr "Image ID"

#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
msgid "Image Offer"
msgstr "Image Offer"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Impact %"
msgstr "Impact %"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Import"
msgstr "Import"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Import Azure Reservations"
msgstr "Import Azure Reservations"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
msgid "Import Reservations"
msgstr "Import Reservations"

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Important: Please complete the entire onboarding process before using the product. Your account will not function correctly until all steps are finished, including the configuration of your account roles."
msgstr "Important: Please complete the entire onboarding process before using the product. Your account will not function correctly until all steps are finished, including the configuration of your account roles."

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
msgid "imported"
msgstr "imported"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Imported"
msgstr "Imported"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Importing Azure Reservations will recreate reservations records in the database."
msgstr "Importing Azure Reservations will recreate reservations records in the database."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "In <0>Policy details</0>, use the following name for the policy:"
msgstr "In <0>Policy details</0>, use the following name for the policy:"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "In an availability set: only sizes from the same family."
msgstr "In an availability set: only sizes from the same family."

#: app/frontend/components/guardian/GuardianContextBar.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/lastJob.jsx
#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "In progress"
msgstr "In progress"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "In Progress"
msgstr "In Progress"

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "In the <0>An AWS account</0> section, choose <1>Another AWS account</1> and enter the Skie.io account ID:"
msgstr "In the <0>An AWS account</0> section, choose <1>Another AWS account</1> and enter the Skie.io account ID:"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "In the <0>Cloud Shell</0> top option bar, select <1>Manage files</1> and <2>Upload</2>, and then open the file downloaded in <3>Step 2</3>."
msgstr "In the <0>Cloud Shell</0> top option bar, select <1>Manage files</1> and <2>Upload</2>, and then open the file downloaded in <3>Step 2</3>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "In the <0>Policy editor</0>, choose the <1>JSON</1> option and use the following content:"
msgstr "In the <0>Policy editor</0>, choose the <1>JSON</1> option and use the following content:"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "In the Azure Portal, open the <0>Cloud Shell</0> from the top navigation bar. Or click <1>here</1>"
msgstr "In the Azure Portal, open the <0>Cloud Shell</0> from the top navigation bar. Or click <1>here</1>"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "In the per-resource tables, SLA is the tier's target and Breached counts the resources that went over it."
msgstr "In the per-resource tables, SLA is the tier's target and Breached counts the resources that went over it."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Include EKS node group and container rightsizing recommendations in this run."
msgstr "Include EKS node group and container rightsizing recommendations in this run."

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Include resource IDs and Split cost allocation data"
msgstr "Include resource IDs and Split cost allocation data"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Included"
msgstr "Included"

#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
msgid "Included for consistency with other resource types — network recommendations don't currently reference any commitments."
msgstr "Included for consistency with other resource types — network recommendations don't currently reference any commitments."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Incomplete uploads"
msgstr "Incomplete uploads"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Inconsistent"
msgstr "Inconsistent"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
msgid "Incremental"
msgstr "Incremental"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Incremental commit"
msgstr "Incremental commit"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Incurring"
msgstr "Incurring"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Individual resource checks that failed across all enabled controls in the selected period. Broken down per control in “Top failing controls” below."
msgstr "Individual resource checks that failed across all enabled controls in the selected period. Broken down per control in “Top failing controls” below."

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Informational"
msgstr "Informational"

#: app/frontend/pages/dashboard/subscriptions/sections/IntegrationsCard.jsx
msgid "Infrastructure provisioning"
msgstr "Infrastructure provisioning"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
msgid "Inspector"
msgstr "Inspector"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Inspector Findings"
msgstr "Inspector Findings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Inspector Findings - {instanceLabel}"
msgstr "Inspector Findings - {instanceLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Inspector Findings - {periodLabel}"
msgstr "Inspector Findings - {periodLabel}"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
msgid "Instance"
msgstr "Instance"

#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
msgid "Instance Class"
msgstr "Instance Class"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Instance count"
msgstr "Instance count"

#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Instance Count"
msgstr "Instance Count"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Instance Count, USD"
msgstr "Instance Count, USD"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/index.jsx
msgid "Instance counts by patch status over the last 12 months. For each month, status is evaluated using the last patch execution that occurred during that month."
msgstr "Instance counts by patch status over the last 12 months. For each month, status is evaluated using the last patch execution that occurred during that month."

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
msgid "Instance create time"
msgstr "Instance create time"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Instance Create Time"
msgstr "Instance Create Time"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgid "Instance Details"
msgstr "Instance Details"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Instance Family"
msgstr "Instance Family"

#: app/frontend/components/guardian/help/patch_management.js
msgid "Instance has the skie-io:auto-tagging:end_of_support=true tag — the OS is past vendor support and no longer receives security patches."
msgstr "Instance has the skie-io:auto-tagging:end_of_support=true tag — the OS is past vendor support and no longer receives security patches."

#: app/frontend/components/guardian/help/patch_management.js
msgid "Instance has the skie-io:patch:disable=true tag and is intentionally excluded from patching."
msgstr "Instance has the skie-io:patch:disable=true tag and is intentionally excluded from patching."

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
msgid "Instance ID"
msgstr "Instance ID"

#: app/frontend/components/guardian/help/patch_management.js
msgid "Instance is in a resource group but no patch execution has started yet this period — awaiting the next maintenance window."
msgstr "Instance is in a resource group but no patch execution has started yet this period — awaiting the next maintenance window."

#: app/frontend/components/guardian/help/patch_management.js
msgid "Instance is in a resource group, the reporting period has closed, and no patch execution was recorded — the maintenance window was missed."
msgstr "Instance is in a resource group, the reporting period has closed, and no patch execution was recorded — the maintenance window was missed."

#: app/frontend/components/guardian/help/patch_management.js
msgid "Instance is not matched by any resource group and will not be patched automatically."
msgstr "Instance is not matched by any resource group and will not be patched automatically."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Instance Name"
msgstr "Instance Name"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Instance spend, pricing-model mix & inventory across all connected Azure subscriptions"
msgstr "Instance spend, pricing-model mix & inventory across all connected Azure subscriptions"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Instance spend, reservation coverage & engine mix across all connected AWS accounts"
msgstr "Instance spend, reservation coverage & engine mix across all connected AWS accounts"

#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Instance Tenancy"
msgstr "Instance Tenancy"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Instance type"
msgstr "Instance type"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Instance Type"
msgstr "Instance Type"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Instance types"
msgstr "Instance types"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Instance Types"
msgstr "Instance Types"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
msgid "Instances"
msgstr "Instances"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/BreachCard.jsx
msgid "Instances below their SLA threshold, or with not-yet-computable availability, for the selected month."
msgstr "Instances below their SLA threshold, or with not-yet-computable availability, for the selected month."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Instances by State"
msgstr "Instances by State"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Instances by Tenancy"
msgstr "Instances by Tenancy"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Instances by Type"
msgstr "Instances by Type"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Instances by Usage Operation"
msgstr "Instances by Usage Operation"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/ComplianceCard.jsx
msgid "Instances meeting their EC2 availability SLA threshold for the selected month."
msgstr "Instances meeting their EC2 availability SLA threshold for the selected month."

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Instances out of compliance"
msgstr "Instances out of compliance"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Instances past end of support no longer receive vendor patches, so they stay outside coverage by definition."
msgstr "Instances past end of support no longer receive vendor patches, so they stay outside coverage by definition."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Instances tagged as past vendor end-of-support — patching is irrelevant; they should be upgraded."
msgstr "Instances tagged as past vendor end-of-support — patching is irrelevant; they should be upgraded."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Instances, spend & commitment coverage across all connected AWS accounts"
msgstr "Instances, spend & commitment coverage across all connected AWS accounts"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Instances, USD"
msgstr "Instances, USD"

#: app/frontend/pages/admin/trusted_keys/new.jsx
msgid "Instructions"
msgstr "Instructions"

#: app/frontend/pages/dashboard/subscriptions/sections/IntegrationsCard.jsx
msgid "Integrations and access"
msgstr "Integrations and access"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Internal Monitoring"
msgstr "Internal Monitoring"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Internal Monitoring Tickets"
msgstr "Internal Monitoring Tickets"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Inventory"
msgstr "Inventory"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Investigate root causes in slow tickets — recurring categories signal systemic issues worth a deeper look."
msgstr "Investigate root causes in slow tickets — recurring categories signal systemic issues worth a deeper look."

#: app/frontend/pages/dashboard/invitation_acceptances/show.jsx
msgid "Invitation"
msgstr "Invitation"

#: app/frontend/pages/dashboard/invitation_acceptances/show.jsx
msgid "Invitation to join"
msgstr "Invitation to join"

#: app/frontend/pages/dashboard/memberships/InviteModal.jsx
msgid "Invite a new member"
msgstr "Invite a new member"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Invite member"
msgstr "Invite member"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Invite people to the organization and choose what each one can do. A role decides whether someone only reads the data or can also act on it."
msgstr "Invite people to the organization and choose what each one can do. A role decides whether someone only reads the data or can also act on it."

#. placeholder {0}: invitation.invited_by_email
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "invited by {0}"
msgstr "invited by {0}"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Invoice ID"
msgstr "Invoice ID"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Invoice ID only groups rows within a single invoice — AWS issues a separate invoice for the buyer's charge (SELLER_REV_SHARE) than for the seller's listing fee (AWS_REV_SHARE), even for the same sale. The Sales tab groups by buyer transaction reference instead — AWS documents it as the field linking the buyer invoice, seller invoice, and any VAT for one transaction — and expanding a row reveals every linked event across the INVOICED → COLLECTED → DISBURSED lifecycle."
msgstr "Invoice ID only groups rows within a single invoice — AWS issues a separate invoice for the buyer's charge (SELLER_REV_SHARE) than for the seller's listing fee (AWS_REV_SHARE), even for the same sale. The Sales tab groups by buyer transaction reference instead — AWS documents it as the field linking the buyer invoice, seller invoice, and any VAT for one transaction — and expanding a row reveals every linked event across the INVOICED → COLLECTED → DISBURSED lifecycle."

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Invoiced amount for sales AWS has already collected from the buyer, but hasn't disbursed to Skie yet."
msgstr "Invoiced amount for sales AWS has already collected from the buyer, but hasn't disbursed to Skie yet."

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Invoiced amount for sales that haven't reached COLLECTED or DISBURSED yet — still waiting on AWS to collect from the buyer."
msgstr "Invoiced amount for sales that haven't reached COLLECTED or DISBURSED yet — still waiting on AWS to collect from the buyer."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "IO Model Change"
msgstr "IO Model Change"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
msgid "IOPS"
msgstr "IOPS"

#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "IOPS Read/Write"
msgstr "IOPS Read/Write"

#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
msgid "IP Address"
msgstr "IP Address"

#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "IP Address Type"
msgstr "IP Address Type"

#: app/frontend/pages/dashboard/resource_groups/TagClauses.jsx
msgid "is"
msgstr "is"

#. placeholder {0}: top.share_pct
#. placeholder {1}: top.typical_pct
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendBand.jsx
msgid "is {0}% of your bill vs {1}% typical"
msgstr "is {0}% of your bill vs {1}% typical"

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "is already included."
msgstr "is already included."

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Is Default?"
msgstr "Is Default?"

#: app/frontend/pages/dashboard/resource_groups/TagClauses.jsx
msgid "is either"
msgstr "is either"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Is skipped?"
msgstr "Is skipped?"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Is Skipped?"
msgstr "Is Skipped?"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Issue Key"
msgstr "Issue Key"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Issue Type"
msgstr "Issue Type"

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "It analyzes your resources and produces recommendations. Nothing is changed until you apply one."
msgstr "It analyzes your resources and produces recommendations. Nothing is changed until you apply one."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each commitment. Additionally, hovering over a segment enables users to view specific cost values associated with each commitment, facilitating precise analysis and decision-making."
msgstr "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each commitment. Additionally, hovering over a segment enables users to view specific cost values associated with each commitment, facilitating precise analysis and decision-making."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each EC2 Reservation by Operating System. Additionally, hovering over a segment enables users to view specific cost values associated with each reservation, facilitating precise analysis and decision-making."
msgstr "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each EC2 Reservation by Operating System. Additionally, hovering over a segment enables users to view specific cost values associated with each reservation, facilitating precise analysis and decision-making."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each Savings Plan description. Additionally, hovering over a segment enables users to view specific cost values associated with each Savings Plan, facilitating precise analysis and decision-making."
msgstr "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to depict the proportion of costs attributed to each Savings Plan description. Additionally, hovering over a segment enables users to view specific cost values associated with each Savings Plan, facilitating precise analysis and decision-making."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to show the proportion of costs attributed to commitment waste versus the on-demand equivalent. Hovering over segments enables users to view specific cost values, facilitating precise analysis and decision-making."
msgstr "It is presented as a bar chart, where the Y-axis represents costs in USD and the X-axis denotes the months. Each bar is segmented to show the proportion of costs attributed to commitment waste versus the on-demand equivalent. Hovering over segments enables users to view specific cost values, facilitating precise analysis and decision-making."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It presents a bar chart format, where the Y-axis represents costs in USD and the X-axis displays the months. Each bar is segmented, representing the proportion of costs attributed to other expenses. Users can hover over a segment to view the specific cost value related to that particular category of other costs."
msgstr "It presents a bar chart format, where the Y-axis represents costs in USD and the X-axis displays the months. Each bar is segmented, representing the proportion of costs attributed to other expenses. Users can hover over a segment to view the specific cost value related to that particular category of other costs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It presents a bar chart format, where the Y-axis represents costs in USD and the X-axis displays the months. Each bar is segmented, representing the proportion of costs attributed to specific storage types. Users can hover over a segment to view the specific cost value related to that particular storage type."
msgstr "It presents a bar chart format, where the Y-axis represents costs in USD and the X-axis displays the months. Each bar is segmented, representing the proportion of costs attributed to specific storage types. Users can hover over a segment to view the specific cost value related to that particular storage type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It presents a bar chart where the Y-axis denotes costs in USD, and the X-axis depicts the months. Each bar is segmented to represent the proportion of costs for each usage type. By hovering over a segment, users can view the specific value associated with that usage type."
msgstr "It presents a bar chart where the Y-axis denotes costs in USD, and the X-axis depicts the months. Each bar is segmented to represent the proportion of costs for each usage type. By hovering over a segment, users can view the specific value associated with that usage type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It's a bar chart with the Y-axis representing costs in USD and the X-axis showing months. Each bar is segmented to represent the proportion of costs for each record type. Hovering over a segment reveals the specific cost value for that record type."
msgstr "It's a bar chart with the Y-axis representing costs in USD and the X-axis showing months. Each bar is segmented to represent the proportion of costs for each record type. Hovering over a segment reveals the specific cost value for that record type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "It's a bar graph, where the Y-axis represents costs in USD and the X-axis shows the days. Each bar is segmented to depict the proportion of costs for each instance type. Hovering over a segment reveals the specific cost value for that instance type."
msgstr "It's a bar graph, where the Y-axis represents costs in USD and the X-axis shows the days. Each bar is segmented to depict the proportion of costs for each instance type. Hovering over a segment reveals the specific cost value for that instance type."

#: app/frontend/components/PageHeader.jsx
msgid "item"
msgstr "item"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Item"
msgstr "Item"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Item Count"
msgstr "Item Count"

#: app/frontend/components/PageHeader.jsx
msgid "items"
msgstr "items"

#: app/frontend/pages/dashboard/subscriptions/sections/ThirdPartyIntegrationsSection.jsx
msgid "Jira External ID"
msgstr "Jira External ID"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Karpenter"
msgstr "Karpenter"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Keep"
msgstr "Keep"

#: app/frontend/components/optimization_dashboard/CancelActionButton.jsx
msgid "Keep it"
msgstr "Keep it"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Keep subscription"
msgstr "Keep subscription"

#: app/frontend/components/ResourceTagsTable.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Key"
msgstr "Key"

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Key can only include letters, numbers, spaces, and _.:/=+-@"
msgstr "Key can only include letters, numbers, spaces, and _.:/=+-@"

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Key cannot start with \"aws:\""
msgstr "Key cannot start with \"aws:\""

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Key must be 1 to 128 characters long"
msgstr "Key must be 1 to 128 characters long"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Key Schema"
msgstr "Key Schema"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/StackedBarTable.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Kind"
msgstr "Kind"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "KMS Key"
msgstr "KMS Key"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
msgid "KMS Key ID"
msgstr "KMS Key ID"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "KPI — average P1+P2 ticket resolution within SLA."
msgstr "KPI — average P1+P2 ticket resolution within SLA."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "KPI — combined coverage across AWS Backup + DRS + Commvault."
msgstr "KPI — combined coverage across AWS Backup + DRS + Commvault."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "KPI — patched EC2 instances / total eligible."
msgstr "KPI — patched EC2 instances / total eligible."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "KPI — Security Hub controls passing / total."
msgstr "KPI — Security Hub controls passing / total."

#: app/frontend/layout/top_bar.jsx
#: app/frontend/pages/users/registrations/edit.jsx
msgid "Language"
msgstr "Language"

#: app/frontend/components/chat/groups.js
msgid "Last 30 days"
msgstr "Last 30 days"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Last 30 days · top 10 + other"
msgstr "Last 30 days · top 10 + other"

#: app/frontend/components/chat/groups.js
msgid "Last 7 days"
msgstr "Last 7 days"

#. placeholder {0}: ageLabel(service.failed_attempt_at)
#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Last attempt failed {0}"
msgstr "Last attempt failed {0}"

#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Last Backup Status"
msgstr "Last Backup Status"

#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Last Backup Time"
msgstr "Last Backup Time"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Last detection"
msgstr "Last detection"

#. placeholder {0}: jobs.last_drill_at
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Last drill: {0}"
msgstr "Last drill: {0}"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "Last error"
msgstr "Last error"

#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Last Execution Date"
msgstr "Last Execution Date"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "Last job"
msgstr "Last job"

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Last job completion date"
msgstr "Last job completion date"

#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Last job date"
msgstr "Last job date"

#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Last job status"
msgstr "Last job status"

#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
msgid "Last Modified"
msgstr "Last Modified"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Last modified time"
msgstr "Last modified time"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Last Month Summary"
msgstr "Last Month Summary"

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendBand.jsx
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Last month's figures are preliminary and may still change."
msgstr "Last month's figures are preliminary and may still change."

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Last Observed at"
msgstr "Last Observed at"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Last Online"
msgstr "Last Online"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Last Operation Date"
msgstr "Last Operation Date"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Last Patch"
msgstr "Last Patch"

#. placeholder {0}: run.services_succeeded
#. placeholder {1}: run.services_total
#. placeholder {2}: ageLabel(run.started_at)
#: app/frontend/components/optimization_overview/OverviewHeader.jsx
msgid "Last run · {0} of {1} completed · {2}"
msgstr "Last run · {0} of {1} completed · {2}"

#: app/frontend/components/optimization_overview/CostChart.jsx
msgid "last run failed — no data"
msgstr "last run failed — no data"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Last Scan"
msgstr "Last Scan"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Last Seen"
msgstr "Last Seen"

#: app/frontend/pages/admin/users/show.jsx
msgid "Last sign in at"
msgstr "Last sign in at"

#: app/frontend/pages/admin/users/show.jsx
msgid "Last sign in IP"
msgstr "Last sign in IP"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Last Snapshot"
msgstr "Last Snapshot"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Last Synced"
msgstr "Last Synced"

#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Last used"
msgstr "Last used"

#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
msgid "Latency"
msgstr "Latency"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
msgid "Launch time"
msgstr "Launch time"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Launch Time"
msgstr "Launch Time"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Leave this field blank"
msgstr "Leave this field blank"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Left: current reservations by region and flexibility group. Right: the recommended decision (keep, cancel, convert, or purchase). Amounts are total commitment over the reservation term (purchases = 3 years; existing = remaining term), not a monthly cost — see Cost Analysis for the monthly impact."
msgstr "Left: current reservations by region and flexibility group. Right: the recommended decision (keep, cancel, convert, or purchase). Amounts are total commitment over the reservation term (purchases = 3 years; existing = remaining term), not a monthly cost — see Cost Analysis for the monthly impact."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Licence"
msgstr "Licence"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Licence cores consumed"
msgstr "Licence cores consumed"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Licence spend billed by Azure"
msgstr "Licence spend billed by Azure"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Licence today"
msgstr "Licence today"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Licences confirmed"
msgstr "Licences confirmed"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Licences per day"
msgstr "Licences per day"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Licensable"
msgstr "Licensable"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Licensable instances"
msgstr "Licensable instances"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "License model"
msgstr "License model"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "License Model"
msgstr "License Model"

#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "License Type"
msgstr "License Type"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Licensed cores"
msgstr "Licensed cores"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Licenses"
msgstr "Licenses"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Licensing"
msgstr "Licensing"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
msgid "Lifecycle"
msgstr "Lifecycle"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Lifetime commitment"
msgstr "Lifetime commitment"

#: app/frontend/layout/top_bar.jsx
msgid "Light"
msgstr "Light"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Limit:"
msgstr "Limit:"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "Line Items"
msgstr "Line Items"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Linux"
msgstr "Linux"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Load Balancer ARN"
msgstr "Load Balancer ARN"

#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
msgid "Load Balancer ID"
msgstr "Load Balancer ID"

#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
msgid "Load Balancers"
msgstr "Load Balancers"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Loading nodes..."
msgstr "Loading nodes..."

#: app/frontend/components/spinner.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Loading..."
msgstr "Loading..."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Location"
msgstr "Location"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Locations"
msgstr "Locations"

#: app/frontend/pages/admin/users/show.jsx
msgid "Locked at"
msgstr "Locked at"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Log Exports"
msgstr "Log Exports"

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Low"
msgstr "Low"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgctxt "network profile"
msgid "Low"
msgstr "Low"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Low freeable memory can lead to performance degradation and query latency."
msgstr "Low freeable memory can lead to performance degradation and query latency."

#. placeholder {0}: withUnit(tooltipData[1])
#: app/frontend/components/echarts/options.js
msgid "Lower: {0}"
msgstr "Lower: {0}"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Lowest Backup Coverage"
msgstr "Lowest Backup Coverage"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Lowest Patch Coverage"
msgstr "Lowest Patch Coverage"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Lowest Security Score"
msgstr "Lowest Security Score"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Lustre Configuration"
msgstr "Lustre Configuration"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "MAD is used instead of classic σ because spend distributions are skewed — a few large clients would distort σ and under-flag real outliers. The 1.4826 constant makes MAD comparable to σ for normal distributions."
msgstr "MAD is used instead of classic σ because spend distributions are skewed — a few large clients would distort σ and under-flag real outliers. The 1.4826 constant makes MAD comparable to σ for normal distributions."

#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Magnetic Store Write Properties"
msgstr "Magnetic Store Write Properties"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Main Attributes"
msgstr "Main Attributes"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/dashboard/AzureDashboardTabs.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Main Spend"
msgstr "Main Spend"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Maintenance Excluded (min)"
msgstr "Maintenance Excluded (min)"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Maintenance window allowance"
msgstr "Maintenance window allowance"

#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/edit.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Maintenance Windows"
msgstr "Maintenance Windows"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Major Variation Decrease"
msgstr "Major Variation Decrease"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Major Variation Increase"
msgstr "Major Variation Increase"

#: app/frontend/components/azure/ReservationImportModal.jsx
msgid "Make sure the CSV file you are importing is correctly formatted."
msgstr "Make sure the CSV file you are importing is correctly formatted."

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Manage EA enrollment policies"
msgstr "Manage EA enrollment policies"

#: app/frontend/pages/admin/plans/organizations.jsx
#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Manage features"
msgstr "Manage features"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "managed by"
msgstr "managed by"

#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
msgid "Managed By"
msgstr "Managed By"

#: app/frontend/pages/dashboard/organizations/index.jsx
msgid "managed by {managedBy}"
msgstr "managed by {managedBy}"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Managed DB"
msgstr "Managed DB"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Managed DB RPO"
msgstr "Managed DB RPO"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Managed disk"
msgstr "Managed disk"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Managed Disk"
msgstr "Managed Disk"

#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "Managed Disk ID"
msgstr "Managed Disk ID"

#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
msgid "Managed Disks"
msgstr "Managed Disks"

#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
msgid "Managed Disks Dashboard"
msgstr "Managed Disks Dashboard"

#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
msgid "Managed Instance ID"
msgstr "Managed Instance ID"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Managed RDS instances running a paid SQL Server edition (Standard, Enterprise or Web). Express and Developer are free and excluded."
msgstr "Managed RDS instances running a paid SQL Server edition (Standard, Enterprise or Web). Express and Developer are free and excluded."

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Managed Redis"
msgstr "Managed Redis"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Managed SQL Server"
msgstr "Managed SQL Server"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Managed VM"
msgstr "Managed VM"

#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
msgid "Management"
msgstr "Management"

#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
msgid "Management Group"
msgstr "Management Group"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Management Groups"
msgstr "Management Groups"

#: app/frontend/pages/admin/users/show.jsx
msgid "Manager"
msgstr "Manager"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
msgid "Manual"
msgstr "Manual"

#: app/frontend/pages/dashboard/aws/accounts/SetupGuideTabs.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Manual onboarding"
msgstr "Manual onboarding"

#: app/frontend/pages/notifications/index.jsx
msgid "Mark as Read"
msgstr "Mark as Read"

#: app/frontend/pages/admin/billing_line_items/index.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "Marketplace Billings"
msgstr "Marketplace Billings"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Marketplace Disbursement Events"
msgstr "Marketplace Disbursement Events"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
msgid "Master Count"
msgstr "Master Count"

#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Master Node CPU Utilization"
msgstr "Master Node CPU Utilization"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Master node type"
msgstr "Master node type"

#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Master Node Type"
msgstr "Master Node Type"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Master node types"
msgstr "Master node types"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Master nodes"
msgstr "Master nodes"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
msgid "Master Nodes"
msgstr "Master Nodes"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Master Optimizer"
msgstr "Master Optimizer"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "Master SBU Required"
msgstr "Master SBU Required"

#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Master Username"
msgstr "Master Username"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Max"
msgstr "Max"

#: app/frontend/components/guardian/GuardianSlaDrawer.jsx
msgid "Max credit"
msgstr "Max credit"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Max Impact"
msgstr "Max Impact"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Max nodes"
msgstr "Max nodes"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Max Replicas"
msgstr "Max Replicas"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Max RPUs"
msgstr "Max RPUs"

#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
msgid "Max Size"
msgstr "Max Size"

#: app/frontend/components/ChartCardHeader.jsx
#: app/frontend/components/chat/ChatPanel.jsx
#: app/frontend/components/echarts/modal/maximize_button.jsx
#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Maximize"
msgstr "Maximize"

#: app/frontend/layout/components.jsx
msgid "Maximize menu"
msgstr "Maximize menu"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Maximum allowed recovery job duration for compliance."
msgstr "Maximum allowed recovery job duration for compliance."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Maximum allowed replication lag for compliance."
msgstr "Maximum allowed replication lag for compliance."

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Maximum number of tags (50) reached"
msgstr "Maximum number of tags (50) reached"

#: app/frontend/components/guardian/help/service_desk.js
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Mean Time to Resolve"
msgstr "Mean Time to Resolve"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Mean Time to Resolve — per-priority average vs SLA, with a 25% grace buffer (yellow within grace, red beyond)."
msgstr "Mean Time to Resolve — per-priority average vs SLA, with a 25% grace buffer (yellow within grace, red beyond)."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Mean Time to Resolve (12 months)"
msgstr "Mean Time to Resolve (12 months)"

#: app/frontend/components/guardian/help/service_desk.js
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Mean Time to Respond"
msgstr "Mean Time to Respond"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Mean Time to Respond — per-priority average vs SLA, with a 25% grace buffer (yellow within grace, red beyond)."
msgstr "Mean Time to Respond — per-priority average vs SLA, with a 25% grace buffer (yellow within grace, red beyond)."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Mean Time to Respond (12 months)"
msgstr "Mean Time to Respond (12 months)"

#: app/frontend/components/guardian/help/service_desk.js
msgid "Mean Time to Respond / Resolve"
msgstr "Mean Time to Respond / Resolve"

#: app/frontend/components/ChartCardHeader.jsx
#: app/frontend/components/echarts/chart/chart.jsx
msgid "Meaningful"
msgstr "Meaningful"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Measured against {caption}."
msgstr "Measured against {caption}."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Measured against the {tierLabel} tier SLA"
msgstr "Measured against the {tierLabel} tier SLA"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Measured against the contracted SLA"
msgstr "Measured against the contracted SLA"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "Measured against the most recent copy replicated to a destination (cross-region) — not the in-region backup. A resource is breached when its latest cross-region copy is older than the RPO target."
msgstr "Measured against the most recent copy replicated to a destination (cross-region) — not the in-region backup. A resource is breached when its latest cross-region copy is older than the RPO target."

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "measured from Azure"
msgstr "measured from Azure"

#. placeholder {0}: memory(r.required_memory_gb)
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Measured memory need: {0}."
msgstr "Measured memory need: {0}."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Measured once a day at extraction time (not live) and compared to the selected tier's targets."
msgstr "Measured once a day at extraction time (not live) and compared to the selected tier's targets."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Measures how effectively your AWS commitment strategy (Reserved Instances & Savings Plans) generates savings from eligible spend."
msgstr "Measures how effectively your AWS commitment strategy (Reserved Instances & Savings Plans) generates savings from eligible spend."

#. placeholder {0}: total_resources.toLocaleString()
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Measures what fraction of AWS resources have each governance tag key populated · <0>{0}</0> total resources (EC2, RDS, S3, ECS, EKS)"
msgstr "Measures what fraction of AWS resources have each governance tag key populated · <0>{0}</0> total resources (EC2, RDS, S3, ECS, EKS)"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "median"
msgstr "median"

#. placeholder {0}: withUnit(tooltipData[3])
#: app/frontend/components/echarts/options.js
msgid "Median: {0}"
msgstr "Median: {0}"

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Medium"
msgstr "Medium"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgctxt "network profile"
msgid "Medium"
msgstr "Medium"

#: app/frontend/pages/admin/users/show.jsx
msgid "Member"
msgstr "Member"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Member since"
msgstr "Member since"

#: app/frontend/layout/menu.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Members"
msgstr "Members"

#: app/frontend/pages/admin/users/show.jsx
msgid "Memberships"
msgstr "Memberships"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Memcached Reserved Instances view to plan commitments and assess current coverage."
msgstr "Memcached Reserved Instances view to plan commitments and assess current coverage."

#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Memory"
msgstr "Memory"

#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Memory (GB)"
msgstr "Memory (GB)"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Memory (GiB)"
msgstr "Memory (GiB)"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
msgid "Memory GiB"
msgstr "Memory GiB"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Memory Impact"
msgstr "Memory Impact"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Memory Limit"
msgstr "Memory Limit"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "Memory Provisioned vs Used"
msgstr "Memory Provisioned vs Used"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Memory Request"
msgstr "Memory Request"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "Memory Requests"
msgstr "Memory Requests"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "Memory Savings"
msgstr "Memory Savings"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Memory Size (MiB)"
msgstr "Memory Size (MiB)"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Memory Status"
msgstr "Memory Status"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Memory Usage"
msgstr "Memory Usage"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Memory usage by the database engine instance."
msgstr "Memory usage by the database engine instance."

#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Memory Utilization"
msgstr "Memory Utilization"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Memory utilization for the RDS instance used to evaluate rightsizing recommendations."
msgstr "Memory utilization for the RDS instance used to evaluate rightsizing recommendations."

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Memory Variability by DB Engine"
msgstr "Memory Variability by DB Engine"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Meter Category"
msgstr "Meter Category"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Meter sub category"
msgstr "Meter sub category"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Metric Name"
msgstr "Metric Name"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Metric Target Type"
msgstr "Metric Target Type"

#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Metrics"
msgstr "Metrics"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "MiB/operation"
msgstr "MiB/operation"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "MiB/Operation"
msgstr "MiB/Operation"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "MiB/s"
msgstr "MiB/s"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Microsoft does not verify ownership. A licence is used either on-premises or in Azure, not both, except for 180 days during a migration."
msgstr "Microsoft does not verify ownership. A licence is used either on-premises or in Azure, not both, except for 180 days during a migration."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Microsoft publishes no benchmark for this size, so the VM keeps its size."
msgstr "Microsoft publishes no benchmark for this size, so the VM keeps its size."

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Migration"
msgstr "Migration"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Min"
msgstr "Min"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Min coverage:"
msgstr "Min coverage:"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Min Replicas"
msgstr "Min Replicas"

#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Min TLS"
msgstr "Min TLS"

#: app/frontend/layout/components.jsx
msgid "Minimize menu"
msgstr "Minimize menu"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Minimum number of nodes to keep in each nodegroup, regardless of observed utilization."
msgstr "Minimum number of nodes to keep in each nodegroup, regardless of observed utilization."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Minimum number of nodes to keep in each nodegroup. The default value is 0."
msgstr "Minimum number of nodes to keep in each nodegroup. The default value is 0."

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Minimum TLS Version"
msgstr "Minimum TLS Version"

#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Minor Version"
msgstr "Minor Version"

#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Missed"
msgstr "Missed"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Missing database-type tag"
msgstr "Missing database-type tag"

#: app/frontend/components/guardian/help/patch_management.js
msgid "Missing patches"
msgstr "Missing patches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
msgid "Missing Patches"
msgstr "Missing Patches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Missing Patches - {periodLabel}"
msgstr "Missing Patches - {periodLabel}"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Model"
msgstr "Model"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Modified Date"
msgstr "Modified Date"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Monitor"
msgstr "Monitor"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Monitor sustained high CPU to identify tuning or scaling opportunities."
msgstr "Monitor sustained high CPU to identify tuning or scaling opportunities."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Monitor to ensure cluster coordination remains healthy under topology or workload changes."
msgstr "Monitor to ensure cluster coordination remains healthy under topology or workload changes."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Monitor to prevent out-of-space situations that can impact database availability."
msgstr "Monitor to prevent out-of-space situations that can impact database availability."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Monitoring tickets"
msgstr "Monitoring tickets"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Monitoring tickets opened each month by priority, over the last 12 months — the internal monitoring workload over time."
msgstr "Monitoring tickets opened each month by priority, over the last 12 months — the internal monitoring workload over time."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Monitoring Volume (12 months)"
msgstr "Monitoring Volume (12 months)"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Month"
msgstr "Month"

#: app/frontend/pages/admin/billing_reports/index.jsx
msgid "Monthly Billing Reports"
msgstr "Monthly Billing Reports"

#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "Monthly Billing V2 Reports"
msgstr "Monthly Billing V2 Reports"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "Monthly Commitment"
msgstr "Monthly Commitment"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Monthly cost"
msgstr "Monthly cost"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Monthly Cost"
msgstr "Monthly Cost"

#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
msgid "Monthly Costs By Disk Types"
msgstr "Monthly Costs By Disk Types"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Monthly credit cap"
msgstr "Monthly credit cap"

#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
msgid "Monthly Database Costs By Meter SubCategory"
msgstr "Monthly Database Costs By Meter SubCategory"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Monthly EBS snapshot spend over the trailing 12 months, shown as bars with a dashed line marking the average. Hover a bar for that month's spend."
msgstr "Monthly EBS snapshot spend over the trailing 12 months, shown as bars with a dashed line marking the average. Hover a bar for that month's spend."

#: app/frontend/pages/dashboard/subscriptions/sections/CloudFlexSection.jsx
msgid "Monthly fee"
msgstr "Monthly fee"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Monthly issues opened by priority (bars) and number of issues resolved or closed in the same month (line). A higher line relative to the bars indicates the team is keeping up with demand."
msgstr "Monthly issues opened by priority (bars) and number of issues resolved or closed in the same month (line). A higher line relative to the bars indicates the team is keeping up with demand."

#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
msgid "Monthly Reports"
msgstr "Monthly Reports"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Monthly savings"
msgstr "Monthly savings"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Monthly Savings Percentage"
msgstr "Monthly Savings Percentage"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Monthly SBU Utilization"
msgstr "Monthly SBU Utilization"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "Monthly Utilization"
msgstr "Monthly Utilization"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Monthly, in arrears"
msgstr "Monthly, in arrears"

#: app/frontend/components/chat/TopicSidebar.jsx
msgid "More actions"
msgstr "More actions"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Most common threat types"
msgstr "Most common threat types"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Most failed Critical / High checks"
msgstr "Most failed Critical / High checks"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Most frequent GuardDuty finding types in the selected period."
msgstr "Most frequent GuardDuty finding types in the selected period."

#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
msgid "Mount Targets"
msgstr "Mount Targets"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "MS Fee"
msgstr "MS Fee"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "Multi AZ"
msgstr "Multi AZ"

#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Multi-AZ"
msgstr "Multi-AZ"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Multi-Region Writes"
msgstr "Multi-Region Writes"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Multiplier"
msgstr "Multiplier"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
msgid "MySQL"
msgstr "MySQL"

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "N/A"
msgstr "N/A"

#: app/frontend/components/ResourceStagesTable.jsx
#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/plans/organizations.jsx
#: app/frontend/pages/admin/plans/PlanForm.jsx
#: app/frontend/pages/admin/reseller_organizations/index.jsx
#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/ServiceUserForm.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/dashboard/organizations/edit.jsx
#: app/frontend/pages/dashboard/organizations/index.jsx
#: app/frontend/pages/dashboard/organizations/new.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Name"
msgstr "Name"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Name is required"
msgstr "Name is required"

#: app/frontend/components/echarts/options.js
msgid "Name: {title}"
msgstr "Name: {title}"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Namespace"
msgstr "Namespace"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Namespace ARN"
msgstr "Namespace ARN"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Namespace Details"
msgstr "Namespace Details"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
msgid "NAT Gateway"
msgstr "NAT Gateway"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "NAT Gateway Addresses"
msgstr "NAT Gateway Addresses"

#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "NAT Gateway ID"
msgstr "NAT Gateway ID"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Navigate to <0>Billing and Cost Management</0> → <1>Data Exports</1>."
msgstr "Navigate to <0>Billing and Cost Management</0> → <1>Data Exports</1>."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Need an exception for a specific cluster? Add it below in"
msgstr "Need an exception for a specific cluster? Add it below in"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Need an exception for a specific database? Add it below in"
msgstr "Need an exception for a specific database? Add it below in"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Need an exception for a specific domain? Add it below in"
msgstr "Need an exception for a specific domain? Add it below in"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Needed to enable Hybrid Benefit on Azure SQL databases, managed instances and SQL Server VMs."
msgstr "Needed to enable Hybrid Benefit on Azure SQL databases, managed instances and SQL Server VMs."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Needed to enable Hybrid Benefit on Windows Server VMs."
msgstr "Needed to enable Hybrid Benefit on Windows Server VMs."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Needed to switch RHEL VMs to bring-your-own-subscription."
msgstr "Needed to switch RHEL VMs to bring-your-own-subscription."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Needed to switch SLES and SLES for SAP VMs to bring-your-own-subscription."
msgstr "Needed to switch SLES and SLES for SAP VMs to bring-your-own-subscription."

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "needs {needs}"
msgstr "needs {needs}"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "Needs attention"
msgstr "Needs attention"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Needs Attention"
msgstr "Needs Attention"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Negative — the listing fee AWS charges."
msgstr "Negative — the listing fee AWS charges."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "net change"
msgstr "net change"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Net commitment change"
msgstr "Net commitment change"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Net Savings / mo"
msgstr "Net Savings / mo"

#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Network"
msgstr "Network"

#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "Network Access Policy"
msgstr "Network Access Policy"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Network Border Group"
msgstr "Network Border Group"

#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Network In"
msgstr "Network In"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Network Interface ID"
msgstr "Network Interface ID"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Network Interface IDs"
msgstr "Network Interface IDs"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Network Interface Owner ID"
msgstr "Network Interface Owner ID"

#: app/frontend/pages/dashboard/aws/elb/optimizations/index.jsx
msgid "Network Optimizations"
msgstr "Network Optimizations"

#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
msgid "Network optimizations have no tunable settings today — idle load balancer and NAT gateway recommendations are generated straight from usage data across the organization."
msgstr "Network optimizations have no tunable settings today — idle load balancer and NAT gateway recommendations are generated straight from usage data across the organization."

#: app/frontend/pages/dashboard/aws/ec2_instances/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/MetricsSection.jsx
msgid "Network Out"
msgstr "Network Out"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Network Performance"
msgstr "Network Performance"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Network Profile Required"
msgstr "Network Profile Required"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgid "Network Profile Required ({stat})"
msgstr "Network Profile Required ({stat})"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Network right sizing"
msgstr "Network right sizing"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Network traffic for a VM under a VM Scale Set."
msgstr "Network traffic for a VM under a VM Scale Set."

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Network Type"
msgstr "Network Type"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
msgid "Network Utilization"
msgstr "Network Utilization"

#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Never"
msgstr "Never"

#: app/frontend/components/optimization_overview/CostChart.jsx
msgid "never analyzed — no data"
msgstr "never analyzed — no data"

#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
msgid "Never ran"
msgstr "Never ran"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Never run"
msgstr "Never run"

#: app/frontend/pages/users/admin_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "New admin token"
msgstr "New admin token"

#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
msgid "New AWS account"
msgstr "New AWS account"

#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
msgid "New Azure Credential"
msgstr "New Azure Credential"

#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
msgid "New Azure Subscription"
msgstr "New Azure Subscription"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "New Billing"
msgstr "New Billing"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/change_requests/new.jsx
msgid "New Change Request"
msgstr "New Change Request"

#: app/frontend/components/chat/ChatPanel.jsx
msgid "New Chat"
msgstr "New Chat"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "New class"
msgstr "New class"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "New commitment"
msgstr "New commitment"

#: app/frontend/components/chat/SourceMenu.jsx
msgid "New conversation with"
msgstr "New conversation with"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "New Daily Cost"
msgstr "New Daily Cost"

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "New data import"
msgstr "New data import"

#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
msgid "New Disk Optimization"
msgstr "New Disk Optimization"

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
msgid "New EBS Optimization"
msgstr "New EBS Optimization"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "New EC2 Optimization"
msgstr "New EC2 Optimization"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "New ElastiCache Optimization"
msgstr "New ElastiCache Optimization"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "New Instance Credentials"
msgstr "New Instance Credentials"

#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "New instance type"
msgstr "New instance type"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "New IO"
msgstr "New IO"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
msgid "New kind"
msgstr "New kind"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/new.jsx
msgid "New Maintenance Window"
msgstr "New Maintenance Window"

#: app/frontend/components/chat/MessageList.jsx
msgid "New message"
msgstr "New message"

#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
msgid "New Network Optimization"
msgstr "New Network Optimization"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "New OpenSearch Optimization"
msgstr "New OpenSearch Optimization"

#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/index.jsx
msgid "New Optimization"
msgstr "New Optimization"

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "New organization"
msgstr "New organization"

#: app/frontend/pages/users/settings/password.jsx
msgid "New password"
msgstr "New password"

#: app/frontend/pages/users/settings/password.jsx
msgid "New password confirmation"
msgstr "New password confirmation"

#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/plans/new.jsx
msgid "New Plan"
msgstr "New Plan"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "New RDS Optimization"
msgstr "New RDS Optimization"

#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/new.jsx
msgid "New Resource Group"
msgstr "New Resource Group"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "New RIs"
msgstr "New RIs"

#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
msgid "New S3 Optimization"
msgstr "New S3 Optimization"

#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/new.jsx
msgid "New service user"
msgstr "New service user"

#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
msgid "New SQL Optimization"
msgstr "New SQL Optimization"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "New storage"
msgstr "New storage"

#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/new.jsx
msgid "New Tag Template"
msgstr "New Tag Template"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "New this period"
msgstr "New this period"

#: app/frontend/pages/admin/trusted_keys/new.jsx
msgid "New trusted key"
msgstr "New trusted key"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "New type"
msgstr "New type"

#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "New VM Optimization"
msgstr "New VM Optimization"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Next"
msgstr "Next"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Next 6 months, by product"
msgstr "Next 6 months, by product"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Next executions"
msgstr "Next executions"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Next OS patch"
msgstr "Next OS patch"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "no"
msgstr "no"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "No"
msgstr "No"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "No accounts"
msgstr "No accounts"

#: app/frontend/pages/dashboard/subscriptions/components.jsx
msgid "No accounts configured."
msgstr "No accounts configured."

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
msgid "No API tokens yet."
msgstr "No API tokens yet."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No App Service Plan right sizing recommendations found."
msgstr "No App Service Plan right sizing recommendations found."

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "No attached volumes."
msgstr "No attached volumes."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No Aurora IO recommendations found."
msgstr "No Aurora IO recommendations found."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "No available volume recommendations found for this optimization."
msgstr "No available volume recommendations found for this optimization."

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "No AWS accounts found for the selected filters."
msgstr "No AWS accounts found for the selected filters."

#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
msgid "No AWS billing groups found for the selected filters."
msgstr "No AWS billing groups found for the selected filters."

#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "No AWS data imports found for the selected filters."
msgstr "No AWS data imports found for the selected filters."

#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "No AWS instance credentials found for the selected filters."
msgstr "No AWS instance credentials found for the selected filters."

#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
msgid "No Azure billing accounts found."
msgstr "No Azure billing accounts found."

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "No Azure Credentials Found"
msgstr "No Azure Credentials Found"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "No Azure credentials found for the selected filters."
msgstr "No Azure credentials found for the selected filters."

#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
msgid "No Azure subscriptions found for the selected filters."
msgstr "No Azure subscriptions found for the selected filters."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "No backup jobs"
msgstr "No backup jobs"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "No backup plans"
msgstr "No backup plans"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "No backup runs found for the selected period."
msgstr "No backup runs found for the selected period."

#: app/frontend/components/optimization_overview/OverviewHeader.jsx
msgid "No batch run yet"
msgstr "No batch run yet"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "No billing line items."
msgstr "No billing line items."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No change"
msgstr "No change"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No change recommended — already optimally sized"
msgstr "No change recommended — already optimally sized"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "No change requests found."
msgstr "No change requests found."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "No clusters configured for this run."
msgstr "No clusters configured for this run."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No commitment recommendations found."
msgstr "No commitment recommendations found."

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "no completed run"
msgstr "no completed run"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "No consumption data found for this period."
msgstr "No consumption data found for this period."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "No controls data available for the selected period."
msgstr "No controls data available for the selected period."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No convertible reservation recommendations found."
msgstr "No convertible reservation recommendations found."

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
msgid "No copy jobs found for the selected period."
msgstr "No copy jobs found for the selected period."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "No copy jobs found in destination regions"
msgstr "No copy jobs found in destination regions"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "No Cost Category selected"
msgstr "No Cost Category selected"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No CPU data"
msgstr "No CPU data"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "No CPU data, so the VM keeps its size."
msgstr "No CPU data, so the VM keeps its size."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "no data"
msgstr "no data"

#: app/frontend/components/echarts/options.js
#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "No data"
msgstr "No data"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "No Data"
msgstr "No Data"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "No data available for this component."
msgstr "No data available for this component."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "No data for selected period"
msgstr "No data for selected period"

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
msgid "No data for the selected period."
msgstr "No data for the selected period."

#: app/frontend/components/RankedListCard.jsx
msgid "No data for this period"
msgstr "No data for this period"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "No data yet."
msgstr "No data yet."

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "No Database settings found."
msgstr "No Database settings found."

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "No Databases available for the selected filters."
msgstr "No Databases available for the selected filters."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "No detections in the last 30 days"
msgstr "No detections in the last 30 days"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No disk right sizing recommendations found."
msgstr "No disk right sizing recommendations found."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "No disk SKU changes"
msgstr "No disk SKU changes"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "No domains configured for this run."
msgstr "No domains configured for this run."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
msgid "No DR resources"
msgstr "No DR resources"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "No DRS RPO target configured"
msgstr "No DRS RPO target configured"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "No DRS RTO target configured"
msgstr "No DRS RTO target configured"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "No EC2 CPU optimized recommendations found for this optimization."
msgstr "No EC2 CPU optimized recommendations found for this optimization."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "No EC2 instance settings found."
msgstr "No EC2 instance settings found."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "No EC2 instances available for the selected filters."
msgstr "No EC2 instances available for the selected filters."

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "No EC2 right sizing recommendations found for this optimization."
msgstr "No EC2 right sizing recommendations found for this optimization."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No ECS right sizing recommendations found."
msgstr "No ECS right sizing recommendations found."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "No EKS cluster settings found."
msgstr "No EKS cluster settings found."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "No EKS clusters available for the selected filters."
msgstr "No EKS clusters available for the selected filters."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No EKS node group recommendations found."
msgstr "No EKS node group recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No EKS workload right sizing recommendations found."
msgstr "No EKS workload right sizing recommendations found."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "No ElastiCache cluster settings found."
msgstr "No ElastiCache cluster settings found."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "No ElastiCache clusters available for the selected filters."
msgstr "No ElastiCache clusters available for the selected filters."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "No eligible instances in this period."
msgstr "No eligible instances in this period."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "No eligible resources in this period."
msgstr "No eligible resources in this period."

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "No error was reported."
msgstr "No error was reported."

#: app/frontend/components/guardian/help/patch_management.js
msgid "No Execution"
msgstr "No Execution"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DeliveryBand.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
msgid "No executions yet"
msgstr "No executions yet"

#: app/frontend/pages/dashboard/change_requests/show.jsx
msgid "No executions yet."
msgstr "No executions yet."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No extended support recommendations found."
msgstr "No extended support recommendations found."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/TopVolumesCard.jsx
msgid "No failed or missed backups in this period."
msgstr "No failed or missed backups in this period."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "No Falcon agent was detected on the EC2 instance."
msgstr "No Falcon agent was detected on the EC2 instance."

#: app/frontend/pages/dashboard/subscriptions/features/OrganizationFeaturesLayout.jsx
msgid "No features available"
msgstr "No features available"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "No features currently configured"
msgstr "No features currently configured"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "No governance tag keys found above the coverage threshold."
msgstr "No governance tag keys found above the coverage threshold."

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "NO HPA Configured"
msgstr "NO HPA Configured"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No idle database recommendations found."
msgstr "No idle database recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No idle load balancer recommendations found."
msgstr "No idle load balancer recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No idle NAT gateway recommendations found."
msgstr "No idle NAT gateway recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No idle RDS instance recommendations found."
msgstr "No idle RDS instance recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No incomplete multipart upload recommendations found."
msgstr "No incomplete multipart upload recommendations found."

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "No instance"
msgstr "No instance"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "No instance-type changes"
msgstr "No instance-type changes"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "No instances configured for this run."
msgstr "No instances configured for this run."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "No item outside target this period"
msgstr "No item outside target this period"

#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "No items found"
msgstr "No items found"

#: app/frontend/pages/dashboard/aws/backup_plans/lastJob.jsx
msgid "No jobs"
msgstr "No jobs"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "No Karpenter nodepools found for this cluster."
msgstr "No Karpenter nodepools found for this cluster."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No lifecycle rule"
msgstr "No lifecycle rule"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
msgid "No maintenance windows configured yet."
msgstr "No maintenance windows configured yet."

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "No members found for the selected filters."
msgstr "No members found for the selected filters."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "No memory data, so the new size keeps at least today's memory."
msgstr "No memory data, so the new size keeps at least today's memory."

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgid "No metrics"
msgstr "No metrics"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "No monitoring tickets in the selected period."
msgstr "No monitoring tickets in the selected period."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "No monitoring tickets tied to a server in this period."
msgstr "No monitoring tickets tied to a server in this period."

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "No node groups found for this cluster."
msgstr "No node groups found for this cluster."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No node right sizing recommendations found."
msgstr "No node right sizing recommendations found."

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "No nodes found."
msgstr "No nodes found."

#: app/frontend/pages/notifications/index.jsx
msgid "No notifications yet"
msgstr "No notifications yet"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "No open Critical or High detections"
msgstr "No open Critical or High detections"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "No Opensearch cluster settings found."
msgstr "No Opensearch cluster settings found."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "No Opensearch clusters available for the selected filters."
msgstr "No Opensearch clusters available for the selected filters."

#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
msgid "No optimization found for this execution."
msgstr "No optimization found for this execution."

#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
msgid "no optimization was created"
msgstr "no optimization was created"

#: app/frontend/components/optimizations/OptimizationsListing.jsx
msgid "No optimizations found for the selected filters."
msgstr "No optimizations found for the selected filters."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "No organizations found matching your search."
msgstr "No organizations found matching your search."

#: app/frontend/layout/menu.jsx
#: app/frontend/pages/dashboard/organizations/index.jsx
msgid "No organizations found."
msgstr "No organizations found."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "No organizations have active subscriptions to this plan."
msgstr "No organizations have active subscriptions to this plan."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "No organizations match the current filters."
msgstr "No organizations match the current filters."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "No organizations need attention."
msgstr "No organizations need attention."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No orphaned snapshot recommendations found."
msgstr "No orphaned snapshot recommendations found."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "No outliers above the signal threshold for the current cohort."
msgstr "No outliers above the signal threshold for the current cohort."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "No patching operations recorded in this period."
msgstr "No patching operations recorded in this period."

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "No pending Savings Plan recommendations found for this optimization."
msgstr "No pending Savings Plan recommendations found for this optimization."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "No priority data for monitoring tickets."
msgstr "No priority data for monitoring tickets."

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "No RDS instance settings found."
msgstr "No RDS instance settings found."

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "No RDS instances available for the selected filters."
msgstr "No RDS instances available for the selected filters."

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "No RDS right sizing recommendations found for this optimization."
msgstr "No RDS right sizing recommendations found for this optimization."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "No recommendation available."
msgstr "No recommendation available."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No recommendations found for this optimization."
msgstr "No recommendations found for this optimization."

#: app/frontend/components/optimization_dashboard/schedule/RecommendationGroup.jsx
msgid "No recommendations found."
msgstr "No recommendations found."

#: app/frontend/components/guardian/GuardianDrillDown.jsx
msgid "No records found for the selected filters."
msgstr "No records found for the selected filters."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/RequestTypeCard.jsx
msgid "No request type data available. Tickets require a Request Type in Jira."
msgstr "No request type data available. Tickets require a Request Type in Jira."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No reservation decisions found."
msgstr "No reservation decisions found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No reserved instance recommendations found."
msgstr "No reserved instance recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No reserved node recommendations found."
msgstr "No reserved node recommendations found."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "No resources"
msgstr "No resources"

#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "No resources assigned."
msgstr "No resources assigned."

#: app/frontend/components/ListingTable.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "No resources found for the selected filters."
msgstr "No resources found for the selected filters."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/OperationResourcesDrawer.jsx
msgid "No resources recorded for this operation."
msgstr "No resources recorded for this operation."

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "No resources selected yet."
msgstr "No resources selected yet."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
msgid "No restore jobs"
msgstr "No restore jobs"

#: app/frontend/utils/azure.js
msgid "No restrictions — migrate with no restrictions."
msgstr "No restrictions — migrate with no restrictions."

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "No results match your filters"
msgstr "No results match your filters"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No right sizing recommendations found."
msgstr "No right sizing recommendations found."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "No running volume recommendations found for this optimization."
msgstr "No running volume recommendations found for this optimization."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No saving plan recommendations found."
msgstr "No saving plan recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgid "No SBU for instance type"
msgstr "No SBU for instance type"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "No Security Hub data for this period."
msgstr "No Security Hub data for this period."

#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "no services configured"
msgstr "no services configured"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "No SKU changes"
msgstr "No SKU changes"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "No snapshots"
msgstr "No snapshots"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "No stopped volume recommendations found for this optimization."
msgstr "No stopped volume recommendations found for this optimization."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ServiceHoursCard.jsx
msgid "No support window data available"
msgstr "No support window data available"

#: app/frontend/pages/dashboard/aws/tag_manager/TagTemplateMultiSelect.jsx
msgid "No tags"
msgstr "No tags"

#: app/frontend/components/ResourceTagsTable.jsx
msgid "No tags match \"{search}\""
msgstr "No tags match \"{search}\""

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "No trend available"
msgstr "No trend available"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No unattached disk recommendations found."
msgstr "No unattached disk recommendations found."

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "No updates available."
msgstr "No updates available."

#: app/frontend/utils/aws.js
msgid "No Upfront"
msgstr "No Upfront"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "No Virtual Machine settings found."
msgstr "No Virtual Machine settings found."

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "No Virtual Machines available for the selected filters."
msgstr "No Virtual Machines available for the selected filters."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "No VM size changes"
msgstr "No VM size changes"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No volume cleanup recommendations found."
msgstr "No volume cleanup recommendations found."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "No volume kind change recommendations found."
msgstr "No volume kind change recommendations found."

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "No volume kind changes"
msgstr "No volume kind changes"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "No workgroups found for this namespace."
msgstr "No workgroups found for this namespace."

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Node"
msgstr "Node"

#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
msgid "Node Count"
msgstr "Node Count"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Node group"
msgstr "Node group"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Node Groups"
msgstr "Node Groups"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Node headroom"
msgstr "Node headroom"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Node Headroom"
msgstr "Node Headroom"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Node headroom percentage"
msgstr "Node headroom percentage"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Node type"
msgstr "Node type"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Node Type"
msgstr "Node Type"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Nodepools"
msgstr "Nodepools"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
msgid "Nodes"
msgstr "Nodes"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Non-compliant"
msgstr "Non-compliant"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
msgid "Non-compliant patches on instances that failed, missed their maintenance window, or are not protected by any resource group — the work this patch cycle did not close."
msgstr "Non-compliant patches on instances that failed, missed their maintenance window, or are not protected by any resource group — the work this patch cycle did not close."

#: app/frontend/pages/dashboard/subscriptions/components.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Non-production"
msgstr "Non-production"

#: app/frontend/pages/dashboard/subscriptions/sections/AwsAccountsSection.jsx
msgid "Non-production accounts are covered under the {otherTierLabel} tier."
msgstr "Non-production accounts are covered under the {otherTierLabel} tier."

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Non-Production Cloud Spend"
msgstr "Non-Production Cloud Spend"

#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
msgid "Non-SSL Port"
msgstr "Non-SSL Port"

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Noncompliance counts"
msgstr "Noncompliance counts"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "None"
msgstr "None"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Normal"
msgstr "Normal"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Normalization Size Factor"
msgstr "Normalization Size Factor"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/index.jsx
msgid "Not collecting data yet"
msgstr "Not collecting data yet"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Not contracted in this tier"
msgstr "Not contracted in this tier"

#. placeholder {0}: notContracted.join(', ')
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Not contracted in this tier: {0}."
msgstr "Not contracted in this tier: {0}."

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Not enabled"
msgstr "Not enabled"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Not protected right now — replication is stalled, paused, stopped or disconnected."
msgstr "Not protected right now — replication is stalled, paused, stopped or disconnected."

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Not reached"
msgstr "Not reached"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Not Running (min)"
msgstr "Not Running (min)"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Not set"
msgstr "Not set"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "not sold on the AWS Marketplace"
msgstr "not sold on the AWS Marketplace"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "Not subscribed"
msgstr "Not subscribed"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Note:"
msgstr "Note:"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Notes"
msgstr "Notes"

#: app/frontend/utils/aws.js
msgid "Nothing paid upfront — the whole commitment is billed hourly."
msgstr "Nothing paid upfront — the whole commitment is billed hourly."

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Notification ARN"
msgstr "Notification ARN"

#: app/frontend/layout/sidebar_menu.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
#: app/frontend/pages/notifications/index.jsx
#: app/frontend/pages/notifications/show.jsx
msgid "Notifications"
msgstr "Notifications"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Notifications are configured under Settings, not here."
msgstr "Notifications are configured under Settings, not here."

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Num Cache Nodes"
msgstr "Num Cache Nodes"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Number of Data Nodes"
msgstr "Number of Data Nodes"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Number of EBS volumes grouped by EC2 attachment status—Running EC2, Stopped EC2, or Unattached—shown as horizontal bars. Hover a bar for its exact count and percentage of the total."
msgstr "Number of EBS volumes grouped by EC2 attachment status—Running EC2, Stopped EC2, or Unattached—shown as horizontal bars. Hover a bar for its exact count and percentage of the total."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Number of Master Nodes"
msgstr "Number of Master Nodes"

#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Number of Nodes"
msgstr "Number of Nodes"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Number of recovery jobs that exceeded the RTO target."
msgstr "Number of recovery jobs that exceeded the RTO target."

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Number of Replicas"
msgstr "Number of Replicas"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Number of source servers whose replication lag exceeded the RPO target."
msgstr "Number of source servers whose replication lag exceeded the RPO target."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Numeric"
msgstr "Numeric"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Numeric, Min, Average, Max"
msgstr "Numeric, Min, Average, Max"

#. placeholder {0}: round2(recommendation.real_max_bandwidth)
#. placeholder {0}: round2(recommendation.real_max_iops)
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "observed peak {0}"
msgstr "observed peak {0}"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "OD Equivalent / mo"
msgstr "OD Equivalent / mo"

#. placeholder {0}: fmtPct(score.effective_discount_rate)
#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "OD equivalent is <0>estimated</0> using an assumed {0} RI savings rate. The effective discount rate is set by this assumption and does not independently measure your actual discount. Only <1>Coverage Rate</1> and <2>SCORE</2> carry diagnostic value."
msgstr "OD equivalent is <0>estimated</0> using an assumed {0} RI savings rate. The effective discount rate is set by this assumption and does not independently measure your actual discount. Only <1>Coverage Rate</1> and <2>SCORE</2> carry diagnostic value."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "OD Spend"
msgstr "OD Spend"

#. placeholder {0}: summary.evaluated
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "of {0} evaluated"
msgstr "of {0} evaluated"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ComplianceCard.jsx
msgid "of {evaluatedLabel}"
msgstr "of {evaluatedLabel}"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "of bill"
msgstr "of bill"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "of previous month spend, by service"
msgstr "of previous month spend, by service"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "of previous month spend, by service family"
msgstr "of previous month spend, by service family"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "of running spend"
msgstr "of running spend"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Of the findings tracked in a ticket that already got a first response, the share answered inside the contracted response time. A finding still waiting for its first response is inside its window, not a miss, and is counted separately."
msgstr "Of the findings tracked in a ticket that already got a first response, the share answered inside the contracted response time. A finding still waiting for its first response is inside its window, not a miss, and is counted separately."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Of the monitoring tickets opened in the period, the share already resolved or closed."
msgstr "Of the monitoring tickets opened in the period, the share already resolved or closed."

#: app/frontend/components/guardian/help/service_desk.js
msgid "Of the tickets opened in the period, the share that were resolved or closed. Higher is better."
msgstr "Of the tickets opened in the period, the share that were resolved or closed. Higher is better."

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
msgid "off"
msgstr "off"

#: app/frontend/pages/dashboard/subscriptions/components.jsx
msgid "Off"
msgstr "Off"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Offer Type"
msgstr "Offer Type"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Offering Class"
msgstr "Offering Class"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Offering ID"
msgstr "Offering ID"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Offering Type"
msgstr "Offering Type"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
msgid "Offering Type Detail"
msgstr "Offering Type Detail"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Offline"
msgstr "Offline"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "OK"
msgstr "OK"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "OLAP — Non-Production"
msgstr "OLAP — Non-Production"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "OLAP — Production"
msgstr "OLAP — Production"

#: app/frontend/components/chat/groups.js
msgid "Older"
msgstr "Older"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "OLTP — Non-Production"
msgstr "OLTP — Non-Production"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "OLTP — Production"
msgstr "OLTP — Production"

#: app/frontend/pages/dashboard/subscriptions/components.jsx
msgid "On"
msgstr "On"

#: app/frontend/components/guardian/help/service_desk.js
msgid "On average, how long a ticket takes to be fully resolved — per priority. Premium tier only."
msgstr "On average, how long a ticket takes to be fully resolved — per priority. Premium tier only."

#: app/frontend/components/guardian/help/service_desk.js
msgid "On average, how long a ticket waits for its first response — shown per priority."
msgstr "On average, how long a ticket waits for its first response — shown per priority."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "On the <0>Add permissions</0> page, under <1>Permissions policies</1>, use the search bar to find and select the role"
msgstr "On the <0>Add permissions</0> page, under <1>Permissions policies</1>, use the search bar to find and select the role"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "On the <0>Configure stack options</0> page, check the option <1>I acknowledge that AWS CloudFormation might create IAM resources with custom names</1> and then click <2>Next</2>."
msgstr "On the <0>Configure stack options</0> page, check the option <1>I acknowledge that AWS CloudFormation might create IAM resources with custom names</1> and then click <2>Next</2>."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "On the <0>Create Stack page</0>, select <1>Choose an existing template</1>, then select <2>Upload a template file</2>. Upload the template you downloaded in the previous step and click <3>Next</3>."
msgstr "On the <0>Create Stack page</0>, select <1>Choose an existing template</1>, then select <2>Upload a template file</2>. Upload the template you downloaded in the previous step and click <3>Next</3>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "On the <0>Name, review, and create</0> page, use the following <1>Role name</1>:"
msgstr "On the <0>Name, review, and create</0> page, use the following <1>Role name</1>:"

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "On the <0>Select trusted entity</0> page, select <1>AWS account</1> as the trusted entity type."
msgstr "On the <0>Select trusted entity</0> page, select <1>AWS account</1> as the trusted entity type."

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "On the <0>Specify stack details</0> page, give the stack a name (e.g., <1>skie-io-eks-split-cost</1>) and click <2>Next</2>."
msgstr "On the <0>Specify stack details</0> page, give the stack a name (e.g., <1>skie-io-eks-split-cost</1>) and click <2>Next</2>."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "On the <0>Specify stack details</0> page, give the stack a name (e.g., <1>skie-io-write-permissions-policy</1>) and provide the SkieioAssumeRoleName with the name of the existing role you want to add the policies to. Click <2>Next</2>. <3>Note:</3> This will only create the policies and attach them to an existing role."
msgstr "On the <0>Specify stack details</0> page, give the stack a name (e.g., <1>skie-io-write-permissions-policy</1>) and provide the SkieioAssumeRoleName with the name of the existing role you want to add the policies to. Click <2>Next</2>. <3>Note:</3> This will only create the policies and attach them to an existing role."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "On the <0>Specify stack details</0>, give the stack a name (e.g., <1>skie-io-assume-role-stack</1>) and click <2>Next</2>."
msgstr "On the <0>Specify stack details</0>, give the stack a name (e.g., <1>skie-io-assume-role-stack</1>) and click <2>Next</2>."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "On the Disaster Recovery tab, DR RPO looks at the most recent copy replicated to another region (not the in-region backup) — a resource is breached when that cross-region copy is older than the target."
msgstr "On the Disaster Recovery tab, DR RPO looks at the most recent copy replicated to another region (not the in-region backup) — a resource is breached when that cross-region copy is older than the target."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "On the final <0>Review and create</0> page, review the details and click <1>Submit</1>."
msgstr "On the final <0>Review and create</0> page, review the details and click <1>Submit</1>."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "On the Security Hub tab, a control that passed — not an issue to action, so it is excluded from the active total. The Inspector tab has no such exclusion: its counts include all five severities."
msgstr "On the Security Hub tab, a control that passed — not an issue to action, so it is excluded from the active total. The Inspector tab has no such exclusion: its counts include all five severities."

#: app/frontend/components/chat/SourceMenu.jsx
msgid "On this page"
msgstr "On this page"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "On-Demand (uncovered)"
msgstr "On-Demand (uncovered)"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "On-Demand Equivalent Spend"
msgstr "On-Demand Equivalent Spend"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "On-demand RDS spend only for the latest of the trailing 6 months (excludes reserved instances and savings plans)."
msgstr "On-demand RDS spend only for the latest of the trailing 6 months (excludes reserved instances and savings plans)."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "On-Demand Spend"
msgstr "On-Demand Spend"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "On-Demand Spend by Instance Type"
msgstr "On-Demand Spend by Instance Type"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "On-Demand Usage"
msgstr "On-Demand Usage"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Onboard your account with the CloudFormation setup below."
msgstr "Onboard your account with the CloudFormation setup below."

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Onboarding"
msgstr "Onboarding"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Once the prompt appears, you can clear the screen by typing"
msgstr "Once the prompt appears, you can clear the screen by typing"

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Once your organization is created, you'll receive step-by-step instructions on how to set up your AWS accounts in the platform to ensure a smooth and complete onboarding."
msgstr "Once your organization is created, you'll receive step-by-step instructions on how to set up your AWS accounts in the platform to ensure a smooth and complete onboarding."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "One badge per breaching signal, across every domain. Empty means nothing to act on."
msgstr "One badge per breaching signal, across every domain. Empty means nothing to act on."

#. placeholder {0}: tierFeatures.length
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "One of {0} active tiers, each covering different accounts"
msgstr "One of {0} active tiers, each covering different accounts"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Only an owner can schedule optimizations."
msgstr "Only an owner can schedule optimizations."

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "Only an owner can start an optimization run."
msgstr "Only an owner can start an optimization run."

#: app/frontend/utils/azure.js
msgid "Only migrate databases in and out of pools in the same server (no downtime)"
msgstr "Only migrate databases in and out of pools in the same server (no downtime)"

#: app/frontend/utils/azure.js
msgid "Only migrate databases in and out of pools of the same subscription."
msgstr "Only migrate databases in and out of pools of the same subscription."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Only the latest optimization can be scheduled."
msgstr "Only the latest optimization can be scheduled."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Only usage with a non-zero amortized cost on record is included, since some Shared-scope reservations post their amortized cost outside the ingested billing scope — this keeps the percentage from being understated or overstated by usage the data pipeline cannot currently cost."
msgstr "Only usage with a non-zero amortized cost on record is included, since some Shared-scope reservations post their amortized cost outside the ingested billing scope — this keeps the percentage from being understated or overstated by usage the data pipeline cannot currently cost."

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Only used to categorize the Jira Change Request."
msgstr "Only used to categorize the Jira Change Request."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "Only what is outside target, most severe first"
msgstr "Only what is outside target, most severe first"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "ONTAP Configuration"
msgstr "ONTAP Configuration"

#: app/frontend/components/chat/ChatLauncher.jsx
#: app/frontend/components/guardian/TicketStatusTree.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ServiceHoursCard.jsx
msgid "Open"
msgstr "Open"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Open dashboard"
msgstr "Open dashboard"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Open detections"
msgstr "Open detections"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Open Detections"
msgstr "Open Detections"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Open detections by severity"
msgstr "Open detections by severity"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
msgid "Open in Jira"
msgstr "Open in Jira"

#: app/frontend/components/chat/SourceMenu.jsx
msgid "Open optimization"
msgstr "Open optimization"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Open Security & Compliance in the per-org dashboard and prioritise failed controls, starting with high-severity ones."
msgstr "Open Security & Compliance in the per-org dashboard and prioritise failed controls, starting with high-severity ones."

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "Open your authenticator app (such as Google or Microsoft Authenticator) and scan the QR code."
msgstr "Open your authenticator app (such as Google or Microsoft Authenticator) and scan the QR code."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "OpenSearch"
msgstr "OpenSearch"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "OpenSearch cluster"
msgstr "OpenSearch cluster"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "OpenSearch cluster exceptions"
msgstr "OpenSearch cluster exceptions"

#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "OpenSearch Clusters"
msgstr "OpenSearch Clusters"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "OpenSearch Domain Settings"
msgstr "OpenSearch Domain Settings"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "OpenSearch Domains"
msgstr "OpenSearch Domains"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/index.jsx
msgid "OpenSearch Optimizations"
msgstr "OpenSearch Optimizations"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
msgid "OpenSearch reserved instance"
msgstr "OpenSearch reserved instance"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
msgid "OpenSearch Reserved Instances"
msgstr "OpenSearch Reserved Instances"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "OpenSearch Reserved Instances by category to support commitment planning and savings analysis."
msgstr "OpenSearch Reserved Instances by category to support commitment planning and savings analysis."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "OpenSearch right sizing"
msgstr "OpenSearch right sizing"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "OpenSearch Settings"
msgstr "OpenSearch Settings"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "OpenZFS Configuration"
msgstr "OpenZFS Configuration"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Operating system"
msgstr "Operating system"

#: app/frontend/pages/dashboard/aws/baselines/index.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Operating System"
msgstr "Operating System"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Operation"
msgstr "Operation"

#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
msgid "Operational State"
msgstr "Operational State"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "operations"
msgstr "operations"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Operations / month"
msgstr "Operations / month"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Operations are priced at the tier's cheapest and dearest meters; the move is recommended only when it saves under both."
msgstr "Operations are priced at the tier's cheapest and dearest meters; the move is recommended only when it saves under both."

#: app/frontend/pages/dashboard/azure/managed_disks/MetricsSection.jsx
msgid "Operations per Second"
msgstr "Operations per Second"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Operations/Second"
msgstr "Operations/Second"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Opportunity Board — Ranked by estimated $ impact"
msgstr "Opportunity Board — Ranked by estimated $ impact"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Optimization"
msgstr "Optimization"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
msgid "Optimization actions"
msgstr "Optimization actions"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Optimization failed"
msgstr "Optimization failed"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Optimization in progress"
msgstr "Optimization in progress"

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "Optimization Settings"
msgstr "Optimization Settings"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Optimizations"
msgstr "Optimizations"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_overview/CostChart.jsx
msgid "Optimized"
msgstr "Optimized"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Optimized /mo"
msgstr "Optimized /mo"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Optimized/mo"
msgstr "Optimized/mo"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "optimizer settings"
msgstr "optimizer settings"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "optional"
msgstr "optional"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Optional notes about this maintenance window"
msgstr "Optional notes about this maintenance window"

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Optionally, add a description for the policy."
msgstr "Optionally, add a description for the policy."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "Optionally, add a description for the role."
msgstr "Optionally, add a description for the role."

#: app/frontend/pages/dashboard/resource_groups/TagClauses.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "or"
msgstr "or"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Orchestration Mode"
msgstr "Orchestration Mode"

#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_v2_organizations/index.jsx
#: app/frontend/pages/admin/guardian_billing_organizations/index.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/admin/reseller_organizations/index.jsx
msgid "Organization"
msgstr "Organization"

#: app/frontend/pages/dashboard/organizations/edit.jsx
msgid "Organization Details"
msgstr "Organization Details"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Organization Health Matrix"
msgstr "Organization Health Matrix"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Organization ID"
msgstr "Organization ID"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Organization Members"
msgstr "Organization Members"

#: app/frontend/pages/admin/users/show.jsx
msgid "Organization name"
msgstr "Organization name"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Organization Name"
msgstr "Organization Name"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Organization Settings"
msgstr "Organization Settings"

#: app/frontend/layout/menu.jsx
#: app/frontend/pages/dashboard/organizations/index.jsx
msgid "Organizations"
msgstr "Organizations"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Organizations needing attention"
msgstr "Organizations needing attention"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Organizations tracked"
msgstr "Organizations tracked"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "OS"
msgstr "OS"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "OS Patch"
msgstr "OS Patch"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "OS support"
msgstr "OS support"

#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "OS Type"
msgstr "OS Type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "OS Version"
msgstr "OS Version"

#: app/frontend/components/DonutLegend.jsx
#: app/frontend/components/echarts/pie_utils.js
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/RequestTypeCard.jsx
msgid "Other"
msgstr "Other"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Other Non-Compliant Count"
msgstr "Other Non-Compliant Count"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Other resources RPO"
msgstr "Other resources RPO"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Other statuses"
msgstr "Other statuses"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Out of compliance"
msgstr "Out of compliance"

#: app/frontend/components/echarts/options.js
msgid "Outlier"
msgstr "Outlier"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Outlier Heatmap — Service share as % of bill vs peer median"
msgstr "Outlier Heatmap — Service share as % of bill vs peer median"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Outside SLA"
msgstr "Outside SLA"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "over-committed"
msgstr "over-committed"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Overall Utilization Summary"
msgstr "Overall Utilization Summary"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Overprovision"
msgstr "Overprovision"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Overprovisioned"
msgstr "Overprovisioned"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Override global EKS robustness settings. The default value is 0"
msgstr "Override global EKS robustness settings. The default value is 0"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Override global node headroom setting. The default value is 0.05 (5%)"
msgstr "Override global node headroom setting. The default value is 0.05 (5%)"

#. placeholder {0}: optimizerSetting.eks_robustness
#. placeholder {0}: optimizerSetting.target_quantile
#. placeholder {0}: optimizer_setting.target_quantile
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Overrides the global default of {0}"
msgstr "Overrides the global default of {0}"

#. placeholder {0}: optimizerSetting.node_headroom * 100
#. placeholder {0}: optimizerSetting.target_buffer
#. placeholder {0}: optimizer_setting.target_buffer
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Overrides the global default of {0}%"
msgstr "Overrides the global default of {0}%"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Overrides the global default of No"
msgstr "Overrides the global default of No"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Overrides the global default."
msgstr "Overrides the global default."

#: app/frontend/components/optimization_dashboard/OptimizationDashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "Overview"
msgstr "Overview"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Overview of Savings Plans utilization and opportunities for EC2 workloads."
msgstr "Overview of Savings Plans utilization and opportunities for EC2 workloads."

#: app/frontend/pages/admin/users/show.jsx
msgid "Owner"
msgstr "Owner"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Owner ID"
msgstr "Owner ID"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Packages with the most active CVE findings in the selected period."
msgstr "Packages with the most active CVE findings in the selected period."

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "Paid to Azure with the database"
msgstr "Paid to Azure with the database"

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Paid to Azure with the VM"
msgstr "Paid to Azure with the VM"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Parquet"
msgstr "Parquet"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Parquet (Snappy)"
msgstr "Parquet (Snappy)"

#: app/frontend/utils/aws.js
msgid "Part of the commitment paid upfront, the rest billed hourly at a lower rate."
msgstr "Part of the commitment paid upfront, the rest billed hourly at a lower rate."

#: app/frontend/pages/dashboard/aws/backup_plans/lastJob.jsx
msgid "Partial"
msgstr "Partial"

#: app/frontend/utils/aws.js
msgid "Partial Upfront"
msgstr "Partial Upfront"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Partition"
msgstr "Partition"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Passed"
msgstr "Passed"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "passing"
msgstr "passing"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Password"
msgstr "Password"

#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/pages/users/settings/password.jsx
msgid "Password and security"
msgstr "Password and security"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Password confirmation"
msgstr "Password confirmation"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Password confirmation (Step 1 of 3)"
msgstr "Password confirmation (Step 1 of 3)"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Password is required"
msgstr "Password is required"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Patch"
msgstr "Patch"

#: app/frontend/pages/dashboard/aws/baselines/index.jsx
msgid "Patch Baselines"
msgstr "Patch Baselines"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
msgid "Patch Coverage"
msgstr "Patch Coverage"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Patch Coverage - {periodLabel}"
msgstr "Patch Coverage - {periodLabel}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Patch coverage {v}%"
msgstr "Patch coverage {v}%"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/index.jsx
msgid "Patch Coverage Trend (12 months)"
msgstr "Patch Coverage Trend (12 months)"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Patch Groups"
msgstr "Patch Groups"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/index.jsx
msgid "Patch Management"
msgstr "Patch Management"

#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Patch Manager"
msgstr "Patch Manager"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Patch Now"
msgstr "Patch Now"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/OperationResourcesDrawer.jsx
msgid "Patch operation"
msgstr "Patch operation"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Patch Operations"
msgstr "Patch Operations"

#: app/frontend/components/guardian/help/patch_management.js
msgid "Patch status"
msgstr "Patch status"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Patch Version"
msgstr "Patch Version"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "patched"
msgstr "patched"

#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Patched"
msgstr "Patched"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Patched EC2 instances divided by total eligible instances."
msgstr "Patched EC2 instances divided by total eligible instances."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Patching change requests executed (or scheduled) in the selected period, grouped by day. Expand a day to see the per-operation breakdown."
msgstr "Patching change requests executed (or scheduled) in the selected period, grouped by day. Expand a day to see the per-operation breakdown."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Payer accounts"
msgstr "Payer accounts"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "paying Azure"
msgstr "paying Azure"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Payment option"
msgstr "Payment option"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Payment Option"
msgstr "Payment Option"

#. placeholder {0}: paymentOptionLabel(optimization.payment_option)
#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
msgid "Payment: {0}"
msgstr "Payment: {0}"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Peak/Trough Ratio"
msgstr "Peak/Trough Ratio"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Peer Intelligence"
msgstr "Peer Intelligence"

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Peer Intelligence settings"
msgstr "Peer Intelligence settings"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "pending"
msgstr "pending"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Pending"
msgstr "Pending"

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Pending — Collected"
msgstr "Pending — Collected"

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Pending — Invoiced"
msgstr "Pending — Invoiced"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Pending Change"
msgstr "Pending Change"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Pending invitations"
msgstr "Pending invitations"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
msgid "Pending Reboot"
msgstr "Pending Reboot"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Pending Review"
msgstr "Pending Review"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
msgid "pending setup"
msgstr "pending setup"

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Pending Tasks"
msgstr "Pending Tasks"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Per cell (client × service)"
msgstr "Per cell (client × service)"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Per month"
msgstr "Per month"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Percent of CPU and memory capacity to keep free in EKS nodes. The default value is 0.05 (5%)."
msgstr "Percent of CPU and memory capacity to keep free in EKS nodes. The default value is 0.05 (5%)."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Percent of CPU and memory capacity to keep free on EKS nodes before a rightsizing recommendation is made."
msgstr "Percent of CPU and memory capacity to keep free on EKS nodes before a rightsizing recommendation is made."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Percentage"
msgstr "Percentage"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Percentage of cloud bill"
msgstr "Percentage of cloud bill"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/index.jsx
msgid "Percentage of instances meeting their SLA availability threshold, evaluated per month."
msgstr "Percentage of instances meeting their SLA availability threshold, evaluated per month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Percentage, Month"
msgstr "Percentage, Month"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Percentile"
msgstr "Percentile"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Percentile rank within the cohort — \"this client is worse than X% of peers on this metric.\" Bounded 0–100, reads naturally as a worklist."
msgstr "Percentile rank within the cohort — \"this client is worse than X% of peers on this metric.\" Bounded 0–100, reads naturally as a worklist."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Performance"
msgstr "Performance"

#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
msgid "Performance Mode"
msgstr "Performance Mode"

#: app/frontend/components/FinopsFilterBar.jsx
#: app/frontend/components/guardian/GuardianContextBar.jsx
#: app/frontend/pages/admin/billing_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Period"
msgstr "Period"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Period:"
msgstr "Period:"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Persistent"
msgstr "Persistent"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Persistent high CPU can indicate indexing/search load that may benefit from scaling or shard rebalancing."
msgstr "Persistent high CPU can indicate indexing/search load that may benefit from scaling or shard rebalancing."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Phase ends"
msgstr "Phase ends"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Physical Processor"
msgstr "Physical Processor"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Pick manually"
msgstr "Pick manually"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Pillar"
msgstr "Pillar"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Pinned to an availability zone: only sizes Azure sells in that zone."
msgstr "Pinned to an availability zone: only sizes Azure sells in that zone."

#: app/frontend/pages/admin/plans/PlanSettingsLayout.jsx
msgid "Plan"
msgstr "Plan"

#: app/frontend/pages/admin/plans/edit.jsx
msgid "Plan Details"
msgstr "Plan Details"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Plan OS upgrade or migration to a supported version — these instances will not receive vendor patches regardless of scheduling."
msgstr "Plan OS upgrade or migration to a supported version — these instances will not receive vendor patches regardless of scheduling."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "plan."
msgstr "plan."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Planned utilization"
msgstr "Planned utilization"

#: app/frontend/layout/menu.jsx
#: app/frontend/pages/admin/plan_features/edit.jsx
#: app/frontend/pages/admin/plans/edit.jsx
#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/plans/new.jsx
#: app/frontend/pages/admin/plans/organizations.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/subscriptions/index.jsx
#: app/frontend/pages/dashboard/subscriptions/overview.jsx
msgid "Plans"
msgstr "Plans"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
msgid "Platform"
msgstr "Platform"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Platform Fault Domain Count"
msgstr "Platform Fault Domain Count"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Platform is required"
msgstr "Platform is required"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
msgid "Platform version"
msgstr "Platform version"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Platform Version"
msgstr "Platform Version"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Please fill in both S3 Bucket Name and S3 Prefix fields."
msgstr "Please fill in both S3 Bucket Name and S3 Prefix fields."

#: app/frontend/pages/users/registrations/edit.jsx
msgid "Please open the email you have received and click on the link to verify your account."
msgstr "Please open the email you have received and click on the link to verify your account."

#: app/frontend/pages/dashboard/organizations/new.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Please review the problems below:"
msgstr "Please review the problems below:"

#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Policy"
msgstr "Policy"

#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Policy ID"
msgstr "Policy ID"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Poor"
msgstr "Poor"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Port"
msgstr "Port"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "Portal: open the database, Compute + storage, under Save money select Yes for Azure Hybrid Benefit, tick the confirmation, Apply."
msgstr "Portal: open the database, Compute + storage, under Save money select Yes for Azure Hybrid Benefit, tick the confirmation, Apply."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Portal: open the SQL virtual machines resource, Settings, Configure, choose Azure Hybrid Benefit, tick the confirmation, Apply."
msgstr "Portal: open the SQL virtual machines resource, Settings, Configure, choose Azure Hybrid Benefit, tick the confirmation, Apply."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Portal: open the VM, Operating system, Licensing, select Yes, tick the confirmation, Save."
msgstr "Portal: open the VM, Operating system, Licensing, select Yes, tick the confirmation, Save."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Portal: open the VM, Operating system, set Azure Hybrid Benefit to Enable, Save."
msgstr "Portal: open the VM, Operating system, set Azure Hybrid Benefit to Enable, Save."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Positive — tax added on top of your revenue share, which you owe."
msgstr "Positive — tax added on top of your revenue share, which you owe."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Positive — the price you set in your agreement with the buyer."
msgstr "Positive — the price you set in your agreement with the buyer."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Positive, but informational only — tax AWS collected and remits to authorities on your behalf. Doesn't affect your balance or get disbursed."
msgstr "Positive, but informational only — tax AWS collected and remits to authorities on your behalf. Doesn't affect your balance or get disbursed."

#: app/frontend/components/ResourceStagesTable.jsx
msgid "Post-hook"
msgstr "Post-hook"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Post-hook failed"
msgstr "Post-hook failed"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
msgid "Post-hook failure"
msgstr "Post-hook failure"

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Post-hook updates"
msgstr "Post-hook updates"

#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
msgid "PostgreSQL"
msgstr "PostgreSQL"

#. placeholder {0}: fmtPct(score.potential_score)
#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Potential SCORE (zero waste): {0}"
msgstr "Potential SCORE (zero waste): {0}"

#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Power State"
msgstr "Power State"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "PowerShell Console Output"
msgstr "PowerShell Console Output"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Pre-approve Change Requests"
msgstr "Pre-approve Change Requests"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Pre-assigned based on AWS service taxonomy. Used for filtering, grouping, and routing signals to the right FinOps specialist."
msgstr "Pre-assigned based on AWS service taxonomy. Used for filtering, grouping, and routing signals to the right FinOps specialist."

#: app/frontend/components/ResourceStagesTable.jsx
msgid "Pre-hook"
msgstr "Pre-hook"

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Pre-hook updates"
msgstr "Pre-hook updates"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "Pre-setup on AWS management (payer) account"
msgstr "Pre-setup on AWS management (payer) account"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferable Families"
msgstr "Preferable Families"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferable instance families to buy new savings plans from"
msgstr "Preferable instance families to buy new savings plans from"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferable RDS instance families to buy new Reserved Instances from"
msgstr "Preferable RDS instance families to buy new Reserved Instances from"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Preferences specific to OpenSearch recommendations, on top of the global defaults above."
msgstr "Preferences specific to OpenSearch recommendations, on top of the global defaults above."

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Preferred Availability Zone"
msgstr "Preferred Availability Zone"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Preferred instance families"
msgstr "Preferred instance families"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Preferred Instance Families"
msgstr "Preferred Instance Families"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Preferred Maintenance Window"
msgstr "Preferred Maintenance Window"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Preferred regions"
msgstr "Preferred regions"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferred Regions"
msgstr "Preferred Regions"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferred regions and families to buy new RDS Reserved Instances from"
msgstr "Preferred regions and families to buy new RDS Reserved Instances from"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferred regions to buy new RDS Reserved Instances from"
msgstr "Preferred regions to buy new RDS Reserved Instances from"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferred regions to buy new savings plans from"
msgstr "Preferred regions to buy new savings plans from"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Preferred regions, families and payment option for new savings plans"
msgstr "Preferred regions, families and payment option for new savings plans"

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Premium — Includes Advanced + expanded SLAs and regional disaster recovery (AWS DRS). 6-month minimum commitment."
msgstr "Premium — Includes Advanced + expanded SLAs and regional disaster recovery (AWS DRS). 6-month minimum commitment."

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Premium (Production)"
msgstr "Premium (Production)"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart with the Y-axis representing costs in USD and the X-axis displaying the days. Each bar is segmented to indicate the proportion of costs for each EC2 instance by purchase type. Users can obtain specific cost values for each purchase type by hovering over the corresponding segment."
msgstr "Presented as a bar chart with the Y-axis representing costs in USD and the X-axis displaying the days. Each bar is segmented to indicate the proportion of costs for each EC2 instance by purchase type. Users can obtain specific cost values for each purchase type by hovering over the corresponding segment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart, each segment represents the utilization rate for a specific month."
msgstr "Presented as a bar chart, each segment represents the utilization rate for a specific month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart, it offers insights into cost distribution over time, with the Y-axis denoting costs in USD and the X-axis representing individual months. Each bar is segmented to reflect the proportion of costs attributed to a specific service, enabling a granular understanding of expenditure patterns. Users can access service-specific details, including cost values, by hovering over each segment."
msgstr "Presented as a bar chart, it offers insights into cost distribution over time, with the Y-axis denoting costs in USD and the X-axis representing individual months. Each bar is segmented to reflect the proportion of costs attributed to a specific service, enabling a granular understanding of expenditure patterns. Users can access service-specific details, including cost values, by hovering over each segment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart, it provides a clear visualization of cost distribution, with the Y-axis representing costs in USD and the X-axis delineating individual days within the specified timeframe. Each bar is segmented to illustrate the proportion of costs attributed to specific services, facilitating a granular understanding of expenditure patterns. Users can access detailed information for each segment, including the specific cost value associated with each service, by hovering over them."
msgstr "Presented as a bar chart, it provides a clear visualization of cost distribution, with the Y-axis representing costs in USD and the X-axis delineating individual days within the specified timeframe. Each bar is segmented to illustrate the proportion of costs attributed to specific services, facilitating a granular understanding of expenditure patterns. Users can access detailed information for each segment, including the specific cost value associated with each service, by hovering over them."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart, it shows four percentile metrics (P90, P95, P98, P99) for each month, representing different utilization levels. SBU utilization is calculated by comparing actual SBU usage against the instance type's SBU capacity."
msgstr "Presented as a bar chart, it shows four percentile metrics (P90, P95, P98, P99) for each month, representing different utilization levels. SBU utilization is calculated by comparing actual SBU usage against the instance type's SBU capacity."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar chart, where the Y-axis represents value in USD and the X-axis displays the upcoming months. Each bar is segmented by product to show the proportion of expiring reservation value attributed to each one. Hovering over a segment reveals the exact value for that product."
msgstr "Presented as a bar chart, where the Y-axis represents value in USD and the X-axis displays the upcoming months. Each bar is segmented by product to show the proportion of expiring reservation value attributed to each one. Hovering over a segment reveals the exact value for that product."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar graph, the Y-axis represents costs in USD, while the X-axis denotes individual days within the specified period. Each bar is segmented to illustrate the proportion of costs attributed to a particular usage type. Users can obtain detailed information about each segment by hovering over it, including the precise value associated with that specific usage type."
msgstr "Presented as a bar graph, the Y-axis represents costs in USD, while the X-axis denotes individual days within the specified period. Each bar is segmented to illustrate the proportion of costs attributed to a particular usage type. Users can obtain detailed information about each segment by hovering over it, including the precise value associated with that specific usage type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a bar graph, with the Y-axis denoting costs in USD and the X-axis indicating months. Each bar is divided into segments representing the proportion of expenses attributed to specific regions. By hovering over individual segments, users can access detailed information, including the precise cost value associated with each region."
msgstr "Presented as a bar graph, with the Y-axis denoting costs in USD and the X-axis indicating months. Each bar is divided into segments representing the proportion of expenses attributed to specific regions. By hovering over individual segments, users can access detailed information, including the precise cost value associated with each region."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a donut chart, each segment represents a specific disk type, with the total disk count shown at the center. Hovering over a segment reveals the quantity and percentage share for that type."
msgstr "Presented as a donut chart, each segment represents a specific disk type, with the total disk count shown at the center. Hovering over a segment reveals the quantity and percentage share for that type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a donut chart, each segment represents a VM instance series (such as D-series, E-series, F-series, etc.), with the total cost at the center. Hovering over segments reveals the cost and percentage share for each series."
msgstr "Presented as a donut chart, each segment represents a VM instance series (such as D-series, E-series, F-series, etc.), with the total cost at the center. Hovering over segments reveals the cost and percentage share for each series."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a grouped bar chart, one bar per DB engine per month, this view makes it easy to compare how efficiently each engine is priced relative to the memory it provisions, side by side across the full 18-month window."
msgstr "Presented as a grouped bar chart, one bar per DB engine per month, this view makes it easy to compare how efficiently each engine is priced relative to the memory it provisions, side by side across the full 18-month window."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a multi-series line chart, each line corresponds to a specific pricing model, allowing users to observe cost trends, shifts in consumption behavior, and the financial impact of pricing choices over time. Hovering over data points reveals precise monthly spend values per model."
msgstr "Presented as a multi-series line chart, each line corresponds to a specific pricing model, allowing users to observe cost trends, shifts in consumption behavior, and the financial impact of pricing choices over time. Hovering over data points reveals precise monthly spend values per model."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a multi-series line chart, each line represents a specific meter category, allowing for clear comparison of cost fluctuations over time. Hovering over data points reveals exact monthly spend values for each category."
msgstr "Presented as a multi-series line chart, each line represents a specific meter category, allowing for clear comparison of cost fluctuations over time. Hovering over data points reveals exact monthly spend values for each category."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a pie chart, each segment represents the proportion of costs associated with a specific instance type. Users can easily access detailed information for each segment by hovering over it, revealing expenditure values and percentages."
msgstr "Presented as a pie chart, each segment represents the proportion of costs associated with a specific instance type. Users can easily access detailed information for each segment by hovering over it, revealing expenditure values and percentages."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a pie chart, each segment represents the proportion of costs associated with a specific operating system. Users can easily access detailed information for each segment by hovering over it, revealing expenditure values and percentages."
msgstr "Presented as a pie chart, each segment represents the proportion of costs associated with a specific operating system. Users can easily access detailed information for each segment by hovering over it, revealing expenditure values and percentages."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a pie chart, it visually depicts the distribution of instances across different types. The total aggregated count of instances is highlighted at the chart's center. Each segment represents the proportion of instances for a specific type, allowing users to hover over segments for detailed information, including the total count of instances."
msgstr "Presented as a pie chart, it visually depicts the distribution of instances across different types. The total aggregated count of instances is highlighted at the chart's center. Each segment represents the proportion of instances for a specific type, allowing users to hover over segments for detailed information, including the total count of instances."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a pie chart, it visually represents the distribution of instances across different states. At the center of the chart, the total aggregated count of instances is highlighted, offering a quick overview. Each segment of the chart corresponds to the proportion of instances in a specific state, allowing users to access detailed information by hovering over segments, including the total count of instances."
msgstr "Presented as a pie chart, it visually represents the distribution of instances across different states. At the center of the chart, the total aggregated count of instances is highlighted, offering a quick overview. Each segment of the chart corresponds to the proportion of instances in a specific state, allowing users to access detailed information by hovering over segments, including the total count of instances."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a pie chart, it visually represents the distribution of instances across different tenancy types. The total aggregated count of instances by tenancy is prominently displayed at the chart's center. Each segment corresponds to the proportion of instances for a specific tenancy type, enabling users to access detailed information by hovering over segments, including the total count of instances."
msgstr "Presented as a pie chart, it visually represents the distribution of instances across different tenancy types. The total aggregated count of instances by tenancy is prominently displayed at the chart's center. Each segment corresponds to the proportion of instances for a specific tenancy type, enabling users to access detailed information by hovering over segments, including the total count of instances."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a stacked bar chart with a total line, each bar represents a month and each segment within it represents the proportion of spend attributed to a specific DB engine. Hovering over a segment reveals the exact spend value for that DB engine in that month."
msgstr "Presented as a stacked bar chart with a total line, each bar represents a month and each segment within it represents the proportion of spend attributed to a specific DB engine. Hovering over a segment reveals the exact spend value for that DB engine in that month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as a stacked bar chart, the Y-axis represents costs in USD and the X-axis shows each day within the selected timeframe. Each bar is segmented by meter category (such as Compute, Storage, Networking, etc.), allowing users to see how different resource types contribute to daily costs. Hovering over a segment reveals the exact value for that meter category on that day."
msgstr "Presented as a stacked bar chart, the Y-axis represents costs in USD and the X-axis shows each day within the selected timeframe. Each bar is segmented by meter category (such as Compute, Storage, Networking, etc.), allowing users to see how different resource types contribute to daily costs. Hovering over a segment reveals the exact value for that meter category on that day."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as one stacked bar chart with a total line per DB engine, each bar represents a month and each segment within it represents the proportion of spend attributed to a specific purchase type. Hovering over a segment reveals the exact spend value for that purchase type in that month."
msgstr "Presented as one stacked bar chart with a total line per DB engine, each bar represents a month and each segment within it represents the proportion of spend attributed to a specific purchase type. Hovering over a segment reveals the exact spend value for that purchase type in that month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Presented as one stacked bar chart with a total line per DB engine, each bar represents a month and each segment within it represents the spend attributed to a specific instance type, ranked from highest to lowest within that engine and month. Hovering over a segment reveals the exact spend value for that instance type in that month."
msgstr "Presented as one stacked bar chart with a total line per DB engine, each bar represents a month and each segment within it represents the spend attributed to a specific instance type, ranked from highest to lowest within that engine and month. Hovering over a segment reveals the exact spend value for that instance type in that month."

#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Preview"
msgstr "Preview"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Previous"
msgstr "Previous"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Previous 12 Months by Charge Type"
msgstr "Previous 12 Months by Charge Type"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by account"
msgstr "Previous 18 months spend by account"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by Cost Category"
msgstr "Previous 18 months spend by Cost Category"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous 18 months spend by Location"
msgstr "Previous 18 months spend by Location"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous 18 months spend by Meter Category"
msgstr "Previous 18 months spend by Meter Category"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous 18 months spend by Meter Sub Category"
msgstr "Previous 18 months spend by Meter Sub Category"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous 18 months spend by Pricing Model"
msgstr "Previous 18 months spend by Pricing Model"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by purchase type"
msgstr "Previous 18 months spend by purchase type"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by region"
msgstr "Previous 18 months spend by region"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by service"
msgstr "Previous 18 months spend by service"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous 18 months spend by Subscription"
msgstr "Previous 18 months spend by Subscription"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 18 months spend by usage type group"
msgstr "Previous 18 months spend by usage type group"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days EKS spend by cluster"
msgstr "Previous 30 days EKS spend by cluster"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 30 days spend by service *"
msgstr "Previous 30 days spend by service *"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous 30 days spend by usage type *"
msgstr "Previous 30 days spend by usage type *"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by cluster name"
msgstr "Previous 30 days split-cost EKS spend by cluster name"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by deployment"
msgstr "Previous 30 days split-cost EKS spend by deployment"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by namespace"
msgstr "Previous 30 days split-cost EKS spend by namespace"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by node"
msgstr "Previous 30 days split-cost EKS spend by node"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by workload"
msgstr "Previous 30 days split-cost EKS spend by workload"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Previous 30 days split-cost EKS spend by workload type"
msgstr "Previous 30 days split-cost EKS spend by workload type"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Previous 30 days VM usage by pricing model"
msgstr "Previous 30 days VM usage by pricing model"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Previous calendar month"
msgstr "Previous calendar month"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Previous month"
msgstr "Previous month"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Previous Month Spend By Meter Category"
msgstr "Previous Month Spend By Meter Category"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous month spend by service"
msgstr "Previous month spend by service"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous month spend by usage type group"
msgstr "Previous month spend by usage type group"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Previous month's EBS storage spend broken down by volume kind (gp3, gp2, io2, etc.), shown as a donut chart with each kind's share and cost listed in the legend."
msgstr "Previous month's EBS storage spend broken down by volume kind (gp3, gp2, io2, etc.), shown as a donut chart with each kind's share and cost listed in the legend."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Previous month's spend billed at on-demand rates only."
msgstr "Previous month's spend billed at on-demand rates only."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Previous month's spend covered by Reserved Instances or Savings Plans."
msgstr "Previous month's spend covered by Reserved Instances or Savings Plans."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Previous month's spend on EBS snapshot storage only."
msgstr "Previous month's spend on EBS snapshot storage only."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Previous month's spend on EBS volume storage only (excludes snapshots)."
msgstr "Previous month's spend on EBS volume storage only (excludes snapshots)."

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Price / unit"
msgstr "Price / unit"

#: app/frontend/pages/dashboard/subscriptions/sections/BillingSection.jsx
msgid "Price per unit"
msgstr "Price per unit"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Price Performance Target"
msgstr "Price Performance Target"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Price/hour"
msgstr "Price/hour"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Prices and service levels are part of the contract, and an owner sees them. Ask an owner if you need the terms."
msgstr "Prices and service levels are part of the contract, and an owner sees them. Ask an owner if you need the terms."

#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Pricing"
msgstr "Pricing"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Pricing Model"
msgstr "Pricing Model"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Pricing plan ARN"
msgstr "Pricing plan ARN"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Primary account ID"
msgstr "Primary account ID"

#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
msgid "Primary Account ID"
msgstr "Primary Account ID"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Primary Endpoints"
msgstr "Primary Endpoints"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Primary Location"
msgstr "Primary Location"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Priority"
msgstr "Priority"

#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/pages/users/settings/privacy.jsx
msgid "Privacy"
msgstr "Privacy"

#: app/frontend/layout/footer.jsx
#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Privacy policy"
msgstr "Privacy policy"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Private IP"
msgstr "Private IP"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
msgid "Private Key"
msgstr "Private Key"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Private Key is required"
msgstr "Private Key is required"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Processing"
msgstr "Processing"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Processor Architecture"
msgstr "Processor Architecture"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Processor Features"
msgstr "Processor Features"

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
msgid "prod, staging"
msgstr "prod, staging"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Product"
msgstr "Product"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Product / Offer"
msgstr "Product / Offer"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Product ARN"
msgstr "Product ARN"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Product Description"
msgstr "Product Description"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Product Name"
msgstr "Product Name"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "Product Order Name"
msgstr "Product Order Name"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Product Types"
msgstr "Product Types"

#: app/frontend/pages/dashboard/subscriptions/sections/AwsAccountsSection.jsx
msgid "production"
msgstr "production"

#: app/frontend/components/guardian/GuardianAccountsDrawer.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/subscriptions/components.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Production"
msgstr "Production"

#: app/frontend/pages/dashboard/subscriptions/sections/AwsAccountsSection.jsx
msgid "Production accounts are covered under the {otherTierLabel} tier."
msgstr "Production accounts are covered under the {otherTierLabel} tier."

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Production Cloud Spend"
msgstr "Production Cloud Spend"

#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/layout/top_bar.jsx
#: app/frontend/pages/users/registrations/edit.jsx
msgid "Profile"
msgstr "Profile"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
msgid "Progress"
msgstr "Progress"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "Projected cost change"
msgstr "Projected cost change"

#: app/frontend/components/optimization_dashboard/SummaryCards.jsx
#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "Projected savings"
msgstr "Projected savings"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Prolonged high CPU usage may indicate a need to right-size or optimize queries."
msgstr "Prolonged high CPU usage may indicate a need to right-size or optimize queries."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "protected"
msgstr "protected"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Protected"
msgstr "Protected"

#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Protected Item ID"
msgstr "Protected Item ID"

#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Protected Items"
msgstr "Protected Items"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Protected resources across AWS Backup, DRS, and Commvault."
msgstr "Protected resources across AWS Backup, DRS, and Commvault."

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Protection Container"
msgstr "Protection Container"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Protection State"
msgstr "Protection State"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Protection State Description"
msgstr "Protection State Description"

#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Protection Status"
msgstr "Protection Status"

#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "Protocol"
msgstr "Protocol"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Provide a comma-separated list of billing account IDs."
msgstr "Provide a comma-separated list of billing account IDs."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Provide a comma-separated list of subscription IDs to grant access to specific subscriptions."
msgstr "Provide a comma-separated list of subscription IDs to grant access to specific subscriptions."

#. placeholder {0}: recommendation.destination_iops
#. placeholder {1}: recommendation.destination_mbps
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Provision the new disk at {0} IOPS and {1} MB/s — the saving above assumes exactly that."
msgstr "Provision the new disk at {0} IOPS and {1} MB/s — the saving above assumes exactly that."

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
msgid "Provisioned Throughput"
msgstr "Provisioned Throughput"

#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Provisioning State"
msgstr "Provisioning State"

#: app/frontend/components/guardian/EC2AvailabilityTrendChart.jsx
msgid "pts vs prior month"
msgstr "pts vs prior month"

#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Public IP"
msgstr "Public IP"

#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
msgid "Public IP ID"
msgstr "Public IP ID"

#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
msgid "Public IPs"
msgstr "Public IPs"

#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
msgid "Public IPv4 Pool"
msgstr "Public IPv4 Pool"

#: app/frontend/pages/admin/trusted_keys/new.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
msgid "Public key"
msgstr "Public key"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Public Network Access"
msgstr "Public Network Access"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Publicly Accessible"
msgstr "Publicly Accessible"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Purchase"
msgstr "Purchase"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Purchase Configuration"
msgstr "Purchase Configuration"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Purchase Date"
msgstr "Purchase Date"

#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
msgid "Purchase Model"
msgstr "Purchase Model"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Purchase option"
msgstr "Purchase option"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Purchase type"
msgstr "Purchase type"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Purchased automatically"
msgstr "Purchased automatically"

#. placeholder {0}: withUnit(tooltipData[2])
#: app/frontend/components/echarts/options.js
msgid "Q1: {0}"
msgstr "Q1: {0}"

#. placeholder {0}: withUnit(tooltipData[4])
#: app/frontend/components/echarts/options.js
msgid "Q3: {0}"
msgstr "Q3: {0}"

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "QR code for two-factor authentication"
msgstr "QR code for two-factor authentication"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Quantity"
msgstr "Quantity"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Quantity by Availability Zone"
msgstr "Quantity by Availability Zone"

#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
msgid "Quantity By Disks States"
msgstr "Quantity By Disks States"

#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
msgid "Quantity By Disks Types"
msgstr "Quantity By Disks Types"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Quantity by Image Publisher"
msgstr "Quantity by Image Publisher"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Quantity by Operating System"
msgstr "Quantity by Operating System"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Quantity by Power State"
msgstr "Quantity by Power State"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Quantity by VM Size"
msgstr "Quantity by VM Size"

#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
msgid "Queue Length"
msgstr "Queue Length"

#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "Quota"
msgstr "Quota"

#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
msgid "Quota (GiB)"
msgstr "Quota (GiB)"

#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Quota ID"
msgstr "Quota ID"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Rate"
msgstr "Rate"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Raw CPU core count from EC2 inventory, summed across licensable instances (each counted once). The actual licensable total may be higher because Microsoft applies a 4-core-per-instance minimum, which this number does not."
msgstr "Raw CPU core count from EC2 inventory, summed across licensable instances (each counted once). The actual licensable total may be higher because Microsoft applies a 4-core-per-instance minimum, which this number does not."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "RDS"
msgstr "RDS"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "RDS · ElastiCache · OpenSearch · Redshift"
msgstr "RDS · ElastiCache · OpenSearch · Redshift"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "RDS cluster"
msgstr "RDS cluster"

#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
msgid "RDS Clusters"
msgstr "RDS Clusters"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "RDS Dashboard"
msgstr "RDS Dashboard"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "RDS Engine"
msgstr "RDS Engine"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "RDS instance"
msgstr "RDS instance"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "RDS instance exceptions"
msgstr "RDS instance exceptions"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "RDS Instance Settings"
msgstr "RDS Instance Settings"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "RDS Instances"
msgstr "RDS Instances"

#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
msgid "RDS Optimization"
msgstr "RDS Optimization"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "RDS optimization action"
msgstr "RDS optimization action"

#: app/frontend/pages/dashboard/aws/rds/optimizations/index.jsx
msgid "RDS Optimizations"
msgstr "RDS Optimizations"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "RDS reservations ending within the next 60 days, and their combined monthly value."
msgstr "RDS reservations ending within the next 60 days, and their combined monthly value."

#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "RDS reserved instance"
msgstr "RDS reserved instance"

#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "RDS Reserved Instances"
msgstr "RDS Reserved Instances"

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "RDS resizing"
msgstr "RDS resizing"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "RDS right sizing"
msgstr "RDS right sizing"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "RDS Right Sizing"
msgstr "RDS Right Sizing"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "RDS Right Sizing / Right Typing"
msgstr "RDS Right Sizing / Right Typing"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "RDS Settings"
msgstr "RDS Settings"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "read"
msgstr "read"

#: app/frontend/pages/notifications/show.jsx
msgid "Read"
msgstr "Read"

#: app/frontend/pages/notifications/show.jsx
msgid "Read by"
msgstr "Read by"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "read IOPS"
msgstr "read IOPS"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Read IOPS counts completed read operations per second, while write IOPS counts completed write operations per second. Monitoring combined IOPS helps assess storage performance and identify whether the volume is approaching its provisioned IOPS limit."
msgstr "Read IOPS counts completed read operations per second, while write IOPS counts completed write operations per second. Monitoring combined IOPS helps assess storage performance and identify whether the volume is approaching its provisioned IOPS limit."

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Read Replica DB Cluster Identifiers"
msgstr "Read Replica DB Cluster Identifiers"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Read throughput measures the volume of data read from storage per second, while write throughput measures data written per second. Monitoring combined bandwidth helps evaluate storage efficiency and detect saturation against the volume's maximum throughput limits."
msgstr "Read throughput measures the volume of data read from storage per second, while write throughput measures data written per second. Monitoring combined bandwidth helps evaluate storage efficiency and detect saturation against the volume's maximum throughput limits."

#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
msgid "Read/Write Speed"
msgstr "Read/Write Speed"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "reallocated via conversion"
msgstr "reallocated via conversion"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Reason"
msgstr "Reason"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Reason (optional)"
msgstr "Reason (optional)"

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Received from AWS"
msgstr "Received from AWS"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Recommendation"
msgstr "Recommendation"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Recommendation Details"
msgstr "Recommendation Details"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Recommendation Status"
msgstr "Recommendation Status"

#: app/frontend/components/optimization_dashboard/OptimizationDashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Recommendations"
msgstr "Recommendations"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Recommendations won't scale a domain beyond this many nodes unless overridden per domain below."
msgstr "Recommendations won't scale a domain beyond this many nodes unless overridden per domain below."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended Azure disk types after optimization."
msgstr "Recommended Azure disk types after optimization."

#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
msgid "Recommended Class"
msgstr "Recommended Class"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
msgid "Recommended cores"
msgstr "Recommended cores"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Recommended CPU Requests"
msgstr "Recommended CPU Requests"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended DB and Pool SKUs after optimization."
msgstr "Recommended DB and Pool SKUs after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended distribution of EBS volume types after optimization."
msgstr "Recommended distribution of EBS volume types after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended EC2 instance types after optimization and rightsizing."
msgstr "Recommended EC2 instance types after optimization and rightsizing."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended ElastiCache node types after optimization and rightsizing."
msgstr "Recommended ElastiCache node types after optimization and rightsizing."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Recommended hourly commitment"
msgstr "Recommended hourly commitment"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Recommended IOPS"
msgstr "Recommended IOPS"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Recommended Kind"
msgstr "Recommended Kind"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Recommended Max Replicas"
msgstr "Recommended Max Replicas"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Recommended Memory Requests"
msgstr "Recommended Memory Requests"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Recommended Min Replicas"
msgstr "Recommended Min Replicas"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended OpenSearch data node instance types after optimization."
msgstr "Recommended OpenSearch data node instance types after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended OpenSearch master node instance types after optimization."
msgstr "Recommended OpenSearch master node instance types after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended RDS DB instance classes after optimization and rightsizing."
msgstr "Recommended RDS DB instance classes after optimization and rightsizing."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Recommended size"
msgstr "Recommended size"

#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Recommended SKU"
msgstr "Recommended SKU"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
msgid "Recommended threads / core"
msgstr "Recommended threads / core"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Recommended Throughput"
msgstr "Recommended Throughput"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Recommended type"
msgstr "Recommended type"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
msgid "Recommended Type"
msgstr "Recommended Type"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Recommended VM SKUs after optimization."
msgstr "Recommended VM SKUs after optimization."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Record State"
msgstr "Record State"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "Record type"
msgstr "Record type"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Recovery"
msgstr "Recovery"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Recovery Jobs"
msgstr "Recovery Jobs"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Recovery Objectives"
msgstr "Recovery Objectives"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "Recovery objectives (RPO / RTO)"
msgstr "Recovery objectives (RPO / RTO)"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Recovery Point"
msgstr "Recovery Point"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Recurring"
msgstr "Recurring"

#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Recurring Charge Amount"
msgstr "Recurring Charge Amount"

#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Recurring Charge Frequency"
msgstr "Recurring Charge Frequency"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
msgid "Recurring Charges"
msgstr "Recurring Charges"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Recurring Payment Amount"
msgstr "Recurring Payment Amount"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Red Hat subscription"
msgstr "Red Hat subscription"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Redis Reserved Instances view to plan commitments and assess current coverage."
msgstr "Redis Reserved Instances view to plan commitments and assess current coverage."

#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Redis Version"
msgstr "Redis Version"

#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "Redshift Clusters"
msgstr "Redshift Clusters"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
msgid "Redshift Serverless"
msgstr "Redshift Serverless"

#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Redundancy"
msgstr "Redundancy"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Redundancy Mode"
msgstr "Redundancy Mode"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Refund allowance"
msgstr "Refund allowance"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "refund allowance remaining"
msgstr "refund allowance remaining"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/index.jsx
#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
#: app/frontend/pages/dashboard/aws/baselines/index.jsx
#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Region"
msgstr "Region"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Region / AZ"
msgstr "Region / AZ"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Region is required"
msgstr "Region is required"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Regions the optimizer is able to buy Instance Savings Plans in."
msgstr "Regions the optimizer is able to buy Instance Savings Plans in."

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Regions the optimizer is allowed to buy RIs in."
msgstr "Regions the optimizer is allowed to buy RIs in."

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Registered Container Instances"
msgstr "Registered Container Instances"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Reject"
msgstr "Reject"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Rejected"
msgstr "Rejected"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Rejected Patches"
msgstr "Rejected Patches"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Rejected Patches Action"
msgstr "Rejected Patches Action"

#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
msgid "Related Resources"
msgstr "Related Resources"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Remaining commit"
msgstr "Remaining commit"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Remediation"
msgstr "Remediation"

#: app/frontend/pages/admin/users/show.jsx
msgid "Remember created at"
msgstr "Remember created at"

#: app/frontend/components/optimizer/OptimizerSettingsListing.jsx
msgid "Remove"
msgstr "Remove"

#. placeholder {0}: row.email
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Remove {0} from the organization?"
msgstr "Remove {0} from the organization?"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Remove cluster"
msgstr "Remove cluster"

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "Remove Database Settings"
msgstr "Remove Database Settings"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Remove domain"
msgstr "Remove domain"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Remove EC2 Instance Settings"
msgstr "Remove EC2 Instance Settings"

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Remove EKS Cluster Settings"
msgstr "Remove EKS Cluster Settings"

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "Remove ElastiCache Cluster Settings"
msgstr "Remove ElastiCache Cluster Settings"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Remove instance"
msgstr "Remove instance"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Remove Opensearch Cluster Settings"
msgstr "Remove Opensearch Cluster Settings"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Remove RDS Instance Settings"
msgstr "Remove RDS Instance Settings"

#. placeholder {0}: invitation.email
#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Remove the invitation sent to {0}?"
msgstr "Remove the invitation sent to {0}?"

#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
msgid "Remove this feature from the organization's subscription."
msgstr "Remove this feature from the organization's subscription."

#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "Remove this feature from the plan template."
msgstr "Remove this feature from the plan template."

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Remove Virtual Machine Settings"
msgstr "Remove Virtual Machine Settings"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
msgid "Remove volume"
msgstr "Remove volume"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Renew"
msgstr "Renew"

#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
msgid "Replicas per Primary"
msgstr "Replicas per Primary"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Replicated Item"
msgstr "Replicated Item"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Replicated Item ID"
msgstr "Replicated Item ID"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Replicating"
msgstr "Replicating"

#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
msgid "Replication"
msgstr "Replication"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Replication Group ID"
msgstr "Replication Group ID"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Replication Health"
msgstr "Replication Health"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Replication Role"
msgstr "Replication Role"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Replication Status"
msgstr "Replication Status"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Replication Type"
msgstr "Replication Type"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Report name:"
msgstr "Report name:"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Reporter"
msgstr "Reporter"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Reporter Type"
msgstr "Reporter Type"

#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "Request Count"
msgstr "Request Count"

#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/created.jsx
msgid "Request example:"
msgstr "Request example:"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Request Type"
msgstr "Request Type"

#: app/frontend/components/echarts/chart/chart_info.jsx
#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "Requests"
msgstr "Requests"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Required"
msgstr "Required"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Required — ElastiCache has no implicit fallback default."
msgstr "Required — ElastiCache has no implicit fallback default."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Required — OpenSearch has no implicit fallback default."
msgstr "Required — OpenSearch has no implicit fallback default."

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Requires AWS DRS for these targets"
msgstr "Requires AWS DRS for these targets"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Requires eligible licences"
msgstr "Requires eligible licences"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Requires migration"
msgstr "Requires migration"

#: app/frontend/pages/dashboard/memberships/RolePicker.jsx
msgid "requires owner"
msgstr "requires owner"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Resell Fee"
msgstr "Resell Fee"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Reseller"
msgstr "Reseller"

#: app/frontend/pages/admin/reseller_organizations/index.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Reseller Billing"
msgstr "Reseller Billing"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Reseller fee"
msgstr "Reseller fee"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Reservation"
msgstr "Reservation"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Reservation Coverage"
msgstr "Reservation Coverage"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Reservation ID"
msgstr "Reservation ID"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "Reservation management"
msgstr "Reservation management"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Reservation management and coverage for Azure VMs."
msgstr "Reservation management and coverage for Azure VMs."

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "Reservation Name"
msgstr "Reservation Name"

#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Reservation Order ID"
msgstr "Reservation Order ID"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Reservation recommendations and coverage for Azure databases."
msgstr "Reservation recommendations and coverage for Azure databases."

#: app/frontend/pages/dashboard/azure/dashboard/AzureDashboardTabs.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "Reservation Spend"
msgstr "Reservation Spend"

#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Reservation Type"
msgstr "Reservation Type"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
msgid "Reservations"
msgstr "Reservations"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Reservations & Coverage"
msgstr "Reservations & Coverage"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Reservations Administrator"
msgstr "Reservations Administrator"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Reservations Ending Soon"
msgstr "Reservations Ending Soon"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Reserved + Savings Plan"
msgstr "Reserved + Savings Plan"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
msgid "Reserved Cache Node ID"
msgstr "Reserved Cache Node ID"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
msgid "Reserved Cache Nodes Offering ID"
msgstr "Reserved Cache Nodes Offering ID"

#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "Reserved capacity commitments expiring before this date are excluded from reservation recommendations."
msgstr "Reserved capacity commitments expiring before this date are excluded from reservation recommendations."

#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "Reserved DB Instance ARN"
msgstr "Reserved DB Instance ARN"

#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "Reserved DB Instance ID"
msgstr "Reserved DB Instance ID"

#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "Reserved DB Instance Offering ID"
msgstr "Reserved DB Instance Offering ID"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Reserved Instance & Savings Plan capacity paid for but not used by any running instance, previous month."
msgstr "Reserved Instance & Savings Plan capacity paid for but not used by any running instance, previous month."

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Reserved instance and savings plan RDS spend for the latest of the trailing 6 months."
msgstr "Reserved instance and savings plan RDS spend for the latest of the trailing 6 months."

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Reserved Instance ID"
msgstr "Reserved Instance ID"

#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
msgid "Reserved Instance Offering ID"
msgstr "Reserved Instance Offering ID"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Reserved Instance Value Ending"
msgstr "Reserved Instance Value Ending"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
msgid "Reserved Instances"
msgstr "Reserved Instances"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Reserved Instances and Savings Plans expiring before this date are excluded from reservation recommendations."
msgstr "Reserved Instances and Savings Plans expiring before this date are excluded from reservation recommendations."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Reserved Instances expiring before this date are excluded from reservation recommendations."
msgstr "Reserved Instances expiring before this date are excluded from reservation recommendations."

#: app/frontend/components/FinopsFilterBar.jsx
#: app/frontend/pages/dashboard/aws/patch_manager/index.jsx
msgid "Reset"
msgstr "Reset"

#: app/frontend/pages/admin/users/show.jsx
msgid "Reset password sent at"
msgstr "Reset password sent at"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Reset to defaults"
msgstr "Reset to defaults"

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Resize DB instance class"
msgstr "Resize DB instance class"

#: app/frontend/components/guardian/help/service_desk.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Resolution Rate"
msgstr "Resolution Rate"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Resolution rate {v}%"
msgstr "Resolution rate {v}%"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Resolution SLA by Severity"
msgstr "Resolution SLA by Severity"

#: app/frontend/components/guardian/help/common.js
msgid "Resolution time"
msgstr "Resolution time"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Resolution time per severity vs the SLA target. Based on Jira tickets linked to GuardDuty findings."
msgstr "Resolution time per severity vs the SLA target. Based on Jira tickets linked to GuardDuty findings."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Resolve"
msgstr "Resolve"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Resolve avg"
msgstr "Resolve avg"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Resolve target"
msgstr "Resolve target"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "resolved"
msgstr "resolved"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/components/guardian/TicketStatusTree.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Resolved"
msgstr "Resolved"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Resolved / Closed"
msgstr "Resolved / Closed"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Resolved tickets divided by tickets opened in the period. Resolved counts both Resolved and Closed."
msgstr "Resolved tickets divided by tickets opened in the period. Resolved counts both Resolved and Closed."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_addresses/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
msgid "Resource"
msgstr "Resource"

#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
msgid "Resource execution"
msgstr "Resource execution"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Resource group"
msgstr "Resource group"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourceGroupSelect.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Resource Group"
msgstr "Resource Group"

#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
msgid "Resource Group ID"
msgstr "Resource Group ID"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_group_settings/edit.jsx
#: app/frontend/pages/dashboard/resource_groups/edit.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/new.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Resource Groups"
msgstr "Resource Groups"

#: app/frontend/pages/dashboard/aws/tag_manager/ResourceGroupSelect.jsx
msgid "Resource groups are managed under Patch › Resource Groups. Every EC2 instance in the group is tagged."
msgstr "Resource groups are managed under Patch › Resource Groups. Every EC2 instance in the group is tagged."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
msgid "Resource ID"
msgstr "Resource ID"

#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Resource Identifier"
msgstr "Resource Identifier"

#: app/frontend/pages/dashboard/change_requests/resource_details.jsx
msgid "Resource Name"
msgstr "Resource Name"

#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
msgid "Resource State"
msgstr "Resource State"

#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Resource type"
msgstr "Resource type"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Resource Type"
msgstr "Resource Type"

#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Resource types"
msgstr "Resource types"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Resources"
msgstr "Resources"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
msgid "resources analyzed"
msgstr "resources analyzed"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Resources to tag"
msgstr "Resources to tag"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Resp"
msgstr "Resp"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Respond avg"
msgstr "Respond avg"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "Respond target"
msgstr "Respond target"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Response SLA by Severity"
msgstr "Response SLA by Severity"

#: app/frontend/components/guardian/help/common.js
msgid "Response time"
msgstr "Response time"

#: app/frontend/components/chat/ChatPanel.jsx
msgid "Restore"
msgstr "Restore"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Restore Jobs - {periodLabel}"
msgstr "Restore Jobs - {periodLabel}"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Restores exceeding their RTO target. AWS Backup + Commvault."
msgstr "Restores exceeding their RTO target. AWS Backup + Commvault."

#: app/frontend/utils/azure.js
msgid "Restrict by Server"
msgstr "Restrict by Server"

#: app/frontend/utils/azure.js
msgid "Restrict by Subscription"
msgstr "Restrict by Subscription"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "results"
msgstr "results"

#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Retention"
msgstr "Retention"

#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Retention Properties"
msgstr "Retention Properties"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
msgid "Retrieval Date"
msgstr "Retrieval Date"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Review"
msgstr "Review"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Review backup plan tags and ensure eligible resources are included. Skipped resources should be intentional."
msgstr "Review backup plan tags and ensure eligible resources are included. Skipped resources should be intentional."

#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "Review changes"
msgstr "Review changes"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Review restore performance — slow restores often point to instance sizing, network throughput, or snapshot freshness issues."
msgstr "Review restore performance — slow restores often point to instance sizing, network throughput, or snapshot freshness issues."

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Review the export configuration and click <0>Create export</0>."
msgstr "Review the export configuration and click <0>Create export</0>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "Review the information and click <0>Next</0>."
msgstr "Review the information and click <0>Next</0>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Review the permissions and click <0>Create policy</0>."
msgstr "Review the permissions and click <0>Create policy</0>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "Review the trusted entities and permissions, then click <0>Create role</0>."
msgstr "Review the trusted entities and permissions, then click <0>Create role</0>."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Review unresolved P1/P2 tickets in the per-org dashboard; escalate or reassign blocked items."
msgstr "Review unresolved P1/P2 tickets in the per-org dashboard; escalate or reassign blocked items."

#: app/frontend/pages/admin/users/show.jsx
msgid "Revoke admin permissions"
msgstr "Revoke admin permissions"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "RI"
msgstr "RI"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "RI Amortized"
msgstr "RI Amortized"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "RI OD equiv + OD spend (estimated via assumed savings rate)"
msgstr "RI OD equiv + OD spend (estimated via assumed savings rate)"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "RI OD equivalent / total OD equivalent"
msgstr "RI OD equivalent / total OD equivalent"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "RI qty"
msgstr "RI qty"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "RI Savings (est.)"
msgstr "RI Savings (est.)"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Rightsize"
msgstr "Rightsize"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "RIs & Savings Plans paid for but idle"
msgstr "RIs & Savings Plans paid for but idle"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
#: app/frontend/pages/dashboard/memberships/InviteModal.jsx
msgid "Role"
msgstr "Role"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Role Based Access Control Administrator (RBAC)"
msgstr "Role Based Access Control Administrator (RBAC)"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Role is required"
msgstr "Role is required"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Role name"
msgstr "Role name"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Root Causes"
msgstr "Root Causes"

#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Route Table ID"
msgstr "Route Table ID"

#: app/frontend/components/table/RowActions.jsx
msgid "Row actions"
msgstr "Row actions"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Rows (organization × tier) with at least one breaching signal in an enabled domain — service desk, security, patch, or backup. See the matrix below."
msgstr "Rows (organization × tier) with at least one breaching signal in an enabled domain — service desk, security, patch, or backup. See the matrix below."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "RPO"
msgstr "RPO"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "RPO — Recovery Point Objective"
msgstr "RPO — Recovery Point Objective"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "RPO breach count across AWS Backup + Commvault."
msgstr "RPO breach count across AWS Backup + Commvault."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "RPO Breaches"
msgstr "RPO Breaches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "RPO Compliance"
msgstr "RPO Compliance"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "RTO"
msgstr "RTO"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "RTO — Recovery Time Objective"
msgstr "RTO — Recovery Time Objective"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "RTO breach count across AWS Backup + Commvault."
msgstr "RTO breach count across AWS Backup + Commvault."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "RTO Breaches"
msgstr "RTO Breaches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "RTO Compliance"
msgstr "RTO Compliance"

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Rules"
msgstr "Rules"

#: app/frontend/components/optimization_dashboard/RunSwitcher.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Run"
msgstr "Run"

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "Run all optimizers"
msgstr "Run all optimizers"

#. placeholder {0}: ageLabel(run.started_at)
#: app/frontend/components/optimization_overview/OverviewHeader.jsx
msgid "Run in progress · started {0}"
msgstr "Run in progress · started {0}"

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/pages/dashboard/aws/ebs/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/index.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/index.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/index.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/index.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/index.jsx
msgid "Run Optimizer"
msgstr "Run Optimizer"

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "Run Optimizer Now"
msgstr "Run Optimizer Now"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Run test"
msgstr "Run test"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Run the script using one of the execution methods below. Select the appropriate tab for your needs."
msgstr "Run the script using one of the execution methods below. Select the appropriate tab for your needs."

#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
msgid "Running"
msgstr "Running"

#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Running Tasks"
msgstr "Running Tasks"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Running VMs"
msgstr "Running VMs"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Running volumes"
msgstr "Running volumes"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Running Volumes"
msgstr "Running Volumes"

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "Running…"
msgstr "Running…"

#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
msgid "S3"
msgstr "S3"

#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "S3 bucket"
msgstr "S3 bucket"

#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
msgid "S3 Bucket"
msgstr "S3 Bucket"

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
msgid "S3 bucket name"
msgstr "S3 bucket name"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "S3 Bucket Name"
msgstr "S3 Bucket Name"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "S3 Bucket Name is required"
msgstr "S3 Bucket Name is required"

#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
msgid "S3 bucket path"
msgstr "S3 bucket path"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "S3 bucket:"
msgstr "S3 bucket:"

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "S3 Dashboard"
msgstr "S3 Dashboard"

#: app/frontend/pages/dashboard/aws/s3/optimizations/index.jsx
msgid "S3 Optimizations"
msgstr "S3 Optimizations"

#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
msgid "S3 path"
msgstr "S3 path"

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "S3 Prefix (including report name)"
msgstr "S3 Prefix (including report name)"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "S3 prefix:"
msgstr "S3 prefix:"

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "S3 Spend by Other Costs"
msgstr "S3 Spend by Other Costs"

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "S3 Spend by Storage Type"
msgstr "S3 Spend by Storage Type"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_organizations/index.jsx
#: app/frontend/pages/admin/billing_reports/index.jsx
msgid "Sage Billing"
msgstr "Sage Billing"

#: app/frontend/pages/admin/billing_v2_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Sage Billing V2"
msgstr "Sage Billing V2"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Sales"
msgstr "Sales"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Same sale (buyer transaction ref)"
msgstr "Same sale (buyer transaction ref)"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "SAP application server: burstable sizes are excluded."
msgstr "SAP application server: burstable sizes are excluded."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "SAP HANA Kind"
msgstr "SAP HANA Kind"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "SAP HANA kind for the instance"
msgstr "SAP HANA kind for the instance"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "SAP HANA Workload"
msgstr "SAP HANA Workload"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "SAP HANA: only SAP-certified sizes, and never less memory."
msgstr "SAP HANA: only SAP-certified sizes, and never less memory."

#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
#: app/frontend/pages/admin/plan_features/edit.jsx
#: app/frontend/pages/admin/plans/PlanForm.jsx
#: app/frontend/pages/admin/service_users/ServiceUserForm.jsx
#: app/frontend/pages/admin/subscription_features/edit.jsx
#: app/frontend/pages/dashboard/aws/data_imports/DataImportFormModal.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/memberships/ChangeRoleModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/organizations/edit.jsx
#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
#: app/frontend/pages/users/registrations/edit.jsx
#: app/frontend/pages/users/settings/password.jsx
msgid "Save"
msgstr "Save"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Save Changes"
msgstr "Save Changes"

#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Save resource group"
msgstr "Save resource group"

#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
#: app/frontend/pages/dashboard/resource_group_settings/edit.jsx
msgid "Save Settings"
msgstr "Save Settings"

#: app/frontend/pages/users/two_factor/BackupCodesDialog.jsx
msgid "Save these codes in a safe place. You will only see these codes once. Each code can be used exactly once."
msgstr "Save these codes in a safe place. You will only see these codes once. Each code can be used exactly once."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Saving is the price-list difference between the Windows and Linux rates of this size for a month, as Azure billed no licence meter for this VM in the last 30 days."
msgstr "Saving is the price-list difference between the Windows and Linux rates of this size for a month, as Azure billed no licence meter for this VM in the last 30 days."

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "Saving is the SQL Server licence part of this database's price for a month; the chart below shows the licence meter Azure billed and should drop to zero once applied."
msgstr "Saving is the SQL Server licence part of this database's price for a month; the chart below shows the licence meter Azure billed and should drop to zero once applied."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Saving is what Azure billed on this VM's licence meter over the last 30 days, scaled to a month; the chart below shows the same meter and should drop to zero once applied."
msgstr "Saving is what Azure billed on this VM's licence meter over the last 30 days, scaled to a month; the chart below shows the same meter and should drop to zero once applied."

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
msgid "Saving Plan ARN"
msgstr "Saving Plan ARN"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Saving Plans"
msgstr "Saving Plans"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Savings"
msgstr "Savings"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Savings /mo"
msgstr "Savings /mo"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Savings %"
msgstr "Savings %"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Savings as a % of committed OD equivalent"
msgstr "Savings as a % of committed OD equivalent"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Savings Percentage"
msgstr "Savings Percentage"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Savings Plan Administrator"
msgstr "Savings Plan Administrator"

#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Savings Plan ARN"
msgstr "Savings Plan ARN"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Savings Plan ID"
msgstr "Savings Plan ID"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "Savings Plan optimization action"
msgstr "Savings Plan optimization action"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "Savings Plan purchase"
msgstr "Savings Plan purchase"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Savings Plan recommendation"
msgstr "Savings Plan recommendation"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Savings Plan Recommendations"
msgstr "Savings Plan Recommendations"

#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Savings Plan Type"
msgstr "Savings Plan Type"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Savings Plan Value Ending"
msgstr "Savings Plan Value Ending"

#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
msgid "Savings Plans"
msgstr "Savings Plans"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Savings Plans (Compute + EC2Instance)"
msgstr "Savings Plans (Compute + EC2Instance)"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Savings/mo"
msgstr "Savings/mo"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "SBU"
msgstr "SBU"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "SBU (compute-capacity Benchmark Unit) weights each instance type by its relative CPU capacity. Utilization below is CPU p90-p99, weighted by SBU across all running instances."
msgstr "SBU (compute-capacity Benchmark Unit) weights each instance type by its relative CPU capacity. Utilization below is CPU p90-p99, weighted by SBU across all running instances."

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "SBU Required"
msgstr "SBU Required"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
msgid "SBU Required ({stat})"
msgstr "SBU Required ({stat})"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "SBU Utilization"
msgstr "SBU Utilization"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
msgid "Scale Set"
msgstr "Scale Set"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
msgid "Scale Set VMs"
msgstr "Scale Set VMs"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
msgid "Scale Sets"
msgstr "Scale Sets"

#: app/frontend/pages/dashboard/aws/backup_plans/show.jsx
msgid "Scan Settings"
msgstr "Scan Settings"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Schedule"
msgstr "Schedule"

#: app/frontend/components/optimization_dashboard/schedule/ScheduleFooter.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Schedule Actions"
msgstr "Schedule Actions"

#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Schedule change requests"
msgstr "Schedule change requests"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Schedule optimizations"
msgstr "Schedule optimizations"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Schedule Type"
msgstr "Schedule Type"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Scheduled for {when}"
msgstr "Scheduled for {when}"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "Scheduled via a change request"
msgstr "Scheduled via a change request"

#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Schema"
msgstr "Schema"

#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Scope"
msgstr "Scope"

#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
msgid "Scope Resource Group"
msgstr "Scope Resource Group"

#: app/frontend/pages/admin/service_users/ServiceUserForm.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/admin_tokens/index.jsx
#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "Scopes"
msgstr "Scopes"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Score"
msgstr "Score"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "SCORE — Commitment Optimization Rate & Efficiency"
msgstr "SCORE — Commitment Optimization Rate & Efficiency"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "SCORE = Coverage × Effective Discount"
msgstr "SCORE = Coverage × Effective Discount"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "SCORE Benchmarks"
msgstr "SCORE Benchmarks"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "SCORE points lost to unused commitments"
msgstr "SCORE points lost to unused commitments"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Search by cluster ID..."
msgstr "Search by cluster ID..."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "Search by cluster name..."
msgstr "Search by cluster name..."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "Search by domain ID..."
msgstr "Search by domain ID..."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Search by domain name..."
msgstr "Search by domain name..."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "Search by ElastiCache ID..."
msgstr "Search by ElastiCache ID..."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Search by instance ID..."
msgstr "Search by instance ID..."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Search by name or ID..."
msgstr "Search by name or ID..."

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Search by name..."
msgstr "Search by name..."

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "Search by RDS ID..."
msgstr "Search by RDS ID..."

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Search by VM ID..."
msgstr "Search by VM ID..."

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Search for <0>Cost Management + Billing</0>"
msgstr "Search for <0>Cost Management + Billing</0>"

#: app/frontend/layout/sidebar_menu.jsx
msgid "Search menu"
msgstr "Search menu"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "Search organization"
msgstr "Search organization"

#: app/frontend/pages/dashboard/organizations/index.jsx
msgid "Search organizations"
msgstr "Search organizations"

#: app/frontend/components/ResourceTagsTable.jsx
msgid "Search tags..."
msgstr "Search tags..."

#: app/frontend/layout/menu.jsx
msgid "Search…"
msgstr "Search…"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Secondary Location"
msgstr "Secondary Location"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
msgid "Security"
msgstr "Security"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "Security & Compliance"
msgstr "Security & Compliance"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Security Controls"
msgstr "Security Controls"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Security Group IDs"
msgstr "Security Group IDs"

#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
msgid "Security Groups"
msgstr "Security Groups"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/index.jsx
msgid "Security Hub"
msgstr "Security Hub"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Security Hub controls by status, and how each enabled standard scores. Disabled controls are listed but excluded from the passed total."
msgstr "Security Hub controls by status, and how each enabled standard scores. Disabled controls are listed but excluded from the passed total."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Security Hub controls passed divided by controls enabled — a control your organization has turned off is excluded from both sides."
msgstr "Security Hub controls passed divided by controls enabled — a control your organization has turned off is excluded from both sides."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Security Hub controls passing divided by total monitored controls."
msgstr "Security Hub controls passing divided by total monitored controls."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Security Hub Findings"
msgstr "Security Hub Findings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Security Hub Findings - {periodLabel}"
msgstr "Security Hub Findings - {periodLabel}"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Security Hub has not yet evaluated the control."
msgstr "Security Hub has not yet evaluated the control."

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
msgid "Security Non-Compliant Count"
msgstr "Security Non-Compliant Count"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Security score"
msgstr "Security score"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Security Score"
msgstr "Security Score"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Security score {v}%"
msgstr "Security score {v}%"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Security score and control status across enabled AWS Security Hub standards."
msgstr "Security score and control status across enabled AWS Security Hub standards."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "See Microsoft's official guide for <0>assigning roles</0>:"
msgstr "See Microsoft's official guide for <0>assigning roles</0>:"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Select <0>Billing scopes</0> → choose your Billing Account"
msgstr "Select <0>Billing scopes</0> → choose your Billing Account"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Select a Cost Category in the filters to view results."
msgstr "Select a Cost Category in the filters to view results."

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
msgid "Select a credential"
msgstr "Select a credential"

#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
msgid "Select a group..."
msgstr "Select a group..."

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "Select a Guardian plan"
msgstr "Select a Guardian plan"

#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Select account"
msgstr "Select account"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select accounts to skip"
msgstr "Select accounts to skip"

#: app/frontend/components/optimization_dashboard/schedule/RecommendationGroup.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select all"
msgstr "Select all"

#. placeholder {0}: pagination.total
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "Select all {0}"
msgstr "Select all {0}"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "Select an account..."
msgstr "Select an account..."

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select AWS accounts"
msgstr "Select AWS accounts"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select day"
msgstr "Select day"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select environment"
msgstr "Select environment"

#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "Select new instance type"
msgstr "Select new instance type"

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
msgid "Select new kind"
msgstr "Select new kind"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Select organizations to subscribe to the"
msgstr "Select organizations to subscribe to the"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select preferable instance families"
msgstr "Select preferable instance families"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select preferable RDS instance families"
msgstr "Select preferable RDS instance families"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select preferred RDS regions"
msgstr "Select preferred RDS regions"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select preferred regions"
msgstr "Select preferred regions"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select resource groups"
msgstr "Select resource groups"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerModal.jsx
msgid "Select resources"
msgstr "Select resources"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Select subscriptions to skip"
msgstr "Select subscriptions to skip"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Select term"
msgstr "Select term"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Select timezone"
msgstr "Select timezone"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Select week"
msgstr "Select week"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "Select which instances to change CPU options."
msgstr "Select which instances to change CPU options."

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
msgid "Select which instances to change instance type."
msgstr "Select which instances to change instance type."

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Select which instances to resize."
msgstr "Select which instances to resize."

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Select which recommendations to schedule for purchase."
msgstr "Select which recommendations to schedule for purchase."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Select which running volumes to change type."
msgstr "Select which running volumes to change type."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Select which stopped volumes to change type."
msgstr "Select which stopped volumes to change type."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Select which unattached volumes to remove."
msgstr "Select which unattached volumes to remove."

#: app/frontend/pages/dashboard/aws/tag_manager/ResourceGroupSelect.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagTemplateMultiSelect.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Select…"
msgstr "Select…"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
msgid "Selected Savings Plans are queued and purchased automatically shortly after you schedule them."
msgstr "Selected Savings Plans are queued and purchased automatically shortly after you schedule them."

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Self-installed SQL without the skie-io:auto-tagging:database-type tag is not detected."
msgstr "Self-installed SQL without the skie-io:auto-tagging:database-type tag is not detected."

#: app/frontend/components/chat/Composer.jsx
#: app/frontend/pages/dashboard/memberships/InviteModal.jsx
msgid "Send"
msgstr "Send"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Sent at"
msgstr "Sent at"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Series"
msgstr "Series"

#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
msgid "Server"
msgstr "Server"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Server ID"
msgstr "Server ID"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Serverless"
msgstr "Serverless"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "servers"
msgstr "servers"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Servers in initial sync, backlog, rescanning, or creating a snapshot."
msgstr "Servers in initial sync, backlog, rescanning, or creating a snapshot."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Servers stalled, paused, stopped, or disconnected from replication."
msgstr "Servers stalled, paused, stopped, or disconnected from replication."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Servers with continuous data replication active (data_replication_state = CONTINUOUS)."
msgstr "Servers with continuous data replication active (data_replication_state = CONTINUOUS)."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Servers with the most monitoring tickets in the selected period. Many of these tickets are auto-resolved without human review, so this surfaces which servers are chronically noisy. Click a server to see its tickets."
msgstr "Servers with the most monitoring tickets in the selected period. Many of these tickets are auto-resolved without human review, so this surfaces which servers are chronically noisy. Click a server to see its tickets."

#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_line_items/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Service"
msgstr "Service"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "service / key combos below 50%"
msgstr "service / key combos below 50%"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Service Avg"
msgstr "Service Avg"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Service best practice, not contract clauses"
msgstr "Service best practice, not contract clauses"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Service Connect Defaults"
msgstr "Service Connect Defaults"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Service Desk"
msgstr "Service Desk"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Service Desk resolution rate"
msgstr "Service Desk resolution rate"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Service Family"
msgstr "Service Family"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ServiceHoursCard.jsx
msgid "Service Hours"
msgstr "Service Hours"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
msgid "Service Info 2"
msgstr "Service Info 2"

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Service level"
msgstr "Service level"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Service tier"
msgstr "Service tier"

#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
msgid "Service Tier"
msgstr "Service Tier"

#: app/frontend/pages/admin/service_users/edit.jsx
#: app/frontend/pages/admin/service_users/index.jsx
#: app/frontend/pages/admin/service_users/new.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/users/UsersSectionNav.jsx
msgid "Service users"
msgstr "Service users"

#: app/frontend/pages/admin/service_users/index.jsx
msgid "Service users identify other applications on Zee. They have access to the API, cannot access the dashboard, and are limited to their assigned scopes."
msgstr "Service users identify other applications on Zee. They have access to the API, cannot access the dashboard, and are limited to their assigned scopes."

#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Services"
msgstr "Services"

#: app/frontend/components/optimization_overview/OverviewTiles.jsx
msgid "Services analyzed"
msgstr "Services analyzed"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Services tracked"
msgstr "Services tracked"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "services where every key = 100%"
msgstr "services where every key = 100%"

#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
msgid "Session Count"
msgstr "Session Count"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Set licence type to"
msgstr "Set licence type to"

#: app/frontend/components/optimization_dashboard/panels/ReservationManagement.jsx
msgid "set on the organization"
msgstr "set on the organization"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Set the licence type in the Azure portal or CLI; no restart."
msgstr "Set the licence type in the Azure portal or CLI; no restart."

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "Set up a CUR 2.0 Data Export with split cost allocation data for EKS. Provide the S3 bucket name and prefix below, then use the CloudFormation template or follow the manual steps to create the export in your AWS account."
msgstr "Set up a CUR 2.0 Data Export with split cost allocation data for EKS. Provide the S3 bucket name and prefix below, then use the CloudFormation template or follow the manual steps to create the export in your AWS account."

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "Set up authenticator app (Step 2 of 3)"
msgstr "Set up authenticator app (Step 2 of 3)"

#: app/frontend/pages/dashboard/aws/tag_manager/TagTemplateMultiSelect.jsx
msgid "Sets of tags prepared by the Skie team. The tags of every selected template are applied."
msgstr "Sets of tags prepared by the Skie team. The tags of every selected template are applied."

#: app/frontend/components/optimization_dashboard/OptimizationHeader.jsx
#: app/frontend/components/optimization_overview/OverviewHeader.jsx
#: app/frontend/components/optimizer/DeleteSettingModal.jsx
#: app/frontend/components/optimizer/OptimizerSettingsListing.jsx
#: app/frontend/layout/menu.jsx
#: app/frontend/pages/admin/peer_intelligence/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/GuideShell.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/data_imports/index.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/index.jsx
#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
#: app/frontend/pages/dashboard/aws/settings/write_permissions.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/setup.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
#: app/frontend/pages/dashboard/memberships/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
#: app/frontend/pages/dashboard/organization_tokens/index.jsx
#: app/frontend/pages/dashboard/organizations/billing_report.jsx
#: app/frontend/pages/dashboard/organizations/edit.jsx
#: app/frontend/pages/dashboard/organizations/index.jsx
#: app/frontend/pages/dashboard/organizations/show.jsx
#: app/frontend/pages/dashboard/resource_group_settings/edit.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/subscriptions/index.jsx
#: app/frontend/pages/dashboard/subscriptions/overview.jsx
msgid "Settings"
msgstr "Settings"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Settings used"
msgstr "Settings used"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Settings used for this run"
msgstr "Settings used for this run"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Setup Done"
msgstr "Setup Done"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Setup guide"
msgstr "Setup guide"

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "Setup Guide"
msgstr "Setup Guide"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "Severity"
msgstr "Severity"

#: app/frontend/components/guardian/help/patch_management.js
msgid "Severity counts only come from instances with a recent SSM scan; an instance with no scan still counts towards the instance total."
msgstr "Severity counts only come from instances with a recent SSM scan; an instance with no scan still counts towards the instance total."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Severity model"
msgstr "Severity model"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Severity Normalized"
msgstr "Severity Normalized"

#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
msgid "Shards"
msgstr "Shards"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Share"
msgstr "Share"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Share of eligible instances that had a successful patch run this period."
msgstr "Share of eligible instances that had a successful patch run this period."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Share of eligible resources currently protected — AWS Backup alone, or combined with your managed databases when your organization is entitled to them."
msgstr "Share of eligible resources currently protected — AWS Backup alone, or combined with your managed databases when your organization is entitled to them."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Share of eligible spend covered by a commitment"
msgstr "Share of eligible spend covered by a commitment"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Share of instances that met their contracted uptime target this period — not the uptime itself. See the EC2 Availability page for the exact thresholds."
msgstr "Share of instances that met their contracted uptime target this period — not the uptime itself. See the EC2 Availability page for the exact thresholds."

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Share of latest-month VM spend covered by Reservations or Savings Plans, rather than on-demand."
msgstr "Share of latest-month VM spend covered by Reservations or Savings Plans, rather than on-demand."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Share of previous month's running-instance spend covered by Reserved Instances or Savings Plans, rather than on-demand."
msgstr "Share of previous month's running-instance spend covered by Reserved Instances or Savings Plans, rather than on-demand."

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "Share of the gap to the typical value counted as saving. Applies right away."
msgstr "Share of the gap to the typical value counted as saving. Applies right away."

#. placeholder {0}: filtered.length
#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
msgid "Showing {rangeStart}–{rangeEnd} of {0}"
msgstr "Showing {rangeStart}–{rangeEnd} of {0}"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Sign in"
msgstr "Sign in"

#: app/frontend/pages/admin/users/show.jsx
msgid "Sign in count"
msgstr "Sign in count"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "Sign in to the <0>AWS Management Console</0> in your management account and switch to the <1>US East (N. Virginia) / us-east-1</1> region — AWS Data Exports is only available there, and the template stops if deployed elsewhere."
msgstr "Sign in to the <0>AWS Management Console</0> in your management account and switch to the <1>US East (N. Virginia) / us-east-1</1> region — AWS Data Exports is only available there, and the template stops if deployed elsewhere."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>CloudFormation</2>."
msgstr "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>CloudFormation</2>."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>IAM</2>."
msgstr "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>IAM</2>."

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>S3</2>."
msgstr "Sign in to the <0>AWS Management Console</0>, click on <1>Services</1> and search for <2>S3</2>."

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Sign in with Google"
msgstr "Sign in with Google"

#: app/frontend/layout/top_bar.jsx
msgid "Sign out"
msgstr "Sign out"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Signal"
msgstr "Signal"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Significant Opportunity"
msgstr "Significant Opportunity"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Single Placement Group"
msgstr "Single Placement Group"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Site Recovery Protected Item Disks"
msgstr "Site Recovery Protected Item Disks"

#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
msgid "Sites"
msgstr "Sites"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/index.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Size"
msgstr "Size"

#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
msgid "Size (GiB)"
msgstr "Size (GiB)"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Sized for (IOPS)"
msgstr "Sized for (IOPS)"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Sized for (MB/s)"
msgstr "Sized for (MB/s)"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Skie Amount"
msgstr "Skie Amount"

#: app/frontend/components/chat/ChatLauncher.jsx
#: app/frontend/components/chat/ChatPanel.jsx
#: app/frontend/components/chat/Message.jsx
msgid "Skie Assist"
msgstr "Skie Assist"

#: app/frontend/components/chat/Message.jsx
msgid "Skie Assist is typing"
msgstr "Skie Assist is typing"

#: app/frontend/components/chat/ReplyNotice.jsx
msgid "Skie Assist replied"
msgstr "Skie Assist replied"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Skie billed the buyer for this amount."
msgstr "Skie billed the buyer for this amount."

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "SKIE Fee"
msgstr "SKIE Fee"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Skie Fees"
msgstr "Skie Fees"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Skie recommendations"
msgstr "Skie recommendations"

#: app/frontend/pages/dashboard/memberships/index.jsx
msgid "Skie staff"
msgstr "Skie staff"

#: app/frontend/pages/users/aws_marketplace_signup/new.jsx
msgid "Skie.io"
msgstr "Skie.io"

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "Skip this cluster from optimization."
msgstr "Skip this cluster from optimization."

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
msgid "Skip this Database from optimization"
msgstr "Skip this Database from optimization"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Skip this domain from optimization."
msgstr "Skip this domain from optimization."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
msgid "Skip this EC2 instance from optimization"
msgstr "Skip this EC2 instance from optimization"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Skip this EC2 instance from optimization."
msgstr "Skip this EC2 instance from optimization."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Skip this EKS cluster from optimization"
msgstr "Skip this EKS cluster from optimization"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
msgid "Skip this EKS cluster from optimization."
msgstr "Skip this EKS cluster from optimization."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
msgid "Skip this ElastiCache cluster from optimization"
msgstr "Skip this ElastiCache cluster from optimization"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Skip this Opensearch domain from optimization"
msgstr "Skip this Opensearch domain from optimization"

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
msgid "Skip this RDS instance from optimization"
msgstr "Skip this RDS instance from optimization"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Skip this RDS instance from optimization."
msgstr "Skip this RDS instance from optimization."

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Skip this Virtual Machine from optimization"
msgstr "Skip this Virtual Machine from optimization"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Skipped"
msgstr "Skipped"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Skipped Accounts"
msgstr "Skipped Accounts"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Skipped Subscriptions"
msgstr "Skipped Subscriptions"

#: app/frontend/components/optimizer/OptimizerSettingsListing.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Skipped?"
msgstr "Skipped?"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "SKU"
msgstr "SKU"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
msgid "SKU Capacity"
msgstr "SKU Capacity"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "SKU Count"
msgstr "SKU Count"

#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
msgid "SKU Name"
msgstr "SKU Name"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
msgid "SKU Tier"
msgstr "SKU Tier"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "SKUs"
msgstr "SKUs"

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
msgid "SLA"
msgstr "SLA"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/BreachCard.jsx
msgid "SLA Breaches"
msgstr "SLA Breaches"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "SLA Breaches - {periodLabel}"
msgstr "SLA Breaches - {periodLabel}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "SLA by priority"
msgstr "SLA by priority"

#: app/frontend/components/guardian/help/service_desk.js
msgid "SLA Clock"
msgstr "SLA Clock"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/ComplianceCard.jsx
msgid "SLA Compliance"
msgstr "SLA Compliance"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "SLA rows come from Jira tickets linked to GuardDuty findings, not from the findings themselves — a finding with no linked ticket does not appear in either SLA table."
msgstr "SLA rows come from Jira tickets linked to GuardDuty findings, not from the findings themselves — a finding with no linked ticket does not appear in either SLA table."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "SLA Status"
msgstr "SLA Status"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "SLA timings get a 25% grace buffer before they read as a miss."
msgstr "SLA timings get a 25% grace buffer before they read as a miss."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Smallest instance"
msgstr "Smallest instance"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
msgid "Snapshot"
msgstr "Snapshot"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
msgid "Snapshot ID"
msgstr "Snapshot ID"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Snapshot Retention Limit"
msgstr "Snapshot Retention Limit"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
msgid "Snapshot Size"
msgstr "Snapshot Size"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Snapshot Spend"
msgstr "Snapshot Spend"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
msgid "Snapshots"
msgstr "Snapshots"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Snapshots where DRS confirmed data consistency."
msgstr "Snapshots where DRS confirmed data consistency."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Snapshots where DRS detected data inconsistencies."
msgstr "Snapshots where DRS detected data inconsistencies."

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Sockets"
msgstr "Sockets"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "sold on the AWS Marketplace"
msgstr "sold on the AWS Marketplace"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Sold through"
msgstr "Sold through"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Some settings below can be overridden by the settings in the individual optimizer settings."
msgstr "Some settings below can be overridden by the settings in the individual optimizer settings."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Some trends run through today rather than through the selected period; those rows are marked, because the trend and the change beside it are then not measuring the same window. Threat response has no trend at all yet, and says so."
msgstr "Some trends run through today rather than through the selected period; those rows are marked, because the trend and the change beside it are then not measuring the same window. Threat response has no trend at all yet, and says so."

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "Something went wrong while generating this optimization. Run the optimizer again, or open the history to view a previous successful run."
msgstr "Something went wrong while generating this optimization. Run the optimizer again, or open the history to view a previous successful run."

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Something went wrong. Please try again."
msgstr "Something went wrong. Please try again."

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "Source"
msgstr "Source"

#: app/frontend/components/chat/SourceMenu.jsx
msgctxt "chat source menu"
msgid "Source"
msgstr "Source"

#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
msgid "Source Disk"
msgstr "Source Disk"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Source disk (deleted)"
msgstr "Source disk (deleted)"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Source Region"
msgstr "Source Region"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Source Servers"
msgstr "Source Servers"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Source URL"
msgstr "Source URL"

#: app/frontend/components/chat/SourceMenu.jsx
msgid "Source: {label}"
msgstr "Source: {label}"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "Sources"
msgstr "Sources"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "SP"
msgstr "SP"

#: app/frontend/components/StackedBarTable.jsx
msgid "Space"
msgstr "Space"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Space Allocated by Volume Kind"
msgstr "Space Allocated by Volume Kind"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
msgid "Specific Date"
msgstr "Specific Date"

#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Spend"
msgstr "Spend"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Spend across all connected AWS accounts"
msgstr "Spend across all connected AWS accounts"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Spend across all connected Azure subscriptions"
msgstr "Spend across all connected Azure subscriptions"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Spend billed at on-demand rates only, for the latest of the trailing 6 months."
msgstr "Spend billed at on-demand rates only, for the latest of the trailing 6 months."

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Spend by DB Engine"
msgstr "Spend by DB Engine"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Spend by Instance Series"
msgstr "Spend by Instance Series"

#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
msgid "Spend by meter sub category across all connected Azure subscriptions"
msgstr "Spend by meter sub category across all connected Azure subscriptions"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Spend by Operating System"
msgstr "Spend by Operating System"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Spend by Pricing Model"
msgstr "Spend by Pricing Model"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Spend by Purchase Type"
msgstr "Spend by Purchase Type"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Spend by Record Type"
msgstr "Spend by Record Type"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Spend by Volume Kind"
msgstr "Spend by Volume Kind"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Spend covered by Reservations or Savings Plans, for the latest of the trailing 6 months."
msgstr "Spend covered by Reservations or Savings Plans, for the latest of the trailing 6 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Spikes may indicate increased egress traffic, data transfer, or service load."
msgstr "Spikes may indicate increased egress traffic, data transfer, or service load."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Spikes may indicate increased ingress traffic, data transfer, or service load."
msgstr "Spikes may indicate increased ingress traffic, data transfer, or service load."

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Split Tunnel"
msgstr "Split Tunnel"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Split-Cost Dashboard"
msgstr "Split-Cost Dashboard"

#: app/frontend/pages/dashboard/azure/sql/optimizations/new.jsx
msgid "SQL"
msgstr "SQL"

#: app/frontend/pages/dashboard/azure/databases/index.jsx
msgid "SQL Databases"
msgstr "SQL Databases"

#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
msgid "SQL Instance Memory Percent"
msgstr "SQL Instance Memory Percent"

#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
msgid "SQL Managed Instances"
msgstr "SQL Managed Instances"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "SQL Server compliance rules and what to do in each case. The rule matching your current state is highlighted."
msgstr "SQL Server compliance rules and what to do in each case. The rule matching your current state is highlighted."

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "SQL Server Enterprise or Standard core licences with Software Assurance or subscription covering this database's vCores."
msgstr "SQL Server Enterprise or Standard core licences with Software Assurance or subscription covering this database's vCores."

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "SQL Server is licensed per core"
msgstr "SQL Server is licensed per core"

#: app/frontend/pages/dashboard/aws/sql_server_licences/index.jsx
msgid "SQL Server Licences"
msgstr "SQL Server Licences"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "SQL Server licences with Software Assurance"
msgstr "SQL Server licences with Software Assurance"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "SQL Server pay-as-you-go: the licence is billed per active vCPU, so fewer cores also cut the licence."
msgstr "SQL Server pay-as-you-go: the licence is billed per active vCPU, so fewer cores also cut the licence."

#. placeholder {0}: recommendation.license_cores ?? 4
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "SQL Server Standard or Enterprise core licences with Software Assurance or subscription covering {0} cores (at least 4 per VM)."
msgstr "SQL Server Standard or Enterprise core licences with Software Assurance or subscription covering {0} cores (at least 4 per VM)."

#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
msgid "SQL Virtual Machines"
msgstr "SQL Virtual Machines"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "SSH"
msgstr "SSH"

#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
msgid "SSL Port"
msgstr "SSL Port"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "SSM"
msgstr "SSM"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
msgid "SSM Patch Baseline"
msgstr "SSM Patch Baseline"

#: app/frontend/pages/admin/users/show.jsx
msgid "Staff"
msgstr "Staff"

#: app/frontend/pages/dashboard/change_requests/show.jsx
msgid "Stage"
msgstr "Stage"

#: app/frontend/components/optimization_overview/ServiceTable.jsx
msgid "Stale"
msgstr "Stale"

#: app/frontend/components/guardian/help/ec2_availability.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Standard"
msgstr "Standard"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "STAR — Tagging Accomplishment Rate"
msgstr "STAR — Tagging Accomplishment Rate"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "STAR Score"
msgstr "STAR Score"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Start Date"
msgstr "Start Date"

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "Start run"
msgstr "Start run"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
msgid "Start time"
msgstr "Start time"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Start Time"
msgstr "Start Time"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Start Time (Local)"
msgstr "Start Time (Local)"

#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "Start Time (UTC)"
msgstr "Start Time (UTC)"

#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Started"
msgstr "Started"

#. placeholder {0}: subscription.started_at
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Started {0}"
msgstr "Started {0}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Started At"
msgstr "Started At"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/index.jsx
#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "State"
msgstr "State"

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "State Transition Reason"
msgstr "State Transition Reason"

#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
msgid "Statistics"
msgstr "Statistics"

#: app/frontend/components/guardian/GuardianTimelineDrawer.jsx
#: app/frontend/components/optimization_overview/RunServicesDrawer.jsx
#: app/frontend/components/optimization_overview/ServiceTable.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/marketplace_billings/index.jsx
#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/ecs_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchCoverageCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestSummaryCard.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
#: app/frontend/pages/dashboard/change_requests/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/master_optimizations/index.jsx
msgid "Status"
msgstr "Status"

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "Status reason"
msgstr "Status reason"

#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Status: {label}"
msgstr "Status: {label}"

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Step"
msgstr "Step"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Step 1: Ensure you have the required permissions in your Azure environment"
msgstr "Step 1: Ensure you have the required permissions in your Azure environment"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Step 2: Get the PowerShell script"
msgstr "Step 2: Get the PowerShell script"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Step 3: Open Azure Cloud Shell"
msgstr "Step 3: Open Azure Cloud Shell"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Step 4: Upload and run the PowerShell script"
msgstr "Step 4: Upload and run the PowerShell script"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Step 5: Send Results to Skie.io"
msgstr "Step 5: Send Results to Skie.io"

#: app/frontend/components/GuidePanel.jsx
#: app/frontend/pages/dashboard/aws/accounts/GuideShell.jsx
msgid "Step-by-step guide"
msgstr "Step-by-step guide"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "Steps to enable \"Account Owner can view charges\""
msgstr "Steps to enable \"Account Owner can view charges\""

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
msgid "Stopped"
msgstr "Stopped"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Stopped volumes"
msgstr "Stopped volumes"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "Stopped Volumes"
msgstr "Stopped Volumes"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
msgid "Stopping"
msgstr "Stopping"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
#: app/frontend/pages/dashboard/azure/databases/MetricsSection.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Storage"
msgstr "Storage"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Storage (GB)"
msgstr "Storage (GB)"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Storage account"
msgstr "Storage account"

#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "Storage Account"
msgstr "Storage Account"

#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Storage Account ID"
msgstr "Storage Account ID"

#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
msgid "Storage Accounts"
msgstr "Storage Accounts"

#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Storage Auto Grow"
msgstr "Storage Auto Grow"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Storage Capacity"
msgstr "Storage Capacity"

#: app/frontend/pages/dashboard/aws/s3_buckets/index.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
msgid "Storage Class"
msgstr "Storage Class"

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Storage right sizing"
msgstr "Storage right sizing"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Storage Size (GB)"
msgstr "Storage Size (GB)"

#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
msgid "Storage Size in GB"
msgstr "Storage Size in GB"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Storage Spend"
msgstr "Storage Spend"

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "Storage spend by type across all connected AWS accounts"
msgstr "Storage spend by type across all connected AWS accounts"

#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
msgid "Storage Throughput"
msgstr "Storage Throughput"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Storage Tier"
msgstr "Storage Tier"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Storage Type"
msgstr "Storage Type"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Storage usage for the database to assess capacity and growth."
msgstr "Storage usage for the database to assess capacity and growth."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Storage, Volume Count"
msgstr "Storage, Volume Count"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Stream Specification"
msgstr "Stream Specification"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "STS External ID"
msgstr "STS External ID"

#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Submit"
msgstr "Submit"

#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "Subnet ID"
msgstr "Subnet ID"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Subnet IDs"
msgstr "Subnet IDs"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Subscribe Organizations"
msgstr "Subscribe Organizations"

#. placeholder {0}: plan.name
#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Subscribe Organizations to {0}"
msgstr "Subscribe Organizations to {0}"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Subscribe Selected Organizations"
msgstr "Subscribe Selected Organizations"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/index.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/index.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
#: app/frontend/pages/dashboard/azure/databases/index.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/index.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/index.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/index.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/index.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/index.jsx
#: app/frontend/pages/dashboard/azure/resource_groups/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/azure/sql_virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/sql/database_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/index.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Subscription"
msgstr "Subscription"

#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
msgid "Subscription ID"
msgstr "Subscription ID"

#: app/frontend/pages/dashboard/azure/subscriptions/index.jsx
msgid "Subscription Name"
msgstr "Subscription Name"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "Subscription Owner"
msgstr "Subscription Owner"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Subscription Started"
msgstr "Subscription Started"

#: app/frontend/pages/admin/plans/PlanSettingsLayout.jsx
#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
#: app/frontend/pages/dashboard/subscriptions/features/show.jsx
msgid "Subscriptions"
msgstr "Subscriptions"

#: app/frontend/pages/dashboard/change_requests/ResourceUpdatesStepper.jsx
msgid "Succeeded"
msgstr "Succeeded"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
#: app/frontend/pages/dashboard/change_requests/ExecutionStatusBadge.jsx
msgid "Success"
msgstr "Success"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Successful"
msgstr "Successful"

#: app/frontend/pages/admin/guardian_global_dashboard/SignalCell.jsx
msgid "Suggested action"
msgstr "Suggested action"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Sum of currently breaching items across the fleet: resolution SLA misses (P1/P2 tickets past target), RPO breaches, and RTO breaches."
msgstr "Sum of currently breaching items across the fleet: resolution SLA misses (P1/P2 tickets past target), RPO breaches, and RTO breaches."

#: app/frontend/components/marketplace_disbursement_events/StatTiles.jsx
msgid "Sum of DISBURSEMENT rows (action=DISBURSED) in the current filter — the actual net amount AWS has paid Skie. Not the same as invoiced revenue, which may not be disbursed yet."
msgstr "Sum of DISBURSEMENT rows (action=DISBURSED) in the current filter — the actual net amount AWS has paid Skie. Not the same as invoiced revenue, which may not be disbursed yet."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Sum of failed Security Hub checks at CRITICAL or HIGH severity."
msgstr "Sum of failed Security Hub checks at CRITICAL or HIGH severity."

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Summary"
msgstr "Summary"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Summary of AWS optimization savings and key metrics."
msgstr "Summary of AWS optimization savings and key metrics."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Summary of Azure optimization savings and KPIs."
msgstr "Summary of Azure optimization savings and KPIs."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Support phase"
msgstr "Support phase"

#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Support Type"
msgstr "Support Type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Supported"
msgstr "Supported"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Supported Virtualization Types"
msgstr "Supported Virtualization Types"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "SUSE subscription"
msgstr "SUSE subscription"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Sustained high available memory can indicate the VM is over-provisioned."
msgstr "Sustained high available memory can indicate the VM is over-provisioned."

#: app/frontend/layout/menu.jsx
msgid "Switch organization"
msgstr "Switch organization"

#: app/frontend/pages/dashboard/aws/baselines/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
msgid "Synced At"
msgstr "Synced At"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Syncing"
msgstr "Syncing"

#: app/frontend/layout/top_bar.jsx
msgid "System"
msgstr "System"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Table ID"
msgstr "Table ID"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Table Name"
msgstr "Table Name"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/index.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
msgid "Table Size"
msgstr "Table Size"

#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Table Status"
msgstr "Table Status"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "Tag"
msgstr "Tag"

#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "Tag key"
msgstr "Tag key"

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Tag Key"
msgstr "Tag Key"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Tag Manager"
msgstr "Tag Manager"

#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/SelectedResourcesTable.jsx
msgid "Tag Name"
msgstr "Tag Name"

#: app/frontend/pages/admin/tag_templates/edit.jsx
#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/new.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagTemplateMultiSelect.jsx
msgid "Tag Templates"
msgstr "Tag Templates"

#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Tag value"
msgstr "Tag value"

#: app/frontend/pages/admin/plan_features/BillingV2TagFiltersRepeater.jsx
msgid "Tag Values"
msgstr "Tag Values"

#. placeholder {0}: compliant.toLocaleString()
#. placeholder {1}: total.toLocaleString()
#: app/frontend/pages/dashboard/aws/finops_hub/star.jsx
msgid "Tagged: {0} / {1}"
msgstr "Tagged: {0} / {1}"

#: app/frontend/components/ResourceTagsTable.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
#: app/frontend/pages/dashboard/resource_groups/index.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Tags"
msgstr "Tags"

#: app/frontend/pages/dashboard/aws/tag_manager/ReviewChanges.jsx
msgid "Tags are written to AWS in the background after you save. \"+\" adds a tag, \"old → new\" replaces the current value, \"=\" means the resource already has it."
msgstr "Tags are written to AWS in the background after you save. \"+\" adds a tag, \"old → new\" replaces the current value, \"=\" means the resource already has it."

#: app/frontend/components/chat/Message.jsx
msgid "Taking longer than usual…"
msgstr "Taking longer than usual…"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Target"
msgstr "Target"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
msgid "Target buffer"
msgstr "Target buffer"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Target Buffer"
msgstr "Target Buffer"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Target buffer percentage"
msgstr "Target buffer percentage"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Target CPU Buffer"
msgstr "Target CPU Buffer"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Target CPU Quantile"
msgstr "Target CPU Quantile"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Target CPU Utilization"
msgstr "Target CPU Utilization"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Target Memory Buffer"
msgstr "Target Memory Buffer"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "Target Memory Quantile"
msgstr "Target Memory Quantile"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Target Memory Utilization"
msgstr "Target Memory Utilization"

#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Target percentile"
msgstr "Target percentile"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "Target Percentile"
msgstr "Target Percentile"

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Target quantile"
msgstr "Target quantile"

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Target Quantile"
msgstr "Target Quantile"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Task definition"
msgstr "Task definition"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Tell us in the optimizer settings whether you own eligible licences; until then this saving is not counted."
msgstr "Tell us in the optimizer settings whether you own eligible licences; until then this saving is not counted."

#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Tenancy"
msgstr "Tenancy"

#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/credentials/index.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Tenant ID"
msgstr "Tenant ID"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/dashboard/reservation.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/database_reservations/show.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/index.jsx
#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_reservations/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "Term"
msgstr "Term"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Terms"
msgstr "Terms"

#: app/frontend/pages/admin/plan_features/AccountLevelInfoRepeater.jsx
msgid "Test Account"
msgstr "Test Account"

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "Test ETL assume role"
msgstr "Test ETL assume role"

#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Test Failover State"
msgstr "Test Failover State"

#: app/frontend/components/guardian/help/common.js
msgid "The 12-month trend charts roll each metric up by calendar month over the past year."
msgstr "The 12-month trend charts roll each metric up by calendar month over the past year."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "The aggregate for the period; each dedicated page carries the matrix"
msgstr "The aggregate for the period; each dedicated page carries the matrix"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "The amount AWS credited to the buyer."
msgstr "The amount AWS credited to the buyer."

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "The assume role operation used the following parameters:"
msgstr "The assume role operation used the following parameters:"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "The bar covers the tickets that carry a request type: the top five plus \"Other\". Uncategorized means the ticket has no request type set in Jira — it is listed under the bar, outside it."
msgstr "The bar covers the tickets that carry a request type: the top five plus \"Other\". Uncategorized means the ticket has no request type set in Jira — it is listed under the bar, outside it."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "The cell value is how many robust standard deviations above the median this client sits:"
msgstr "The cell value is how many robust standard deviations above the median this client sits:"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart compares the percentage of unutilized commitments (waste) against the equivalent on-demand cost for EC2 instances over the past months."
msgstr "The chart compares the percentage of unutilized commitments (waste) against the equivalent on-demand cost for EC2 instances over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart depicts the expenditure associated with different storage types in Amazon S3 over the past months."
msgstr "The chart depicts the expenditure associated with different storage types in Amazon S3 over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays cost distribution across different usage types within the AWS ecosystem over a recent 30-day period."
msgstr "The chart displays cost distribution across different usage types within the AWS ecosystem over a recent 30-day period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays costs associated with various record types over the past year within AWS ecosystem."
msgstr "The chart displays costs associated with various record types over the past year within AWS ecosystem."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays monthly SBU (Skie Benachmark Unit) utilization percentages for EC2 instances over time."
msgstr "The chart displays monthly SBU (Skie Benachmark Unit) utilization percentages for EC2 instances over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays the average write operations per second, commonly referred to as write IOPS. It provides insight into the write activity on the storage device, indicating how frequently data is being written to or stored. For a deeper understanding of storage performance, including aspects like latency, additional monitoring or metric-based analysis may be necessary."
msgstr "The chart displays the average write operations per second, commonly referred to as write IOPS. It provides insight into the write activity on the storage device, indicating how frequently data is being written to or stored. For a deeper understanding of storage performance, including aspects like latency, additional monitoring or metric-based analysis may be necessary."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays the expenses associated with RDS by Usage Type over the past 18 months."
msgstr "The chart displays the expenses associated with RDS by Usage Type over the past 18 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart displays the monthly value of RDS reservations set to expire over the next 6 months, broken down by product."
msgstr "The chart displays the monthly value of RDS reservations set to expire over the next 6 months, broken down by product."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates a comparative analysis of CPU utilization percentages between the current and new instance versions."
msgstr "The chart illustrates a comparative analysis of CPU utilization percentages between the current and new instance versions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates a comparative analysis of network utilization between the current and new instance versions."
msgstr "The chart illustrates a comparative analysis of network utilization between the current and new instance versions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates costs associated with different types of EC2 Instances over the past 30 days, categorized by purchase type."
msgstr "The chart illustrates costs associated with different types of EC2 Instances over the past 30 days, categorized by purchase type."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates costs associated with different types of On-Demand EC2 Instances over a recent 30-day period."
msgstr "The chart illustrates costs associated with different types of On-Demand EC2 Instances over a recent 30-day period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the distribution of costs among various AWS resource type groups."
msgstr "The chart illustrates the distribution of costs among various AWS resource type groups."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the expenditure associated with other costs in Amazon S3 over the past months."
msgstr "The chart illustrates the expenditure associated with other costs in Amazon S3 over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the expenses associated with EC2 reservations over the past months."
msgstr "The chart illustrates the expenses associated with EC2 reservations over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the expenses associated with EC2 Savings Plans ending over the past months."
msgstr "The chart illustrates the expenses associated with EC2 Savings Plans ending over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the unit cost, in USD per GiB of RAM-hour, for each DB engine over the trailing 18 months."
msgstr "The chart illustrates the unit cost, in USD per GiB of RAM-hour, for each DB engine over the trailing 18 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart illustrates the unutilized costs associated with commitments over the past months."
msgstr "The chart illustrates the unutilized costs associated with commitments over the past months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart offers a concise breakdown of instance quantity based on tenancy within the AWS ecosystem."
msgstr "The chart offers a concise breakdown of instance quantity based on tenancy within the AWS ecosystem."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart offers a concise overview of expenditure across various AWS services over a recent 30-day period."
msgstr "The chart offers a concise overview of expenditure across various AWS services over a recent 30-day period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a breakdown of costs based on the operating system utilized over the preceding six months. It serves as a crucial tool for understanding expenditure patterns across different operating systems within the AWS EC2 service."
msgstr "The chart provides a breakdown of costs based on the operating system utilized over the preceding six months. It serves as a crucial tool for understanding expenditure patterns across different operating systems within the AWS EC2 service."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a clear breakdown of cost distribution by instance type over the previous month."
msgstr "The chart provides a clear breakdown of cost distribution by instance type over the previous month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a clear breakdown of cost distribution by operating system over the previous month."
msgstr "The chart provides a clear breakdown of cost distribution by operating system over the previous month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a clear breakdown of CPU capacity utilization over time."
msgstr "The chart provides a clear breakdown of CPU capacity utilization over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a clear breakdown of instance quantity based on type within the AWS ecosystem."
msgstr "The chart provides a clear breakdown of instance quantity based on type within the AWS ecosystem."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a clear depiction of the percentage of savings achieved over time."
msgstr "The chart provides a clear depiction of the percentage of savings achieved over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a comprehensive breakdown of expenditure across various AWS services, offering valuable insights for service management strategies."
msgstr "The chart provides a comprehensive breakdown of expenditure across various AWS services, offering valuable insights for service management strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a comprehensive breakdown of expenditure across various purchase types within AWS services over the past 18 months."
msgstr "The chart provides a comprehensive breakdown of expenditure across various purchase types within AWS services over the past 18 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a comprehensive breakdown of instance quantity categorized by usage operation within the AWS ecosystem."
msgstr "The chart provides a comprehensive breakdown of instance quantity categorized by usage operation within the AWS ecosystem."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a detailed breakdown of expenditure across various accounts, within the organization over the preceding 18 months."
msgstr "The chart provides a detailed breakdown of expenditure across various accounts, within the organization over the preceding 18 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a detailed breakdown of expenditure across various AWS services over the specified period."
msgstr "The chart provides a detailed breakdown of expenditure across various AWS services over the specified period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a detailed breakdown of instance quantity categorized by instance state within the AWS ecosystem."
msgstr "The chart provides a detailed breakdown of instance quantity categorized by instance state within the AWS ecosystem."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a month-by-month breakdown of on-demand RDS spend, over the trailing 12 months, across the top instance types in that month, with the remainder grouped into an \"other\" category — split into one chart per DB engine."
msgstr "The chart provides a month-by-month breakdown of on-demand RDS spend, over the trailing 12 months, across the top instance types in that month, with the remainder grouped into an \"other\" category — split into one chart per DB engine."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a month-by-month breakdown of RDS spend, over the trailing 6 months, across the different DB engines in use."
msgstr "The chart provides a month-by-month breakdown of RDS spend, over the trailing 6 months, across the different DB engines in use."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart provides a month-by-month breakdown of RDS spend, over the trailing 6 months, by purchase type, such as On-Demand, Reserved Instances, and Savings Plans — split into one chart per DB engine."
msgstr "The chart provides a month-by-month breakdown of RDS spend, over the trailing 6 months, by purchase type, such as On-Demand, Reserved Instances, and Savings Plans — split into one chart per DB engine."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart shows the hourly CPU utilization of a Workload."
msgstr "The chart shows the hourly CPU utilization of a Workload."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart shows the maximum hourly Memory utilization of a Workload."
msgstr "The chart shows the maximum hourly Memory utilization of a Workload."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart shows the memory utilization of an EC2 instance over a specified period of time."
msgstr "The chart shows the memory utilization of an EC2 instance over a specified period of time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart uses amortized costs for EC2 commitments to calculate the equivalent on-demand pricing for those commitments on a monthly basis over the past six months."
msgstr "The chart uses amortized costs for EC2 commitments to calculate the equivalent on-demand pricing for those commitments on a monthly basis over the past six months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart uses the read operations per second, also known as read IOPS. The chart provides insight into the read activity on the storage device, showing how frequently data is being accessed or retrieved. To gain further insights into storage performance, such as latency, additional monitoring or metric-based analysis may be required."
msgstr "The chart uses the read operations per second, also known as read IOPS. The chart provides insight into the read activity on the storage device, showing how frequently data is being accessed or retrieved. To gain further insights into storage performance, such as latency, additional monitoring or metric-based analysis may be required."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The chart visually represents expenditure distribution across various regions over the preceding 18 months."
msgstr "The chart visually represents expenditure distribution across various regions over the preceding 18 months."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "The CloudFormation stack will be created, and after a few minutes you will see the status <0>CREATE_COMPLETE</0>."
msgstr "The CloudFormation stack will be created, and after a few minutes you will see the status <0>CREATE_COMPLETE</0>."

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "The cohort is the organizations flagged for Peer Intelligence. A client is never compared against itself."
msgstr "The cohort is the organizations flagged for Peer Intelligence. A client is never compared against itself."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "The command below can be used to apply the recommended CPU resource requests and limits to the specified container in your Kubernetes cluster."
msgstr "The command below can be used to apply the recommended CPU resource requests and limits to the specified container in your Kubernetes cluster."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "The command below can be used to apply the recommended memory resource requests and limits to the specified container in your Kubernetes cluster."
msgstr "The command below can be used to apply the recommended memory resource requests and limits to the specified container in your Kubernetes cluster."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "The control could not be evaluated."
msgstr "The control could not be evaluated."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "The control is turned off for the standard."
msgstr "The control is turned off for the standard."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "The control's checks all succeeded."
msgstr "The control's checks all succeeded."

#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "The display name shown to customers and admins."
msgstr "The display name shown to customers and admins."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "The duration of the commitment for reserved instances."
msgstr "The duration of the commitment for reserved instances."

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "The ETL can assume the configured IAM role in this AWS account."
msgstr "The ETL can assume the configured IAM role in this AWS account."

#: app/frontend/pages/dashboard/aws/accounts/show.jsx
msgid "The ETL cannot assume the configured IAM role in this AWS account."
msgstr "The ETL cannot assume the configured IAM role in this AWS account."

#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "The execution will be fired immediately after the creation."
msgstr "The execution will be fired immediately after the creation."

#: app/frontend/components/guardian/help/common.js
msgid "The Executive Summary page rolls all of this up into one view."
msgstr "The Executive Summary page rolls all of this up into one view."

#: app/frontend/components/guardian/help/security_compliance.js
msgid "The Falcon agent is installed but not currently reporting."
msgstr "The Falcon agent is installed but not currently reporting."

#: app/frontend/components/guardian/help/common.js
msgid "The figures shown are averages, with a small grace buffer before something counts as a breach — see \"View SLA\" for the exact grace period for your tier."
msgstr "The figures shown are averages, with a small grace buffer before something counts as a breach — see \"View SLA\" for the exact grace period for your tier."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "The first export delivery may take up to 24 hours to appear in the S3 bucket."
msgstr "The first export delivery may take up to 24 hours to appear in the S3 bucket."

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "The following Enterprise Agreement subscription(s) have \"AO View Charges\" disabled, so Azure refuses to return their cost data and the spend charts appear empty:"
msgstr "The following Enterprise Agreement subscription(s) have \"AO View Charges\" disabled, so Azure refuses to return their cost data and the spend charts appear empty:"

#: app/frontend/pages/dashboard/azure/subscriptions/CostAccessDisabledAlert.jsx
msgid "The following Enterprise Agreement subscription(s) have <0>\"AO View Charges\"</0> disabled, so Azure refuses to return their cost data and the spend charts appear empty:"
msgstr "The following Enterprise Agreement subscription(s) have <0>\"AO View Charges\"</0> disabled, so Azure refuses to return their cost data and the spend charts appear empty:"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "The headroom kept above observed usage before a rightsizing recommendation is made. Every OpenSearch domain below must have its own buffer and percentile set — there is no implicit fallback for this resource, so this value is only a starting point when adding a domain."
msgstr "The headroom kept above observed usage before a rightsizing recommendation is made. Every OpenSearch domain below must have its own buffer and percentile set — there is no implicit fallback for this resource, so this value is only a starting point when adding a domain."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "The headroom kept above observed usage before a rightsizing recommendation is made. Lower values recommend more aggressive downsizing."
msgstr "The headroom kept above observed usage before a rightsizing recommendation is made. Lower values recommend more aggressive downsizing."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "The headroom kept above observed usage before a rightsizing recommendation is made. Lower values recommend more aggressive downsizing. Every ElastiCache cluster below must have its own buffer and percentile set — there is no implicit fallback for this resource, so this value is only a starting point when adding a cluster."
msgstr "The headroom kept above observed usage before a rightsizing recommendation is made. Lower values recommend more aggressive downsizing. Every ElastiCache cluster below must have its own buffer and percentile set — there is no implicit fallback for this resource, so this value is only a starting point when adding a cluster."

#: app/frontend/pages/dashboard/optimizer/azure/database_settings/index.jsx
msgid "The list below displays Databases which have custom optimization settings."
msgstr "The list below displays Databases which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "The list below displays EC2 instances which have custom optimization settings."
msgstr "The list below displays EC2 instances which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
msgid "The list below displays EKS clusters which have custom optimization settings."
msgstr "The list below displays EKS clusters which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/index.jsx
msgid "The list below displays ElastiCache clusters which have custom optimization settings."
msgstr "The list below displays ElastiCache clusters which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/index.jsx
msgid "The list below displays Opensearch clusters which have custom optimization settings."
msgstr "The list below displays Opensearch clusters which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/index.jsx
msgid "The list below displays RDS instances which have custom optimization settings."
msgstr "The list below displays RDS instances which have custom optimization settings."

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "The list below displays Virtual Machines which have custom optimization settings."
msgstr "The list below displays Virtual Machines which have custom optimization settings."

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "The maximum acceptable quantile for the target buffer. The default value is 0.99."
msgstr "The maximum acceptable quantile for the target buffer. The default value is 0.99."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "The number of data nodes in the Opensearch cluster."
msgstr "The number of data nodes in the Opensearch cluster."

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "The number of master nodes in the Opensearch cluster."
msgstr "The number of master nodes in the Opensearch cluster."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The number of read and write operation requests waiting to be completed in a specified period of time."
msgstr "The number of read and write operation requests waiting to be completed in a specified period of time."

#: app/frontend/components/guardian/help/patch_management.js
msgid "The patching automation completed successfully. Pre and post-hook scripts are reported separately and do not affect this status."
msgstr "The patching automation completed successfully. Pre and post-hook scripts are reported separately and do not affect this status."

#: app/frontend/components/guardian/help/patch_management.js
msgid "The patching automation failed or was cancelled, so the instance was not patched."
msgstr "The patching automation failed or was cancelled, so the instance was not patched."

#: app/frontend/components/guardian/help/patch_management.js
msgid "The patching automation is currently in progress for this instance."
msgstr "The patching automation is currently in progress for this instance."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "The per-type rows read protected over eligible, and they add up to the headline."
msgstr "The per-type rows read protected over eligible, and they add up to the headline."

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "The percentage of the buffer pool the optimizer will try to keep free. The default value is 20%."
msgstr "The percentage of the buffer pool the optimizer will try to keep free. The default value is 20%."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "The recommended size has no local temporary disk. Azure does not resize directly from a size with one to a size without one."
msgstr "The recommended size has no local temporary disk. Azure does not resize directly from a size with one to a size without one."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The recommended SKU line projects the same billed vCores onto the capacity of the new SKU."
msgstr "The recommended SKU line projects the same billed vCores onto the capacity of the new SKU."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "The refund amount requested by the buyer."
msgstr "The refund amount requested by the buyer."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "The reseller fee is Skie's margin. It is shown to an owner and to Skie, never to a member."
msgstr "The reseller fee is Skie's margin. It is shown to an owner and to Skie, never to a member."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "The resource is currently covered by an active backup or replication."
msgstr "The resource is currently covered by an active backup or replication."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "The resource should be backed up but currently is not."
msgstr "The resource should be backed up but currently is not."

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
msgid "The resource was deliberately left out of the backup targets."
msgstr "The resource was deliberately left out of the backup targets."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "The RTO target scales with data size — it is set per terabyte restored, not a flat time. See the Backup & Disaster Recovery page for the exact targets."
msgstr "The RTO target scales with data size — it is set per terabyte restored, not a flat time. See the Backup & Disaster Recovery page for the exact targets."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The savings are calculated by simulating how much would cost if all the EC2 Instances were using on-demand options, instead of reservations and other cheaper options."
msgstr "The savings are calculated by simulating how much would cost if all the EC2 Instances were using on-demand options, instead of reservations and other cheaper options."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "The savings is calculated by simulating how much would cost if all the RDS Instances were using on-demand options, instead of reservations and other cheaper options."
msgstr "The savings is calculated by simulating how much would cost if all the RDS Instances were using on-demand options, instead of reservations and other cheaper options."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "The script progress is shown in the console:"
msgstr "The script progress is shown in the console:"

#: app/frontend/components/guardian/help/patch_management.js
msgid "The server counts as patched when the patch automation phase finishes successfully. Pre and post-hook results are reported separately: a hook can fail on a server that was still patched."
msgstr "The server counts as patched when the patch automation phase finishes successfully. Pre and post-hook results are reported separately: a hook can fail on a server that was still patched."

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "The service family with the largest month-over-month spend increase, for the latest of the trailing 2 months."
msgstr "The service family with the largest month-over-month spend increase, for the latest of the trailing 2 months."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "The service filters for the Daily Costs Charts are applicable only to the following services:"
msgstr "The service filters for the Daily Costs Charts are applicable only to the following services:"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "The service filters for the Daily Costs charts are applicable only to the following services: Amazon Elastic Compute Cloud (EC2) – Compute EC2 - Other · Amazon Relational Database Service (RDS) · Amazon Simple Storage Service (S3) · AWS Cost Explorer · Amazon Elastic Container Service"
msgstr "The service filters for the Daily Costs charts are applicable only to the following services: Amazon Elastic Compute Cloud (EC2) – Compute EC2 - Other · Amazon Relational Database Service (RDS) · Amazon Simple Storage Service (S3) · AWS Cost Explorer · Amazon Elastic Container Service"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "The service with the largest month-over-month spend increase, previous month."
msgstr "The service with the largest month-over-month spend increase, previous month."

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "The services Skie operates under this tier, and where they reach."
msgstr "The services Skie operates under this tier, and where they reach."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "The services Zee collects and keeps up to date."
msgstr "The services Zee collects and keeps up to date."

#: app/frontend/components/chat/SourceMenu.jsx
msgid "The source does not change in this conversation."
msgstr "The source does not change in this conversation."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "The switch lives on the SQL virtual machines resource and needs the SQL IaaS Agent extension. Where Hybrid Benefit is centrally managed for the subscription, a billing admin assigns the licences instead."
msgstr "The switch lives on the SQL virtual machines resource and needs the SQL IaaS Agent extension. Where Hybrid Benefit is centrally managed for the subscription, a billing admin assigns the licences instead."

#: app/frontend/pages/dashboard/resource_group_settings/ResourceGroupSettingsForm.jsx
msgid "The tag keys defined here will be used to auto-create groups of resources which have the same tag key."
msgstr "The tag keys defined here will be used to auto-create groups of resources which have the same tag key."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "The target buffer is the percentage of the buffer pool that the optimizer will try to keep free."
msgstr "The target buffer is the percentage of the buffer pool that the optimizer will try to keep free."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "The target buffer is the percentage of the buffer pool that the optimizer will try to keep free. The default value is 20%."
msgstr "The target buffer is the percentage of the buffer pool that the optimizer will try to keep free. The default value is 20%."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "The target quantile is the maximum acceptable quantile for the target buffer."
msgstr "The target quantile is the maximum acceptable quantile for the target buffer."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 0.95."
msgstr "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 0.95."

#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 0.99."
msgstr "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 0.99."

#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
msgid "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 1."
msgstr "The target quantile is the maximum acceptable quantile for the target buffer. The default value is 1."

#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
msgid "The term is the duration of the commitment for reserved instances."
msgstr "The term is the duration of the commitment for reserved instances."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "The tiles at the top count contracted work completed this period: tickets completed, backups evaluated against RPO, instances patched, and patch operations run. You only see the tiles your tier is contracted for."
msgstr "The tiles at the top count contracted work completed this period: tickets completed, backups evaluated against RPO, instances patched, and patch operations run. You only see the tiles your tier is contracted for."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "The use of this auto registration mechanism is <0>highly recommended</0>, however if for any reason you don't have these data, you can proceed by carefully taking note of the application credentials, as instructed further down in this document."
msgstr "The use of this auto registration mechanism is <0>highly recommended</0>, however if for any reason you don't have these data, you can proceed by carefully taking note of the application credentials, as instructed further down in this document."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "The utilization percentile used to drive rightsizing — the cluster must comfortably serve load at this percentile, including the buffer above."
msgstr "The utilization percentile used to drive rightsizing — the cluster must comfortably serve load at this percentile, including the buffer above."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "The utilization percentile used to drive rightsizing — the domain must comfortably serve load at this percentile, including the buffer above."
msgstr "The utilization percentile used to drive rightsizing — the domain must comfortably serve load at this percentile, including the buffer above."

#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "The utilization percentile used to drive rightsizing — the instance must comfortably serve load at this percentile, including the buffer above."
msgstr "The utilization percentile used to drive rightsizing — the instance must comfortably serve load at this percentile, including the buffer above."

#: app/frontend/pages/dashboard/aws/tag_manager/ResourcePickerTable.jsx
msgid "The value of the resource's Name tag in AWS. Empty when the resource has none."
msgstr "The value of the resource's Name tag in AWS. Empty when the resource has none."

#: app/frontend/utils/aws.js
msgid "The whole commitment paid upfront for the largest discount."
msgstr "The whole commitment paid upfront for the largest discount."

#: app/frontend/pages/dashboard/aws/elb/optimizations/new.jsx
msgid "There are no per-resource overrides today. This run will evaluate every load balancer and NAT gateway in scope for your organization."
msgstr "There are no per-resource overrides today. This run will evaluate every load balancer and NAT gateway in scope for your organization."

#: app/frontend/pages/dashboard/azure/disks/optimizations/new.jsx
msgid "There are no tunable settings for Disks today. This run will evaluate every eligible disk in scope for your organization."
msgstr "There are no tunable settings for Disks today. This run will evaluate every eligible disk in scope for your organization."

#: app/frontend/pages/dashboard/aws/ebs/optimizations/new.jsx
msgid "There are no tunable settings for EBS today. This run will evaluate every eligible volume in scope for your organization."
msgstr "There are no tunable settings for EBS today. This run will evaluate every eligible volume in scope for your organization."

#: app/frontend/pages/dashboard/azure/network/optimizations/new.jsx
msgid "There are no tunable settings for Network today. This run will evaluate every eligible load balancer and public IP in scope for your organization."
msgstr "There are no tunable settings for Network today. This run will evaluate every eligible load balancer and public IP in scope for your organization."

#: app/frontend/pages/dashboard/aws/s3/optimizations/new.jsx
msgid "There are no tunable settings for S3 today. This run will evaluate every eligible bucket in scope for your organization."
msgstr "There are no tunable settings for S3 today. This run will evaluate every eligible bucket in scope for your organization."

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "There are pending CPU Requests for this workload. Approve them for more accurate suggestions"
msgstr "There are pending CPU Requests for this workload. Approve them for more accurate suggestions"

#: app/frontend/pages/users/aws_marketplace/associate.jsx
msgid "There is no token or the token is invalid. Please visit the AWS Marketplace product page and click on \"Setup your account\" to be redirected to this page with a valid token."
msgstr "There is no token or the token is invalid. Please visit the AWS Marketplace product page and click on \"Setup your account\" to be redirected to this page with a valid token."

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "These apply to every optimizer, for every service."
msgstr "These apply to every optimizer, for every service."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "These are Monitoring tickets opened by automation — the opposite scope from the customer-reported figures above. Ticket count stands in for alarm volume, ranking the servers with the most."
msgstr "These are Monitoring tickets opened by automation — the opposite scope from the customer-reported figures above. Ticket count stands in for alarm volume, ranking the servers with the most."

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "These charts apply to subscriptions with an Enterprise Agreement or a Microsoft Customer Agreement."
msgstr "These charts apply to subscriptions with an Enterprise Agreement or a Microsoft Customer Agreement."

#: app/frontend/components/guardian/help/executive_summary.js
msgid "These figures are as reported by the monitoring and ticketing data, not as invoiced. Any service credit is settled with your Skie service manager against the contract, not from this page."
msgstr "These figures are as reported by the monitoring and ticketing data, not as invoiced. Any service credit is settled with your Skie service manager against the contract, not from this page."

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "These organizations form the typical values and see the unusual spend alert on their AWS dashboard."
msgstr "These organizations form the typical values and see the unusual spend alert on their AWS dashboard."

#: app/frontend/pages/admin/peer_intelligence/SettingsDrawer.jsx
msgid "These organizations see the unusual spend alert on their AWS dashboard, compared against the cohort. They do not change the typical values."
msgstr "These organizations see the unusual spend alert on their AWS dashboard, compared against the cohort. They do not change the typical values."

#: app/frontend/pages/dashboard/subscriptions/sections/ThirdPartyIntegrationsSection.jsx
msgid "Third-party integrations"
msgstr "Third-party integrations"

#: app/frontend/pages/users/aws_marketplace/associate.jsx
msgid "This account is already associated with this marketplace product."
msgstr "This account is already associated with this marketplace product."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "This action cannot be undone."
msgstr "This action cannot be undone."

#: app/frontend/pages/dashboard/aws/accounts/DeleteAccountModal.jsx
msgid "This action will delete all data associated with this AWS account, including cost details and recommendations, and will take effect immediately. You can onboard this account again in the future if needed, but some historical data may not be recovered."
msgstr "This action will delete all data associated with this AWS account, including cost details and recommendations, and will take effect immediately. You can onboard this account again in the future if needed, but some historical data may not be recovered."

#: app/frontend/pages/dashboard/azure/subscriptions/DeleteSubscriptionModal.jsx
msgid "This action will delete all data associated with this Azure subscription, including cost details and recommendations, and will take effect immediately. You can onboard this subscription again in the future if needed, but some historical data may not be recovered."
msgstr "This action will delete all data associated with this Azure subscription, including cost details and recommendations, and will take effect immediately. You can onboard this subscription again in the future if needed, but some historical data may not be recovered."

#: app/frontend/pages/dashboard/organizations/DeleteOrganizationModal.jsx
msgid "This action will delete all data associated with this organization, including AWS accounts, Azure subscriptions, cost details and recommendations, and will take effect immediately. You can create this organization again in the future if needed, but some historical data may not be recovered."
msgstr "This action will delete all data associated with this organization, including AWS accounts, Azure subscriptions, cost details and recommendations, and will take effect immediately. You can create this organization again in the future if needed, but some historical data may not be recovered."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "This action will permanently cancel the subscription for"
msgstr "This action will permanently cancel the subscription for"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This bar chart visualizes costs associated with different purchase options, such as On-Demand Instances, Reserved Instances, Spot Instances, and others. Each bar represents a month, while the Y-axis denotes costs in USD. The segmentation within each bar reflects the proportion of expenditure attributed to a specific purchase type. By hovering over each segment, users can access detailed information, including the precise expenditure related to the corresponding purchase type."
msgstr "This bar chart visualizes costs associated with different purchase options, such as On-Demand Instances, Reserved Instances, Spot Instances, and others. Each bar represents a month, while the Y-axis denotes costs in USD. The segmentation within each bar reflects the proportion of expenditure attributed to a specific purchase type. By hovering over each segment, users can access detailed information, including the precise expenditure related to the corresponding purchase type."

#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
msgid "This billing group has no account associations."
msgstr "This billing group has no account associations."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This boxplot chart illustrates the Full Time Equivalent (FTE) variability across different DB Engines. The Y-axis represents the total FTE, while the X-axis displays the various DB Engines. Each boxplot encapsulates the minimum, average, and maximum FTE values for a specific DB Engine. Hovering over a box allows users to view the specific FTE values associated with that particular DB Engine."
msgstr "This boxplot chart illustrates the Full Time Equivalent (FTE) variability across different DB Engines. The Y-axis represents the total FTE, while the X-axis displays the various DB Engines. Each boxplot encapsulates the minimum, average, and maximum FTE values for a specific DB Engine. Hovering over a box allows users to view the specific FTE values associated with that particular DB Engine."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This boxplot chart illustrates the memory usage across different DB Engines utilized in AWS services. Each boxplot visually represents the minimum, average, and maximum memory usage in gigabytes (GB) for a specific DB Engine. The Y-axis denotes the total memory in GB, while the X-axis displays the various DB Engines. Hovering over a boxplot enables users to access specific values associated with that particular DB Engine, facilitating informed decision-making regarding memory allocation and performance optimization."
msgstr "This boxplot chart illustrates the memory usage across different DB Engines utilized in AWS services. Each boxplot visually represents the minimum, average, and maximum memory usage in gigabytes (GB) for a specific DB Engine. The Y-axis denotes the total memory in GB, while the X-axis displays the various DB Engines. Hovering over a boxplot enables users to access specific values associated with that particular DB Engine, facilitating informed decision-making regarding memory allocation and performance optimization."

#: app/frontend/components/optimization_dashboard/CancelActionButton.jsx
msgid "This cancels the scheduled action and can't be undone."
msgstr "This cancels the scheduled action and can't be undone."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This card summarizes how many Azure virtual machines are placed in an availability set, out of your total VM inventory."
msgstr "This card summarizes how many Azure virtual machines are placed in an availability set, out of your total VM inventory."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart assists in comprehending costs linked to various EC2 Instances by purchase types, providing insights for stakeholders to effectively manage AWS services. It assists in identifying trends and defining strategies for resource reallocation and cost optimization."
msgstr "This chart assists in comprehending costs linked to various EC2 Instances by purchase types, providing insights for stakeholders to effectively manage AWS services. It assists in identifying trends and defining strategies for resource reallocation and cost optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart assists in understanding costs associated with different record types, informing AWS service management strategies."
msgstr "This chart assists in understanding costs associated with different record types, informing AWS service management strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart assists in understanding costs linked to various instance types, informing AWS service management strategies."
msgstr "This chart assists in understanding costs linked to various instance types, informing AWS service management strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart breaks down virtual machine spend by pricing model — On-Demand, Reservation, and Savings Plan — for each of the trailing 30 days."
msgstr "This chart breaks down virtual machine spend by pricing model — On-Demand, Reservation, and Savings Plan — for each of the trailing 30 days."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart breaks down your Azure virtual machines by license type, as reported by Azure: Azure Hybrid Benefit, License Included, BYOS, or Pay-as-you-go."
msgstr "This chart breaks down your Azure virtual machines by license type, as reported by Azure: Azure Hybrid Benefit, License Included, BYOS, or Pay-as-you-go."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart compares Azure Virtual Machines compute spend against license spend (such as Azure Hybrid Benefit or SQL Server licensing) over the trailing 6 months."
msgstr "This chart compares Azure Virtual Machines compute spend against license spend (such as Azure Hybrid Benefit or SQL Server licensing) over the trailing 6 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart compares Current vs. Recommended CPU Requests for node groups."
msgstr "This chart compares Current vs. Recommended CPU Requests for node groups."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart compares Current vs. Recommended Memory Requests for node groups."
msgstr "This chart compares Current vs. Recommended Memory Requests for node groups."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart compares daily OpenSearch costs before and after optimization."
msgstr "This chart compares daily OpenSearch costs before and after optimization."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays a daily breakdown of Azure costs, grouped by service family, for the most recent 30 days."
msgstr "This chart displays a daily breakdown of Azure costs, grouped by service family, for the most recent 30 days."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays a historical view of AWS expenditures over the past 18 months, categorized by meter category. It enables users to track long-term spending trends across various resource types such as compute, storage, and data transfer."
msgstr "This chart displays a historical view of AWS expenditures over the past 18 months, categorized by meter category. It enables users to track long-term spending trends across various resource types such as compute, storage, and data transfer."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays available memory for an Azure VM over time."
msgstr "This chart displays available memory for an Azure VM over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays available memory for an Azure VM Scale Set over time."
msgstr "This chart displays available memory for an Azure VM Scale Set over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays Azure Virtual Machines spend broken down by charge type (such as Usage or UnusedReservation) over the trailing 12 months."
msgstr "This chart displays Azure Virtual Machines spend broken down by charge type (such as Usage or UnusedReservation) over the trailing 12 months."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays CPU usage for an Azure VM over time."
msgstr "This chart displays CPU usage for an Azure VM over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays CPU usage for an Azure VM Scale Set over time."
msgstr "This chart displays CPU usage for an Azure VM Scale Set over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays CPU utilization for an Azure Database over time."
msgstr "This chart displays CPU utilization for an Azure Database over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays CPU utilization for an ElastiCache node over time."
msgstr "This chart displays CPU utilization for an ElastiCache node over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays CPU utilization for OpenSearch data nodes."
msgstr "This chart displays CPU utilization for OpenSearch data nodes."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the average vCores billed per hour for a serverless Azure Database, between its configured minimum and maximum vCores."
msgstr "This chart displays the average vCores billed per hour for a serverless Azure Database, between its configured minimum and maximum vCores."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the combined read and write IOPS (I/O operations per second) for the EBS volume over the selected time period."
msgstr "This chart displays the combined read and write IOPS (I/O operations per second) for the EBS volume over the selected time period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the CPU utilization of an RDS instance over the selected time frame."
msgstr "This chart displays the CPU utilization of an RDS instance over the selected time frame."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the distribution of Azure costs across different pricing models for the selected time period. It helps users understand how various purchasing options impact overall expenditure."
msgstr "This chart displays the distribution of Azure costs across different pricing models for the selected time period. It helps users understand how various purchasing options impact overall expenditure."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the distribution of Azure Virtual Machines costs across meter locations (the region billing considers the meter to be in) for the previous month."
msgstr "This chart displays the distribution of Azure Virtual Machines costs across meter locations (the region billing considers the meter to be in) for the previous month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the hourly vCores billed for a serverless Azure Database during the 7 days before the optimization, as a percentage of its maximum vCores."
msgstr "This chart displays the hourly vCores billed for a serverless Azure Database during the 7 days before the optimization, as a percentage of its maximum vCores."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the monthly spend over the past 18 months, broken down by Cost Category. Each category is represented with a distinct color, allowing for easy comparison of spending trends and patterns across different categories over time. The x-axis shows the months in chronological order, while the y-axis represents the total spend amount. This visualization helps identify shifts in spending priorities and highlights cost drivers across the observed period."
msgstr "This chart displays the monthly spend over the past 18 months, broken down by Cost Category. Each category is represented with a distinct color, allowing for easy comparison of spending trends and patterns across different categories over time. The x-axis shows the months in chronological order, while the y-axis represents the total spend amount. This visualization helps identify shifts in spending priorities and highlights cost drivers across the observed period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of Azure virtual machines grouped by availability zone, showing how VMs are distributed for resilience against datacenter-level failures."
msgstr "This chart displays the number of Azure virtual machines grouped by availability zone, showing how VMs are distributed for resilience against datacenter-level failures."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of Azure virtual machines grouped by operating system, giving visibility into the OS mix across your Azure environment."
msgstr "This chart displays the number of Azure virtual machines grouped by operating system, giving visibility into the OS mix across your Azure environment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of Azure virtual machines grouped by their current power state, offering a snapshot of resource utilization and potential inefficiencies."
msgstr "This chart displays the number of Azure virtual machines grouped by their current power state, offering a snapshot of resource utilization and potential inefficiencies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of Azure virtual machines grouped by their image publisher, showing which vendors your VM images come from across your Azure environment."
msgstr "This chart displays the number of Azure virtual machines grouped by their image publisher, showing which vendors your VM images come from across your Azure environment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of managed disks in your Azure environment, grouped by disk type—such as Premium SSD, Standard SSD, and Standard HDD."
msgstr "This chart displays the number of managed disks in your Azure environment, grouped by disk type—such as Premium SSD, Standard SSD, and Standard HDD."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the number of read and write operations performed by the RDS instance."
msgstr "This chart displays the number of read and write operations performed by the RDS instance."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart displays the total number of read operations over a specified time period, with each read operation counted upon completion."
msgstr "This chart displays the total number of read operations over a specified time period, with each read operation counted upon completion."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart facilitates the comprehension of spending patterns across regions, enabling stakeholders to identify areas of high expenditure, optimize resource allocation, and formulate effective strategies for AWS cost management."
msgstr "This chart facilitates the comprehension of spending patterns across regions, enabling stakeholders to identify areas of high expenditure, optimize resource allocation, and formulate effective strategies for AWS cost management."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart helps stakeholders evaluate reservation coverage per DB engine and identify further opportunities to shift on-demand spend into cheaper commitment-based options over time."
msgstr "This chart helps stakeholders evaluate reservation coverage per DB engine and identify further opportunities to shift on-demand spend into cheaper commitment-based options over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart helps stakeholders identify which instance types are driving on-demand costs per DB engine, and how that mix is trending, informing right-sizing and reservation purchase decisions."
msgstr "This chart helps stakeholders identify which instance types are driving on-demand costs per DB engine, and how that mix is trending, informing right-sizing and reservation purchase decisions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart helps stakeholders plan ahead for reservation renewals, avoiding lapses into more expensive on-demand pricing."
msgstr "This chart helps stakeholders plan ahead for reservation renewals, avoiding lapses into more expensive on-demand pricing."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart helps stakeholders understand which database engines drive the most cost, and how that mix is trending, informing engine selection and consolidation decisions."
msgstr "This chart helps stakeholders understand which database engines drive the most cost, and how that mix is trending, informing engine selection and consolidation decisions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart illustrates the read block size for a storage device over a specified period of time. The vertical axis represents the size of each data block read per operation, measured in MiB, while the horizontal axis shows the time period. The chart provides insight into how much data is being transferred during each read operation, with larger spikes indicating instances when larger amounts of data were read in a single operation. Understanding these patterns can help assess the efficiency of data retrieval processes on the storage device."
msgstr "This chart illustrates the read block size for a storage device over a specified period of time. The vertical axis represents the size of each data block read per operation, measured in MiB, while the horizontal axis shows the time period. The chart provides insight into how much data is being transferred during each read operation, with larger spikes indicating instances when larger amounts of data were read in a single operation. Understanding these patterns can help assess the efficiency of data retrieval processes on the storage device."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart illustrates the write block size for a storage device over a specified period of time. The vertical axis represents the size of each data block written per operation, measured in MiB, while the horizontal axis shows the time period. The chart provides insight into how much data is being transferred during each write operation, with larger spikes indicating instances when larger amounts of data were written in a single operation. Understanding these patterns can help assess the efficiency of data storage processes on the device."
msgstr "This chart illustrates the write block size for a storage device over a specified period of time. The vertical axis represents the size of each data block written per operation, measured in MiB, while the horizontal axis shows the time period. The chart provides insight into how much data is being transferred during each write operation, with larger spikes indicating instances when larger amounts of data were written in a single operation. Understanding these patterns can help assess the efficiency of data storage processes on the device."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart lists the subscriptions with the most Windows VMs currently paying full license price instead of using Azure Hybrid Benefit — the biggest opportunities to reduce licensing cost."
msgstr "This chart lists the subscriptions with the most Windows VMs currently paying full license price instead of using Azure Hybrid Benefit — the biggest opportunities to reduce licensing cost."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart offers valuable insights into cost distribution among various S3 storage types over time. It enables users to analyze spending patterns and allocate resources efficiently. By identifying trends and fluctuations in costs for each storage type, organizations can develop effective AWS service management strategies, optimizing cost-effectiveness and resource allocation based on specific data access patterns, durability requirements, and performance needs."
msgstr "This chart offers valuable insights into cost distribution among various S3 storage types over time. It enables users to analyze spending patterns and allocate resources efficiently. By identifying trends and fluctuations in costs for each storage type, organizations can develop effective AWS service management strategies, optimizing cost-effectiveness and resource allocation based on specific data access patterns, durability requirements, and performance needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart offers valuable insights into cost distribution beyond storage fees within S3 over time. It enables users to analyze spending patterns and allocate resources efficiently. By identifying trends and fluctuations in other costs, organizations can develop effective AWS service management strategies, optimizing cost-effectiveness and resource allocation based on specific areas of expenditure within the S3 service."
msgstr "This chart offers valuable insights into cost distribution beyond storage fees within S3 over time. It enables users to analyze spending patterns and allocate resources efficiently. By identifying trends and fluctuations in other costs, organizations can develop effective AWS service management strategies, optimizing cost-effectiveness and resource allocation based on specific areas of expenditure within the S3 service."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart presents a detailed breakdown of Azure spending categorized by meter category, providing insights into how different types of resources contribute to overall costs."
msgstr "This chart presents a detailed breakdown of Azure spending categorized by meter category, providing insights into how different types of resources contribute to overall costs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart presents a historical breakdown of Azure spending over the past 18 months, segmented by meter subcategory. It offers a granular view of how costs are distributed across more specific Azure resource types within broader meter categories."
msgstr "This chart presents a historical breakdown of Azure spending over the past 18 months, segmented by meter subcategory. It offers a granular view of how costs are distributed across more specific Azure resource types within broader meter categories."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart provides a breakdown of virtual machine counts by VM size, giving visibility into the types of instances being used across your Azure environment."
msgstr "This chart provides a breakdown of virtual machine counts by VM size, giving visibility into the types of instances being used across your Azure environment."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart provides a daily breakdown of Azure spending, grouped by meter category, over the most recent 30-day period."
msgstr "This chart provides a daily breakdown of Azure spending, grouped by meter category, over the most recent 30-day period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart provides a historical overview of Azure spending across different geographic locations over the past 18 months. It helps users understand how resource consumption and associated costs vary by region."
msgstr "This chart provides a historical overview of Azure spending across different geographic locations over the past 18 months. It helps users understand how resource consumption and associated costs vary by region."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart provides a historical view of Azure spending categorized by pricing model over the past 18 months. It helps users understand how different purchasing options—such as Pay-As-You-Go, Reserved Instances, and Spot pricing—contribute to overall costs."
msgstr "This chart provides a historical view of Azure spending categorized by pricing model over the past 18 months. It helps users understand how different purchasing options—such as Pay-As-You-Go, Reserved Instances, and Spot pricing—contribute to overall costs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart provides a monthly view of storage costs in Azure, broken down by disk type. It helps users understand how different disk tiers contribute to overall storage spend over time."
msgstr "This chart provides a monthly view of storage costs in Azure, broken down by disk type. It helps users understand how different disk tiers contribute to overall storage spend over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart ranks the top Azure Virtual Machine sizes by spend for the previous month."
msgstr "This chart ranks the top Azure Virtual Machine sizes by spend for the previous month."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart represents the total number of write operations over a specified period of time. write operations are counted upon completion."
msgstr "This chart represents the total number of write operations over a specified period of time. write operations are counted upon completion."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart serves as a valuable tool for crafting effective AWS service management strategies, empowering users to identify cost-intensive areas and optimize resources accordingly to enhance cost-effectiveness and maintain budget control."
msgstr "This chart serves as a valuable tool for crafting effective AWS service management strategies, empowering users to identify cost-intensive areas and optimize resources accordingly to enhance cost-effectiveness and maintain budget control."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart serves as a vital tool in understanding cost distribution across different RDS usage types. By analyzing the trends over time, users can identify patterns and fluctuations in expenditure, enabling them to devise effective AWS service management strategies."
msgstr "This chart serves as a vital tool in understanding cost distribution across different RDS usage types. By analyzing the trends over time, users can identify patterns and fluctuations in expenditure, enabling them to devise effective AWS service management strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows a historical breakdown of Azure spending across different subscriptions over the past 18 months, offering visibility into how costs are distributed at the subscription level."
msgstr "This chart shows a historical breakdown of Azure spending across different subscriptions over the past 18 months, offering visibility into how costs are distributed at the subscription level."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows CPU utilization for OpenSearch master nodes, which coordinate cluster state."
msgstr "This chart shows CPU utilization for OpenSearch master nodes, which coordinate cluster state."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows how well each Virtual Machines reservation product (VM size) is being used, based on the 30-day utilization Azure reports for each reservation."
msgstr "This chart shows how well each Virtual Machines reservation product (VM size) is being used, based on the 30-day utilization Azure reports for each reservation."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows inbound and outbound network traffic across VM Scale Set instances."
msgstr "This chart shows inbound and outbound network traffic across VM Scale Set instances."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows inbound and outbound network traffic for an Azure VM."
msgstr "This chart shows inbound and outbound network traffic for an Azure VM."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows incoming network traffic (bytes received) for an EC2 instance over time."
msgstr "This chart shows incoming network traffic (bytes received) for an EC2 instance over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows monthly Azure database costs grouped by meter subcategory, highlighting cost drivers such as compute, storage, or IO."
msgstr "This chart shows monthly Azure database costs grouped by meter subcategory, highlighting cost drivers such as compute, storage, or IO."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows outgoing network traffic (bytes sent) for an EC2 instance over time."
msgstr "This chart shows outgoing network traffic (bytes sent) for an EC2 instance over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the amount of available memory that can be used by the RDS instance."
msgstr "This chart shows the amount of available memory that can be used by the RDS instance."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the amount of available storage for the RDS instance."
msgstr "This chart shows the amount of available storage for the RDS instance."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the Application Gateway's current, estimated billed, and fixed billable capacity units."
msgstr "This chart shows the Application Gateway's current, estimated billed, and fixed billable capacity units."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the breakdown of Azure compute costs by instance series, providing insight into which virtual machine families are driving the majority of expenditures."
msgstr "This chart shows the breakdown of Azure compute costs by instance series, providing insight into which virtual machine families are driving the majority of expenditures."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the combined read and write block size (MiB per operation) for the EBS volume over the selected time period."
msgstr "This chart shows the combined read and write block size (MiB per operation) for the EBS volume over the selected time period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the combined read and write throughput (MiB/s) for the EBS volume over the selected time period."
msgstr "This chart shows the combined read and write throughput (MiB/s) for the EBS volume over the selected time period."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the compute units consumed by the Application Gateway."
msgstr "This chart shows the compute units consumed by the Application Gateway."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the CPU utilization percentage for an EC2 instance over time."
msgstr "This chart shows the CPU utilization percentage for an EC2 instance over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the current CPU utilization of the Application Gateway."
msgstr "This chart shows the current CPU utilization of the Application Gateway."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of active connections to a Client VPN endpoint over time."
msgstr "This chart shows the number of active connections to a Client VPN endpoint over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of active sessions connected to the database."
msgstr "This chart shows the number of active sessions connected to the database."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of Azure managed disks grouped by their current state, such as \"attached\", \"unattached\", or \"reserved\". It provides visibility into how storage resources are being utilized or left idle."
msgstr "This chart shows the number of Azure managed disks grouped by their current state, such as \"attached\", \"unattached\", or \"reserved\". It provides visibility into how storage resources are being utilized or left idle."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of bytes per second the Application Gateway has served."
msgstr "This chart shows the number of bytes per second the Application Gateway has served."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of concurrent active connections through a NAT Gateway over time."
msgstr "This chart shows the number of concurrent active connections through a NAT Gateway over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of disk operations (IOPS) performed per second."
msgstr "This chart shows the number of disk operations (IOPS) performed per second."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of disk operations performed per second across the VM Scale Set."
msgstr "This chart shows the number of disk operations performed per second across the VM Scale Set."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of disk operations performed per second."
msgstr "This chart shows the number of disk operations performed per second."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the number of requests handled by the load balancer over time."
msgstr "This chart shows the number of requests handled by the load balancer over time."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the percentage of time the EBS volume was idle during a specified period, indicating moments when no read or write operations were performed. Please note that this metric is not supported for volumes with Multi-Attach enabled."
msgstr "This chart shows the percentage of time the EBS volume was idle during a specified period, indicating moments when no read or write operations were performed. Please note that this metric is not supported for volumes with Multi-Attach enabled."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the rate of bytes read from and written to a managed disk."
msgstr "This chart shows the rate of bytes read from and written to a managed disk."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the rate of data transfer to and from disks across the VM Scale Set."
msgstr "This chart shows the rate of data transfer to and from disks across the VM Scale Set."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the rate of data transfer to and from the VM disks."
msgstr "This chart shows the rate of data transfer to and from the VM disks."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the total bytes received from and sent to clients by the Application Gateway."
msgstr "This chart shows the total bytes received from and sent to clients by the Application Gateway."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows the volume of data read from and written to storage per second."
msgstr "This chart shows the volume of data read from and written to storage per second."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart shows, month by month over the trailing 6 months, how much cheaper virtual machine usage was compared to what that same consumption would have cost at on-demand (retail) rates."
msgstr "This chart shows, month by month over the trailing 6 months, how much cheaper virtual machine usage was compared to what that same consumption would have cost at on-demand (retail) rates."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart supports decisions about which DB engines offer the best value for money, and helps flag engines whose unit cost is trending upward."
msgstr "This chart supports decisions about which DB engines offer the best value for money, and helps flag engines whose unit cost is trending upward."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart, also known as the Read Throughput chart, provides information on the volume of data read from the storage device over a specified period of time. It indicates the rate at which data is being retrieved, helping to analyze the efficiency and performance of read operations on the EBS volume."
msgstr "This chart, also known as the Read Throughput chart, provides information on the volume of data read from the storage device over a specified period of time. It indicates the rate at which data is being retrieved, helping to analyze the efficiency and performance of read operations on the EBS volume."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This chart, also known as the write throughput chart, provides information on the volume of data written to the storage device over a specified period of time. It indicates the rate at which data is being stored, helping to analyze the efficiency and performance of write operations on the EBS volume."
msgstr "This chart, also known as the write throughput chart, provides information on the volume of data written to the storage device over a specified period of time. It indicates the rate at which data is being stored, helping to analyze the efficiency and performance of write operations on the EBS volume."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "This CloudFormation template contains <0>only the additional write permissions policies</0> for your existing Skie.io role. Upload it to create the policies and attach them to your existing role, allowing Skie.io to perform cost optimization actions in your AWS account. All required steps are documented below. If you have any questions, feel free to reach out to"
msgstr "This CloudFormation template contains <0>only the additional write permissions policies</0> for your existing Skie.io role. Upload it to create the policies and attach them to your existing role, allowing Skie.io to perform cost optimization actions in your AWS account. All required steps are documented below. If you have any questions, feel free to reach out to"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "This CloudFormation template creates a CUR 2.0 Data Export with split cost allocation data, an S3 bucket, and the necessary bucket policies."
msgstr "This CloudFormation template creates a CUR 2.0 Data Export with split cost allocation data, an S3 bucket, and the necessary bucket policies."

#: app/frontend/components/chat/SourceMenu.jsx
msgid "This conversation"
msgstr "This conversation"

#: app/frontend/components/chat/Conversation.jsx
msgid "This conversation's assistant is no longer available. Start a new conversation."
msgstr "This conversation's assistant is no longer available. Start a new conversation."

#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "This feature has no configurable options."
msgstr "This feature has no configurable options."

#: app/frontend/components/guardian/GuardianNoAccess.jsx
msgid "This feature is not active in the Guardian configuration"
msgstr "This feature is not active in the Guardian configuration"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graph, with its bar representation and trending line, offers insights into the fluctuation of savings throughout the specified period. Each bar represents the proportion of savings for a particular month, while the trending line provides a visual representation of the overall trend in savings percentage over time. Users can access detailed information by hovering over individual bars, including specific savings values for each month and corresponding trendlines."
msgstr "This graph, with its bar representation and trending line, offers insights into the fluctuation of savings throughout the specified period. Each bar represents the proportion of savings for a particular month, while the trending line provides a visual representation of the overall trend in savings percentage over time. Users can access detailed information by hovering over individual bars, including specific savings values for each month and corresponding trendlines."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical depiction assists in making informed decisions regarding resource allocation and optimization within AWS services, allowing for effective management based on tenancy type distribution."
msgstr "This graphical depiction assists in making informed decisions regarding resource allocation and optimization within AWS services, allowing for effective management based on tenancy type distribution."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical representation enables informed decision-making regarding resource allocation and optimization within AWS services, facilitating effective management based on instance state."
msgstr "This graphical representation enables informed decision-making regarding resource allocation and optimization within AWS services, facilitating effective management based on instance state."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical representation facilitates a clear understanding of spending patterns, aiding in the formulation of effective AWS service management strategies."
msgstr "This graphical representation facilitates a clear understanding of spending patterns, aiding in the formulation of effective AWS service management strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical representation facilitates informed decision-making regarding resource allocation and optimization within AWS services, enabling effective management based on the distribution of usage operations."
msgstr "This graphical representation facilitates informed decision-making regarding resource allocation and optimization within AWS services, enabling effective management based on the distribution of usage operations."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical representation facilitates informed decision-making regarding resource allocation and optimization within AWS services, enabling efficient management based on instance type distribution."
msgstr "This graphical representation facilitates informed decision-making regarding resource allocation and optimization within AWS services, enabling efficient management based on instance type distribution."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This graphical representation facilitates strategic decision-making in AWS management, enabling users to evaluate the effectiveness of optimization efforts and refine cost-saving strategies for improved efficiency and resource utilization."
msgstr "This graphical representation facilitates strategic decision-making in AWS management, enabling users to evaluate the effectiveness of optimization efforts and refine cost-saving strategies for improved efficiency and resource utilization."

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "This guide will help you <0>add write permissions to your existing Skie.io role</0> using IAM policies. Follow these steps to create the policies and attach them to your existing role, allowing Skie.io to perform cost optimization actions in your AWS account. All required steps are documented below. If you have any questions, feel free to reach out to"
msgstr "This guide will help you <0>add write permissions to your existing Skie.io role</0> using IAM policies. Follow these steps to create the policies and attach them to your existing role, allowing Skie.io to perform cost optimization actions in your AWS account. All required steps are documented below. If you have any questions, feel free to reach out to"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "This guide will help you <0>manually create a CUR 2.0 Data Export with split cost allocation data</0>"
msgstr "This guide will help you <0>manually create a CUR 2.0 Data Export with split cost allocation data</0>"

#: app/frontend/pages/dashboard/aws/accounts/index.jsx
msgid "This guide will help you get your AWS account setup and connected to your organization."
msgstr "This guide will help you get your AWS account setup and connected to your organization."

#: app/frontend/pages/dashboard/aws/accounts/setup.jsx
msgid "This guide will help you set up an IAM role with read-only permissions in your AWS account, allowing Skie.io to collect usage data and metadata that we will use to optimize your cloud costs. All required steps are documented below. If you have any questions, feel free to reach out to"
msgstr "This guide will help you set up an IAM role with read-only permissions in your AWS account, allowing Skie.io to collect usage data and metadata that we will use to optimize your cloud costs. All required steps are documented below. If you have any questions, feel free to reach out to"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "This guide will help you set up your AWS account using a CloudFormation template, allowing Skie.io to collect usage data and metadata that we will use to optimize your cloud costs. All required steps are documented below. If you have any questions, feel free to reach out to"
msgstr "This guide will help you set up your AWS account using a CloudFormation template, allowing Skie.io to collect usage data and metadata that we will use to optimize your cloud costs. All required steps are documented below. If you have any questions, feel free to reach out to"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This insight enables organizations to monitor regional cost dynamics, identify high-cost locations, and make informed decisions regarding workload distribution and regional optimization to enhance cost efficiency."
msgstr "This insight enables organizations to monitor regional cost dynamics, identify high-cost locations, and make informed decisions regarding workload distribution and regional optimization to enhance cost efficiency."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This insight helps identify underutilized or idle resources, enabling teams to take corrective action to reduce unnecessary spend and improve operational efficiency."
msgstr "This insight helps identify underutilized or idle resources, enabling teams to take corrective action to reduce unnecessary spend and improve operational efficiency."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This insight supports efficient resource management by helping identify unattached or orphaned disks that may be incurring unnecessary costs and should be reviewed for cleanup or repurposing."
msgstr "This insight supports efficient resource management by helping identify unattached or orphaned disks that may be incurring unnecessary costs and should be reviewed for cleanup or repurposing."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "This instruction manual explains how to give Skie.io permission using the PowerShell script approach."
msgstr "This instruction manual explains how to give Skie.io permission using the PowerShell script approach."

#: app/frontend/components/guardian/EC2AvailabilityTrendChart.jsx
msgid "this month"
msgstr "this month"

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "This operation can still be canceled until the Change is executed."
msgstr "This operation can still be canceled until the Change is executed."

#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "This operation cannot be undone. If necessary, you can create a new Change Request."
msgstr "This operation cannot be undone. If necessary, you can create a new Change Request."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "This optimization action failed to complete."
msgstr "This optimization action failed to complete."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "This optimization action has been applied successfully."
msgstr "This optimization action has been applied successfully."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "This optimization action has been cancelled."
msgstr "This optimization action has been cancelled."

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
msgid "This optimization action is pending and will be processed at the scheduled time."
msgstr "This optimization action is pending and will be processed at the scheduled time."

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "This optimization action is pending and will be processed soon."
msgstr "This optimization action is pending and will be processed soon."

#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "This optimization action is pending and will be processed when the change is applied."
msgstr "This optimization action is pending and will be processed when the change is applied."

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "This optimization action is pending and will be processed when the OS patch is applied."
msgstr "This optimization action is pending and will be processed when the OS patch is applied."

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "This optimization action was cancelled."
msgstr "This optimization action was cancelled."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "This option automatically registers the credentials with Skie.io, so you don't have to send them manually."
msgstr "This option automatically registers the credentials with Skie.io, so you don't have to send them manually."

#. placeholder {0}: plan.name
#: app/frontend/pages/dashboard/subscriptions/overview.jsx
msgid "This organization has no active {0} subscription."
msgstr "This organization has no active {0} subscription."

#: app/frontend/pages/dashboard/organizations/show.jsx
msgid "This organization is not onboarded yet. To start the onboarding, go to the <0>settings</0> page to add accounts."
msgstr "This organization is not onboarded yet. To start the onboarding, go to the <0>settings</0> page to add accounts."

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ec2/right_size_recommendations/edit.jsx
msgid "This overwrites the optimizer-generated recommendation for this instance and may affect future optimization actions. Proceed with caution."
msgstr "This overwrites the optimizer-generated recommendation for this instance and may affect future optimization actions. Proceed with caution."

#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
msgid "This overwrites the optimizer-generated recommendation for this volume and may affect future optimization actions. Proceed with caution."
msgstr "This overwrites the optimizer-generated recommendation for this volume and may affect future optimization actions. Proceed with caution."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "This pay-as-you-go image makes Azure bill a Red Hat meter that includes Red Hat support. Setting the licence type to RHEL_BYOS stops that meter; Red Hat then bills you directly, so the net saving is this meter minus the subscription."
msgstr "This pay-as-you-go image makes Azure bill a Red Hat meter that includes Red Hat support. Setting the licence type to RHEL_BYOS stops that meter; Red Hat then bills you directly, so the net saving is this meter minus the subscription."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "This pay-as-you-go image makes Azure bill a SUSE meter that includes SUSE support. Setting the licence type to SLES_BYOS stops that meter; SUSE then bills you directly, so the net saving is this meter minus the subscription."
msgstr "This pay-as-you-go image makes Azure bill a SUSE meter that includes SUSE support. Setting the licence type to SLES_BYOS stops that meter; SUSE then bills you directly, so the net saving is this meter minus the subscription."

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "This pay-as-you-go SQL Server image makes Azure bill a SQL Server licence meter per vCPU on top of compute. Switching the SQL licence type to Azure Hybrid Benefit stops that meter at once; no restart."
msgstr "This pay-as-you-go SQL Server image makes Azure bill a SQL Server licence meter per vCPU on top of compute. Switching the SQL licence type to Azure Hybrid Benefit stops that meter at once; no restart."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "This period against the previous one, plus the six-month series"
msgstr "This period against the previous one, plus the six-month series"

#: app/frontend/components/guardian/GuardianContextBar.jsx
msgid "This period has ended, so its totals and rates cover the whole month."
msgstr "This period has ended, so its totals and rates cover the whole month."

#: app/frontend/components/guardian/GuardianContextBar.jsx
msgid "This period is still being collected. Totals and rates cover the days gathered so far and keep changing until it closes."
msgstr "This period is still being collected. Totals and rates cover the days gathered so far and keep changing until it closes."

#: app/frontend/pages/dashboard/organizations/new.jsx
msgid "This process will guide you through onboarding your user and AWS accounts. To get started, please choose a name for your organization — this will be used to group all your AWS accounts, including the one linked to your {planName} subscription."
msgstr "This process will guide you through onboarding your user and AWS accounts. To get started, please choose a name for your organization — this will be used to group all your AWS accounts, including the one linked to your {planName} subscription."

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "This recommendation will be marked as reviewed and dismissed."
msgstr "This recommendation will be marked as reviewed and dismissed."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "This reservation ends soon; the VMs it covers will need a new decision at expiry."
msgstr "This reservation ends soon; the VMs it covers will need a new decision at expiry."

#: app/frontend/components/optimization_overview/RunOptimizersButton.jsx
msgid "This runs the optimizer for each configured service, one after another:"
msgstr "This runs the optimizer for each configured service, one after another:"

#. placeholder {0}: family.label
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "This saving only applies if you own {0} licences. Confirm it in the"
msgstr "This saving only applies if you own {0} licences. Confirm it in the"

#: app/frontend/pages/dashboard/azure/sql/license_recommendations/show.jsx
msgid "This saving only applies if you own SQL Server licences with Software Assurance. Confirm it in the"
msgstr "This saving only applies if you own SQL Server licences with Software Assurance. Confirm it in the"

#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
msgid "This Savings Plan purchase has been applied successfully."
msgstr "This Savings Plan purchase has been applied successfully."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This scale-based visual representation helps in understanding the performance differences between the old and new instances."
msgstr "This scale-based visual representation helps in understanding the performance differences between the old and new instances."

#: app/frontend/pages/admin/service_users/show.jsx
msgid "This service user has no trusted keys."
msgstr "This service user has no trusted keys."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This stacked visual representation helps in understanding the distribution of network traffic between incoming and outgoing data, highlighting performance differences between the old and new instances."
msgstr "This stacked visual representation helps in understanding the distribution of network traffic between incoming and outgoing data, highlighting performance differences between the old and new instances."

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "This step deploys the cost and usage export in FOCUS 1.2 format, along with the S3 bucket where the reports will be stored. Deploy it as its own stack in your organization's <0>management (payer)</0> account — do not add it to the StackSet from the previous step. The export created here automatically includes data from every member account in the organization."
msgstr "This step deploys the cost and usage export in FOCUS 1.2 format, along with the S3 bucket where the reports will be stored. Deploy it as its own stack in your organization's <0>management (payer)</0> account — do not add it to the StackSet from the previous step. The export created here automatically includes data from every member account in the organization."

#: app/frontend/pages/dashboard/azure/dashboard/reservations.jsx
msgid "This table shows data from the past two months."
msgstr "This table shows data from the past two months."

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
msgid "This tier is disabled."
msgstr "This tier is disabled."

#: app/frontend/pages/admin/users/show.jsx
msgid "This user has no admin tokens."
msgstr "This user has no admin tokens."

#: app/frontend/pages/admin/users/show.jsx
msgid "This user is an admin, which grants them full access to all organizations. To revoke their admin permissions, click the button below. The change will take effect immediately."
msgstr "This user is an admin, which grants them full access to all organizations. To revoke their admin permissions, click the button below. The change will take effect immediately."

#: app/frontend/pages/admin/users/show.jsx
msgid "This user is not a member of any organization."
msgstr "This user is not a member of any organization."

#: app/frontend/pages/admin/users/show.jsx
msgid "This user is not an admin on Zee. To grant admin permissions, click the button below. Admins have full access to all organizations."
msgstr "This user is not an admin on Zee. To grant admin permissions, click the button below. Admins have full access to all organizations."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view helps spot day-to-day spend volatility and shifts in the pricing-model mix, such as a sudden jump in on-demand usage that a reservation purchase could cover instead."
msgstr "This view helps spot day-to-day spend volatility and shifts in the pricing-model mix, such as a sudden jump in on-demand usage that a reservation purchase could cover instead."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view helps teams quickly identify which VM sizes are driving the most cost, supporting rightsizing and purchasing decisions."
msgstr "This view helps teams quickly identify which VM sizes are driving the most cost, supporting rightsizing and purchasing decisions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view helps teams understand how much of their spend comes from active usage versus other charge types, such as unused reservation commitments."
msgstr "This view helps teams understand how much of their spend comes from active usage versus other charge types, such as unused reservation commitments."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view helps teams understand how much of their VM spend is driven by licensing versus raw compute usage, supporting licensing and rightsizing decisions."
msgstr "This view helps teams understand how much of their VM spend is driven by licensing versus raw compute usage, supporting licensing and rightsizing decisions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports capacity planning and cost management by highlighting instance size distribution, helping teams assess sizing strategies and identify opportunities to optimize workloads."
msgstr "This view supports capacity planning and cost management by highlighting instance size distribution, helping teams assess sizing strategies and identify opportunities to optimize workloads."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports commitment management by surfacing which reservations are underused and may be worth exchanging or not renewing."
msgstr "This view supports commitment management by surfacing which reservations are underused and may be worth exchanging or not renewing."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports cost allocation and regional planning by highlighting where VM spend is concentrated."
msgstr "This view supports cost allocation and regional planning by highlighting where VM spend is concentrated."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports cost optimization efforts by highlighting the proportion of spend allocated to each pricing model, allowing users to assess savings opportunities and adjust purchasing strategies accordingly."
msgstr "This view supports cost optimization efforts by highlighting the proportion of spend allocated to each pricing model, allowing users to assess savings opportunities and adjust purchasing strategies accordingly."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports high-availability planning by highlighting whether workloads are spread across zones or concentrated in one."
msgstr "This view supports high-availability planning by highlighting whether workloads are spread across zones or concentrated in one."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports high-availability planning: VMs outside an availability set have no fault-domain spreading, and are more exposed to a single hardware failure taking them all down together."
msgstr "This view supports high-availability planning: VMs outside an availability set have no fault-domain spreading, and are more exposed to a single hardware failure taking them all down together."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports license cost optimization by pointing to where enabling Azure Hybrid Benefit would have the largest impact."
msgstr "This view supports license cost optimization by pointing to where enabling Azure Hybrid Benefit would have the largest impact."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports license cost optimization by showing how much of your fleet already benefits from Azure Hybrid Benefit versus where there's still an opportunity to apply it."
msgstr "This view supports license cost optimization by showing how much of your fleet already benefits from Azure Hybrid Benefit versus where there's still an opportunity to apply it."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports licensing reviews and vendor risk assessments by highlighting which image sources are most heavily used."
msgstr "This view supports licensing reviews and vendor risk assessments by highlighting which image sources are most heavily used."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This view supports patching and compliance planning by highlighting how VMs are distributed across operating systems."
msgstr "This view supports patching and compliance planning by highlighting how VMs are distributed across operating systems."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visual representation facilitates informed decision-making regarding resource allocation and optimization strategies within AWS services, aiding in cost management and efficiency enhancement."
msgstr "This visual representation facilitates informed decision-making regarding resource allocation and optimization strategies within AWS services, aiding in cost management and efficiency enhancement."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization empowers stakeholders to identify cost trends, optimize resource allocation, and formulate effective AWS management strategies tailored to their needs."
msgstr "This visualization empowers stakeholders to identify cost trends, optimize resource allocation, and formulate effective AWS management strategies tailored to their needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization enables cost trend analysis, helping users assess the impact of storage choices and identify opportunities to optimize disk provisioning and reduce unnecessary spending."
msgstr "This visualization enables cost trend analysis, helping users assess the impact of storage choices and identify opportunities to optimize disk provisioning and reduce unnecessary spending."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization enables stakeholders to evaluate cost-saving strategies, measure the effectiveness of commitment-based pricing, and make informed decisions to optimize Azure spend."
msgstr "This visualization enables stakeholders to evaluate cost-saving strategies, measure the effectiveness of commitment-based pricing, and make informed decisions to optimize Azure spend."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization enables users to identify high-cost instance families, evaluate workload placement, and explore opportunities to right-size or switch to more cost-effective options."
msgstr "This visualization enables users to identify high-cost instance families, evaluate workload placement, and explore opportunities to right-size or switch to more cost-effective options."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization enables users to quickly identify the most significant contributors to costs, allowing them to prioritize optimization efforts and refine resource allocation within their AWS environments effectively."
msgstr "This visualization enables users to quickly identify the most significant contributors to costs, allowing them to prioritize optimization efforts and refine resource allocation within their AWS environments effectively."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization enables users to quickly identify the most significant contributors to CPU capacity utilization, allowing them to prioritize optimization efforts and refine resource allocation within their AWS environments effectively."
msgstr "This visualization enables users to quickly identify the most significant contributors to CPU capacity utilization, allowing them to prioritize optimization efforts and refine resource allocation within their AWS environments effectively."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization facilitates the formulation of AWS service management strategies by providing insights into account-specific spending trends, enabling stakeholders to optimize resource allocation, identify cost-intensive areas, and enhance cost-effectiveness."
msgstr "This visualization facilitates the formulation of AWS service management strategies by providing insights into account-specific spending trends, enabling stakeholders to optimize resource allocation, identify cost-intensive areas, and enhance cost-effectiveness."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization facilitates the formulation of effective AWS service management strategies by offering clear insights into spending patterns and facilitating informed decision-making regarding purchase options."
msgstr "This visualization facilitates the formulation of effective AWS service management strategies by offering clear insights into spending patterns and facilitating informed decision-making regarding purchase options."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization helps identify opportunities to optimize commitment utilization by comparing wasted commitment costs with what would have been spent on on-demand instances, enabling users to make informed decisions about commitment management and cost optimization strategies."
msgstr "This visualization helps identify opportunities to optimize commitment utilization by comparing wasted commitment costs with what would have been spent on on-demand instances, enabling users to make informed decisions about commitment management and cost optimization strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization helps identify utilization trends, assess resource efficiency, and make informed decisions about instance right-sizing and optimization strategies."
msgstr "This visualization helps identify utilization trends, assess resource efficiency, and make informed decisions about instance right-sizing and optimization strategies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization helps stakeholders quickly identify cost spikes, analyze trends, and understand which resource categories are driving Azure expenditures. It supports proactive cost management and optimization by highlighting daily usage patterns and potential anomalies."
msgstr "This visualization helps stakeholders quickly identify cost spikes, analyze trends, and understand which resource categories are driving Azure expenditures. It supports proactive cost management and optimization by highlighting daily usage patterns and potential anomalies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization helps teams understand the distribution of storage across performance tiers, identify overuse of high-cost disk types, and make informed decisions to align storage provisioning with workload needs and cost targets."
msgstr "This visualization helps teams understand the distribution of storage across performance tiers, identify overuse of high-cost disk types, and make informed decisions to align storage provisioning with workload needs and cost targets."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization is a valuable tool for identifying spending patterns, monitoring changes in usage behavior, and informing strategic decisions to improve cost management and optimize Azure resource allocations."
msgstr "This visualization is a valuable tool for identifying spending patterns, monitoring changes in usage behavior, and informing strategic decisions to improve cost management and optimize Azure resource allocations."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization supports governance, budget tracking, and accountability across teams or projects by helping stakeholders identify high-spending subscriptions, monitor usage patterns, and enforce cost control policies."
msgstr "This visualization supports governance, budget tracking, and accountability across teams or projects by helping stakeholders identify high-spending subscriptions, monitor usage patterns, and enforce cost control policies."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "This visualization supports strategic planning and budget forecasting, helping users identify cost growth patterns, seasonal variations, and areas where cost optimization initiatives may be most impactful."
msgstr "This visualization supports strategic planning and budget forecasting, helping users identify cost growth patterns, seasonal variations, and areas where cost optimization initiatives may be most impactful."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "This VM changes size so that an existing reservation can cover it (or so its reservation can cover another VM). The saving shows up in the plan total, not on this row."
msgstr "This VM changes size so that an existing reservation can cover it (or so its reservation can cover another VM). The saving shows up in the plan total, not on this row."

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "This will also delete all associated features:"
msgstr "This will also delete all associated features:"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "This will automatically detect all subscriptions and billing accounts."
msgstr "This will automatically detect all subscriptions and billing accounts."

#: app/frontend/pages/dashboard/aws/data_imports/DeleteDataImportModal.jsx
msgid "This will remove the data import and stop collecting its files. This cannot be undone."
msgstr "This will remove the data import and stop collecting its files. This cannot be undone."

#: app/frontend/pages/admin/billing_reports/index.jsx
msgid "This will trigger billing calculation for this organization. Continue?"
msgstr "This will trigger billing calculation for this organization. Continue?"

#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "This will trigger billing V2 calculation for this organization. Continue?"
msgstr "This will trigger billing V2 calculation for this organization. Continue?"

#: app/frontend/pages/admin/guardian_billing_reports/index.jsx
msgid "This will trigger guardian billing calculation for this organization. Continue?"
msgstr "This will trigger guardian billing calculation for this organization. Continue?"

#: app/frontend/components/guardian/help/service_desk.js
msgid "Those windows come from the Jira calendars and differ per work type, priority and timezone. The Service Hours card on this page shows the ones in force right now."
msgstr "Those windows come from the Jira calendars and differ per work type, priority and timezone. The Service Hours card on this page shows the ones in force right now."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "Threads per core"
msgstr "Threads per core"

#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
msgid "Threads per Core"
msgstr "Threads per Core"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Threat"
msgstr "Threat"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Threat Type"
msgstr "Threat Type"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Threats"
msgstr "Threats"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
msgid "Threshold"
msgstr "Threshold"

#: app/frontend/components/aws/RDSMetricsSection.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/MetricsSection.jsx
msgid "Throughput"
msgstr "Throughput"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Throughput (MB/s)"
msgstr "Throughput (MB/s)"

#: app/frontend/pages/dashboard/aws/efs_file_systems/index.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
msgid "Throughput Mode"
msgstr "Throughput Mode"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
msgid "Ticket"
msgstr "Ticket"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
msgid "Ticket Details"
msgstr "Ticket Details"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Ticket figures count customer-reported tickets only — tickets opened by the monitoring automation are summarised separately, on the Service Desk page. \"Completed\" means a ticket Jira puts in the Done category, which covers Resolved, Closed and Canceled."
msgstr "Ticket figures count customer-reported tickets only — tickets opened by the monitoring automation are summarised separately, on the Service Desk page. \"Completed\" means a ticket Jira puts in the Done category, which covers Resolved, Closed and Canceled."

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/TicketStatusCard.jsx
msgid "Ticket status"
msgstr "Ticket status"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Ticket Type"
msgstr "Ticket Type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Tickets"
msgstr "Tickets"

#. placeholder {0}: serverDrilldown.instanceName
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Tickets — {0}"
msgstr "Tickets — {0}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/CustomerTicketsPane.jsx
msgid "Tickets by Priority (12 months)"
msgstr "Tickets by Priority (12 months)"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Tickets by reporter"
msgstr "Tickets by reporter"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/RequestTypeCard.jsx
msgid "Tickets by Request Type"
msgstr "Tickets by Request Type"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/IssuesByTypeCard.jsx
msgid "Tickets by Type"
msgstr "Tickets by Type"

#: app/frontend/components/guardian/help/executive_summary.js
msgid "Tickets Jira puts in the Done category divided by tickets opened this period, across all priorities. Counted the same way as the Delivery tickets above."
msgstr "Tickets Jira puts in the Done category divided by tickets opened this period, across all priorities. Counted the same way as the Delivery tickets above."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Tickets opened by internal automation (e.g. Monitoring Bot, AutoSRE Bot) rather than by customers. They are kept here so they don't skew the customer-facing service desk metrics."
msgstr "Tickets opened by internal automation (e.g. Monitoring Bot, AutoSRE Bot) rather than by customers. They are kept here so they don't skew the customer-facing service desk metrics."

#: app/frontend/components/guardian/GuardianContextBar.jsx
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/FleetMatrix.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
#: app/frontend/pages/admin/plans/organizations.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/drilldowns.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
msgid "Tier"
msgstr "Tier"

#. placeholder {0}: tierFeature.tier_label
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Tier {0}, the only one active"
msgstr "Tier {0}, the only one active"

#: app/frontend/components/guardian/help/ec2_availability.js
msgid "Tier tagging (Standard vs H/A) is not yet configured — every instance is shown against the Standard threshold until that convention is confirmed."
msgstr "Tier tagging (Standard vs H/A) is not yet configured — every instance is shown against the Standard threshold until that convention is confirmed."

#: app/frontend/components/guardian/help/common.js
msgid "Tiers and SLA methodology"
msgstr "Tiers and SLA methodology"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Time"
msgstr "Time"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Time created"
msgstr "Time created"

#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/index.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "Time Created"
msgstr "Time Created"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Time elapsed since the most recent DRS point-in-time snapshot across all source servers."
msgstr "Time elapsed since the most recent DRS point-in-time snapshot across all source servers."

#: app/frontend/dashboard/aws_load_balancer_metrics_charts.jsx
msgid "Time Frame"
msgstr "Time Frame"

#: app/frontend/pages/dashboard/aws/settings/EksSplitCostGuide.jsx
msgid "Time granularity:"
msgstr "Time granularity:"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Time to Resolve"
msgstr "Time to Resolve"

#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Time to Respond"
msgstr "Time to Respond"

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
msgid "Timed out"
msgstr "Timed out"

#: app/frontend/components/guardian/TicketDetailDrawer.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Timeline"
msgstr "Timeline"

#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
msgid "Timestream database"
msgstr "Timestream database"

#: app/frontend/pages/dashboard/aws/timestream_databases/index.jsx
#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Timestream Databases"
msgstr "Timestream Databases"

#: app/frontend/pages/dashboard/aws/timestream_tables/show.jsx
msgid "Timestream table"
msgstr "Timestream table"

#: app/frontend/pages/dashboard/aws/timestream_databases/show.jsx
msgid "Timestream Tables"
msgstr "Timestream Tables"

#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/index.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
#: app/frontend/pages/dashboard/aws/maintenance_windows/show.jsx
#: app/frontend/pages/dashboard/change_requests/ChangeRequestForm.jsx
msgid "Timezone"
msgstr "Timezone"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/drilldowns.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Title"
msgstr "Title"

#: app/frontend/pages/dashboard/aws/patch_manager/compliance_report.jsx
#: app/frontend/pages/dashboard/change_requests/index.jsx
msgid "To"
msgstr "To"

#: app/frontend/pages/dashboard/aws/accounts/cloud_formation_setup.jsx
msgid "To backfill historical data, open an AWS Support case with the export name <0>skieio-focus-1-2-daily</0> and the billing period you need. Data from before the account existed, or from a different organization structure, cannot be backfilled. See the <1>AWS documentation</1> for details."
msgstr "To backfill historical data, open an AWS Support case with the export name <0>skieio-focus-1-2-daily</0> and the billing period you need. Data from before the account existed, or from a different organization structure, cannot be backfilled. See the <1>AWS documentation</1> for details."

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "To find how much AWS actually paid us: Action = DISBURSED and Transaction type = DISBURSEMENT — exactly what the \"Received from AWS\" tile above sums."
msgstr "To find how much AWS actually paid us: Action = DISBURSED and Transaction type = DISBURSEMENT — exactly what the \"Received from AWS\" tile above sums."

#: app/frontend/pages/admin/users/show.jsx
msgid "To let this user sign in with their password alone, click the button below. Use this when they have lost both their authenticator app and their backup codes."
msgstr "To let this user sign in with their password alone, click the button below. Use this when they have lost both their authenticator app and their backup codes."

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "To manage AWS Credentials, visit"
msgstr "To manage AWS Credentials, visit"

#: app/frontend/pages/dashboard/organizations/edit.jsx
msgid "To permanently delete this organization, click the button below. This action will delete all data associated with this organization, including AWS accounts, Azure subscriptions, cost details and recommendations. You will be asked for confirmation."
msgstr "To permanently delete this organization, click the button below. This action will delete all data associated with this organization, including AWS accounts, Azure subscriptions, cost details and recommendations. You will be asked for confirmation."

#: app/frontend/pages/admin/users/show.jsx
msgid "To permanently delete this user from the database, click the button below. This action will take effect immediately and cannot be undone."
msgstr "To permanently delete this user from the database, click the button below. This action will take effect immediately and cannot be undone."

#: app/frontend/pages/admin/users/show.jsx
msgid "To restore access and allow this user to sign in to Zee, click the button below. The change will take effect immediately."
msgstr "To restore access and allow this user to sign in to Zee, click the button below. The change will take effect immediately."

#: app/frontend/pages/admin/users/show.jsx
msgid "To restrict access and prevent this user from signing in to Zee, click the button below. The change will take effect immediately."
msgstr "To restrict access and prevent this user from signing in to Zee, click the button below. The change will take effect immediately."

#: app/frontend/pages/admin/trusted_keys/new.jsx
msgid "To sign and verify JSON Web Tokens (JWT) for use in the API, generate a pair of ECDSA keys by using these commands:"
msgstr "To sign and verify JSON Web Tokens (JWT) for use in the API, generate a pair of ECDSA keys by using these commands:"

#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
msgid "to skip it or override its buffer and percentile."
msgstr "to skip it or override its buffer and percentile."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "to skip it or set its required buffer and percentile."
msgstr "to skip it or set its required buffer and percentile."

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "to skip it or set its required buffer, percentile, and node counts."
msgstr "to skip it or set its required buffer, percentile, and node counts."

#: app/frontend/pages/dashboard/azure/credentials/index.jsx
msgid "To start monitoring your Azure resources, you need to connect your Azure account."
msgstr "To start monitoring your Azure resources, you need to connect your Azure account."

#: app/frontend/utils/format.js
msgid "today"
msgstr "today"

#: app/frontend/components/chat/groups.js
msgid "Today"
msgstr "Today"

#: app/frontend/layout/components.jsx
msgid "Toggle navigation"
msgstr "Toggle navigation"

#: app/frontend/components/chat/ChatPanel.jsx
msgid "Toggle Sidebar"
msgstr "Toggle Sidebar"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Top 10 AWS resources with the most active findings in the selected period — actionable only (Informational/passed excluded), ordered by finding count."
msgstr "Top 10 AWS resources with the most active findings in the selected period — actionable only (Informational/passed excluded), ordered by finding count."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Top 10 endpoints with the highest number of open High and Critical detections."
msgstr "Top 10 endpoints with the highest number of open High and Critical detections."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Top 10 Servers by Ticket Volume"
msgstr "Top 10 Servers by Ticket Volume"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/TopVolumesCard.jsx
msgid "Top 10 Volumes with Backup Issues"
msgstr "Top 10 Volumes with Backup Issues"

#: app/frontend/pages/admin/guardian_global_dashboard/AttentionCards.jsx
msgid "Top 5 (organization, tier) by sum of failed Security Hub checks at CRITICAL or HIGH severity. Rows where Security is disabled are excluded."
msgstr "Top 5 (organization, tier) by sum of failed Security Hub checks at CRITICAL or HIGH severity. Rows where Security is disabled are excluded."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Top affected packages"
msgstr "Top affected packages"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Top failing controls"
msgstr "Top failing controls"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Top Instance Types by Spend"
msgstr "Top Instance Types by Spend"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Top Operating Systems by Spend"
msgstr "Top Operating Systems by Spend"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Top risky assets"
msgstr "Top risky assets"

#: app/frontend/components/guardian/help/executive_summary.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
msgid "Top Servers by Ticket Volume"
msgstr "Top Servers by Ticket Volume"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "Top services"
msgstr "Top services"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "Top threats"
msgstr "Top threats"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Top Tier"
msgstr "Top Tier"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Top VM Sizes by Spend"
msgstr "Top VM Sizes by Spend"

#: app/frontend/components/echarts/modal_tooltip.jsx
#: app/frontend/components/echarts/options.js
#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
#: app/frontend/components/StackedBarTable.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/PatchOperationsCard.jsx
msgid "Total"
msgstr "Total"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "TOTAL"
msgstr "TOTAL"

#: app/frontend/pages/admin/marketplace_billings/index.jsx
msgid "Total Amount"
msgstr "Total Amount"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Total AWS Spend"
msgstr "Total AWS Spend"

#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
msgid "Total Azure Spend"
msgstr "Total Azure Spend"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Total Consumption"
msgstr "Total Consumption"

#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
msgid "Total data + master node count override for this domain."
msgstr "Total data + master node count override for this domain."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Total disaster recovery drill jobs executed via AWS DRS across all accounts."
msgstr "Total disaster recovery drill jobs executed via AWS DRS across all accounts."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Total EBS Spend"
msgstr "Total EBS Spend"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Total EC2 Spend"
msgstr "Total EC2 Spend"

#: app/frontend/pages/dashboard/aws/elasti_cache/right_size_recommendations/show.jsx
msgid "Total Factor"
msgstr "Total Factor"

#: app/frontend/pages/dashboard/aws/cost_anomalies/index.jsx
msgid "Total Impact"
msgstr "Total Impact"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Total Managed DBs"
msgstr "Total Managed DBs"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Total monthly EBS storage spend over the trailing 18 months, shown as a filled trend line. Hover any point for that month's spend."
msgstr "Total monthly EBS storage spend over the trailing 18 months, shown as a filled trend line. Hover any point for that month's spend."

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Total OD Equiv (est.)"
msgstr "Total OD Equiv (est.)"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "Total open"
msgstr "Total open"

#: app/frontend/pages/dashboard/organizations/billing_report.jsx
msgid "Total Organization Consumption by Period"
msgstr "Total Organization Consumption by Period"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Total per day"
msgstr "Total per day"

#: app/frontend/pages/admin/billing_entries/show.jsx
msgid "Total Quantity"
msgstr "Total Quantity"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Total RDS Spend"
msgstr "Total RDS Spend"

#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
msgid "Total S3 Spend"
msgstr "Total S3 Spend"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "Total Savings"
msgstr "Total Savings"

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Total Security Hub failed checks at CRITICAL or HIGH severity, summed across every (organization × tier) row. Each check is a configuration rule (e.g. \"S3 buckets should block public access\"); a failed check means one or more resources do not comply."
msgstr "Total Security Hub failed checks at CRITICAL or HIGH severity, summed across every (organization × tier) row. Each check is a configuration rule (e.g. \"S3 buckets should block public access\"); a failed check means one or more resources do not comply."

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Total Services (group B)"
msgstr "Total Services (group B)"

#: app/frontend/pages/admin/billing_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
msgid "Total SKIE Fee"
msgstr "Total SKIE Fee"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "Total source servers enrolled in AWS Elastic Disaster Recovery (DRS), grouped by replication state."
msgstr "Total source servers enrolled in AWS Elastic Disaster Recovery (DRS), grouped by replication state."

#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/index.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Total Spend"
msgstr "Total Spend"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Total Usage"
msgstr "Total Usage"

#: app/frontend/pages/dashboard/aws/dedicated_hosts/show.jsx
msgid "Total vCPUs"
msgstr "Total vCPUs"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Total VM Spend"
msgstr "Total VM Spend"

#: app/frontend/pages/admin/billing_line_items/index.jsx
msgid "Total VMs"
msgstr "Total VMs"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Track"
msgstr "Track"

#: app/frontend/components/guardian/help/service_desk.js
msgid "Tracks how long it takes to respond and resolve a ticket, but only counts time inside the support window for that ticket's work type and priority — so an out-of-hours ticket is not penalised for the hours nobody was on shift. The clock also pauses while waiting for the customer to reply."
msgstr "Tracks how long it takes to respond and resolve a ticket, but only counts time inside the support window for that ticket's work type and priority — so an out-of-hours ticket is not penalised for the hours nobody was on shift. The clock also pauses while waiting for the customer to reply."

#: app/frontend/pages/admin/guardian_global_dashboard/index.jsx
msgid "Traffic light per signal — green / yellow / red. Hover a dot for the underlying value, click a row for the full breakdown. Sorted by organization name; click a column to sort by that signal."
msgstr "Traffic light per signal — green / yellow / red. Hover a dot for the underlying value, click a row for the full breakdown. Sorted by organization name; click a column to sort by that signal."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/s3_buckets/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Trailing 12 months"
msgstr "Trailing 12 months"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Trailing 12 months · top 6 + other, by DB engine"
msgstr "Trailing 12 months · top 6 + other, by DB engine"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Trailing 18 months"
msgstr "Trailing 18 months"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Trailing 30 days"
msgstr "Trailing 30 days"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/databases/dashboard.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Trailing 6 months"
msgstr "Trailing 6 months"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Trailing 6 months · by DB engine"
msgstr "Trailing 6 months · by DB engine"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Trailing 6 months · P90-P99"
msgstr "Trailing 6 months · P90-P99"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "Transaction type"
msgstr "Transaction type"

#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
msgid "Transit Encryption"
msgstr "Transit Encryption"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "Transport Protocol"
msgstr "Transport Protocol"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Trending down over the shown months"
msgstr "Trending down over the shown months"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/EvolutionTable.jsx
msgid "Trending up over the shown months"
msgstr "Trending up over the shown months"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Triage in Security Hub. Assign owners to CRITICAL findings first; CIS / NIST controls are usually the highest leverage."
msgstr "Triage in Security Hub. Assign owners to CRITICAL findings first; CIS / NIST controls are usually the highest leverage."

#: app/frontend/pages/admin/trusted_keys/show.jsx
msgid "Trusted key"
msgstr "Trusted key"

#: app/frontend/pages/admin/service_users/show.jsx
msgid "Trusted keys"
msgstr "Trusted keys"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Turn off"
msgstr "Turn off"

#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/two_factor/show.jsx
msgid "Turn off two-factor authentication"
msgstr "Turn off two-factor authentication"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Turn on"
msgstr "Turn on"

#: app/frontend/components/users/UserSettingsHeader.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/users/two_factor/show.jsx
msgid "Two-factor authentication"
msgstr "Two-factor authentication"

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Two-factor authentication (2FA) adds an extra layer of security to your account. Every time you sign in, you will be asked for a code from your authenticator app after your password."
msgstr "Two-factor authentication (2FA) adds an extra layer of security to your account. Every time you sign in, you will be asked for a code from your authenticator app after your password."

#: app/frontend/pages/users/two_factor/show.jsx
msgid "Two-factor authentication applies only when you sign in with your email and password. To secure your Google sign-in, enable 2-Step Verification in your Google account settings."
msgstr "Two-factor authentication applies only when you sign in with your email and password. To secure your Google sign-in, enable 2-Step Verification in your Google account settings."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimizations/OptimizationsListing.jsx
#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/cells.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/DisasterRecoveryPane.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/index.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/index.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Type"
msgstr "Type"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
msgid "Type change"
msgstr "Type change"

#: app/frontend/pages/dashboard/aws/tag_manager/index.jsx
msgid "Type tags"
msgstr "Type tags"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Types"
msgstr "Types"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Unable to load node details."
msgstr "Unable to load node details."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Unattached Volumes"
msgstr "Unattached Volumes"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
msgid "Unavailable"
msgstr "Unavailable"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/utils/aws.js
msgid "Unblended"
msgstr "Unblended"

#: app/frontend/pages/admin/users/show.jsx
msgid "Unblock user"
msgstr "Unblock user"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DetailPanels.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/RequestTypeCard.jsx
msgid "Uncategorized"
msgstr "Uncategorized"

#: app/frontend/pages/admin/users/show.jsx
msgid "Unconfirmed email"
msgstr "Unconfirmed email"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Underprovisioned"
msgstr "Underprovisioned"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Underutilized"
msgstr "Underutilized"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Unit"
msgstr "Unit"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Unit Cost"
msgstr "Unit Cost"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Unit Cost by DB Engine"
msgstr "Unit Cost by DB Engine"

#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "Unit Savings"
msgstr "Unit Savings"

#: app/frontend/components/ChartCardHeader.jsx
#: app/frontend/components/echarts/chart/chart.jsx
msgid "Units"
msgstr "Units"

#: app/frontend/components/guardian/help/security_compliance.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
msgid "Unknown"
msgstr "Unknown"

#: app/frontend/components/guardian/help/security_compliance.js
msgid "Unmanaged"
msgstr "Unmanaged"

#: app/frontend/components/guardian/help/backup_and_disaster_recovery.js
#: app/frontend/components/guardian/help/patch_management.js
#: app/frontend/pages/admin/guardian_global_dashboard/FleetSummaryDrawer.jsx
#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/BackupPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Unprotected"
msgstr "Unprotected"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Unprotected instances"
msgstr "Unprotected instances"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Unprotected resources"
msgstr "Unprotected resources"

#: app/frontend/pages/notifications/show.jsx
msgid "Unread"
msgstr "Unread"

#: app/frontend/components/optimization_dashboard/schedule/RecommendationGroup.jsx
msgid "Unselect all"
msgstr "Unselect all"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Unset"
msgstr "Unset"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ContainerResourceRecommendation.jsx
msgid "Unstage"
msgstr "Unstage"

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Unusual spend vs similar customers"
msgstr "Unusual spend vs similar customers"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Unutilized Commitments"
msgstr "Unutilized Commitments"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Unutilized vs On-Demand Equivalent"
msgstr "Unutilized vs On-Demand Equivalent"

#: app/frontend/pages/admin/billing_entries/show.jsx
#: app/frontend/pages/admin/billing_v2_reports/show.jsx
msgid "UoM"
msgstr "UoM"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Upcoming daily"
msgstr "Upcoming daily"

#: app/frontend/pages/dashboard/aws/accounts/AccountFormModal.jsx
#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/azure/credentials/CredentialFormModal.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/SubscriptionFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/elasti_cache_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/rds_instance_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/database_settings/SettingFormModal.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Update"
msgstr "Update"

#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
msgid "Update Domain"
msgstr "Update Domain"

#: app/frontend/pages/dashboard/aws/eks_dashboard/HpaStatusCard.jsx
msgid "Update HPA"
msgstr "Update HPA"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/show.jsx
msgid "Updated"
msgstr "Updated"

#: app/frontend/pages/admin/billing_entries/index.jsx
#: app/frontend/pages/admin/plans/index.jsx
#: app/frontend/pages/admin/service_users/show.jsx
#: app/frontend/pages/admin/tag_templates/index.jsx
#: app/frontend/pages/admin/tag_templates/show.jsx
#: app/frontend/pages/admin/trusted_keys/show.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/azure/billing_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/credentials/show.jsx
#: app/frontend/pages/dashboard/azure/subscriptions/show.jsx
msgid "Updated at"
msgstr "Updated at"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
#: app/frontend/pages/dashboard/resource_groups/show.jsx
msgid "Updated At"
msgstr "Updated At"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Updated at AWS"
msgstr "Updated at AWS"

#: app/frontend/pages/dashboard/aws/saving_plans/show.jsx
msgid "Upfront Payment Amount"
msgstr "Upfront Payment Amount"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Upgrade Policy"
msgstr "Upgrade Policy"

#. placeholder {0}: withUnit(tooltipData[5])
#: app/frontend/components/echarts/options.js
msgid "Upper: {0}"
msgstr "Upper: {0}"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Usage"
msgstr "Usage"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Usage by Purchase Type"
msgstr "Usage by Purchase Type"

#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/attributes.js
msgid "Usage operation"
msgstr "Usage operation"

#: app/frontend/components/optimization_dashboard/RecommendationInstanceDetails.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/ec2_instance_settings/index.jsx
msgid "Usage Operation"
msgstr "Usage Operation"

#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/show.jsx
msgid "Usage Price"
msgstr "Usage Price"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Usage that stays close to the maximum suggests a provisioned SKU may be cheaper; usage near the minimum suggests the minimum vCores can be lowered."
msgstr "Usage that stays close to the maximum suggests a provisioned SKU may be cheaper; usage near the minimum suggests the minimum vCores can be lowered."

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Usage type"
msgstr "Usage type"

#: app/frontend/pages/admin/guardian_billing_reports/show.jsx
msgid "Usage Type"
msgstr "Usage Type"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Usage type group"
msgstr "Usage type group"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
msgid "Usage Type Group Spend"
msgstr "Usage Type Group Spend"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "USD"
msgstr "USD"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "USD per GiB RAM-hr, Month"
msgstr "USD per GiB RAM-hr, Month"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "USD, Day"
msgstr "USD, Day"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "USD, Month"
msgstr "USD, Month"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "USD, Percentage"
msgstr "USD, Percentage"

#: app/frontend/pages/users/two_factor/BackupCodesDialog.jsx
msgid "Use a backup code to sign in if you lose access to your phone or authenticator app."
msgstr "Use a backup code to sign in if you lose access to your phone or authenticator app."

#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "Use admin tokens to call the API as yourself, limited to the scopes you pick for each token."
msgstr "Use admin tokens to call the API as yourself, limited to the scopes you pick for each token."

#: app/frontend/pages/dashboard/aws/credentials/EditCredentialModal.jsx
msgid "Use it as default credential to all instances?"
msgstr "Use it as default credential to all instances?"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to assess storage activity and investigate performance bottlenecks."
msgstr "Use it to assess storage activity and investigate performance bottlenecks."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to identify sustained high CPU usage that may indicate the need to right-size or optimize workloads."
msgstr "Use it to identify sustained high CPU usage that may indicate the need to right-size or optimize workloads."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to identify traffic patterns, spikes, and potential capacity or scaling needs."
msgstr "Use it to identify traffic patterns, spikes, and potential capacity or scaling needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to identify usage patterns and potential capacity needs."
msgstr "Use it to identify usage patterns and potential capacity needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to identify usage patterns and potential capacity or NAT Gateway scaling needs."
msgstr "Use it to identify usage patterns and potential capacity or NAT Gateway scaling needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to spot sustained CPU pressure that may require node type adjustments or scaling."
msgstr "Use it to spot sustained CPU pressure that may require node type adjustments or scaling."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to track trends and optimize spend across specific database resource categories."
msgstr "Use it to track trends and optimize spend across specific database resource categories."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to understand disk performance and sizing needs."
msgstr "Use it to understand disk performance and sizing needs."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use it to validate savings trends resulting from instance and topology changes."
msgstr "Use it to validate savings trends resulting from instance and topology changes."

#: app/frontend/components/aws_portfolio/dashboard.jsx
msgid "Use Run Optimizer to generate one."
msgstr "Use Run Optimizer to generate one."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Use spikes to correlate with workload changes or potential anomalies."
msgstr "Use spikes to correlate with workload changes or potential anomalies."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/file_shares/index.jsx
#: app/frontend/pages/dashboard/azure/file_shares/show.jsx
msgid "Used"
msgstr "Used"

#: app/frontend/pages/dashboard/azure/disks/file_share_recommendations/show.jsx
msgid "Used capacity"
msgstr "Used capacity"

#: app/frontend/components/optimization_dashboard/PercentileMetricChart.jsx
msgid "Used in this optimization"
msgstr "Used in this optimization"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Useful for understanding disk IOPS demands and storage performance."
msgstr "Useful for understanding disk IOPS demands and storage performance."

#: app/frontend/pages/admin/service_users/show.jsx
msgid "User"
msgstr "User"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "User Access Administrator"
msgstr "User Access Administrator"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Username"
msgstr "Username"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormModal.jsx
msgid "Username is required"
msgstr "Username is required"

#: app/frontend/pages/admin/users/index.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/admin/users/UsersSectionNav.jsx
msgid "Users"
msgstr "Users"

#: app/frontend/pages/admin/users/index.jsx
msgid "Users can access one or more organizations if they are members of those organizations. Memberships can be created by inviting users through the organization's settings. This is a list of users from all organizations on Zee."
msgstr "Users can access one or more organizations if they are members of those organizations. Memberships can be created by inviting users through the organization's settings. This is a list of users from all organizations on Zee."

#. placeholder {0}: Math.round(current)
#. placeholder {1}: Math.round(capacity)
#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Uses {0} of {1} benchmark points on the new size"
msgstr "Uses {0} of {1} benchmark points on the new size"

#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "UTC time is considered in all of the charts."
msgstr "UTC time is considered in all of the charts."

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "Utilization & Waste"
msgstr "Utilization & Waste"

#: app/frontend/components/optimization_dashboard/CommitmentBreakdownTables.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_reserved_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/reserved_instances/index.jsx
#: app/frontend/pages/dashboard/aws/saving_plans/index.jsx
msgid "Utilization %"
msgstr "Utilization %"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Utilization % (1 Day)"
msgstr "Utilization % (1 Day)"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Utilization % (30 Days)"
msgstr "Utilization % (30 Days)"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Utilization % (7 Days)"
msgstr "Utilization % (7 Days)"

#: app/frontend/pages/dashboard/aws/ebs_volumes/MetricsSection.jsx
msgid "Utilization Metrics"
msgstr "Utilization Metrics"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Utilization Percentage"
msgstr "Utilization Percentage"

#: app/frontend/pages/dashboard/azure/saving_plans/show.jsx
msgid "Utilization Trend"
msgstr "Utilization Trend"

#: app/frontend/layout/footer.jsx
msgid "V:"
msgstr "V:"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Valid Cores"
msgstr "Valid Cores"

#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Valid Threads Per Core"
msgstr "Valid Threads Per Core"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Valkey assumed"
msgstr "Valkey assumed"

#: app/frontend/components/ResourceTagsTable.jsx
#: app/frontend/pages/admin/tag_templates/TagTemplateForm.jsx
#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
#: app/frontend/pages/dashboard/azure/app_service_plans/show.jsx
#: app/frontend/pages/dashboard/azure/application_gateways/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/databases/show.jsx
#: app/frontend/pages/dashboard/azure/disk_snapshots/show.jsx
#: app/frontend/pages/dashboard/azure/fabric_capacities/show.jsx
#: app/frontend/pages/dashboard/azure/load_balancers/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/managed_instances/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/azure/redis_caches/show.jsx
#: app/frontend/pages/dashboard/azure/redis_enterprise_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
#: app/frontend/pages/dashboard/resource_groups/ResourceGroupForm.jsx
msgid "Value"
msgstr "Value"

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Value can only include letters, numbers, spaces, and _.:/=+-@"
msgstr "Value can only include letters, numbers, spaces, and _.:/=+-@"

#: app/frontend/pages/dashboard/aws/tag_manager/TagEntry.jsx
msgid "Value must be 0 to 256 characters long"
msgstr "Value must be 0 to 256 characters long"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "Value of Reservations Ending Each Month"
msgstr "Value of Reservations Ending Each Month"

#: app/frontend/pages/admin/peer_intelligence/index.jsx
msgid "Value vs peer median"
msgstr "Value vs peer median"

#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/index.jsx
#: app/frontend/pages/dashboard/azure/site_recovery_protected_item_disks/show.jsx
msgid "Vault"
msgstr "Vault"

#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
#: app/frontend/pages/dashboard/azure/protected_items/index.jsx
#: app/frontend/pages/dashboard/azure/protected_items/show.jsx
msgid "Vault Type"
msgstr "Vault Type"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "vCores"
msgstr "vCores"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "vCPU"
msgstr "vCPU"

#: app/frontend/pages/admin/aws_instance_types/index.jsx
#: app/frontend/pages/admin/aws_instance_types/show.jsx
msgid "Vcpu"
msgstr "Vcpu"

#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/cpu_optimized_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "vCPUs"
msgstr "vCPUs"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Verification State"
msgstr "Verification State"

#: app/frontend/pages/users/two_factor/EnrollTotpDialog.jsx
msgid "Verify and continue"
msgstr "Verify and continue"

#: app/frontend/pages/dashboard/azure/disks/running_recommendations/show.jsx
msgid "Verify before migrating: host caching off, 512e logical sector size, no double encryption, shared disks detached, and Azure Site Recovery disabled for the VM."
msgstr "Verify before migrating: host caching off, 512e logical sector size, no double encryption, shared disks detached, and Azure Site Recovery disabled for the VM."

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "Verify patch schedule and that EC2 instances are tagged into a patch resource group; missing windows reduce coverage fast."
msgstr "Verify patch schedule and that EC2 instances are tagged into a patch resource group; missing windows reduce coverage fast."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/mysql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/index.jsx
#: app/frontend/pages/dashboard/azure/postgresql_flexible_servers/show.jsx
#: app/frontend/pages/dashboard/azure/public_ips/index.jsx
#: app/frontend/pages/dashboard/azure/public_ips/show.jsx
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/aws/eks_cluster_settings/index.jsx
#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Version"
msgstr "Version"

#: app/frontend/pages/dashboard/aws/s3_buckets/show.jsx
msgid "Versioning"
msgstr "Versioning"

#. placeholder {0}: subscription.source_label
#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "via {0}"
msgstr "via {0}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "View"
msgstr "View"

#: app/frontend/components/guardian/GuardianContextBar.jsx
msgid "View Accounts"
msgstr "View Accounts"

#: app/frontend/components/optimization_dashboard/ActionsDrawer.jsx
msgid "View action"
msgstr "View action"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "View all"
msgstr "View all"

#. placeholder {0}: items.length
#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendBand.jsx
msgid "View all ({0})"
msgstr "View all ({0})"

#. placeholder {0}: slices.length
#: app/frontend/components/DonutLegend.jsx
msgid "View all {0}"
msgstr "View all {0}"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/InspectorPane.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/SecurityHubPane.jsx
msgid "View all findings"
msgstr "View all findings"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/ComplianceCard.jsx
msgid "View all instances"
msgstr "View all instances"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "View all RDS instances →"
msgstr "View all RDS instances →"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "View all reservations →"
msgstr "View all reservations →"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "View all Snapshots →"
msgstr "View all Snapshots →"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/GuardDutyPane.jsx
msgid "View all threats"
msgstr "View all threats"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "View all Volumes →"
msgstr "View all Volumes →"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DeliveryBand.jsx
msgid "View Backup & DR"
msgstr "View Backup & DR"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/ec2_availability/BreachCard.jsx
msgid "View breached instances"
msgstr "View breached instances"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "View breakdown"
msgstr "View breakdown"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/show.jsx
msgid "View change request"
msgstr "View change request"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "View detections"
msgstr "View detections"

#: app/frontend/pages/dashboard/aws/eks_dashboard/ClusterCapacityCharts.jsx
msgid "View EC2 instance"
msgstr "View EC2 instance"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/security_compliance/EndpointSecurityPane.jsx
msgid "View hosts"
msgstr "View hosts"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/patch_management/MissingPatchesCard.jsx
msgid "View instances"
msgstr "View instances"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "View of licensed RDS Reserved Instances to support commitment planning and coverage analysis."
msgstr "View of licensed RDS Reserved Instances to support commitment planning and coverage analysis."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "View of open-source RDS Reserved Instances to support commitment planning and coverage analysis."
msgstr "View of open-source RDS Reserved Instances to support commitment planning and coverage analysis."

#: app/frontend/pages/dashboard/change_requests/rds_resource_details.jsx
msgid "View optimization"
msgstr "View optimization"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "View optimization actions"
msgstr "View optimization actions"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DeliveryBand.jsx
msgid "View Patch Management"
msgstr "View Patch Management"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "View recommendation"
msgstr "View recommendation"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "View reservations"
msgstr "View reservations"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/DeliveryBand.jsx
msgid "View Service Desk"
msgstr "View Service Desk"

#: app/frontend/components/guardian/GuardianContextBar.jsx
msgid "View SLA"
msgstr "View SLA"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/ElasticDrPane.jsx
msgid "View Source Servers"
msgstr "View Source Servers"

#: app/frontend/pages/dashboard/subscriptions/OfferingCard.jsx
msgid "View subscription"
msgstr "View subscription"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/ResolutionRateCard.jsx
msgid "View tickets"
msgstr "View tickets"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "View unattached volumes"
msgstr "View unattached volumes"

#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
msgid "View waste breakdown"
msgstr "View waste breakdown"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "View your potential savings across EKS clusters."
msgstr "View your potential savings across EKS clusters."

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Virtual machine"
msgstr "Virtual machine"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/SettingFormModal.jsx
msgid "Virtual Machine"
msgstr "Virtual Machine"

#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Virtual machine ID"
msgstr "Virtual machine ID"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
msgid "Virtual Machine Scale Set VMs"
msgstr "Virtual Machine Scale Set VMs"

#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
msgid "Virtual Machines"
msgstr "Virtual Machines"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Virtual machines currently in the running power state, across all connected subscriptions."
msgstr "Virtual machines currently in the running power state, across all connected subscriptions."

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Virtual Machines Dashboard"
msgstr "Virtual Machines Dashboard"

#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "Visible"
msgstr "Visible"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "visible to organizations"
msgstr "visible to organizations"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a donut chart, each segment corresponds to a disk state, with the total disk count displayed at the center. Hovering over segments reveals the number and percentage of disks in each state."
msgstr "Visualized as a donut chart, each segment corresponds to a disk state, with the total disk count displayed at the center. Hovering over segments reveals the number and percentage of disks in each state."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a donut chart, each segment corresponds to a specific meter category—such as compute, storage, or data transfer—with the total monthly spend displayed at the center. Hovering over each segment reveals precise expenditure values and their percentage share."
msgstr "Visualized as a donut chart, each segment corresponds to a specific meter category—such as compute, storage, or data transfer—with the total monthly spend displayed at the center. Hovering over each segment reveals precise expenditure values and their percentage share."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a donut chart, each segment represents a specific power state—such as running, stopped, or deallocated. Hovering over each segment shows the VM count and its percentage of the total."
msgstr "Visualized as a donut chart, each segment represents a specific power state—such as running, stopped, or deallocated. Hovering over each segment shows the VM count and its percentage of the total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a donut chart, each segment represents a specific publisher (such as canonical, MicrosoftWindowsServer, or RedHat). Hovering over each segment shows the VM count and its percentage of the total; a \"View all\" option reveals publishers beyond the top ones shown."
msgstr "Visualized as a donut chart, each segment represents a specific publisher (such as canonical, MicrosoftWindowsServer, or RedHat). Hovering over each segment shows the VM count and its percentage of the total; a \"View all\" option reveals publishers beyond the top ones shown."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a multi-series line chart, each line represents a specific Azure location (such as East US, West Europe, etc.), allowing for easy comparison of spending trends over time. Hovering over data points reveals detailed monthly expenditure values for each location."
msgstr "Visualized as a multi-series line chart, each line represents a specific Azure location (such as East US, West Europe, etc.), allowing for easy comparison of spending trends over time. Hovering over data points reveals detailed monthly expenditure values for each location."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a pie chart, each segment represents a specific meter location, along with the total cost displayed at the center. Hovering over segments reveals detailed cost values and percentage contributions."
msgstr "Visualized as a pie chart, each segment represents a specific meter location, along with the total cost displayed at the center. Hovering over segments reveals detailed cost values and percentage contributions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a pie chart, each segment represents a specific operating system (such as Windows or Linux). Hovering over each segment shows the VM count and its percentage of the total."
msgstr "Visualized as a pie chart, each segment represents a specific operating system (such as Windows or Linux). Hovering over each segment shows the VM count and its percentage of the total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a pie chart, each segment represents a specific pricing model—such as Pay-As-You-Go, Reserved Instances, or Spot—along with the total cost displayed at the center. Hovering over segments reveals detailed cost values and percentage contributions."
msgstr "Visualized as a pie chart, each segment represents a specific pricing model—such as Pay-As-You-Go, Reserved Instances, or Spot—along with the total cost displayed at the center. Hovering over segments reveals detailed cost values and percentage contributions."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a pie chart, each segment represents a specific zone (such as Zone 1 or Zone 2), with VMs that aren't pinned to any zone grouped under \"No Zone\". A VM that spans more than one zone is counted once in each zone it belongs to. Hovering over each segment shows the VM count and its percentage of the total."
msgstr "Visualized as a pie chart, each segment represents a specific zone (such as Zone 1 or Zone 2), with VMs that aren't pinned to any zone grouped under \"No Zone\". A VM that spans more than one zone is counted once in each zone it belongs to. Hovering over each segment shows the VM count and its percentage of the total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a stacked bar chart with a total line, each bar is a day and each segment within it is the cost attributed to a specific pricing model that day. Hovering over a segment reveals the exact spend for that pricing model."
msgstr "Visualized as a stacked bar chart with a total line, each bar is a day and each segment within it is the cost attributed to a specific pricing model that day. Hovering over a segment reveals the exact spend for that pricing model."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as a stacked bar chart, the Y-axis shows costs in USD and the X-axis represents each day in the period. Each bar is divided into segments for each service family (such as Compute, Storage, Networking, etc.), providing a clear view of how different groups of Azure services contribute to overall daily spend. Hovering over a segment reveals the specific cost for that service family on that day."
msgstr "Visualized as a stacked bar chart, the Y-axis shows costs in USD and the X-axis represents each day in the period. Each bar is divided into segments for each service family (such as Compute, Storage, Networking, etc.), providing a clear view of how different groups of Azure services contribute to overall daily spend. Hovering over a segment reveals the specific cost for that service family on that day."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as horizontal bars, each row is a license type with its VM count and share of the total."
msgstr "Visualized as horizontal bars, each row is a license type with its VM count and share of the total."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as horizontal bars, each row is a product name with its average utilization percentage. Reservations without a reported utilization (expired, cancelled, or failed) are excluded; products beyond the top few are combined into a single \"other products\" row so the list stays short."
msgstr "Visualized as horizontal bars, each row is a product name with its average utilization percentage. Reservations without a reported utilization (expired, cancelled, or failed) are excluded; products beyond the top few are combined into a single \"other products\" row so the list stays short."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Visualized as horizontal bars, each row is a subscription with its count of VMs eligible for Azure Hybrid Benefit; subscriptions beyond the top few are combined into a single \"other subscriptions\" row so the list stays short."
msgstr "Visualized as horizontal bars, each row is a subscription with its count of VMs eligible for Azure Hybrid Benefit; subscriptions beyond the top few are combined into a single \"other subscriptions\" row so the list stays short."

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "VM Count"
msgstr "VM Count"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "VM Count, Percentage"
msgstr "VM Count, Percentage"

#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "VM ID"
msgstr "VM ID"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "VM size"
msgstr "VM size"

#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_set_vms/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/index.jsx
msgid "VM Size"
msgstr "VM Size"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "VM sizes"
msgstr "VM sizes"

#: app/frontend/pages/dashboard/azure/vms/optimizations/new.jsx
msgid "VMs"
msgstr "VMs"

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "VMs by License Classification"
msgstr "VMs by License Classification"

#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/new.jsx
msgid "volume"
msgstr "volume"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
msgid "Volume"
msgstr "Volume"

#: app/frontend/components/aws/RDSClusterMetricsSection.jsx
msgid "Volume Bytes Used"
msgstr "Volume Bytes Used"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Volume Count"
msgstr "Volume Count"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "Volume Count, Percentage"
msgstr "Volume Count, Percentage"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ebs/ebs_optimization_action/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_running_recommendations/show.jsx
#: app/frontend/pages/dashboard/aws/ebs/volumes_in_use_stopped_recommendations/edit.jsx
#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/drilldowns.js
msgid "Volume ID"
msgstr "Volume ID"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "Volume kinds"
msgstr "Volume kinds"

#: app/frontend/pages/dashboard/aws/ebs_snapshots/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/index.jsx
#: app/frontend/pages/dashboard/aws/opensearch_clusters/show.jsx
msgid "Volume Size"
msgstr "Volume Size"

#: app/frontend/components/StackedBarTable.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/index.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
msgid "Volumes"
msgstr "Volumes"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Volumes by State"
msgstr "Volumes by State"

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Volumes not attached to any EC2 instance. AWS still bills for their storage even though nothing is using them."
msgstr "Volumes not attached to any EC2 instance. AWS still bills for their storage even though nothing is using them."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Volumes with a running vs stopped instance"
msgstr "Volumes with a running vs stopped instance"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/backup_and_disaster_recovery/TopVolumesCard.jsx
msgid "Volumes with the most failed or missed backups in the selected period. Click a volume to see its failed backups."
msgstr "Volumes with the most failed or missed backups in the selected period. Click a volume to see its failed backups."

#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
msgid "Volumes, snapshots & storage spend across all connected AWS accounts"
msgstr "Volumes, snapshots & storage spend across all connected AWS accounts"

#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
msgid "VPC"
msgstr "VPC"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/index.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/load_balancers/show.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/index.jsx
#: app/frontend/pages/dashboard/aws/nat_gateways/show.jsx
msgid "VPC ID"
msgstr "VPC ID"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "VPN Port"
msgstr "VPN Port"

#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
msgid "VPN Protocol"
msgstr "VPN Protocol"

#. placeholder {0}: usdFormat(total.data?.prior_value ?? 0)
#. placeholder {0}: usdFormat(totalTrend?.data?.prior_value ?? 0)
#: app/frontend/pages/dashboard/aws/dashboard/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/dashboard.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/dashboard.jsx
#: app/frontend/pages/dashboard/azure/dashboard/index.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "vs {0}/mo last month"
msgstr "vs {0}/mo last month"

#. placeholder {0}: usdFormat(total.data?.prior_value ?? 0)
#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "vs {0}/mo the month before"
msgstr "vs {0}/mo the month before"

#: app/frontend/pages/dashboard/aws/rds_instances/dashboard.jsx
msgid "vs on-demand pricing · trailing 18 months"
msgstr "vs on-demand pricing · trailing 18 months"

#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Vulnerabilities"
msgstr "Vulnerabilities"

#: app/frontend/components/chat/Composer.jsx
msgid "Wait for the current reply before sending another message."
msgstr "Wait for the current reply before sending another message."

#: app/frontend/pages/dashboard/change_requests/AutomationStepStatusBadge.jsx
msgid "Waiting"
msgstr "Waiting"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Waiting for Customer"
msgstr "Waiting for Customer"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/index.jsx
msgid "Waiting for Customer (biz hrs)"
msgstr "Waiting for Customer (biz hrs)"

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Waiting For Support"
msgstr "Waiting For Support"

#: app/frontend/pages/admin/plans/organizations.jsx
msgid "Warning:"
msgstr "Warning:"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Waste / mo"
msgstr "Waste / mo"

#: app/frontend/pages/dashboard/aws/finops_hub/score.jsx
msgid "Waste Drag"
msgstr "Waste Drag"

#: app/frontend/pages/users/registrations/edit.jsx
msgid "We have sent an email to"
msgstr "We have sent an email to"

#: app/frontend/pages/users/registrations/edit.jsx
#: app/frontend/pages/users/settings/password.jsx
msgid "we need your current password to confirm your changes"
msgstr "we need your current password to confirm your changes"

#: app/frontend/components/optimization_dashboard/RunState.jsx
msgid "We're analyzing your fleet and generating recommendations. This can take a few minutes. The page updates automatically when it's done."
msgstr "We're analyzing your fleet and generating recommendations. This can take a few minutes. The page updates automatically when it's done."

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Week"
msgstr "Week"

#: app/frontend/pages/dashboard/aws/maintenance_windows/MaintenanceWindowForm.jsx
msgid "Weekday"
msgstr "Weekday"

#: app/frontend/pages/dashboard/aws/ec2_instances/SbuUtilizationPanel.jsx
msgid "Well utilized"
msgstr "Well utilized"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "What AWS actually pays Skie for AWS Marketplace sales, parsed from AWS Marketplace Seller Data Feeds. Read-only, ETL-populated."
msgstr "What AWS actually pays Skie for AWS Marketplace sales, parsed from AWS Marketplace Seller Data Feeds. Read-only, ETL-populated."

#: app/frontend/pages/admin/marketplace_entitlements/index.jsx
msgid "What AWS Marketplace reports each organization is entitled to, keyed by agreement. Read-only: AWS owns these records, Zee mirrors them. The usage Skie submits against them is under Billings."
msgstr "What AWS Marketplace reports each organization is entitled to, keyed by agreement. Read-only: AWS owns these records, Zee mirrors them. The usage Skie submits against them is under Billings."

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "What is covered"
msgstr "What is covered"

#: app/frontend/pages/dashboard/subscriptions/index.jsx
msgid "What Skie offers, and what your organization is on."
msgstr "What Skie offers, and what your organization is on."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/index.jsx
msgid "What the operation executed in this period"
msgstr "What the operation executed in this period"

#: app/frontend/pages/users/admin_tokens/new.jsx
msgid "What the token is for, so you can tell your tokens apart."
msgstr "What the token is for, so you can tell your tokens apart."

#: app/frontend/pages/dashboard/memberships/RolePicker.jsx
msgid "What this role can do"
msgstr "What this role can do"

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "What this subscription costs."
msgstr "What this subscription costs."

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "What this tier costs and what Skie commits to."
msgstr "What this tier costs and what Skie commits to."

#: app/frontend/pages/dashboard/aws/maintenance_window_settings/edit.jsx
msgid "When enabled, maintenance windows automatically open Change Requests on their schedule."
msgstr "When enabled, maintenance windows automatically open Change Requests on their schedule."

#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
msgid "When enabled, rightsizing recommendations for Redis clusters push toward Valkey-compatible node types instead of like-for-like Redis replacements."
msgstr "When enabled, rightsizing recommendations for Redis clusters push toward Valkey-compatible node types instead of like-for-like Redis replacements."

#: app/frontend/pages/notifications/index.jsx
msgid "When you receive notifications, they'll appear here."
msgstr "When you receive notifications, they'll appear here."

#: app/frontend/pages/admin/plans/PlanForm.jsx
msgid "Whether this plan can be selected when creating new subscriptions."
msgstr "Whether this plan can be selected when creating new subscriptions."

#: app/frontend/pages/dashboard/aws/guardian_dashboard/service_desk/MonitoringPane.jsx
msgid "Which automation or internal team raised the monitoring tickets in the selected period."
msgstr "Which automation or internal team raised the monitoring tickets in the selected period."

#: app/frontend/pages/dashboard/subscriptions/SubscriptionBlock.jsx
msgid "Which clouds Zee reads, and what it does with what it finds."
msgstr "Which clouds Zee reads, and what it does with what it finds."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Which findings reach the organization."
msgstr "Which findings reach the organization."

#: app/frontend/pages/dashboard/subscriptions/sections/SageSections.jsx
msgid "Which recommendations Zee produces."
msgstr "Which recommendations Zee produces."

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Why this size"
msgstr "Why this size"

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "Windows"
msgstr "Windows"

#: app/frontend/pages/dashboard/aws/fsx_file_systems/show.jsx
msgid "Windows Configuration"
msgstr "Windows Configuration"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Windows hosts not managed by SSM automation, so the OS cannot be inspected. BYOL SQL Server may run here undetected — a blind spot, not a confirmation that no SQL exists."
msgstr "Windows hosts not managed by SSM automation, so the OS cannot be inspected. BYOL SQL Server may run here undetected — a blind spot, not a confirmation that no SQL exists."

#: app/frontend/components/sql_server_licences/UnmanagedWindowsModal.jsx
msgid "Windows instances without SSM visibility"
msgstr "Windows instances without SSM visibility"

#: app/frontend/pages/dashboard/optimizer/settings/show.jsx
msgid "Windows Server licences with Software Assurance"
msgstr "Windows Server licences with Software Assurance"

#: app/frontend/pages/dashboard/azure/vms/license_recommendations/show.jsx
msgid "Windows Server licences with Software Assurance or subscription covering {cores} cores (Azure counts at least 8 per VM)."
msgstr "Windows Server licences with Software Assurance or subscription covering {cores} cores (Azure counts at least 8 per VM)."

#: app/frontend/pages/dashboard/azure/virtual_machines/dashboard.jsx
msgid "Windows VMs paying full license"
msgstr "Windows VMs paying full license"

#: app/frontend/components/sql_server_licences/StatTiles.jsx
msgid "Windows without SSM"
msgstr "Windows without SSM"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Windows without SSM visibility"
msgstr "Windows without SSM visibility"

#: app/frontend/pages/dashboard/azure/vms/right_size_recommendations/show.jsx
msgid "Windows: only sizes Azure sells a Windows licence for."
msgstr "Windows: only sizes Azure sells a Windows licence for."

#: app/frontend/pages/dashboard/aws/credentials/CredentialFormFields.jsx
msgid "WinRM"
msgstr "WinRM"

#: app/frontend/pages/admin/marketplace_disbursement_events/index.jsx
msgid "With action=DISBURSED: the actual net amount paid to you. With action=INVOICED: negates the related billing event instead, in full or in part — not a payout."
msgstr "With action=DISBURSED: the actual net amount paid to you. With action=INVOICED: negates the related billing event instead, in full or in part — not a payout."

#: app/frontend/pages/dashboard/subscriptions/sections/SlaSection.jsx
msgid "With AWS DRS — RPO / RTO"
msgstr "With AWS DRS — RPO / RTO"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "With Billing Accounts"
msgstr "With Billing Accounts"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "With Both"
msgstr "With Both"

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "With Subscriptions"
msgstr "With Subscriptions"

#: app/frontend/pages/dashboard/aws/guardian_dashboard/executive_summary/AttentionLists.jsx
msgid "Within grace"
msgstr "Within grace"

#: app/frontend/pages/admin/guardian_global_dashboard/signals.js
msgid "within SLA green · within 25% grace yellow · over red"
msgstr "within SLA green · within 25% grace yellow · over red"

#: app/frontend/components/sql_server_licences/HowToResolveDrawer.jsx
msgid "Without SSM the OS cannot be inspected — a licensing blind spot."
msgstr "Without SSM the OS cannot be inspected — a licensing blind spot."

#: app/frontend/components/guardian/TicketStatusTree.jsx
msgid "Work In Progress"
msgstr "Work In Progress"

#: app/frontend/pages/dashboard/aws/ec2/ec2_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/ec2/saving_plan_optimization_action/new.jsx
#: app/frontend/pages/dashboard/aws/rds/rds_optimization_action/new.jsx
msgid "Workflow"
msgstr "Workflow"

#: app/frontend/pages/dashboard/aws/security_hub_findings/index.jsx
#: app/frontend/pages/dashboard/aws/security_hub_findings/show.jsx
msgid "Workflow Status"
msgstr "Workflow Status"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Workgroup ARN"
msgstr "Workgroup ARN"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Workgroup Details"
msgstr "Workgroup Details"

#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
msgid "Workgroup Version"
msgstr "Workgroup Version"

#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/index.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
msgid "Workgroups"
msgstr "Workgroups"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
msgid "Workload"
msgstr "Workload"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Workload Information"
msgstr "Workload Information"

#: app/frontend/pages/dashboard/aws/eks_dashboard/container_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Workload Kind"
msgstr "Workload Kind"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Workload name"
msgstr "Workload name"

#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Workload Name"
msgstr "Workload Name"

#: app/frontend/pages/dashboard/aws/eks_clusters/dashboard.jsx
msgid "Workload type"
msgstr "Workload type"

#: app/frontend/pages/dashboard/azure/backup_policies/index.jsx
#: app/frontend/pages/dashboard/azure/backup_policies/show.jsx
msgid "Workload Type"
msgstr "Workload Type"

#. placeholder {0}: workload.workload_name
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
msgid "Workload: {0}"
msgstr "Workload: {0}"

#: app/frontend/pages/dashboard/aws/eks_dashboard/namespaces.jsx
msgid "Workloads"
msgstr "Workloads"

#. placeholder {0}: namespace.namespace
#: app/frontend/pages/dashboard/aws/eks_dashboard/workloads.jsx
msgid "Workloads - {0}"
msgstr "Workloads - {0}"

#: app/frontend/components/optimization_dashboard/panels/OverviewPanel.jsx
msgid "worth it"
msgstr "worth it"

#: app/frontend/components/echarts/chart/chart_info.jsx
msgid "write IOPS"
msgstr "write IOPS"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsForm.jsx
msgid "Write Permissions for Cost Optimization Actions"
msgstr "Write Permissions for Cost Optimization Actions"

#: app/frontend/pages/dashboard/aws/dynamodb_tables/show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/rds_instances/show.jsx
#: app/frontend/pages/dashboard/aws/rds_reserved_instances/show.jsx
msgid "yes"
msgstr "yes"

#: app/frontend/components/optimization_dashboard/RecommendationsPanels.jsx
#: app/frontend/components/optimization_dashboard/SettingsUsedDrawer.jsx
#: app/frontend/pages/admin/users/show.jsx
#: app/frontend/pages/dashboard/aws/accounts/show.jsx
#: app/frontend/pages/dashboard/aws/billing_groups/show.jsx
#: app/frontend/pages/dashboard/aws/client_vpn_endpoints/show.jsx
#: app/frontend/pages/dashboard/aws/credentials/index.jsx
#: app/frontend/pages/dashboard/aws/ebs_snapshots/show.jsx
#: app/frontend/pages/dashboard/aws/ebs_volumes/show.jsx
#: app/frontend/pages/dashboard/aws/ec2_instances/show.jsx
#: app/frontend/pages/dashboard/aws/ec2/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/efs_file_systems/show.jsx
#: app/frontend/pages/dashboard/aws/eks_dashboard/workload_show.jsx
#: app/frontend/pages/dashboard/aws/elasti_cache/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/opensearch/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/rds/optimizations/new.jsx
#: app/frontend/pages/dashboard/aws/redshift_clusters/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_namespaces/show.jsx
#: app/frontend/pages/dashboard/aws/redshift_serverless_workgroups/show.jsx
#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
#: app/frontend/pages/dashboard/azure/storage_accounts/show.jsx
msgid "Yes"
msgstr "Yes"

#: app/frontend/utils/format.js
msgid "yesterday"
msgstr "yesterday"

#: app/frontend/components/chat/groups.js
msgid "Yesterday"
msgstr "Yesterday"

#: app/frontend/components/optimization_dashboard/schedule/ScheduleFooter.jsx
msgid "You are about to schedule optimization actions for {selectedCount} {resourceLabel}(s). This applies changes to your AWS infrastructure."
msgstr "You are about to schedule optimization actions for {selectedCount} {resourceLabel}(s). This applies changes to your AWS infrastructure."

#. placeholder {0}: plan.name
#: app/frontend/pages/admin/plan_features/edit.jsx
msgid "You are editing the default template settings for this feature. These configurations will be applied to new subscriptions using the {0} plan. Existing subscriptions will continue using their current settings unless explicitly updated."
msgstr "You are editing the default template settings for this feature. These configurations will be applied to new subscriptions using the {0} plan. Existing subscriptions will continue using their current settings unless explicitly updated."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "You can check if the script is available by issuing the"
msgstr "You can check if the script is available by issuing the"

#: app/frontend/pages/users/settings/connections.jsx
msgid "You can connect your account with other services for faster sign-in."
msgstr "You can connect your account with other services for faster sign-in."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "You can provide both subscription and billing account lists."
msgstr "You can provide both subscription and billing account lists."

#: app/frontend/components/optimization_dashboard/schedule/ConfigureAccessCard.jsx
msgid "You can schedule actions now. Write permissions let Skie safely execute the approved changes in your AWS environment when they run."
msgstr "You can schedule actions now. Write permissions let Skie safely execute the approved changes in your AWS environment when they run."

#: app/frontend/pages/dashboard/invitation_acceptances/show.jsx
msgid "You have been invited by <0>{invitedBy}</0> to join <1>{organizationName}</1> on skie.io."
msgstr "You have been invited by <0>{invitedBy}</0> to join <1>{organizationName}</1> on skie.io."

#: app/frontend/pages/users/admin_tokens/index.jsx
msgid "You have no admin tokens."
msgstr "You have no admin tokens."

#: app/frontend/pages/dashboard/azure/credentials/setup.jsx
msgid "You might need to have <0>elevated access</0> to see all subscriptions in your organization."
msgstr "You might need to have <0>elevated access</0> to see all subscriptions in your organization."

#: app/frontend/pages/dashboard/aws/settings/eks_split_cost.jsx
msgid "You need to activate the \"cost allocation tags\" and \"EKS split cost allocation\" option at the"
msgstr "You need to activate the \"cost allocation tags\" and \"EKS split cost allocation\" option at the"

#: app/frontend/pages/dashboard/aws/settings/WritePermissionsGuide.jsx
msgid "You should be able to see the newly created policies attached to your role in IAM, providing Skie.io with the necessary write permissions."
msgstr "You should be able to see the newly created policies attached to your role in IAM, providing Skie.io with the necessary write permissions."

#: app/frontend/pages/dashboard/azure/subscriptions/setup.jsx
msgid "Your account was successfully created. Contact Skie team to configure your account on Azure."
msgstr "Your account was successfully created. Contact Skie team to configure your account on Azure."

#: app/frontend/pages/users/aws_marketplace/associate.jsx
msgid "Your account will be associated with the AWS Marketplace product and billed via AWS. Click the button below if you accept the conditions and want to associate your account."
msgstr "Your account will be associated with the AWS Marketplace product and billed via AWS. Click the button below if you accept the conditions and want to associate your account."

#: app/frontend/components/guardian/help/common.js
msgid "Your AWS accounts are grouped into service tiers (Flex, Advanced, Premium), and each tier has its own targets for response times and recovery. Use the Tier switch and filters to narrow the view, and \"View SLA\" to see the exact targets for the selected tier."
msgstr "Your AWS accounts are grouped into service tiers (Flex, Advanced, Premium), and each tier has its own targets for response times and recovery. Use the Tier switch and filters to narrow the view, and \"View SLA\" to see the exact targets for the selected tier."

#: app/frontend/components/chat/Composer.jsx
#: app/frontend/components/chat/MessageList.jsx
msgid "Your message could not be sent. Try again."
msgstr "Your message could not be sent. Try again."

#: app/frontend/pages/dashboard/aws/dashboard/UnusualSpendDrawer.jsx
msgid "Your share vs typical"
msgstr "Your share vs typical"

#: app/frontend/pages/dashboard/optimizer/aws/opensearch_cluster_settings/attributes.js
msgid "Zone awareness enabled"
msgstr "Zone awareness enabled"

#: app/frontend/pages/dashboard/azure/cosmos_db_accounts/show.jsx
msgid "Zone Redundant"
msgstr "Zone Redundant"

#: app/frontend/pages/dashboard/aws/eks_clusters/show.jsx
#: app/frontend/pages/dashboard/azure/managed_disks/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machine_scale_sets/show.jsx
#: app/frontend/pages/dashboard/azure/virtual_machines/show.jsx
#: app/frontend/pages/dashboard/optimizer/azure/virtual_machine_settings/attributes.js
msgid "Zones"
msgstr "Zones"
